webpackJsonp([2,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(538);
	
	var _vue = __webpack_require__(19);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _Main = __webpack_require__(642);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _router = __webpack_require__(354);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _vuex = __webpack_require__(51);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _http = __webpack_require__(62);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _elementUi = __webpack_require__(122);
	
	var _elementUi2 = _interopRequireDefault(_elementUi);
	
	__webpack_require__(512);
	
	var _ptBr = __webpack_require__(498);
	
	var _ptBr2 = _interopRequireDefault(_ptBr);
	
	var _locale = __webpack_require__(59);
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _vueSweetalert = __webpack_require__(796);
	
	var _vueSweetalert2 = _interopRequireDefault(_vueSweetalert);
	
	var _vuelidate = __webpack_require__(799);
	
	var _vuelidate2 = _interopRequireDefault(_vuelidate);
	
	var _vueScrollto = __webpack_require__(795);
	
	var _vueScrollto2 = _interopRequireDefault(_vueScrollto);
	
	var _vueMoment = __webpack_require__(793);
	
	var _vueMoment2 = _interopRequireDefault(_vueMoment);
	
	var _vueYoutubeEmbed = __webpack_require__(798);
	
	var _vueYoutubeEmbed2 = _interopRequireDefault(_vueYoutubeEmbed);
	
	var _vMoney = __webpack_require__(639);
	
	var _vMoney2 = _interopRequireDefault(_vMoney);
	
	var _vueTheMask = __webpack_require__(797);
	
	var _vueTheMask2 = _interopRequireDefault(_vueTheMask);
	
	var _access = __webpack_require__(351);
	
	var _access2 = _interopRequireDefault(_access);
	
	var _vueCookie = __webpack_require__(641);
	
	var _vueCookie2 = _interopRequireDefault(_vueCookie);
	
	__webpack_require__(344);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_http2.default, { router: _router2.default });
	_vue2.default.use(_elementUi2.default);
	_locale2.default.use(_ptBr2.default);
	_vue2.default.use(_vueSweetalert2.default);
	_vue2.default.use(_vuelidate2.default);
	_vue2.default.use(_vueScrollto2.default);
	_vue2.default.use(_vueMoment2.default);
	_vue2.default.use(_vueYoutubeEmbed2.default);
	_vue2.default.use(_vMoney2.default);
	_vue2.default.use(_vueTheMask2.default);
	_vue2.default.use(_access2.default);
	_vue2.default.use(_vueCookie2.default);
	
	new _vue2.default({
	  router: _router2.default,
	  store: _vuex2.default,
	  el: '#app',
	  render: function render(h) {
	    return h(_Main2.default);
	  }
	});

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(19);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var bus = new _vue2.default();
	exports.default = bus;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(366),
	  /* template */
	  __webpack_require__(782),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.destroy = exports.save = exports.put = exports.post = exports.search = exports.get = exports.all = undefined;
	
	var _promise = __webpack_require__(27);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _http = __webpack_require__(345);
	
	var HTTP = _interopRequireWildcard(_http);
	
	var _sweetalert = __webpack_require__(42);
	
	var _sweetalert2 = _interopRequireDefault(_sweetalert);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultPage = 1;
	var defaultPerPage = 20;
	
	function _checkQueryString(url) {
	  return url;
	}
	
	function _processUrl(domain, route, id, columns, relations, page, perPage) {
	  var url = domain;
	  var hasUrlParams = false;
	
	  if (id !== undefined && id !== null) {
	    url = _checkQueryString(url);
	    url += '/' + id;
	  }
	  url += route ? '/' + route : '';
	  url += '?q=';
	
	  if (page !== undefined && page !== null && page !== false) {
	    page = page || defaultPage;
	    perPage = perPage || defaultPerPage;
	    url = _checkQueryString(url);
	    url += '&_page=' + page + '&_limit=' + perPage;
	    hasUrlParams = true;
	  }
	
	  if (columns !== null && columns !== undefined && columns.length > 0) {
	    url = _checkQueryString(url);
	    columns.forEach(function (val) {
	      if (val.length > 0) {
	        url += '&_columns[]=' + val;
	      }
	    });
	    hasUrlParams = true;
	  }
	
	  if (relations !== null && relations !== undefined && relations.length > 0) {
	    url = _checkQueryString(url);
	    relations.forEach(function (val) {
	      if (val.length > 0) {
	        url += '&_with[]=' + val;
	      }
	    });
	    hasUrlParams = true;
	  }
	  if (!hasUrlParams) {
	    url = url.replace('?q=', '');
	  }
	  return url;
	}
	
	function _all(domain, route, id, columns, relations, page, perPage) {
	  return HTTP.get(_processUrl(domain, route, id, columns, relations, page, perPage));
	}
	
	function _get(domain, route, id, columns, relations, page, perPage) {
	  return HTTP.get(_processUrl(domain, route, id, columns, relations, page, perPage));
	}
	
	function _search(domain, route, data, columns, relations, page, perPage, customSearch) {
	  if (data === undefined || data === null) {
	    data = null;
	  }
	  page = page || defaultPage;
	  perPage = perPage || defaultPerPage;
	  customSearch = customSearch || false;
	  return HTTP.post(_processUrl((customSearch ? '' : 'search/') + domain, route, null, columns, relations, page, perPage), data);
	}
	
	function _post(domain, route, id, data) {
	  return HTTP.post(_processUrl(domain, route, id), data);
	}
	
	function _put(domain, route, id, data) {
	  return HTTP.put(_processUrl(domain, route, id || data.id), data);
	}
	
	function _save(domain, route, id, data) {
	  if (data.id !== undefined && data.id !== null && data.id !== '' && data.id > 0) {
	    return _put(domain, route, id, data);
	  }
	  return _post(domain, route, id, data);
	}
	
	function _destroy(domain, route, id) {
	  return new _promise2.default(function (resolve, reject) {
	    (0, _sweetalert2.default)({
	      title: 'Deseja realmente remover esse item?',
	      text: 'Essa ação não pode ser revertida!',
	      type: 'warning',
	      showCancelButton: true,
	      confirmButtonColor: '#3085d6',
	      cancelButtonColor: '#d33',
	      confirmButtonText: 'Sim, continuar!'
	    }).then(function () {
	      HTTP.destroy(_processUrl(domain, route, id)).then(function () {
	        resolve();
	      }).catch(function (e) {
	        reject(e);
	      });
	    }).catch(function (e) {
	      reject(e);
	    });
	  });
	}
	
	var all = exports.all = _all;
	var get = exports.get = _get;
	var search = exports.search = _search;
	var post = exports.post = _post;
	var put = exports.put = _put;
	var save = exports.save = _save;
	var destroy = exports.destroy = _destroy;

/***/ }),
/* 7 */,
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.error = exports.success = undefined;
	
	var _elementUi = __webpack_require__(122);
	
	var _lodash = __webpack_require__(3);
	
	var _bus = __webpack_require__(4);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _success(options) {
	  var defaultOptions = {
	    title: 'Sucesso!',
	    message: 'Os dados foram gravados',
	    offset: 50,
	    duration: 3000
	  };
	  options = (0, _lodash.merge)(defaultOptions, options);
	  if (options.hasOwnProperty('hideLoader') && options.hideLoader) {
	    _bus2.default.$emit('hide-loader');
	  }
	  _elementUi.Notification.success(options);
	}
	
	function _error(options) {
	  var defaultOptions = {
	    title: 'Atenção!',
	    message: 'Ocorreu um problema na sua solicitação',
	    offset: 50,
	    duration: 3000
	  };
	  options = (0, _lodash.merge)(defaultOptions, options);
	  if (options.hasOwnProperty('hideLoader') && options.hideLoader) {
	    _bus2.default.$emit('hide-loader');
	  }
	  _elementUi.Notification.error(options);
	}
	
	var success = exports.success = _success;
	var error = exports.error = _error;

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(368),
	  /* template */
	  __webpack_require__(725),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(364),
	  /* template */
	  __webpack_require__(788),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(365),
	  /* template */
	  __webpack_require__(737),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(358),
	  /* template */
	  __webpack_require__(774),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(359),
	  /* template */
	  __webpack_require__(764),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 17 */,
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormatBr = 'DD/MM/YYYY';
	var dateFormatEn = 'YYYY-MM-DD';
	var dateTimeFormatBr = 'DD/MM/YYYY HH:mm:SS';
	var dateTimeFormatEn = 'YYYY-MM-DD HH:mm:SS';
	
	var getMomentInstance = function getMomentInstance(date) {
	  var momentInstance = null;
	  if ((0, _moment2.default)(date, dateFormatBr, true).isValid()) {
	    momentInstance = (0, _moment2.default)(date, dateFormatBr, true);
	  } else if ((0, _moment2.default)(date, dateFormatEn, true).isValid()) {
	    momentInstance = (0, _moment2.default)(date, dateFormatEn, true);
	  } else if ((0, _moment2.default)(date, dateTimeFormatBr, true).isValid()) {
	    momentInstance = (0, _moment2.default)(date, dateTimeFormatBr, true);
	  } else if ((0, _moment2.default)(date, dateTimeFormatEn, true).isValid()) {
	    momentInstance = (0, _moment2.default)(date, dateTimeFormatEn, true);
	  } else {
	    console.warn('Formato inválido', date);
	  }
	  return momentInstance;
	};
	
	exports.default = {
	  methods: {
	    momentNow: function momentNow() {
	      return (0, _moment2.default)();
	    },
	
	    momentInstance: function momentInstance(value) {
	      var momentInstance = getMomentInstance(value);
	      if (!momentInstance) {
	        return false;
	      }
	      return momentInstance;
	    },
	
	    dateFormat: function dateFormat(date, format) {
	      if (date === undefined || date === null || date.length < 1) {
	        return '';
	      }
	      var momentInstance = getMomentInstance(date);
	      if (!momentInstance) {
	        return '';
	      }
	      format = format || 'br';
	      return momentInstance.format(format === 'br' ? dateFormatBr : dateFormatEn);
	    },
	
	    dateTimeFormat: function dateTimeFormat(datetime, format, short) {
	      if (datetime === undefined || datetime === null || datetime.length < 1) {
	        return '';
	      }
	      var momentInstance = getMomentInstance(datetime);
	      if (!momentInstance) {
	        return '';
	      }
	      format = format || 'br';
	      short = short || false;
	      var resultFormat = (format === 'br' ? dateFormatBr : dateFormatEn) + ' ' + (short ? 'HH:mm' : 'HH:mm:SS');
	      return momentInstance.format(resultFormat);
	    },
	
	    timeFormat: function timeFormat(time, short) {
	      if (time === undefined || time === null || time.length < 1) {
	        return '';
	      }
	      var momentInstance = getMomentInstance(time);
	      if (!momentInstance) {
	        return '';
	      }
	      short = short || false;
	      return momentInstance.format(short ? 'HH:mm' : 'HH:mm:SS');
	    },
	
	    currencyBrToEn: function currencyBrToEn(number) {
	      if (number !== undefined && number !== false) {
	        var newValue = number.replace('R$', '').replace('r$', '');
	        if (newValue.indexOf(',') > -1) {
	          var replaced = newValue.replace(/[.]/g, '');
	          newValue = replaced.replace(',', '.');
	        }
	        return parseFloat(newValue);
	      }
	      return number;
	    },
	
	    currencyEnToBr: function currencyEnToBr(number) {
	      if (number !== undefined && number !== null) {
	        return this.numberFormat(number, 2, ',', '.');
	      }
	      return number;
	    },
	
	    numberFormat: function numberFormat(number, decimals, decPoint, thousandsSep) {
	      number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
	      var n = !isFinite(+number) ? 0 : +number;
	      var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
	      var sep = typeof thousandsSep === 'undefined' ? ',' : thousandsSep;
	      var dec = typeof decPoint === 'undefined' ? '.' : decPoint;
	      var s = '';
	
	      var toFixedFix = function toFixedFix(n, prec) {
	        var k = Math.pow(10, prec);
	        return '' + (Math.round(n * k) / k).toFixed(prec);
	      };
	
	      s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
	      if (s[0].length > 3) {
	        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
	      }
	      if ((s[1] || '').length < prec) {
	        s[1] = s[1] || '';
	        s[1] += new Array(prec - s[1].length + 1).join('0');
	      }
	
	      return s.join(dec);
	    },
	    onlyNumbers: function onlyNumbers(str) {
	      if (str === undefined || str === null) {
	        return str;
	      }
	      if (typeof str !== 'string') {
	        str = str.toString();
	      }
	      return str.replace(/\D+/g, '');
	    },
	
	    roundLower: function roundLower(value, decimals) {
	      var aux = Math.pow(10, decimals);
	      return Math.floor(value * aux) / aux;
	    },
	
	    bytesToSize: function bytesToSize(bytes) {
	      var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
	      if (bytes === 0) return '0 Bytes';
	      if (bytes === 1) return '1 Byte';
	      var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
	      if (i === 0) return bytes + ' ' + sizes[i];
	      return (bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i];
	    }
	  }
	};

/***/ }),
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(27);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _axios = __webpack_require__(96);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _restfulService = __webpack_require__(6);
	
	var restfulService = _interopRequireWildcard(_restfulService);
	
	var _bus = __webpack_require__(4);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  get: function get(domains) {
	    var promises = [];
	    var responses = {};
	
	    if (domains !== undefined && domains.length > 0) {
	      _bus2.default.$emit('show-loader');
	      domains.forEach(function (val) {
	        if (val !== undefined) {
	          val.route = val.route || null;
	          var defaultData = {
	            orderBy: [{
	              column: 'name',
	              direction: 'ASC'
	            }]
	          };
	          var _data = val.data || defaultData;
	          switch (val.domain) {
	
	            case 'user':
	              _data = {};
	              promises.push(restfulService.search('user', val.route, _data, null, null, 1, 2000));
	              responses.users = [];
	              break;
	
	            case 'role':
	              promises.push(restfulService.search('role', val.route, _data, null, null, 1, 2000));
	              responses.roles = [];
	              break;
	
	            case 'signature':
	              promises.push(restfulService.search('signature', val.route, _data, null, null, 1, 2000));
	              responses.signature = [];
	              break;
	
	            case 'permission':
	              promises.push(restfulService.search('permission', val.route, _data, null, null, 1, 2000));
	              responses.permissions = [];
	              break;
	
	            case 'country':
	              promises.push(restfulService.search('country', val.route, _data, null, null, 1, 2000));
	              responses.countries = [];
	              break;
	
	            case 'state':
	              promises.push(restfulService.search('state', val.route, _data, null, null, 1, 2000));
	              responses.states = [];
	              break;
	
	            case 'knowledge_area':
	              promises.push(restfulService.search('knowledge_area', val.route, _data, null, null, 1, 2000));
	              responses.knowledge_areas = [];
	              break;
	
	            case 'city':
	              _data = {
	                orderBy: [{
	                  column: 'name',
	                  direction: 'ASC'
	                }]
	              };
	              promises.push(restfulService.search('city', 'search', _data, null, null, 1, 100));
	              responses.cities = [];
	              break;
	
	            case 'modality':
	              promises.push(restfulService.search('modality', val.route, _data, null, null, 1, 2000));
	              responses.modalities = [];
	              break;
	
	            case 'layout':
	              promises.push(restfulService.search('layout', val.route, _data, null, null, 1, 2000));
	              responses.layouts = [];
	              break;
	
	            case 'literacy':
	              promises.push(restfulService.search('literacy', val.route, _data, null, null, 1, 2000));
	              responses.literacies = [];
	              break;
	
	            case 'place':
	              _data = {
	                orderBy: [{
	                  column: 'description',
	                  direction: 'ASC'
	                }]
	              };
	              promises.push(restfulService.search('place', val.route, _data, null, null, 1, 2000));
	              responses.places = [];
	              break;
	
	            case 'event':
	              _data = {
	                orderBy: [{
	                  column: 'title',
	                  direction: 'ASC'
	                }]
	              };
	              promises.push(restfulService.search('event', val.route, _data, null, null, 1, 2000));
	              responses.events = [];
	              break;
	
	            case 'marital_status':
	              promises.push(restfulService.get('marital_status'));
	              responses.marital_status = [];
	              break;
	
	            case 'special_needs':
	              promises.push(restfulService.get('special_needs'));
	              responses.special_needs = [];
	              break;
	
	            case 'ethnicity':
	              promises.push(restfulService.get('ethnicity'));
	              responses.ethnicities = [];
	              break;
	
	            case 'status':
	              promises.push(restfulService.get('registration_status'));
	              responses.status = [];
	              break;
	
	            case 'paper_type':
	              promises.push(restfulService.search('paper_type', val.route, _data, null, null, 1, 2000));
	              responses.paper_types = [];
	              break;
	
	            case 'evaluation_type':
	              promises.push(restfulService.search('evaluation_type', val.route, _data, null, null, 1, 2000));
	              responses.evaluation_types = [];
	              break;
	
	            case 'field':
	              promises.push(restfulService.search('field', val.route, _data, null, null, 1, 2000));
	              responses.fields = [];
	              break;
	
	            case 'criteria':
	              promises.push(restfulService.search('criteria', val.route, _data, null, null, 1, 2000));
	              responses.criterias = [];
	              break;
	            case 'event_type':
	              promises.push(restfulService.search('event_type', val.route, _data, null, null, 1, 2000));
	              responses.event_types = [];
	              break;
	          }
	        }
	      });
	    }
	
	    var i = 0;
	
	    var data = _axios2.default.all(promises).then(function (result) {
	      for (var index in responses) {
	        if (result[i] !== undefined) {
	          if (result[i].data !== undefined) {
	            responses[index] = result[i].data;
	          } else {
	            responses[index] = result[i];
	          }
	        } else {
	          responses[index] = [];
	        }
	        i++;
	      }
	      return responses;
	    });
	
	    return new _promise2.default(function (resolve) {
	      resolve(data);
	      _bus2.default.$emit('hide-loader');
	    });
	  }
	};

/***/ }),
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(362),
	  /* template */
	  __webpack_require__(761),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var basePath = ("https://api.eventos.urcamp.edu.br/");
	var baseAPIGroup = 'admin/';
	var APIVersion = 'v1/';
	
	exports.default = {
	  basePath: basePath,
	  baseAPIGroup: baseAPIGroup,
	  APIVersion: APIVersion,
	  fullAPIPath: basePath + baseAPIGroup + APIVersion
	};

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _promise = __webpack_require__(27);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _defineProperty2 = __webpack_require__(445);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations;
	
	var _vue = __webpack_require__(19);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(9);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _app = __webpack_require__(102);
	
	var _types = __webpack_require__(356);
	
	var TYPES = _interopRequireWildcard(_types);
	
	var _config2 = __webpack_require__(50);
	
	var _config3 = _interopRequireDefault(_config2);
	
	var _http = __webpack_require__(62);
	
	var _storage = __webpack_require__(103);
	
	var _lodash = __webpack_require__(3);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	exports.default = new _vuex2.default.Store({
	  state: {
	    config: {
	      apiPath: _config3.default.basePath,
	      apiImagesPath: _config3.default.basePath + 'images/'
	    },
	    user: {},
	    permissions: [],
	    roles: [],
	    token: '',
	    isLoading: false,
	    collapseMenu: false,
	    listStore: {
	      init: {},
	      listOriginalData: [],
	      listData: [],
	      listTotal: 0,
	      listPerPage: 20,
	      listCurrentPage: 1,
	      listFilters: {}
	    }
	  },
	  mutations: (_mutations = {}, (0, _defineProperty3.default)(_mutations, TYPES.COLLAPSE_MENU, function (state, value) {
	    state.collapseMenu = value;
	  }), (0, _defineProperty3.default)(_mutations, TYPES.LOADER_SHOW, function (state, value) {
	    state.isLoading = value;
	  }), (0, _defineProperty3.default)(_mutations, TYPES.LIST_INIT, function (state, payload) {
	    state.listStore.init = payload;
	  }), (0, _defineProperty3.default)(_mutations, TYPES.LIST_ORIGINAL_DATA, function (state, payload) {
	    state.listStore.listOriginalData = payload;
	  }), (0, _defineProperty3.default)(_mutations, TYPES.LIST_DATA, function (state, payload) {
	    state.listStore.listData = payload;
	  }), (0, _defineProperty3.default)(_mutations, TYPES.LIST_TOTAL, function (state, payload) {
	    state.listStore.listTotal = payload;
	  }), (0, _defineProperty3.default)(_mutations, TYPES.LIST_PER_PAGE, function (state, payload) {
	    state.listStore.listPerPage = payload;
	  }), (0, _defineProperty3.default)(_mutations, TYPES.LIST_CURRENT_PAGE, function (state, payload) {
	    state.listStore.listCurrentPage = payload;
	  }), (0, _defineProperty3.default)(_mutations, TYPES.LIST_FILTERS, function (state, payload) {
	    state.listStore.listFilters = payload;
	  }), (0, _defineProperty3.default)(_mutations, TYPES.AUTH_USER, function (state, payload) {
	    state.user = payload;
	  }), (0, _defineProperty3.default)(_mutations, TYPES.AUTH_PERMISSIONS, function (state, payload) {
	    state.permissions = payload;
	  }), (0, _defineProperty3.default)(_mutations, TYPES.AUTH_ROLES, function (state, payload) {
	    state.roles = payload;
	  }), (0, _defineProperty3.default)(_mutations, TYPES.AUTH_TOKEN, function (state, payload) {
	    (0, _http.setToken)(payload);
	    state.token = payload;
	  }), _mutations),
	  actions: {
	    showLoader: function showLoader(context) {
	      context.commit(TYPES.LOADER_SHOW, true);
	    },
	    setCollapseMenu: function setCollapseMenu(context, payload) {
	      context.commit(TYPES.COLLAPSE_MENU, payload);
	    },
	    hideLoader: function hideLoader(context) {
	      setTimeout(function () {
	        context.commit(TYPES.LOADER_SHOW, false);
	      }, 500);
	    },
	    setListInit: function setListInit(context, payload) {
	      return new _promise2.default(function (resolve) {
	        context.commit(TYPES.LIST_INIT, payload.init);
	        context.commit(TYPES.LIST_ORIGINAL_DATA, payload.data);
	        context.commit(TYPES.LIST_DATA, payload.data);
	        resolve();
	      });
	    },
	    setListOriginalData: function setListOriginalData(context, payload) {
	      return new _promise2.default(function (resolve) {
	        context.commit(TYPES.LIST_ORIGINAL_DATA, payload);
	        resolve();
	      });
	    },
	    setListData: function setListData(context, payload) {
	      context.commit(TYPES.LIST_DATA, payload);
	    },
	    setListTotal: function setListTotal(context, payload) {
	      context.commit(TYPES.LIST_TOTAL, payload);
	    },
	    setListPerPage: function setListPerPage(context, payload) {
	      context.commit(TYPES.LIST_PER_PAGE, payload);
	    },
	    setListCurrentPage: function setListCurrentPage(context, payload) {
	      context.commit(TYPES.LIST_CURRENT_PAGE, payload);
	    },
	    setListFilters: function setListFilters(context, payload) {
	      context.commit(TYPES.LIST_FILTERS, payload);
	    },
	    login: function login(context, payload) {
	      return new _promise2.default(function (resolve) {
	        (0, _storage.set)('user', payload.user);
	        (0, _storage.set)('permissions', payload.permissions);
	        (0, _storage.set)('roles', payload.roles);
	        (0, _storage.set)('token', payload.token);
	        context.commit(TYPES.AUTH_USER, payload.user);
	        context.commit(TYPES.AUTH_PERMISSIONS, payload.permissions);
	        context.commit(TYPES.AUTH_ROLES, payload.roles);
	        context.commit(TYPES.AUTH_TOKEN, payload.token);
	        resolve();
	      });
	    },
	    logout: function logout(context, payload) {
	      return new _promise2.default(function (resolve) {
	        (0, _storage.clear)();
	        context.commit(TYPES.AUTH_USER, {});
	        context.commit(TYPES.AUTH_PERMISSIONS, []);
	        context.commit(TYPES.AUTH_ROLES, []);
	        context.commit(TYPES.AUTH_TOKEN, '');
	        resolve();
	      });
	    }
	  },
	  getters: {
	    config: function config(_ref) {
	      var _config = _ref.config;
	      return _config;
	    },
	    isLogged: function isLogged(_ref2) {
	      var token = _ref2.token;
	      return !(0, _lodash.isEmpty)(token);
	    },
	    token: function token(_ref3) {
	      var _token = _ref3.token;
	      return _token;
	    },
	    currentUser: function currentUser(_ref4) {
	      var user = _ref4.user;
	      return user;
	    },
	    permissions: function permissions(_ref5) {
	      var _permissions = _ref5.permissions;
	      return _permissions;
	    },
	    roles: function roles(_ref6) {
	      var _roles = _ref6.roles;
	      return _roles;
	    },
	    isLoading: function isLoading(_ref7) {
	      var _isLoading = _ref7.isLoading;
	      return _isLoading;
	    },
	    listStore: function listStore(_ref8) {
	      var _listStore = _ref8.listStore;
	      return _listStore;
	    },
	    collapseMenu: function collapseMenu(_ref9) {
	      var _collapseMenu = _ref9.collapseMenu;
	      return _collapseMenu;
	    }
	  },
	  modules: (0, _extends3.default)({}, _app.vuex)
	});

/***/ }),
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.logout = exports.login = exports.checkHeimdallToken = undefined;
	
	var _promise = __webpack_require__(27);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _vue = __webpack_require__(19);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(51);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _restfulService = __webpack_require__(6);
	
	var restfulService = _interopRequireWildcard(_restfulService);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _checkHeimdallToken() {
	  return new _promise2.default(function (resolve) {
	    var token = _vue2.default.cookie.get('heimdall_token');
	    if (token) {
	      var data = { token: token };
	      resolve(_login(data));
	    } else {
	      resolve();
	    }
	  });
	}
	
	function _login(data) {
	  return new _promise2.default(function (resolve, reject) {
	    restfulService.post('auth', 'login', null, data).then(function (loginResponse) {
	      if (loginResponse.heimdall_token) {
	        _vue2.default.cookie.set('heimdall_token', loginResponse.heimdall_token, { domain: (".urcamp.edu.br") });
	      }
	      var person = loginResponse.user.pessoa;
	      loginResponse.user = {
	        id: loginResponse.user.id,
	        ref_pessoa: loginResponse.user.ref_pessoa,
	        name: person.nome
	      };
	      _vuex2.default.dispatch('login', loginResponse).then(function (response) {
	        resolve(response);
	      });
	    }).catch(function (e) {
	      console.log(e);
	      reject();
	    });
	  });
	}
	
	function _logout() {
	  return new _promise2.default(function (resolve, reject) {
	    var token = _vue2.default.cookie.get('heimdall_token');
	    var data = {};
	    if (token) {
	      data.token = token;
	    }
	    restfulService.post('auth', 'logout', null, data).then(function () {
	      _vue2.default.cookie.delete('heimdall_token', { domain: (".urcamp.edu.br") });
	      _vuex2.default.dispatch('logout').then(function () {
	        resolve();
	      });
	    }).catch(function (e) {
	      console.log(e);
	      reject();
	    });
	  });
	}
	
	var checkHeimdallToken = exports.checkHeimdallToken = _checkHeimdallToken;
	var login = exports.login = _login;
	var logout = exports.logout = _logout;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.http = undefined;
	exports.setToken = setToken;
	exports.setTimeout = setTimeout;
	exports.default = install;
	
	var _axios = __webpack_require__(96);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _interceptors = __webpack_require__(349);
	
	var _interceptors2 = _interopRequireDefault(_interceptors);
	
	var _config = __webpack_require__(50);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var http = exports.http = _axios2.default.create({
	  baseURL: _config2.default.fullAPIPath,
	  headers: { 'content-type': 'application/json' },
	  timeout: 60000
	});
	
	function setToken(token) {
	  http.defaults.headers.common.Authorization = 'Bearer ' + token;
	}
	
	function setTimeout(timeout) {
	  http.defaults.timeout = timeout;
	}
	
	function install(Vue, _ref) {
	  var router = _ref.router;
	
	  (0, _interceptors2.default)(http, router);
	}

/***/ }),
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(532)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(361),
	  /* template */
	  __webpack_require__(775),
	  /* scopeId */
	  "data-v-84b10dec",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(369),
	  /* template */
	  __webpack_require__(734),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(388),
	  /* template */
	  __webpack_require__(748),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(346);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});
	
	var _vuex = __webpack_require__(348);
	
	Object.defineProperty(exports, 'vuex', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_vuex).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.clear = exports.remove = exports.set = exports.get = exports.storage = undefined;
	
	var _localforage = __webpack_require__(540);
	
	var _localforage2 = _interopRequireDefault(_localforage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var storage = exports.storage = _localforage2.default.createInstance({ name: 'eventos-sistema' });
	
	var get = exports.get = function get(item) {
	  return storage.getItem(item).then(function (v) {
	    return v;
	  });
	};
	
	var set = exports.set = function set(item, value) {
	  return storage.setItem(item, value).then(function () {
	    return get(item);
	  });
	};
	
	var remove = exports.remove = function remove(item) {
	  return storage.removeItem(item);
	};
	
	var clear = exports.clear = function clear() {
	  return storage.clear();
	};

/***/ }),
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(360),
	  /* template */
	  __webpack_require__(757),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(370),
	  /* template */
	  __webpack_require__(730),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(534)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(390),
	  /* template */
	  __webpack_require__(781),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(515)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(391),
	  /* template */
	  __webpack_require__(712),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(535)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(400),
	  /* template */
	  __webpack_require__(790),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(301);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Main = __webpack_require__(647);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [{
	  path: '/auth',
	  component: _Main2.default,
	  name: 'auth',
	  meta: {
	    auth: false
	  }
	}];

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(303);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _List = __webpack_require__(649);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Form = __webpack_require__(648);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [{ path: '/city', component: _List2.default, name: 'city.index' }, { path: '/city/store', component: _Form2.default, name: 'city.store' }, { path: '/city/:id', component: _Form2.default, name: 'city.update' }];

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(305);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _List = __webpack_require__(651);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Form = __webpack_require__(650);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [{ path: '/country', component: _List2.default, name: 'country.index' }, { path: '/country/store', component: _Form2.default, name: 'country.store' }, { path: '/country/:id', component: _Form2.default, name: 'country.update' }];

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(307);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _List = __webpack_require__(653);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Form = __webpack_require__(652);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [{ path: '/criteria', component: _List2.default, name: 'criteria.index' }, { path: '/criteria/store', component: _Form2.default, name: 'criteria.store' }, { path: '/criteria/:id', component: _Form2.default, name: 'criteria.update' }];

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(309);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _List = __webpack_require__(655);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Form = __webpack_require__(654);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [{ path: '/evaluation_type', component: _List2.default, name: 'evaluation_type.index' }, { path: '/evaluation_type/store', component: _Form2.default, name: 'evaluation_type.store' }, { path: '/evaluation_type/:id', component: _Form2.default, name: 'evaluation_type.update' }];

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(311);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _List = __webpack_require__(657);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _ListEvents = __webpack_require__(658);
	
	var _ListEvents2 = _interopRequireDefault(_ListEvents);
	
	var _Store = __webpack_require__(661);
	
	var _Store2 = _interopRequireDefault(_Store);
	
	var _Form = __webpack_require__(656);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _BasicData = __webpack_require__(94);
	
	var _BasicData2 = _interopRequireDefault(_BasicData);
	
	var _Modalities = __webpack_require__(255);
	
	var _Modalities2 = _interopRequireDefault(_Modalities);
	
	var _PaperTypes = __webpack_require__(256);
	
	var _PaperTypes2 = _interopRequireDefault(_PaperTypes);
	
	var _Evaluations = __webpack_require__(662);
	
	var _Evaluations2 = _interopRequireDefault(_Evaluations);
	
	var _Presence = __webpack_require__(659);
	
	var _Presence2 = _interopRequireDefault(_Presence);
	
	var _Show = __webpack_require__(660);
	
	var _Show2 = _interopRequireDefault(_Show);
	
	var _Home = __webpack_require__(667);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	var _Registrations = __webpack_require__(669);
	
	var _Registrations2 = _interopRequireDefault(_Registrations);
	
	var _Papers = __webpack_require__(668);
	
	var _Papers2 = _interopRequireDefault(_Papers);
	
	var _Reports = __webpack_require__(663);
	
	var _Reports2 = _interopRequireDefault(_Reports);
	
	var _ReportsAdmin = __webpack_require__(664);
	
	var _ReportsAdmin2 = _interopRequireDefault(_ReportsAdmin);
	
	var _ReportsFinals = __webpack_require__(665);
	
	var _ReportsFinals2 = _interopRequireDefault(_ReportsFinals);
	
	var _ReportsMinicursos = __webpack_require__(666);
	
	var _ReportsMinicursos2 = _interopRequireDefault(_ReportsMinicursos);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [{ path: '/event', component: _List2.default, name: 'event.index' }, { path: '/event/store', component: _Store2.default, name: 'event.store', props: true }, {
	  path: '/event/:id',
	  component: _Form2.default,
	  name: 'event.update',
	  children: [{
	    path: 'basic-data',
	    component: _BasicData2.default,
	    name: 'event.update.basic-data',
	    meta: { permission: 'event.update' }
	  }, {
	    path: 'modalities',
	    component: _Modalities2.default,
	    name: 'event.update.modalities',
	    meta: { permission: 'event.update' }
	  }, {
	    path: 'paper-types',
	    component: _PaperTypes2.default,
	    name: 'event.update.paper-types',
	    meta: { permission: 'event.update' }
	  }, {
	    path: 'evaluations',
	    component: _Evaluations2.default,
	    name: 'event.update.evaluations',
	    meta: { permission: 'event.update' }
	  }]
	}, {
	  path: '/event/:id/events',
	  component: _ListEvents2.default,
	  name: 'event.events.index',
	  meta: { permission: 'event.index' }
	}, {
	  path: '/event/:eventMainId/show/:id',
	  component: _Show2.default,
	  name: 'event.show',
	  children: [{ path: '', component: _Home2.default, name: 'event.show.home', props: true, meta: { permission: 'event.show' } }, {
	    path: 'registrations',
	    component: _Registrations2.default,
	    name: 'event.index.registrations',
	    props: true,
	    meta: { permission: 'event.show' }
	  }, {
	    path: 'papers/status/:statusKey?',
	    component: _Papers2.default,
	    name: 'event.index.papers',
	    props: true,
	    meta: { permission: 'event.show' }
	  }]
	}, {
	  path: '/presence/event/:id',
	  component: _Presence2.default,
	  name: 'event.presence',
	  meta: { permission: 'registration_activity.store' }
	}, {
	  path: '/reports/event/:id',
	  component: _Reports2.default,
	  name: 'event.report',
	  meta: { permission: 'event.search' }
	}, {
	  path: '/reports-admin/event/:id',
	  component: _ReportsAdmin2.default,
	  name: 'event.report-admin',
	  meta: { permission: 'event.search' }
	}, {
	  path: '/reports-finals/event/:id',
	  component: _ReportsFinals2.default,
	  name: 'event.report-finals',
	  meta: { permission: 'event.search' }
	}, {
	  path: '/reports-minicursos/event/:id',
	  component: _ReportsMinicursos2.default,
	  name: 'event.report-minicursos',
	  meta: { permission: 'event.search' }
	}];

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(313);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _List = __webpack_require__(678);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Form = __webpack_require__(677);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [{ path: '/field', component: _List2.default, name: 'field.index' }, { path: '/field/store', component: _Form2.default, name: 'field.store' }, { path: '/field/:id', component: _Form2.default, name: 'field.update' }];

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(315);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _List = __webpack_require__(680);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Form = __webpack_require__(679);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [{ path: '/institution', component: _List2.default, name: 'institution.index' }, { path: '/institution/store', component: _Form2.default, name: 'institution.store' }, { path: '/institution/:id', component: _Form2.default, name: 'institution.update' }];

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(317);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _List = __webpack_require__(682);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Form = __webpack_require__(681);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [{ path: '/institution_unit', component: _List2.default, name: 'institution_unit.index' }, { path: '/institution_unit/store', component: _Form2.default, name: 'institution_unit.store' }, { path: '/institution_unit/:id', component: _Form2.default, name: 'institution_unit.update' }];

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(319);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _List = __webpack_require__(684);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Form = __webpack_require__(683);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [{ path: '/knowledge_area', component: _List2.default, name: 'knowledge_area.index' }, { path: '/knowledge_area/store', component: _Form2.default, name: 'knowledge_area.store' }, { path: '/knowledge_area/:id', component: _Form2.default, name: 'knowledge_area.update' }];

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(321);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _List = __webpack_require__(686);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Form = __webpack_require__(685);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [{ path: '/layout', component: _List2.default, name: 'layout.index' }, { path: '/layout/store', component: _Form2.default, name: 'layout.store' }, { path: '/layout/:id', component: _Form2.default, name: 'layout.update' }];

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(323);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _List = __webpack_require__(688);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Form = __webpack_require__(687);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [{ path: '/literacy', component: _List2.default, name: 'literacy.index' }, { path: '/literacy/store', component: _Form2.default, name: 'literacy.store' }, { path: '/literacy/:id', component: _Form2.default, name: 'literacy.update' }];

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(325);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _List = __webpack_require__(690);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Form = __webpack_require__(689);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [{ path: '/modality', component: _List2.default, name: 'modality.index' }, { path: '/modality/store', component: _Form2.default, name: 'modality.store' }, { path: '/modality/:id', component: _Form2.default, name: 'modality.update' }];

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(327);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _List = __webpack_require__(692);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Form = __webpack_require__(691);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [{ path: '/paper_status', component: _List2.default, name: 'paper_status.index' }, { path: '/paper_status/store', component: _Form2.default, name: 'paper_status.store' }, { path: '/paper_status/:id', component: _Form2.default, name: 'paper_status.update' }];

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(329);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _List = __webpack_require__(694);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Form = __webpack_require__(693);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [{ path: '/paper_type', component: _List2.default, name: 'paper_type.index' }, { path: '/paper_type/store', component: _Form2.default, name: 'paper_type.store' }, { path: '/paper_type/:id', component: _Form2.default, name: 'paper_type.update' }];

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(331);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _List = __webpack_require__(696);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Form = __webpack_require__(695);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [{ path: '/place', component: _List2.default, name: 'place.index' }, { path: '/place/store', component: _Form2.default, name: 'place.store' }, { path: '/place/:id', component: _Form2.default, name: 'place.update' }];

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(333);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _List = __webpack_require__(698);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Form = __webpack_require__(697);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [{ path: '/registration', component: _List2.default, name: 'registration.index' }, { path: '/registration/store', component: _Form2.default, name: 'registration.store' }, { path: '/registration/:id', component: _Form2.default, name: 'registration.update' }];

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(335);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _List = __webpack_require__(701);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Form = __webpack_require__(700);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [{ path: '/registration_status', component: _List2.default, name: 'registration_status.index' }, { path: '/registration_status/store', component: _Form2.default, name: 'registration_status.store' }, { path: '/registration_status/:id', component: _Form2.default, name: 'registration_status.update' }];

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(337);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _List = __webpack_require__(703);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Form = __webpack_require__(702);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [{ path: '/role', component: _List2.default, name: 'role.index' }, { path: '/role/store', component: _Form2.default, name: 'role.store' }, { path: '/role/:id', component: _Form2.default, name: 'role.update' }];

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(339);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _List = __webpack_require__(705);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Form = __webpack_require__(704);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [{ path: '/signature', component: _List2.default, name: 'signature.index' }, { path: '/signature/store', component: _Form2.default, name: 'signature.store' }, { path: '/signature/:id', component: _Form2.default, name: 'signature.update' }];

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(341);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _List = __webpack_require__(707);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Form = __webpack_require__(706);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [{ path: '/state', component: _List2.default, name: 'state.index' }, { path: '/state/store', component: _Form2.default, name: 'state.store' }, { path: '/state/:id', component: _Form2.default, name: 'state.update' }];

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(343);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _List = __webpack_require__(709);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Form = __webpack_require__(708);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [{ path: '/user', component: _List2.default, name: 'user.index' }, { path: '/user/store', component: _Form2.default, name: 'user.store' }, { path: '/user/:id', component: _Form2.default, name: 'user.update' }];

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(19);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _helper = __webpack_require__(18);
	
	var _helper2 = _interopRequireDefault(_helper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.filter('dateEnToBr', function (value) {
	  if (!value) return '';
	  return _helper2.default.methods.dateFormat(value, 'br');
	});
	
	_vue2.default.filter('dateTimeEnToBr', function (value) {
	  if (!value) return '';
	  return _helper2.default.methods.dateTimeFormat(value, 'br', true);
	});
	
	_vue2.default.filter('currencyEnToBr', function (value) {
	  if (value === 0) return '0,00';
	  if (!value) return '';
	  return _helper2.default.methods.currencyEnToBr(value);
	});

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.destroy = exports.put = exports.post = exports.get = undefined;
	
	var _http2 = __webpack_require__(62);
	
	function _get(url) {
	  return _http2.http.get(url).then(function (response) {
	    return response.data;
	  });
	}
	
	function _post(url, data) {
	  return _http2.http.post(url, data).then(function (response) {
	    return response.data;
	  });
	}
	
	function _put(url, data) {
	  return _http2.http.put(url, data).then(function (response) {
	    return response.data;
	  });
	}
	
	function _destroy(url) {
	  return _http2.http.delete(url).then(function (response) {
	    return response.data;
	  });
	}
	
	var get = exports.get = _get;
	var post = exports.post = _post;
	var put = exports.put = _put;
	var destroy = exports.destroy = _destroy;

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(32);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _auth = __webpack_require__(300);
	
	var _user = __webpack_require__(342);
	
	var _role = __webpack_require__(336);
	
	var _registration = __webpack_require__(332);
	
	var _country = __webpack_require__(304);
	
	var _state = __webpack_require__(340);
	
	var _city = __webpack_require__(302);
	
	var _institution = __webpack_require__(314);
	
	var _institution_unit = __webpack_require__(316);
	
	var _literacy = __webpack_require__(322);
	
	var _modality = __webpack_require__(324);
	
	var _registration_status = __webpack_require__(334);
	
	var _event = __webpack_require__(310);
	
	var _knowledge_area = __webpack_require__(318);
	
	var _place = __webpack_require__(330);
	
	var _field = __webpack_require__(312);
	
	var _criteria = __webpack_require__(306);
	
	var _paper_status = __webpack_require__(326);
	
	var _evaluation_type = __webpack_require__(308);
	
	var _paper_type = __webpack_require__(328);
	
	var _layout = __webpack_require__(320);
	
	var _signature = __webpack_require__(338);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = [].concat((0, _toConsumableArray3.default)(_auth.routes), (0, _toConsumableArray3.default)(_user.routes), (0, _toConsumableArray3.default)(_role.routes), (0, _toConsumableArray3.default)(_registration.routes), (0, _toConsumableArray3.default)(_country.routes), (0, _toConsumableArray3.default)(_state.routes), (0, _toConsumableArray3.default)(_city.routes), (0, _toConsumableArray3.default)(_institution.routes), (0, _toConsumableArray3.default)(_institution_unit.routes), (0, _toConsumableArray3.default)(_literacy.routes), (0, _toConsumableArray3.default)(_modality.routes), (0, _toConsumableArray3.default)(_registration_status.routes), (0, _toConsumableArray3.default)(_event.routes), (0, _toConsumableArray3.default)(_knowledge_area.routes), (0, _toConsumableArray3.default)(_place.routes), (0, _toConsumableArray3.default)(_field.routes), (0, _toConsumableArray3.default)(_criteria.routes), (0, _toConsumableArray3.default)(_paper_status.routes), (0, _toConsumableArray3.default)(_evaluation_type.routes), (0, _toConsumableArray3.default)(_paper_type.routes), (0, _toConsumableArray3.default)(_layout.routes), (0, _toConsumableArray3.default)(_signature.routes));

/***/ }),
/* 347 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var AUTHOR_TYPE_AUTOR = exports.AUTHOR_TYPE_AUTOR = 'autor';
	var AUTHOR_TYPE_CO_ORIENTADOR = exports.AUTHOR_TYPE_CO_ORIENTADOR = 'co_orientador';
	var AUTHOR_TYPE_ORIENTADOR = exports.AUTHOR_TYPE_ORIENTADOR = 'orientador';
	
	var EVALUATION_TYPE_WEB = exports.EVALUATION_TYPE_WEB = 'avaliacao_web';
	var EVALUATION_TYPE_INLOCO = exports.EVALUATION_TYPE_INLOCO = 'avaliacao_inloco';
	
	var MODALITY_AVALIADOR = exports.MODALITY_AVALIADOR = 'avaliador';
	var MODALITY_PARTICIPANTE = exports.MODALITY_PARTICIPANTE = 'participante';
	var MODALITY_EVENTO_PRINCIPAL = exports.MODALITY_EVENTO_PRINCIPAL = 'evento_principal';
	var MODALITY_PROFISSIONAL = exports.MODALITY_PROFISSIONAL = 'profissional';
	var MODALITY_PROPONENTE = exports.MODALITY_PROPONENTE = 'proponente';
	
	var PAPER_STATUS_ACEITO = exports.PAPER_STATUS_ACEITO = 'aceito';
	var PAPER_STATUS_AGUARDANDO_PUBLICACAO = exports.PAPER_STATUS_AGUARDANDO_PUBLICACAO = 'aguardando_publicacao';
	var PAPER_STATUS_APROVADO_TRIAGEM = exports.PAPER_STATUS_APROVADO_TRIAGEM = 'aprovado_pela_triagem';
	var PAPER_STATUS_ATRIBUIDO = exports.PAPER_STATUS_ATRIBUIDO = 'atribuido';
	var PAPER_STATUS_AVALIADO = exports.PAPER_STATUS_AVALIADO = 'avaliado';
	var PAPER_STATUS_CANCELADO = exports.PAPER_STATUS_CANCELADO = 'cancelado';
	var PAPER_STATUS_EM_AVALIACAO = exports.PAPER_STATUS_EM_AVALIACAO = 'em_avaliacao';
	var PAPER_STATUS_FINALIZADO = exports.PAPER_STATUS_FINALIZADO = 'finalizado';
	var PAPER_STATUS_NAO_DESIGNADO = exports.PAPER_STATUS_NAO_DESIGNADO = 'nao_designado';
	var PAPER_STATUS_NOTIFICADO = exports.PAPER_STATUS_NOTIFICADO = 'notificado';
	var PAPER_STATUS_PUBLICADO = exports.PAPER_STATUS_PUBLICADO = 'publicado';
	var PAPER_STATUS_REJEITADO = exports.PAPER_STATUS_REJEITADO = 'rejeitado';
	var REGISTRATION_REPROVADO = exports.REGISTRATION_REPROVADO = 'reprovado';
	var REGISTRATION_REPROVADO_TRIAGEM = exports.REGISTRATION_REPROVADO_TRIAGEM = 'reprovado_pela_triagem';
	var REGISTRATION_SUBSTITUIDO = exports.REGISTRATION_SUBSTITUIDO = 'substituido';

/***/ }),
/* 348 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _messages = __webpack_require__(350);
	
	var _messages2 = _interopRequireDefault(_messages);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (http, router) {
	  http.interceptors.response.use(function (response) {
	    return _messages2.default.success(response);
	  }, function (error) {
	    return _messages2.default.error(error, router);
	  });
	};

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(27);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _typeof2 = __webpack_require__(38);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _authService = __webpack_require__(61);
	
	var authService = _interopRequireWildcard(_authService);
	
	var _lodash = __webpack_require__(3);
	
	var _sweetalert = __webpack_require__(42);
	
	var _sweetalert2 = _interopRequireDefault(_sweetalert);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var devEnvironment = ("production") === 'development';
	
	exports.default = {
	  success: function success(response) {
	    return response;
	  },
	  error: function error(_error, router) {
	    var swalData = {
	      type: 'warning',
	      title: 'Atenção',
	      message: 'Falha ao realizar operação'
	    };
	    var logoutUser = false;
	
	    try {
	      if (_error.toString().includes('timeout')) {
	        swalData.message = 'A sua solicitação está demorando muito, tente novamente mais tarde';
	        if (devEnvironment) {
	          console.error('[API TIMEOUT]');
	        }
	      } else {
	        var status = (0, _lodash.get)(_error, 'response.status');
	
	        var responseData = (0, _lodash.get)(_error, 'response.data') || 'Falha ao realizar operação';
	
	        if ([401, 403].indexOf(status) > -1) {
	          var responseMessage = (0, _lodash.get)(responseData, 'message');
	          var responseError = (0, _lodash.get)(responseData, 'error');
	
	          if (responseMessage && responseMessage === 'Token has expired') {
	            logoutUser = true;
	            swalData.message = 'Sua sessão expirou, faça login novamente';
	          } else {
	            swalData.message = responseError;
	          }
	        }
	
	        if ([400, 422].indexOf(status) > -1) {
	          var _responseError = (0, _lodash.get)(responseData, 'error');
	          if (typeof _responseError === 'string') {
	            swalData.message = _responseError;
	          }
	          if ((typeof _responseError === 'undefined' ? 'undefined' : (0, _typeof3.default)(_responseError)) === 'object') {
	            var errors = [];
	            for (_error in _responseError) {
	              if ((0, _typeof3.default)(_responseError[_error]) === 'object' && _responseError[_error].length > 0) {
	                errors.push(_responseError[_error][0]);
	              }
	            }
	            swalData.message = errors.join('<br>');
	          }
	        }
	
	        if ([500].indexOf(status) > -1) {
	          swalData.message = 'Foi encontrado um erro ao processar a sua operação, por favor tente novamente mais tarde';
	          swalData.type = 'error';
	        }
	
	        if ([503].indexOf(status) > -1) {
	          swalData.message = 'O sistema está em processo de atualização, por favor tente novamente mais tarde';
	          swalData.type = 'error';
	        }
	      }
	
	      (0, _sweetalert2.default)({ title: swalData.title, html: swalData.message, type: swalData.type });
	
	      if (logoutUser) {
	        authService.logout().then(function () {
	          return router.push({ name: 'login' });
	        });
	      }
	    } catch (e) {
	      (0, _sweetalert2.default)({
	        title: swalData.title,
	        html: 'Aconteceu um erro de comunicação, tente novamente mais tarde',
	        type: swalData.type
	      });
	      if (devEnvironment) {
	        console.error('[API CONNECTION ERROR]');
	      }
	    }
	    return _promise2.default.reject(_error);
	  }
	};

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = install;
	
	var _vuex = __webpack_require__(51);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function install(Vue) {
	  Vue.prototype.$can = function (param) {
	    if (!param) {
	      return false;
	    }
	    return _vuex2.default.getters.permissions.some(function (item) {
	      return item.name === param;
	    });
	  };
	}

/***/ }),
/* 352 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (to, from, next) {};

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(446);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(444);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _vuex = __webpack_require__(51);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _bus = __webpack_require__(4);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	var _storage = __webpack_require__(103);
	
	var _sweetalert = __webpack_require__(42);
	
	var _sweetalert2 = _interopRequireDefault(_sweetalert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var needAuth = function needAuth(route) {
	  return route.meta.auth !== false;
	};
	
	var hasPermission = function hasPermission(route) {
	  var permissionName = route.meta.permission || route.name;
	  return _vuex2.default.getters.permissions.some(function (item) {
	    return item.name === permissionName;
	  });
	};
	
	exports.default = function () {
	  var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(to, from, next) {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            window.scrollTo(0, 0);
	
	            _bus2.default.$emit('show-loader');
	
	            setTimeout((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	              var token, user, permissions, roles, login;
	              return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                  switch (_context.prev = _context.next) {
	                    case 0:
	                      if (needAuth(to)) {
	                        _context.next = 2;
	                        break;
	                      }
	
	                      return _context.abrupt('return', next());
	
	                    case 2:
	                      _context.next = 4;
	                      return (0, _storage.get)('token');
	
	                    case 4:
	                      token = _context.sent;
	                      _context.next = 7;
	                      return (0, _storage.get)('user');
	
	                    case 7:
	                      user = _context.sent;
	                      _context.next = 10;
	                      return (0, _storage.get)('permissions');
	
	                    case 10:
	                      permissions = _context.sent;
	                      _context.next = 13;
	                      return (0, _storage.get)('roles');
	
	                    case 13:
	                      roles = _context.sent;
	
	                      if (token) {
	                        _context.next = 16;
	                        break;
	                      }
	
	                      return _context.abrupt('return', next({ name: 'auth' }));
	
	                    case 16:
	                      login = { token: token, user: user, permissions: permissions, roles: roles };
	                      _context.next = 19;
	                      return _vuex2.default.dispatch('login', login);
	
	                    case 19:
	                      if (hasPermission(to)) {
	                        _context.next = 23;
	                        break;
	                      }
	
	                      (0, _sweetalert2.default)({
	                        title: 'Atenção',
	                        html: 'Acesso negado a esse recurso',
	                        type: 'warning'
	                      });
	                      console.log('Acesso negado', to.name);
	                      return _context.abrupt('return', next(false));
	
	                    case 23:
	                      return _context.abrupt('return', next());
	
	                    case 24:
	                    case 'end':
	                      return _context.stop();
	                  }
	                }
	              }, _callee, undefined);
	            })), 300);
	
	          case 3:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, undefined);
	  }));
	
	  return function (_x, _x2, _x3) {
	    return _ref.apply(this, arguments);
	  };
	}();

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(19);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(794);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _routes = __webpack_require__(355);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _beforeEach = __webpack_require__(353);
	
	var _beforeEach2 = _interopRequireDefault(_beforeEach);
	
	var _afterEach = __webpack_require__(352);
	
	var _afterEach2 = _interopRequireDefault(_afterEach);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	var router = new _vueRouter2.default({
	  mode: 'history',
	  routes: _routes2.default,
	  linkActiveClass: 'active'
	});
	
	router.beforeEach(_beforeEach2.default);
	
	router.afterEach(_afterEach2.default);
	
	exports.default = router;

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(32);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _app = __webpack_require__(102);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var root = [{ path: '/', redirect: '/event' }];
	
	exports.default = [].concat(root, (0, _toConsumableArray3.default)(_app.routes));

/***/ }),
/* 356 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CONFIG = exports.CONFIG = 'CONFIG';
	
	var COLLAPSE_MENU = exports.COLLAPSE_MENU = 'COLLAPSE_MENU';
	
	var AUTH_USER = exports.AUTH_USER = 'AUTH_USER';
	var AUTH_PERMISSIONS = exports.AUTH_PERMISSIONS = 'AUTH_PERMISSIONS';
	var AUTH_ROLES = exports.AUTH_ROLES = 'AUTH_ROLES';
	var AUTH_TOKEN = exports.AUTH_TOKEN = 'AUTH_TOKEN';
	
	var LOADER_SHOW = exports.LOADER_SHOW = 'LOADER_SHOW';
	
	var LIST_INIT = exports.LIST_INIT = 'LIST_INIT';
	var LIST_ORIGINAL_DATA = exports.LIST_ORIGINAL_DATA = 'LIST_ORIGINAL_DATA';
	var LIST_DATA = exports.LIST_DATA = 'LIST_DATA';
	var LIST_TOTAL = exports.LIST_TOTAL = 'LIST_TOTAL';
	var LIST_PER_PAGE = exports.LIST_PER_PAGE = 'LIST_PER_PAGE';
	var LIST_CURRENT_PAGE = exports.LIST_CURRENT_PAGE = 'LIST_CURRENT_PAGE';
	var LIST_FILTERS = exports.LIST_FILTERS = 'LIST_FILTERS';

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Header = __webpack_require__(645);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Sidebar = __webpack_require__(646);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _vuex = __webpack_require__(9);
	
	var _bus = __webpack_require__(4);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'App',
	  components: { AppHeader: _Header2.default, AppSidebar: _Sidebar2.default },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['isLogged', 'isLoading'])),
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['showLoader', 'hideLoader'])),
	  mounted: function mounted() {
	    var _this = this;
	
	    _bus2.default.$on('show-loader', function () {
	      return _this.showLoader();
	    });
	    _bus2.default.$on('hide-loader', function () {
	      return _this.hideLoader();
	    });
	  }
	};

/***/ }),
/* 358 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'form-cancel-button',
	  props: ['routeName']
	};

/***/ }),
/* 359 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'form-save-button',
	  props: ['eventClick', 'isDisabled', 'isSubmitted'],
	  methods: {
	    onSend: function onSend() {
	      this.eventClick();
	    }
	  }
	};

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vueBase64FileUpload = __webpack_require__(640);
	
	var _vueBase64FileUpload2 = _interopRequireDefault(_vueBase64FileUpload);
	
	var _sweetalert = __webpack_require__(42);
	
	var _sweetalert2 = _interopRequireDefault(_sweetalert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'form-single-upload',
	  components: { VueBase64FileUpload: _vueBase64FileUpload2.default },
	  props: {
	    model: {
	      default: function _default() {
	        return {};
	      },
	      type: Object
	    },
	    maxFileSize: { default: 5, type: Number },
	    acceptedTypes: { default: '*' },
	    placeholder: { default: 'Clique aqui para selecionar um arquivo' },
	    isInvalid: { default: false, type: Boolean }
	  },
	  data: function data() {
	    return {
	      isAvailable: true,
	      isInvalidType: false,
	      file: {
	        name: '',
	        size: '',
	        base64: '',
	        type: ''
	      }
	    };
	  },
	
	  created: function created() {
	    this.file.name = this.model.name;
	    if (this.file.name && this.file.name.length > 0) {
	      this.isAvailable = false;
	    } else {
	      this.$emit('update:isInvalid', true);
	    }
	  },
	  methods: {
	    onFile: function onFile(file) {
	      if (this.acceptedTypes === '*' || file.type.match(this.acceptedTypes)) {
	        this.file.type = file.type;
	        this.file.name = file.name;
	        this.file.size = file.size;
	        this.isInvalidType = false;
	        this.$emit('update:model', this.file);
	        this.$emit('update:isInvalid', false);
	      } else {
	        this.isInvalidType = true;
	        this.$emit('update:isInvalid', true);
	        (0, _sweetalert2.default)({
	          title: 'Atenção - Formato inválido',
	          text: 'O formato do arquivo selecionado é inválido, só são os formatos:' + this.acceptedTypes + '.',
	          type: 'warning'
	        });
	      }
	    },
	    onLoad: function onLoad(dataUri) {
	      if (!this.isInvalidType) {
	        this.file.base64 = dataUri;
	        this.isAvailable = false;
	        this.$emit('update:model', this.file);
	        this.$emit('update:isInvalid', false);
	      }
	    },
	    onSizeExceeded: function onSizeExceeded() {
	      (0, _sweetalert2.default)({
	        title: 'Atenção - Tamanho excedido',
	        text: 'O tamanho máximo do arquivo é de ' + this.maxFileSize + ' mb.',
	        type: 'warning'
	      });
	    },
	    onDelete: function onDelete() {
	      this.file = {
	        name: '',
	        size: '',
	        base64: '',
	        type: ''
	      };
	      this.$emit('update:model', {});
	      this.$emit('update:isInvalid', true);
	      this.reset();
	    },
	    reset: function reset() {
	      this.isAvailable = false;
	      var _this = this;
	      setTimeout(function () {
	        _this.isAvailable = true;
	      });
	    }
	  }
	};

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _tinymce = __webpack_require__(638);
	
	var _tinymce2 = _interopRequireDefault(_tinymce);
	
	__webpack_require__(637);
	
	__webpack_require__(551);
	
	__webpack_require__(635);
	
	__webpack_require__(555);
	
	__webpack_require__(559);
	
	__webpack_require__(563);
	
	__webpack_require__(567);
	
	__webpack_require__(571);
	
	__webpack_require__(575);
	
	__webpack_require__(579);
	
	__webpack_require__(583);
	
	__webpack_require__(587);
	
	__webpack_require__(591);
	
	__webpack_require__(595);
	
	__webpack_require__(599);
	
	__webpack_require__(603);
	
	__webpack_require__(607);
	
	__webpack_require__(611);
	
	__webpack_require__(615);
	
	__webpack_require__(619);
	
	__webpack_require__(623);
	
	__webpack_require__(627);
	
	__webpack_require__(631);
	
	__webpack_require__(553);
	
	__webpack_require__(557);
	
	__webpack_require__(561);
	
	__webpack_require__(565);
	
	__webpack_require__(569);
	
	__webpack_require__(573);
	
	__webpack_require__(577);
	
	__webpack_require__(581);
	
	__webpack_require__(585);
	
	__webpack_require__(589);
	
	__webpack_require__(593);
	
	__webpack_require__(597);
	
	__webpack_require__(601);
	
	__webpack_require__(605);
	
	__webpack_require__(609);
	
	__webpack_require__(613);
	
	__webpack_require__(617);
	
	__webpack_require__(621);
	
	__webpack_require__(625);
	
	__webpack_require__(629);
	
	__webpack_require__(633);
	
	__webpack_require__(514);
	
	__webpack_require__(513);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'tinymce',
	  props: {
	    id: {
	      type: String,
	      required: true
	    },
	    htmlClass: { default: '', type: String },
	    value: { default: '' },
	    plugins: {
	      default: function _default() {
	        return ['advlist autolink lists link image charmap print preview hr anchor pagebreak', 'searchreplace wordcount visualblocks visualchars code fullscreen', 'insertdatetime media nonbreaking save table contextmenu directionality', 'template paste toc hr'];
	      },
	      type: Array
	    },
	    toolbar1: {
	      default: 'code | formatselect | bold italic strikethrough | link table | alignleft aligncenter alignright alignjustify | numlist bullist | outdent indent | removeformat',
	      type: String
	    },
	    toolbar2: { default: '', type: String },
	    configs: {
	      default: function _default() {
	        return {};
	      },
	      type: Object
	    }
	  },
	  data: function data() {
	    return {
	      content: '',
	      editor: null,
	      cTinyMce: null,
	      checkerTimeout: null,
	      isTyping: false
	    };
	  },
	  mounted: function mounted() {
	    this.content = this.value || '';
	    this.init();
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.editor.destroy();
	  },
	
	  watch: {
	    value: function value(newValue) {
	      if (!this.isTyping) {
	        if (this.editor !== null) {
	          this.editor.setContent(newValue);
	        } else {
	          this.content = newValue;
	        }
	      }
	    }
	  },
	  methods: {
	    init: function init() {
	      var _this = this;
	
	      var options = {
	        selector: '#' + this.id,
	        skin: false,
	        toolbar1: this.toolbar1,
	        toolbar2: this.toolbar2,
	        plugins: this.plugins,
	        branding: false,
	        menubar: false,
	        paste_auto_cleanup_on_paste: true,
	        paste_remove_styles: true,
	        paste_remove_styles_if_webkit: true,
	        paste_strip_class_attributes: true,
	        indentation: '30px',
	        init_instance_callback: function init_instance_callback(editor) {
	          _this.editor = editor;
	          editor.on('KeyUp', function (e) {
	            _this.submitNewContent();
	          });
	          editor.on('Change', function (e) {
	            if (_this.editor.getContent() !== _this.value) {
	              _this.submitNewContent();
	            }
	          });
	        },
	        setup: function setup(editor) {
	          _this.editor = editor;
	          editor.on('Init', function (e) {
	            editor.setContent(_this.content);
	            _this.$emit('input', _this.content);
	          });
	        }
	      };
	      _tinymce2.default.init(this.concatAssciativeArrays(options, this.configs));
	    },
	    concatAssciativeArrays: function concatAssciativeArrays(array1, array2) {
	      if (array2.length === 0) {
	        return array1;
	      }
	      if (array1.length === 0) {
	        return array2;
	      }
	      var dest = [];
	      for (var key in array1) {
	        dest[key] = array1[key];
	      }
	      for (var _key in array2) {
	        dest[_key] = array2[_key];
	      }
	      return dest;
	    },
	    submitNewContent: function submitNewContent() {
	      var _this2 = this;
	
	      this.isTyping = true;
	      if (this.checkerTimeout !== null) {
	        clearTimeout(this.checkerTimeout);
	      }
	      this.checkerTimeout = setTimeout(function () {
	        _this2.isTyping = false;
	      }, 300);
	
	      this.$emit('input', this.editor.getContent());
	    }
	  }
	};

/***/ }),
/* 362 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'validation-message',
	  props: {
	    message: { default: 'Esse campo é obrigatório', type: String }
	  }
	};

/***/ }),
/* 363 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'back-button',
	  props: {
	    size: {
	      default: 'medium',
	      type: String
	    },
	    text: {
	      default: 'Voltar',
	      type: String
	    },
	    icon: {
	      default: 'fa fa-arrow-left',
	      type: String
	    }
	  },
	  methods: {
	    goBack: function goBack() {
	      this.$router.go(-1);
	    }
	  }
	};

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _bus = __webpack_require__(4);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'list-delete-button',
	  props: ['item', 'domain'],
	  methods: {
	    onDestroy: function onDestroy(item) {
	      _bus2.default.$emit('list-destroy-item', item);
	    }
	  }
	};

/***/ }),
/* 365 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'list-edit-button',
	  props: ['routeName', 'domain', 'item']
	};

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BackButton = __webpack_require__(643);
	
	var _BackButton2 = _interopRequireDefault(_BackButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { BackButton: _BackButton2.default },
	  name: 'list-header',
	  props: ['title', 'storeRouteName', 'editRouteName', 'backRoute', 'item'],
	  computed: {
	    domain: function domain() {
	      if (this.storeRouteName) {
	        return this.storeRouteName.split('.')[0];
	      }
	      if (this.editRouteName) {
	        return this.editRouteName.split('.')[0];
	      }
	      return '';
	    },
	    canStore: function canStore() {
	      return this.$can(this.domain + '.store');
	    },
	    canUpdate: function canUpdate() {
	      return this.$can(this.domain + '.update');
	    }
	  }
	};

/***/ }),
/* 367 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'list-empty',
	  props: {
	    title: { default: '', Type: String },
	    description: { default: 'Nenhum registro encontrado', Type: String },
	    type: { default: 'info', Type: String },
	    showCloseButton: { default: false, Type: Boolean },
	    showIcon: { default: true, Type: Boolean }
	  }
	};

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(38);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(9);
	
	var _lodash = __webpack_require__(3);
	
	var _bus = __webpack_require__(4);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	var _restfulService = __webpack_require__(6);
	
	var restfulService = _interopRequireWildcard(_restfulService);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'list-main',
	  props: {
	    isPaginationVisible: { default: true }
	  },
	  data: function data() {
	    return {
	      currentPage: 1
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['listStore']), {
	    pages: function pages() {
	      var _this = this;
	
	      var pages = [20, 50, 100, 500, this.listStore.listTotal];
	      return pages.filter(function (item) {
	        return item <= _this.listStore.listTotal;
	      });
	    }
	  }),
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['setListStoreClear', 'setListInit', 'setListOriginalData', 'setListData', 'setListFilters', 'setListCurrentPage', 'setListPerPage', 'setListTotal']), {
	    onListInit: function onListInit(obj, callback) {
	      var _this2 = this;
	
	      _bus2.default.$emit('show-loader');
	      this.onSearchRequest(obj, true, function (response) {
	        _this2.setListInit({ init: obj, data: response }).then(function () {
	          if (typeof callback === 'function') {
	            _bus2.default.$emit('hide-loader');
	            callback(response);
	          }
	        });
	      });
	    },
	    onSearchRequest: function onSearchRequest(obj, first, callback) {
	      var _this3 = this;
	
	      _bus2.default.$emit('show-loader');
	      var searchObj = this.listStore.init;
	      if (!first) {
	        searchObj = (0, _lodash.merge)({}, searchObj, obj);
	      } else {
	        searchObj = obj;
	      }
	      searchObj.customSearch = searchObj.customSearch || false;
	      restfulService.search(searchObj.domain, searchObj.route, searchObj.data, searchObj.columns, searchObj.relations, searchObj.page, searchObj.perPage, searchObj.customSearch).then(function (response) {
	        var list = [];
	        if (response !== null && response !== undefined && (typeof response === 'undefined' ? 'undefined' : (0, _typeof3.default)(response)) === 'object') {
	          if (!response.data) {
	            list = response;
	            _this3.setListTotal(response.length);
	            _this3.setListPerPage(response.length);
	          } else {
	            list = response.data;
	            _this3.setListTotal(response.total);
	          }
	        }
	        if (list.length > 0) {
	          if (typeof obj.processResponse === 'function') {
	            list = obj.processResponse(list);
	          }
	        }
	        if (typeof callback === 'function') {
	          callback(list);
	          setTimeout(function () {
	            _bus2.default.$emit('hide-loader');
	          }, 400);
	        }
	      }).catch(function (err) {
	        _bus2.default.$emit('hide-loader');
	        console.log('erro na listagem', err);
	      });
	    },
	    onUpdateListData: function onUpdateListData(list, callback) {
	      var _this4 = this;
	
	      this.onFilter(null, list, function (newList) {
	        _this4.setListData(newList);
	        if (typeof callback === 'function') {
	          callback();
	        }
	      });
	    },
	    onFilter: function onFilter(filters, data, callback) {
	      var _this5 = this;
	
	      filters = filters || this.listStore.listFilters;
	      this.setListFilters(filters);
	      var searchObj = this.listStore.init;
	      searchObj.data = data || {};
	      this.onSearchRequest(searchObj, false, function (response) {
	        _this5.setListData(response);
	        if (typeof callback === 'function') {
	          callback();
	        }
	      });
	    },
	    onFilterClean: function onFilterClean(filters, data, callback) {
	      var _this6 = this;
	
	      this.setListFilters(filters || {});
	      this.setListCurrentPage(1);
	      var searchObj = this.listStore.init;
	      if ((0, _lodash.isEmpty)(data)) {
	        delete searchObj.data;
	      } else {
	        searchObj.data = data;
	      }
	      this.onSearchRequest(searchObj, false, function (response) {
	        _this6.setListData(response);
	        if (typeof callback === 'function') {
	          callback();
	        }
	      });
	    },
	    onDestroyItem: function onDestroyItem(item, callback) {
	      var _this7 = this;
	
	      var id = item.id;
	      restfulService.destroy(this.listStore.init.domain, null, id).then(function () {
	        _this7.setListOriginalData(_this7.listStore.listOriginalData.filter(function (obj) {
	          return obj.id !== id;
	        }));
	        _this7.onPaginatorChangePage(_this7.listStore.listCurrentPage);
	        _bus2.default.$emit('hide-loader');
	        if (typeof callback === 'function') {
	          callback();
	        }
	      }).catch(function (e) {
	        console.log(e);
	        _bus2.default.$emit('hide-loader');
	        if (typeof callback === 'function') {
	          callback();
	        }
	      });
	    },
	    onPaginatorChangeSize: function onPaginatorChangeSize(val) {
	      this.setListPerPage(val);
	      this.onPaginatorChangePage(1, val);
	    },
	    onPaginatorChangePage: function onPaginatorChangePage(page, perPage) {
	      var _this8 = this;
	
	      this.setListCurrentPage(page);
	      this.currentPage = page;
	      var searchObj = this.listStore.init;
	      if (page && page !== undefined && page !== null && page > 0) {
	        searchObj.page = page;
	      }
	      if (perPage && perPage !== undefined && perPage !== null && perPage > 0) {
	        searchObj.perPage = perPage;
	      }
	      this.onSearchRequest(searchObj, false, function (response) {
	        _this8.setListData(response);
	      });
	    }
	  }),
	  mounted: function mounted() {
	    var _this9 = this;
	
	    _bus2.default.$on('list-init', function (obj, callback) {
	      return _this9.onListInit(obj, callback);
	    });
	    _bus2.default.$on('list-data-update', function (list, callback) {
	      return _this9.onUpdateListData(list, callback);
	    });
	    _bus2.default.$on('list-filter', function (filters, data, callback) {
	      return _this9.onFilter(filters, data, callback);
	    });
	    _bus2.default.$on('list-filter-clean', function (filters, data, callback) {
	      return _this9.onFilterClean(filters, data, callback);
	    });
	    _bus2.default.$on('list-destroy-item', function (item, callback) {
	      return _this9.onDestroyItem(item, callback);
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    _bus2.default.$off('list-init');
	    _bus2.default.$off('list-data-update');
	    _bus2.default.$off('list-filter');
	    _bus2.default.$off('list-filter-clean');
	    _bus2.default.$off('list-destroy-item');
	  }
	};

/***/ }),
/* 369 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'list-show-button',
	  props: ['routeName', 'item']
	};

/***/ }),
/* 370 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'list-yes-no',
	  props: ['value']
	};

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(9);
	
	var _restfulService = __webpack_require__(6);
	
	var restfulService = _interopRequireWildcard(_restfulService);
	
	var _notifyService = __webpack_require__(8);
	
	var notifyService = _interopRequireWildcard(_notifyService);
	
	var _authService = __webpack_require__(61);
	
	var authService = _interopRequireWildcard(_authService);
	
	var _lodash = __webpack_require__(3);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app-header',
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['currentUser', 'collapseMenu'])),
	  data: function data() {
	    return {
	      isSubmitted: false,
	      showChangePasswordModal: false,
	      changePassword: {
	        current_password: '',
	        password: '',
	        password_confirmation: ''
	      }
	    };
	  },
	
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['setCollapseMenu']), {
	    handleDropdownCommand: function handleDropdownCommand(command) {
	      if (command === 'changePassword') {
	        this.showChangePasswordModal = true;
	      }
	      if (command === 'logout') {
	        this.onLogout();
	      }
	    },
	    toggleCollapseMenu: function toggleCollapseMenu() {
	      this.setCollapseMenu(!this.collapseMenu);
	    },
	    onChangePassword: function onChangePassword() {
	      var _this = this;
	
	      this.isSubmitted = true;
	      var data = (0, _lodash.clone)(this.changePassword);
	      restfulService.put('user', this.currentUser.id, 'change-password', data).then(function (_) {
	        _this.isSubmitted = false;
	        _this.showChangePasswordModal = false;
	        _this.changePassword = {};
	        notifyService.success({ hideLoader: true, message: 'A senha foi alterada' });
	      }).catch(function (e) {
	        _this.isSubmitted = false;
	        console.log(e);
	      });
	    },
	    onLogout: function onLogout() {
	      var _this2 = this;
	
	      authService.logout().then(function () {
	        _this2.$router.push({ name: 'auth' });
	      });
	    }
	  })
	};

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app-sidebar',
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['isLogged', 'currentUser', 'permissions', 'collapseMenu'])),
	  data: function data() {
	    return {
	      activeIndex: '',
	      menu: [{
	        domain: 'event',
	        name: 'Eventos',
	        icon: 'fa fa-calendar',
	        children: [],
	        permission: false
	      }, {
	        domain: '1',
	        name: 'Conf Inscrições',
	        icon: 'fa fa-window-maximize',
	        permission: false,
	        children: [{
	          domain: 'literacy',
	          name: 'Escolaridade',
	          icon: 'fa fa-file-o',
	          permission: false
	        }, {
	          domain: 'modality',
	          name: 'Modalidades',
	          icon: 'fa fa-file-o',
	          permission: false
	        }, {
	          domain: 'registration_status',
	          name: 'Status de Inscrição',
	          icon: 'fa fa-file-o',
	          permission: false
	        }, {
	          domain: 'place',
	          name: 'Endereços',
	          icon: 'fa fa-file-o',
	          permission: false
	        }]
	      }, {
	        domain: '2',
	        name: 'Trabalhos',
	        icon: 'fa fa-window-maximize',
	        permission: false,
	        children: [{
	          domain: 'layout',
	          name: 'Layout Certificados',
	          icon: 'fa fa-file-o',
	          permission: false
	        }, {
	          domain: 'signature',
	          name: 'Assinatura Certificados',
	          icon: 'fa fa-file-o',
	          permission: false
	        }, {
	          domain: 'field',
	          name: 'Campos',
	          icon: 'fa fa-file-o',
	          permission: false
	        }, {
	          domain: 'criteria',
	          name: 'Critérios',
	          icon: 'fa fa-file-o',
	          permission: false
	        }, {
	          domain: 'paper_type',
	          name: 'Tipo de Trabalhos',
	          icon: 'fa fa-file-o',
	          permission: false
	        }, {
	          domain: 'paper_status',
	          name: 'Status Trabalhos',
	          icon: 'fa fa-file-o',
	          permission: false
	        }, {
	          domain: 'evaluation_type',
	          name: 'Tipo de Avaliação',
	          icon: 'fa fa-file-o',
	          permission: false
	        }]
	      }, {
	        domain: '3',
	        name: 'Administração',
	        icon: 'fa fa-window-maximize',
	        permission: false,
	        children: [{
	          domain: 'role',
	          name: 'Perfis de Usuário',
	          icon: 'fa fa-file-o',
	          permission: false
	        }, {
	          domain: 'user',
	          name: 'Usuários',
	          icon: 'fa fa-file-o',
	          permission: false
	        }]
	      }]
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    window.addEventListener('resize', this.handleResize);
	    this.menu.forEach(function (menu) {
	      menu.children.forEach(function (child) {
	        child.permission = _this.hasPermission(child.domain + '.index') || _this.hasPermission(child.domain + '.search');
	      });
	      if (menu.children.length === 0) {
	        menu.permission = _this.hasPermission(menu.domain + '.index') || _this.hasPermission(menu.domain + '.search');
	      } else {
	        menu.permission = !menu.children.some(function (child) {
	          return !child.permission;
	        });
	      }
	    });
	  },
	
	  watch: {
	    '$route.name': function $routeName(name) {
	      this.activeIndex = name;
	    }
	  },
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['setCollapseMenu']), {
	    handleResize: function handleResize() {
	      this.setCollapseMenu(document.documentElement.clientWidth < 1400);
	    },
	    hasPermission: function hasPermission(permission) {
	      return this.permissions.some(function (item) {
	        return item.name === permission;
	      });
	    }
	  })
	};

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _authService = __webpack_require__(61);
	
	var authService = _interopRequireWildcard(_authService);
	
	var _bus = __webpack_require__(4);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	var _lodash = __webpack_require__(3);
	
	var _validators = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = {
	  data: function data() {
	    return {
	      isSubmitted: false,
	      isLoadingData: true,
	      form: {
	        login: '',
	        password: ''
	      }
	    };
	  },
	
	  validations: {
	    form: {
	      login: {
	        required: _validators.required
	      },
	      password: {
	        required: _validators.required
	      }
	    }
	  },
	  mounted: function mounted() {
	    this.$refs.formLogin.focus();
	    _bus2.default.$emit('hide-loader');
	  },
	
	  methods: {
	    onLogin: function onLogin() {
	      var _this = this;
	
	      _bus2.default.$emit('show-loader');
	      this.isSubmitted = true;
	      var data = (0, _lodash.clone)(this.form);
	      authService.login(data).then(function () {
	        _this.isSubmitted = false;
	        _this.$router.push({ name: 'event.index' });
	      }).catch(function (e) {
	        _bus2.default.$emit('hide-loader');
	        _this.isSubmitted = false;
	        console.log(e);
	      });
	    }
	  }
	};

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Header = __webpack_require__(5);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _SaveButton = __webpack_require__(16);
	
	var _SaveButton2 = _interopRequireDefault(_SaveButton);
	
	var _CancelButton = __webpack_require__(14);
	
	var _CancelButton2 = _interopRequireDefault(_CancelButton);
	
	var _dataService = __webpack_require__(21);
	
	var _dataService2 = _interopRequireDefault(_dataService);
	
	var _restfulService = __webpack_require__(6);
	
	var restfulService = _interopRequireWildcard(_restfulService);
	
	var _notifyService = __webpack_require__(8);
	
	var notifyService = _interopRequireWildcard(_notifyService);
	
	var _lodash = __webpack_require__(3);
	
	var _validators = __webpack_require__(10);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ListHeader: _Header2.default, FormSaveButton: _SaveButton2.default, FormCancelButton: _CancelButton2.default },
	  data: function data() {
	    return {
	      isEdit: false,
	      isSubmitted: false,
	      isLoadingData: true,
	      form: {
	        state_id: '',
	        name: ''
	      },
	      dependencies: {}
	    };
	  },
	
	  validations: {
	    form: {
	      state_id: { required: _validators.required },
	      name: { required: _validators.required }
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.getDependencies();
	    var id = this.$route.params.id || null;
	    if (id) {
	      this.isEdit = true;
	      restfulService.get('city', null, id).then(function (response) {
	        _this.form = response;
	        _this.isLoadingData = false;
	      }).catch(function (e) {
	        console.log(e);
	        _this.isLoadingData = false;
	      });
	    } else {
	      this.isLoadingData = false;
	    }
	  },
	
	  methods: {
	    getDependencies: function getDependencies() {
	      var _this2 = this;
	
	      _dataService2.default.get([{ domain: 'state' }]).then(function (result) {
	        _this2.dependencies = result;
	      });
	    },
	    onSend: function onSend() {
	      var _this3 = this;
	
	      this.isSubmitted = true;
	      var data = (0, _lodash.clone)(this.form);
	      restfulService.save('city', null, null, data).then(function () {
	        notifyService.success({ hideLoader: true });
	        _this3.isSubmitted = false;
	        _this3.$router.push({ name: 'city.index' });
	      }).catch(function (e) {
	        _this3.isSubmitted = false;
	        console.log(e);
	      });
	    }
	  }
	};

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Main = __webpack_require__(11);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Header = __webpack_require__(5);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _EditButton = __webpack_require__(13);
	
	var _EditButton2 = _interopRequireDefault(_EditButton);
	
	var _DeleteButton = __webpack_require__(12);
	
	var _DeleteButton2 = _interopRequireDefault(_DeleteButton);
	
	var _bus = __webpack_require__(4);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	var _lodash = __webpack_require__(3);
	
	var _vuex = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ListMain: _Main2.default, ListHeader: _Header2.default, ListEditButton: _EditButton2.default, ListDeleteButton: _DeleteButton2.default },
	  data: function data() {
	    return {
	      isLoadingData: true,
	      filters: {},
	      dependencies: {}
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    _bus2.default.$emit('list-init', { domain: 'city', relations: ['state'] }, function () {
	      _this.isLoadingData = false;
	    });
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['listStore'])),
	  methods: {
	    onFilter: function onFilter() {
	      var searchData = {};
	      if (!(0, _lodash.isEmpty)(this.filters.name)) {
	        searchData.name = {
	          'ilike': '%' + this.filters.name + '%'
	        };
	      }
	      _bus2.default.$emit('list-filter', this.filters, searchData);
	    },
	    onFilterClean: function onFilterClean() {
	      this.filters = {};
	      _bus2.default.$emit('list-filter-clean', this.filters);
	    },
	    onDestroy: function onDestroy(item) {
	      _bus2.default.$emit('list-destroy-item', item);
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.listStore.listData = [];
	  }
	};

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Header = __webpack_require__(5);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _SaveButton = __webpack_require__(16);
	
	var _SaveButton2 = _interopRequireDefault(_SaveButton);
	
	var _CancelButton = __webpack_require__(14);
	
	var _CancelButton2 = _interopRequireDefault(_CancelButton);
	
	var _restfulService = __webpack_require__(6);
	
	var restfulService = _interopRequireWildcard(_restfulService);
	
	var _notifyService = __webpack_require__(8);
	
	var notifyService = _interopRequireWildcard(_notifyService);
	
	var _lodash = __webpack_require__(3);
	
	var _validators = __webpack_require__(10);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ListHeader: _Header2.default, FormSaveButton: _SaveButton2.default, FormCancelButton: _CancelButton2.default },
	  data: function data() {
	    return {
	      isEdit: false,
	      isSubmitted: false,
	      isLoadingData: true,
	      form: {
	        name: '',
	        nationality: ''
	      },
	      dependencies: {}
	    };
	  },
	
	  validations: {
	    form: {
	      name: { required: _validators.required },
	      nationality: { required: _validators.required }
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    var id = this.$route.params.id || null;
	    if (id) {
	      this.isEdit = true;
	      restfulService.get('country', null, id).then(function (response) {
	        _this.form = response;
	        _this.isLoadingData = false;
	      }).catch(function (e) {
	        console.log(e);
	        _this.isLoadingData = false;
	      });
	    } else {
	      this.isLoadingData = false;
	    }
	  },
	
	  methods: {
	    onSend: function onSend() {
	      var _this2 = this;
	
	      this.isSubmitted = true;
	      var data = (0, _lodash.clone)(this.form);
	      restfulService.save('country', null, null, data).then(function () {
	        notifyService.success({ hideLoader: true });
	        _this2.isSubmitted = false;
	        _this2.$router.push({ name: 'country.index' });
	      }).catch(function (e) {
	        _this2.isSubmitted = false;
	        console.log(e);
	      });
	    }
	  }
	};

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Main = __webpack_require__(11);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Header = __webpack_require__(5);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _EditButton = __webpack_require__(13);
	
	var _EditButton2 = _interopRequireDefault(_EditButton);
	
	var _DeleteButton = __webpack_require__(12);
	
	var _DeleteButton2 = _interopRequireDefault(_DeleteButton);
	
	var _bus = __webpack_require__(4);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	var _lodash = __webpack_require__(3);
	
	var _vuex = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ListMain: _Main2.default, ListHeader: _Header2.default, ListEditButton: _EditButton2.default, ListDeleteButton: _DeleteButton2.default },
	  data: function data() {
	    return {
	      isLoadingData: true,
	      filters: {},
	      dependencies: {}
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    _bus2.default.$emit('list-init', { domain: 'country' }, function () {
	      _this.isLoadingData = false;
	    });
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['listStore'])),
	  methods: {
	    onFilter: function onFilter() {
	      var searchData = {};
	      if (!(0, _lodash.isEmpty)(this.filters.name)) {
	        searchData.name = {
	          'ilike': '%' + this.filters.name + '%'
	        };
	      }
	      _bus2.default.$emit('list-filter', this.filters, searchData);
	    },
	    onFilterClean: function onFilterClean() {
	      this.filters = {};
	      _bus2.default.$emit('list-filter-clean', this.filters);
	    },
	    onDestroy: function onDestroy(item) {
	      _bus2.default.$emit('list-destroy-item', item);
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.listStore.listData = [];
	  }
	};

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Header = __webpack_require__(5);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _SaveButton = __webpack_require__(16);
	
	var _SaveButton2 = _interopRequireDefault(_SaveButton);
	
	var _CancelButton = __webpack_require__(14);
	
	var _CancelButton2 = _interopRequireDefault(_CancelButton);
	
	var _restfulService = __webpack_require__(6);
	
	var restfulService = _interopRequireWildcard(_restfulService);
	
	var _notifyService = __webpack_require__(8);
	
	var notifyService = _interopRequireWildcard(_notifyService);
	
	var _lodash = __webpack_require__(3);
	
	var _validators = __webpack_require__(10);
	
	var _bus = __webpack_require__(4);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ListHeader: _Header2.default, FormSaveButton: _SaveButton2.default, FormCancelButton: _CancelButton2.default },
	  data: function data() {
	    return {
	      isEdit: false,
	      isSubmitted: false,
	      isLoadingData: true,
	      form: {
	        name: '',
	        description: '',
	        min_size: '',
	        max_size: '',
	        required: ''
	      },
	      dependencies: {
	        type: [{
	          value: 'number',
	          label: 'Numérico'
	        }, {
	          value: 'text',
	          label: 'Texto'
	        }]
	      }
	    };
	  },
	
	  validations: {
	    form: {
	      name: { required: _validators.required },
	      description: { required: _validators.required },
	      type: { required: _validators.required },
	      min_size: { required: _validators.required },
	      max_size: { required: _validators.required }
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    var id = this.$route.params.id || null;
	    if (id) {
	      this.isEdit = true;
	      restfulService.get('criteria', null, id).then(function (response) {
	        _this.form = response;
	        _this.isLoadingData = false;
	        _bus2.default.$emit('hide-loader');
	      }).catch(function (e) {
	        console.log(e);
	        _this.isLoadingData = false;
	        _bus2.default.$emit('hide-loader');
	      });
	    } else {
	      this.isLoadingData = false;
	      _bus2.default.$emit('hide-loader');
	    }
	  },
	
	  methods: {
	    onSend: function onSend() {
	      var _this2 = this;
	
	      this.isSubmitted = true;
	      var data = (0, _lodash.clone)(this.form);
	      restfulService.save('criteria', null, null, data).then(function () {
	        notifyService.success({ hideLoader: true });
	        _this2.isSubmitted = false;
	        _this2.$router.push({ name: 'criteria.index' });
	      }).catch(function (e) {
	        _this2.isSubmitted = false;
	        console.log(e);
	      });
	    }
	  }
	};

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Main = __webpack_require__(11);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Header = __webpack_require__(5);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _EditButton = __webpack_require__(13);
	
	var _EditButton2 = _interopRequireDefault(_EditButton);
	
	var _DeleteButton = __webpack_require__(12);
	
	var _DeleteButton2 = _interopRequireDefault(_DeleteButton);
	
	var _YesNo = __webpack_require__(254);
	
	var _YesNo2 = _interopRequireDefault(_YesNo);
	
	var _bus = __webpack_require__(4);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	var _lodash = __webpack_require__(3);
	
	var _vuex = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ListMain: _Main2.default, ListHeader: _Header2.default, ListEditButton: _EditButton2.default, ListDeleteButton: _DeleteButton2.default, ListYesNo: _YesNo2.default },
	  data: function data() {
	    return {
	      isLoadingData: true,
	      filters: {},
	      dependencies: {}
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    _bus2.default.$emit('list-init', { domain: 'criteria' }, function () {
	      _this.isLoadingData = false;
	    });
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['listStore'])),
	  methods: {
	    onFilter: function onFilter() {
	      var searchData = {};
	      if (!(0, _lodash.isEmpty)(this.filters.name)) {
	        searchData.name = {
	          'ilike': '%' + this.filters.name + '%'
	        };
	      }
	      _bus2.default.$emit('list-filter', this.filters, searchData);
	    },
	    onFilterClean: function onFilterClean() {
	      this.filters = {};
	      _bus2.default.$emit('list-filter-clean', this.filters);
	    },
	    onDestroy: function onDestroy(item) {
	      _bus2.default.$emit('list-destroy-item', item);
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.listStore.listData = [];
	  }
	};

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Header = __webpack_require__(5);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _SaveButton = __webpack_require__(16);
	
	var _SaveButton2 = _interopRequireDefault(_SaveButton);
	
	var _CancelButton = __webpack_require__(14);
	
	var _CancelButton2 = _interopRequireDefault(_CancelButton);
	
	var _restfulService = __webpack_require__(6);
	
	var restfulService = _interopRequireWildcard(_restfulService);
	
	var _notifyService = __webpack_require__(8);
	
	var notifyService = _interopRequireWildcard(_notifyService);
	
	var _lodash = __webpack_require__(3);
	
	var _validators = __webpack_require__(10);
	
	var _bus = __webpack_require__(4);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ListHeader: _Header2.default, FormSaveButton: _SaveButton2.default, FormCancelButton: _CancelButton2.default },
	  data: function data() {
	    return {
	      isEdit: false,
	      isSubmitted: false,
	      isLoadingData: true,
	      form: {
	        name: '',
	        description: ''
	      },
	      dependencies: {}
	    };
	  },
	
	  validations: {
	    form: {
	      name: { required: _validators.required },
	      description: { required: _validators.required }
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    var id = this.$route.params.id || null;
	    if (id) {
	      this.isEdit = true;
	      restfulService.get('evaluation_type', null, id).then(function (response) {
	        _this.form = response;
	        _this.isLoadingData = false;
	        _bus2.default.$emit('hide-loader');
	      }).catch(function (e) {
	        console.log(e);
	        _this.isLoadingData = false;
	        _bus2.default.$emit('hide-loader');
	      });
	    } else {
	      this.isLoadingData = false;
	      _bus2.default.$emit('hide-loader');
	    }
	  },
	
	  methods: {
	    onSend: function onSend() {
	      var _this2 = this;
	
	      this.isSubmitted = true;
	      var data = (0, _lodash.clone)(this.form);
	      restfulService.save('evaluation_type', null, null, data).then(function () {
	        notifyService.success({ hideLoader: true });
	        _this2.isSubmitted = false;
	        _this2.$router.push({ name: 'evaluation_type.index' });
	      }).catch(function (e) {
	        _this2.isSubmitted = false;
	        console.log(e);
	      });
	    }
	  }
	};

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Main = __webpack_require__(11);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Header = __webpack_require__(5);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _EditButton = __webpack_require__(13);
	
	var _EditButton2 = _interopRequireDefault(_EditButton);
	
	var _DeleteButton = __webpack_require__(12);
	
	var _DeleteButton2 = _interopRequireDefault(_DeleteButton);
	
	var _bus = __webpack_require__(4);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	var _lodash = __webpack_require__(3);
	
	var _vuex = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ListMain: _Main2.default, ListHeader: _Header2.default, ListEditButton: _EditButton2.default, ListDeleteButton: _DeleteButton2.default },
	  data: function data() {
	    return {
	      isLoadingData: true,
	      filters: {},
	      dependencies: {}
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    _bus2.default.$emit('list-init', { domain: 'evaluation_type' }, function () {
	      _this.isLoadingData = false;
	    });
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['listStore'])),
	  methods: {
	    onFilter: function onFilter() {
	      var searchData = {};
	      if (!(0, _lodash.isEmpty)(this.filters.name)) {
	        searchData.name = {
	          'ilike': '%' + this.filters.name + '%'
	        };
	      }
	      _bus2.default.$emit('list-filter', this.filters, searchData);
	    },
	    onFilterClean: function onFilterClean() {
	      this.filters = {};
	      _bus2.default.$emit('list-filter-clean', this.filters);
	    },
	    onDestroy: function onDestroy(item) {
	      _bus2.default.$emit('list-destroy-item', item);
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.listStore.listData = [];
	  }
	};

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Header = __webpack_require__(5);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _BasicData = __webpack_require__(94);
	
	var _BasicData2 = _interopRequireDefault(_BasicData);
	
	var _Modalities = __webpack_require__(255);
	
	var _Modalities2 = _interopRequireDefault(_Modalities);
	
	var _PaperTypes = __webpack_require__(256);
	
	var _PaperTypes2 = _interopRequireDefault(_PaperTypes);
	
	var _restfulService = __webpack_require__(6);
	
	var restfulService = _interopRequireWildcard(_restfulService);
	
	var _notifyService = __webpack_require__(8);
	
	var notifyService = _interopRequireWildcard(_notifyService);
	
	var _helper = __webpack_require__(18);
	
	var _helper2 = _interopRequireDefault(_helper);
	
	var _bus = __webpack_require__(4);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	var _lodash = __webpack_require__(3);
	
	var _sweetalert = __webpack_require__(42);
	
	var _sweetalert2 = _interopRequireDefault(_sweetalert);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultState = {
	  event_id: '',
	  place_id: '',
	  title: '',
	  start_datetime: '',
	  end_datetime: '',
	  start_registration_datetime: '',
	  end_registration_datetime: '',
	  contact_email: '',
	  website: '',
	  description: '',
	  has_material: false,
	  events: []
	};
	
	exports.default = {
	  components: { ListHeader: _Header2.default, EventBasicData: _BasicData2.default, EventModalities: _Modalities2.default, EventPaperTypes: _PaperTypes2.default },
	  mixins: [_helper2.default],
	  data: function data() {
	    return {
	      isEdit: false,
	      isSubmitted: false,
	      isLoadingData: true,
	      event: {
	        id: '',
	        event_id: '',
	        events: []
	      },
	      tabs: {
	        activeName: 'event.update.basic-data',
	        tabBasicDataDisabled: false,
	        tabModalitiesDisabled: true,
	        tabPaperTypesDisabled: true
	      }
	    };
	  },
	
	  created: function created() {
	    var id = this.$route.params.id || null;
	    this.loadData(id);
	  },
	  watch: {
	    '$route.params.id': function $routeParamsId(id) {
	      this.loadData(id);
	    }
	  },
	  methods: {
	    loadData: function loadData(id) {
	      var _this = this;
	
	      _bus2.default.$emit('show-loader');
	      if (id) {
	        this.isEdit = true;
	        restfulService.get('event', null, id, null, ['events']).then(function (response) {
	          _this.event = response;
	          _this.tabs.tabModalitiesDisabled = false;
	          _this.tabs.tabPaperTypesDisabled = false;
	          _this.isLoadingData = false;
	          _bus2.default.$emit('hide-loader');
	        }).catch(function (e) {
	          console.log(e);
	          _bus2.default.$emit('hide-loader');
	          _this.isLoadingData = false;
	        });
	      } else {
	        _bus2.default.$emit('hide-loader');
	        this.isLoadingData = false;
	      }
	    },
	    createSubevent: function createSubevent() {
	      var event = (0, _lodash.clone)(defaultState);
	      event.event_id = this.event.id;
	      this.$router.push({ name: 'event.store', params: { eventId: this.event.id } });
	    },
	    cloneEvent: function cloneEvent(item) {
	      var _this2 = this;
	
	      (0, _sweetalert2.default)({
	        title: 'Deseja realmente clonar esse Evento?',
	        text: 'Essa ação não pode ser revertida!',
	        type: 'warning',
	        showCancelButton: true,
	        confirmButtonColor: '#3085d6',
	        cancelButtonColor: '#d33',
	        confirmButtonText: 'Sim, continuar!'
	      }).then(function () {
	        _bus2.default.$emit('show-loader');
	        _this2.isSubmitted = true;
	        var data = {};
	        restfulService.post('event', 'clone', item.id, data).then(function (response) {
	          notifyService.success({ hideLoader: true });
	          _this2.isSubmitted = false;
	          _this2.$router.push({ name: 'event.update.basic-data', params: { id: response.id } });
	        }).catch(function (e) {
	          _this2.isSubmitted = false;
	          _bus2.default.$emit('hide-loader');
	          console.log(e);
	        });
	      }).catch(function (e) {
	        _this2.isSubmitted = false;
	        _bus2.default.$emit('hide-loader');
	      });
	    },
	    deleteEvent: function deleteEvent(item) {
	      var _this3 = this;
	
	      (0, _sweetalert2.default)({
	        title: 'Deseja realmente remover esse Evento?',
	        text: 'Essa ação não pode ser revertida!',
	        type: 'warning',
	        showCancelButton: true,
	        confirmButtonColor: '#3085d6',
	        cancelButtonColor: '#d33',
	        confirmButtonText: 'Sim, continuar!'
	      }).then(function () {
	        _bus2.default.$emit('show-loader');
	        _this3.isSubmitted = true;
	        restfulService.destroy('event', null, item.id).then(function (response) {
	          notifyService.success({ hideLoader: true });
	          _this3.isSubmitted = false;
	          _this3.event.events = _this3.event.events.filter(function (event) {
	            return event.id !== item.id;
	          });
	          _bus2.default.$emit('hide-loader');
	        }).catch(function (e) {
	          _this3.isSubmitted = false;
	          _bus2.default.$emit('hide-loader');
	          console.log(e);
	        });
	      }).catch(function (e) {
	        _this3.isSubmitted = false;
	        _bus2.default.$emit('hide-loader');
	      });
	    }
	  }
	};

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Main = __webpack_require__(11);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Header = __webpack_require__(5);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _ShowButton = __webpack_require__(93);
	
	var _ShowButton2 = _interopRequireDefault(_ShowButton);
	
	var _EditButton = __webpack_require__(13);
	
	var _EditButton2 = _interopRequireDefault(_EditButton);
	
	var _DeleteButton = __webpack_require__(12);
	
	var _DeleteButton2 = _interopRequireDefault(_DeleteButton);
	
	var _bus = __webpack_require__(4);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	var _lodash = __webpack_require__(3);
	
	var _vuex = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ListMain: _Main2.default, ListHeader: _Header2.default, ListShowButton: _ShowButton2.default, ListEditButton: _EditButton2.default, ListDeleteButton: _DeleteButton2.default },
	  data: function data() {
	    return {
	      isLoadingData: true,
	      filters: {},
	      dependencies: {}
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    var searchData = {
	      event_id: null
	    };
	    _bus2.default.$emit('list-init', { domain: 'event', route: 'custom-search', data: searchData, customSearch: true }, function () {
	      _this.isLoadingData = false;
	    });
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['listStore'])),
	  methods: {
	    onFilter: function onFilter() {
	      var searchData = {};
	      if (!(0, _lodash.isEmpty)(this.filters.title)) {
	        searchData.title = this.filters.title;
	      }
	      _bus2.default.$emit('list-filter', this.filters, searchData);
	    },
	    onFilterClean: function onFilterClean() {
	      this.filters = {
	        event_id: null
	      };
	      _bus2.default.$emit('list-filter-clean', this.filters);
	    },
	    onDestroy: function onDestroy(item) {
	      _bus2.default.$emit('list-destroy-item', item);
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.listStore.listData = [];
	  }
	};

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Header = __webpack_require__(5);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _ListEmpty = __webpack_require__(644);
	
	var _ListEmpty2 = _interopRequireDefault(_ListEmpty);
	
	var _restfulService = __webpack_require__(6);
	
	var restfulService = _interopRequireWildcard(_restfulService);
	
	var _bus = __webpack_require__(4);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	var _helper = __webpack_require__(18);
	
	var _helper2 = _interopRequireDefault(_helper);
	
	var _vuex = __webpack_require__(9);
	
	var _lodash = __webpack_require__(3);
	
	var _highchartsVue = __webpack_require__(131);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ListHeader: _Header2.default, ListEmpty: _ListEmpty2.default, highcharts: _highchartsVue.Chart },
	  mixins: [_helper2.default],
	  data: function data() {
	    return {
	      isLoadingData: true,
	      event: {
	        id: 0,
	        title: ''
	      },
	      list: [],
	      registrations: [],
	      papers: [],
	      chartLineOptionsRegistrations: null,
	      chartLineOptionsPapers: null,
	      chartLineOptions: {
	        chart: { type: 'line' },
	        title: { text: '' },
	        xAxis: { categories: [] },
	        yAxis: { title: { text: 'Total' } },
	        plotOptions: {
	          line: {
	            dataLabels: { enabled: true },
	            enableMouseTracking: false
	          }
	        },
	        series: []
	      }
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['currentUser', 'roles']), {
	    userIsOnlySupportCommittee: function userIsOnlySupportCommittee() {
	      return this.roles && this.roles.length === 1 && this.roles[0] === 'Comissão de Apoio';
	    },
	    hasRootRole: function hasRootRole() {
	      return this.roles && this.roles.some(function (item) {
	        return item === 'Root';
	      });
	    }
	  }),
	  mounted: function mounted() {
	    var _this = this;
	
	    var id = this.$route.params.id || null;
	    if (id) {
	      restfulService.get('event', 'dashboard', id).then(function (response) {
	        _this.event.id = response.event.id;
	        _this.event.title = response.event.title;
	        _this.list = response.event.events;
	        _this.registrations = response.registrations;
	        _this.papers = response.papers;
	        _this.mountCharts();
	        _this.isLoadingData = false;
	        _bus2.default.$emit('hide-loader');
	      }).catch(function (err) {
	        console.log(err);
	        _this.isLoadingData = false;
	        _bus2.default.$emit('hide-loader');
	      });
	    } else {
	      this.isLoadingData = false;
	      _bus2.default.$emit('hide-loader');
	    }
	  },
	
	  methods: {
	    userHaveAccess: function userHaveAccess(coordinators) {
	      var _this2 = this;
	
	      return coordinators.some(function (coordinator) {
	        return coordinator.user_id === _this2.currentUser.id;
	      }) || this.hasRootRole;
	    },
	    mountCharts: function mountCharts() {
	      var chartLineOptionsRegistrations = (0, _lodash.cloneDeep)(this.chartLineOptions);
	      chartLineOptionsRegistrations.title.text = 'Evolução de Inscrições';
	      chartLineOptionsRegistrations.series.splice(0);
	      chartLineOptionsRegistrations.series.push({
	        name: 'Inscrições',
	        data: []
	      });
	      chartLineOptionsRegistrations.xAxis.categories = this.registrations.map(function (item) {
	        return item.date;
	      });
	      chartLineOptionsRegistrations.series[0].data = this.registrations.map(function (item) {
	        return item.total;
	      });
	      this.chartLineOptionsRegistrations = chartLineOptionsRegistrations;
	    }
	  }
	};

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Header = __webpack_require__(5);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Main = __webpack_require__(11);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _RegistrationStatusLabel = __webpack_require__(257);
	
	var _RegistrationStatusLabel2 = _interopRequireDefault(_RegistrationStatusLabel);
	
	var _restfulService = __webpack_require__(6);
	
	var restfulService = _interopRequireWildcard(_restfulService);
	
	var _notifyService = __webpack_require__(8);
	
	var notifyService = _interopRequireWildcard(_notifyService);
	
	var _dataService = __webpack_require__(21);
	
	var _dataService2 = _interopRequireDefault(_dataService);
	
	var _helper = __webpack_require__(18);
	
	var _helper2 = _interopRequireDefault(_helper);
	
	var _bus = __webpack_require__(4);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	var _vuex = __webpack_require__(9);
	
	var _lodash = __webpack_require__(3);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ListHeader: _Header2.default, ListMain: _Main2.default, RegistrationStatusLabel: _RegistrationStatusLabel2.default },
	  mixins: [_helper2.default],
	  data: function data() {
	    return {
	      isLoadingData: true,
	      event: {
	        id: null,
	        title: ''
	      },
	      filters: { ref_pessoa: '', dates: [], status_id: '' },
	      form: {
	        ref_pessoa: ''
	      },
	      registrationActivity: {
	        datetime_in: '',
	        datetime_out: '',
	        event_id: '',
	        user_id: '',
	        registration_id: ''
	      },
	      dependencies: {}
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.getDependencies();
	    var id = this.$route.params.id || null;
	    if (id) {
	      restfulService.get('event', null, id).then(function (response) {
	        _this.event.id = id;
	        _this.event.title = response.title;
	        _this.isLoadingData = false;
	        _bus2.default.$emit('hide-loader');
	      }).catch(function (err) {
	        console.log(err);
	        _this.isLoadingData = false;
	        _bus2.default.$emit('hide-loader');
	      });
	      _bus2.default.$emit('list-init', {
	        domain: 'registration',
	        route: 'activities',
	        customSearch: true,
	        relations: ['registration.person', 'registration.status', 'event_modality_registration.event_modality.event'],
	        data: { event_main_id: id }
	      }, function () {
	        _this.isLoadingData = false;
	      });
	    } else {
	      this.isLoadingData = false;
	    }
	    this.$nextTick(function () {
	      _this.$refs.formMatricula.$el.children['formMatricula'].focus();
	    });
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['listStore', 'currentUser']), {
	    pageTitle: function pageTitle() {
	      return this.event.title + ' - Presença';
	    },
	    labelType: function labelType() {
	      return 'danger';
	    }
	  }),
	  methods: {
	    getDependencies: function getDependencies() {
	      var _this2 = this;
	
	      _dataService2.default.get([{ domain: 'status' }]).then(function (result) {
	        _this2.dependencies = result;
	      });
	    },
	    onFilter: function onFilter() {
	      var id = this.$route.params.id || null;
	      var searchData = { event_main_id: id };
	      if (this.filters.status_id) {
	        searchData.status_id = this.filters.status_id;
	      }
	      if (!(0, _lodash.isEmpty)(this.filters.ref_pessoa)) {
	        searchData.ref_pessoa = this.filters.ref_pessoa;
	      }
	      var startDate = this.dateFormat(this.filters.dates[0], 'en');
	      var endDate = this.dateFormat(this.filters.dates[1], 'en');
	      if (startDate.length > 0 && endDate.length > 0) {
	        searchData.start_date = startDate + ' 00:00:00';
	        searchData.end_date = endDate + ' 23:59:59';
	      } else if (startDate.length > 0 && endDate.length === 0) {
	        searchData.start_date = startDate + ' 00:00:00';
	        searchData.end_date = startDate + ' 23:59:59';
	      } else if (startDate.length === 0 && endDate.length > 0) {
	        searchData.start_date = endDate + ' 00:00:00';
	        searchData.end_date = endDate + ' 23:59:59';
	      }
	      _bus2.default.$emit('list-filter', this.filters, searchData);
	    },
	    onInsert: function onInsert() {
	      var _this3 = this;
	
	      this.isSubmitted = true;
	      var data = {
	        event_main_id: this.event.id,
	        ref_pessoa: this.form.ref_pessoa
	      };
	      if (!(0, _lodash.isEmpty)(data.ref_pessoa)) {
	        restfulService.post('registration_activity', null, null, data).then(function () {
	          _this3.isSubmitted = false;
	          notifyService.success({
	            hideLoader: true,
	            message: 'O registro de presença foi inserido com sucesso.'
	          });
	          _this3.onInsertClean();
	        }).catch(function (err) {
	          console.log(err);
	        });
	      } else {
	        this.$swal({
	          title: 'Atenção',
	          text: 'Favor informar uma matrícula!',
	          type: 'warning'
	        });
	      }
	    },
	    onFilterClean: function onFilterClean() {
	      var id = this.$route.params.id || null;
	      var searchData = { event_main_id: id };
	      this.filters = { ref_pessoa: '', status_id: '', dates: [] };
	      _bus2.default.$emit('list-filter-clean', this.filters, searchData);
	    },
	    onInsertClean: function onInsertClean() {
	      this.form.ref_pessoa = '';
	      this.onFilterClean();
	    },
	    onDestroy: function onDestroy(item) {
	      _bus2.default.$emit('list-destroy-item', item);
	    },
	    cancelRegistrationActivity: function cancelRegistrationActivity(registrationActivity) {
	      var _this4 = this;
	
	      this.isSubmitted = true;
	      this.$swal({
	        title: 'Deseja realmente cancelar o registro de presença no evento?',
	        text: 'Essa ação não pode ser revertida!',
	        type: 'warning',
	        showCancelButton: true,
	        confirmButtonColor: '#3085d6',
	        cancelButtonColor: '#d33',
	        confirmButtonText: 'Sim, continuar!'
	      }).then(function () {
	        _bus2.default.$emit('show-loader');
	        var data = (0, _lodash.clone)(registrationActivity);
	        data.canceled_by = _this4.currentUser.id;
	        restfulService.put('registration_activity', null, registrationActivity.id, data).then(function (response) {
	          _this4.isSubmitted = false;
	          notifyService.success({ hideLoader: true, message: 'O registro de presença foi cancelada com sucesso.' });
	          _this4.onFilter();
	          _bus2.default.$emit('hide-loader');
	        }).catch(function (e) {
	          _this4.isSubmitted = false;
	          _bus2.default.$emit('hide-loader');
	          console.log(e);
	        });
	      }).catch(function (e) {
	        console.log(e);
	        _bus2.default.$emit('hide-loader');
	      });
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.listStore.listData = [];
	  }
	};

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Header = __webpack_require__(5);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _restfulService = __webpack_require__(6);
	
	var restfulService = _interopRequireWildcard(_restfulService);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ListHeader: _Header2.default },
	  data: function data() {
	    return {
	      isLoadingData: true,
	      form: {
	        papers: {}
	      }
	    };
	  },
	
	  computed: {
	    currentView: function currentView() {
	      var route = this.$route;
	      switch (route.name) {
	        case 'event.show.home':
	          return 'home';
	        case 'event.index.registrations':
	          return 'registration';
	        default:
	          return 'event.index.papers.' + route.params.statusKey;
	      }
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    var id = this.$route.params.id || null;
	    if (id) {
	      this.isEdit = true;
	      restfulService.get('event', 'manage', id).then(function (response) {
	        _this.form = response;
	        _this.isLoadingData = false;
	      }).catch(function (err) {
	        console.log(err);
	        _this.isLoadingData = false;
	      });
	    }
	  }
	};

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Header = __webpack_require__(5);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _BasicData = __webpack_require__(94);
	
	var _BasicData2 = _interopRequireDefault(_BasicData);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ListHeader: _Header2.default, EventBasicData: _BasicData2.default },
	  props: ['eventId']
	};

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(32);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _promise = __webpack_require__(27);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _Tinymce = __webpack_require__(92);
	
	var _Tinymce2 = _interopRequireDefault(_Tinymce);
	
	var _CancelButton = __webpack_require__(14);
	
	var _CancelButton2 = _interopRequireDefault(_CancelButton);
	
	var _ValidationMessage = __webpack_require__(49);
	
	var _ValidationMessage2 = _interopRequireDefault(_ValidationMessage);
	
	var _restfulService = __webpack_require__(6);
	
	var restfulService = _interopRequireWildcard(_restfulService);
	
	var _notifyService = __webpack_require__(8);
	
	var notifyService = _interopRequireWildcard(_notifyService);
	
	var _dataService = __webpack_require__(21);
	
	var _dataService2 = _interopRequireDefault(_dataService);
	
	var _validators = __webpack_require__(10);
	
	var _helper = __webpack_require__(18);
	
	var _helper2 = _interopRequireDefault(_helper);
	
	var _lodash = __webpack_require__(3);
	
	var _bus = __webpack_require__(4);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'event-basic-data',
	  components: { FormTinymce: _Tinymce2.default, FormCancelButton: _CancelButton2.default, ValidationMessage: _ValidationMessage2.default },
	  mixins: [_helper2.default],
	  props: ['eventId'],
	  data: function data() {
	    return {
	      isSubmitted: false,
	      isLoadingData: true,
	      isSearchingMonitors: false,
	      dependencies: {
	        places: [],
	        events: [],
	        users: [],
	        monitors: [],
	        layouts: []
	      },
	      event: {
	        event_id: '',
	        title: '',
	        place_id: '',
	        start_datetime: '',
	        end_datetime: '',
	        start_registration_datetime: '',
	        end_registration_datetime: '',
	        contact_email: '',
	        max_submissions_per_author: '',
	        has_material: false,
	        website: '',
	        description: '',
	        layout_id: '',
	        vacancies: 0,
	        workload: 0,
	        coordinators: [],
	        support_committee: [],
	        monitors: []
	      }
	    };
	  },
	
	  computed: {
	    isSubEvent: function isSubEvent() {
	      return this.event.event_id !== null && this.event.event_id !== '';
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    var id = this.$route.params.id || null;
	    this.getDependencies().then(function () {
	      _this.loadData(id);
	      if (_this.eventId) {
	        _this.$set(_this.event, 'event_id', _this.eventId);
	        _this.changeEvent();
	      }
	    });
	  },
	
	  watch: {
	    '$route.params.id': function $routeParamsId(id) {
	      this.loadData(id);
	    }
	  },
	  validations: {
	    event: {
	      title: { required: _validators.required },
	      type_id: { required: _validators.required },
	      place_id: { required: _validators.required },
	      start_datetime: { required: _validators.required },
	      end_datetime: { required: _validators.required },
	      start_registration_datetime: { required: _validators.required },
	      end_registration_datetime: { required: _validators.required },
	      contact_email: { email: _validators.email },
	      website: { url: _validators.url },
	      vacancies: { required: _validators.required },
	      coordinators: {
	        required: (0, _validators.requiredIf)(function () {
	          return this.isSubEvent;
	        })
	      }
	    }
	  },
	  methods: {
	    getDependencies: function getDependencies() {
	      var _this2 = this;
	
	      return new _promise2.default(function (resolve) {
	        _dataService2.default.get([{ domain: 'place' }, { domain: 'event' }, { domain: 'user' }, { domain: 'layout' }, { domain: 'event_type' }]).then(function (result) {
	          _this2.dependencies = (0, _extends3.default)({}, _this2.dependencies, result);
	          resolve();
	        });
	      });
	    },
	    loadData: function loadData(id) {
	      var _this3 = this;
	
	      _bus2.default.$emit('show-loader');
	      if (id) {
	        this.isEdit = true;
	        restfulService.get('event', null, id, null, ['coordinators', 'support_committee', 'monitors']).then(function (response) {
	          if (response.description === null) {
	            response.description = '';
	          }
	          var coordinators = response.coordinators.map(function (item) {
	            return item.user_id;
	          });
	          var supportCommittee = response.support_committee.map(function (item) {
	            return item.user_id;
	          });
	          var monitors = response.monitors.map(function (item) {
	            return item.user_id;
	          });
	          var monitorsRefPessoa = response.monitors.map(function (item) {
	            return item.user.ref_pessoa;
	          });
	          response.coordinators = [].concat((0, _toConsumableArray3.default)((0, _lodash.uniq)(coordinators)));
	          response.support_committee = [].concat((0, _toConsumableArray3.default)((0, _lodash.uniq)(supportCommittee)));
	          response.monitors = [].concat((0, _toConsumableArray3.default)((0, _lodash.uniq)(monitors)));
	          _this3.event = response;
	          _this3.getMonitors(monitorsRefPessoa);
	          _this3.isLoadingData = false;
	          _bus2.default.$emit('hide-loader');
	        }).catch(function (e) {
	          console.log(e);
	          _bus2.default.$emit('hide-loader');
	          _this3.isLoadingData = false;
	        });
	      } else {
	        _bus2.default.$emit('hide-loader');
	        this.isLoadingData = false;
	      }
	    },
	    searchMonitors: function searchMonitors(query) {
	      query = parseInt(query);
	      if (query > 0) {
	        this.getMonitors([query]);
	      }
	    },
	    getMonitors: function getMonitors(ids) {
	      var _this4 = this;
	
	      this.dependencies.monitors.splice(0);
	      if (ids.length > 0) {
	        this.isSearchingMonitors = true;
	        var data = {
	          'person': { has: [{ ref_pessoa: { in: ids } }] },
	          'status': { has: [{ key: { in: ['em_aberto', 'sem_custo', 'pago'] } }] },
	          'modalities.event_modality': { has: [{ event_id: this.event.id }] }
	        };
	        restfulService.search('registration', null, data, null, ['person'], 1, 20).then(function (response) {
	          _this4.dependencies.monitors = (0, _lodash.uniq)([].concat((0, _toConsumableArray3.default)(_this4.dependencies.monitors), (0, _toConsumableArray3.default)(response.data)));
	          _this4.isSearchingMonitors = false;
	        }).catch(function (e) {
	          console.log(e);
	        });
	      }
	    },
	    changeEvent: function changeEvent() {
	      var _this5 = this;
	
	      var event = this.dependencies.events.filter(function (item) {
	        return item.id === _this5.event.event_id;
	      });
	      if (event.length) {
	        this.event.start_registration_datetime = event[0].start_registration_datetime;
	        this.event.end_registration_datetime = event[0].end_registration_datetime;
	      }
	    },
	    onSaveBasicData: function onSaveBasicData() {
	      var _this6 = this;
	
	      this.isSubmitted = true;
	      var data = (0, _lodash.clone)(this.event);
	      data.start_datetime = this.dateTimeFormat(data.start_datetime, 'en');
	      data.end_datetime = this.dateTimeFormat(data.end_datetime, 'en');
	      data.start_registration_datetime = this.dateTimeFormat(data.start_registration_datetime, 'en');
	      data.end_registration_datetime = this.dateTimeFormat(data.end_registration_datetime, 'en');
	      restfulService.save('event', null, null, data).then(function (response) {
	        notifyService.success({ hideLoader: true });
	        _this6.isSubmitted = false;
	        _this6.$router.push({ name: 'event.update.basic-data', params: { id: response.id } });
	      }).catch(function (e) {
	        _this6.isSubmitted = false;
	        console.log(e);
	      });
	    }
	  }
	};

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(27);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _ValidationMessage = __webpack_require__(49);
	
	var _ValidationMessage2 = _interopRequireDefault(_ValidationMessage);
	
	var _restfulService = __webpack_require__(6);
	
	var restfulService = _interopRequireWildcard(_restfulService);
	
	var _notifyService = __webpack_require__(8);
	
	var notifyService = _interopRequireWildcard(_notifyService);
	
	var _dataService = __webpack_require__(21);
	
	var _dataService2 = _interopRequireDefault(_dataService);
	
	var _bus = __webpack_require__(4);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	var _validators = __webpack_require__(10);
	
	var _helper = __webpack_require__(18);
	
	var _helper2 = _interopRequireDefault(_helper);
	
	var _lodash = __webpack_require__(3);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultEvaluation = {
	  id: '',
	  event_paper_type_id: '',
	  evaluation_type_id: '',
	  start_datetime: '',
	  end_datetime: '',
	  min_evaluations_number: 0,
	  min_evaluation_next_step: 0,
	  evaluation_type: { id: '', name: '' },
	  criterias: []
	};
	
	exports.default = {
	  name: 'event-evaluations',
	  components: { ValidationMessage: _ValidationMessage2.default },
	  mixins: [_helper2.default],
	  data: function data() {
	    return {
	      isSubmitted: false,
	      isLoadingData: true,
	      activePaperType: 'tab',
	      modalEvaluationVisible: false,
	      evaluationSelect: '',
	      eventPaperTypes: [],
	      dependencies: {
	        evaluation_types: [],
	        criterias: []
	      },
	      event: { id: '' },
	      evaluation: (0, _lodash.cloneDeep)(defaultEvaluation)
	    };
	  },
	
	  validations: {
	    evaluation: {
	      start_datetime: { required: _validators.required },
	      end_datetime: { required: _validators.required },
	      min_evaluations_number: { required: _validators.required },
	      min_evaluation_next_step: { required: _validators.required }
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.getDependencies().then(function (_) {
	      var id = _this.$route.params.id || null;
	      _this.loadData(id);
	    });
	  },
	
	  methods: {
	    getDependencies: function getDependencies() {
	      var _this2 = this;
	
	      return new _promise2.default(function (resolve) {
	        _dataService2.default.get([{ domain: 'evaluation_type' }, { domain: 'criteria' }]).then(function (result) {
	          _this2.dependencies = result;
	          resolve();
	        });
	      });
	    },
	    loadData: function loadData(id) {
	      var _this3 = this;
	
	      _bus2.default.$emit('show-loader');
	      if (id) {
	        this.isEdit = true;
	        restfulService.get('event', null, id, null, ['paper_types.paper_type', 'paper_types.evaluation_types.evaluation_type', 'paper_types.evaluation_types.criterias.criteria']).then(function (response) {
	          _this3.event.id = response.id;
	          _this3.eventPaperTypes = response.paper_types;
	          _this3.activePaperType = 'tab_' + response.paper_types[0].id;
	          _this3.isLoadingData = false;
	          _bus2.default.$emit('hide-loader');
	        }).catch(function (e) {
	          console.log(e);
	          _bus2.default.$emit('hide-loader');
	          _this3.isLoadingData = false;
	        });
	      } else {
	        _bus2.default.$emit('hide-loader');
	        this.isLoadingData = false;
	      }
	    },
	    checkEvaluationSelected: function checkEvaluationSelected(id, index) {
	      return this.eventPaperTypes[index].evaluation_types.some(function (item) {
	        return item.evaluation_type_id === id;
	      });
	    },
	    selectEvaluation: function selectEvaluation(evaluationSelect, index) {
	      var _this4 = this;
	
	      if (evaluationSelect && evaluationSelect !== '') {
	        var hasEvaluation = this.eventPaperTypes[index].evaluation_types.some(function (item) {
	          return item.evaluation_type_id === evaluationSelect;
	        });
	        if (!hasEvaluation) {
	          var data = (0, _lodash.cloneDeep)(defaultEvaluation);
	          data.evaluation_type = (0, _lodash.find)(this.dependencies.evaluation_types, function (item) {
	            return item.id === evaluationSelect;
	          });
	          data.evaluation_type_id = data.evaluation_type.id;
	          data.event_paper_type_id = this.eventPaperTypes[index].id;
	          this.saveEvaluation(data).then(function (response) {
	            data.id = response.id;
	            _this4.eventPaperTypes[index].evaluation_types.push(data);
	            _this4.evaluationSelect = '';
	            _this4.editEvaluation(data);
	            notifyService.success({ hideLoader: true });
	            _this4.isSubmitted = false;
	          }).catch(function (e) {
	            _this4.isSubmitted = false;
	            console.log(e);
	          });
	        }
	      }
	    },
	    onHandleModalEvaluation: function onHandleModalEvaluation() {
	      this.modalEvaluationVisible = !this.modalEvaluationVisible;
	    },
	    editEvaluation: function editEvaluation(item) {
	      var _this5 = this;
	
	      var evaluation = (0, _lodash.cloneDeep)(item);
	      var criterias = (0, _lodash.cloneDeep)(this.dependencies.criterias);
	      criterias.forEach(function (item) {
	        _this5.$set(item, 'checked', evaluation.criterias.some(function (field) {
	          return field.criteria_id === item.id;
	        }));
	      });
	      evaluation.criterias.splice(0);
	      evaluation.criterias = criterias;
	      this.evaluation = evaluation;
	      this.onHandleModalEvaluation();
	    },
	    saveEvaluation: function saveEvaluation(evaluation) {
	      this.isSubmitted = true;
	      var data = (0, _lodash.cloneDeep)(evaluation);
	      data.event_id = this.event.id;
	      data.start_datetime = this.dateTimeFormat(data.start_datetime, 'en');
	      if (data.start_datetime.length === 0) {
	        delete data.start_datetime;
	      }
	      data.end_datetime = this.dateTimeFormat(data.end_datetime, 'en');
	      if (data.end_datetime.length === 0) {
	        delete data.end_datetime;
	      }
	      return restfulService.save('event_paper_type_evaluation_type', null, null, data);
	    },
	    onSaveEvaluation: function onSaveEvaluation() {
	      var _this6 = this;
	
	      _bus2.default.$emit('show-loader');
	      var data = (0, _lodash.cloneDeep)(this.evaluation);
	      this.saveEvaluation(data).then(function (response) {
	        _this6.loadData(_this6.event.id);
	        notifyService.success({ hideLoader: true });
	        _this6.isSubmitted = false;
	        _this6.onHandleModalEvaluation();
	        _bus2.default.$emit('hide-loader');
	      }).catch(function (e) {
	        _this6.isSubmitted = false;
	        _bus2.default.$emit('show-loader');
	        console.log(e);
	      });
	    },
	    removeEvaluation: function removeEvaluation(evaluation, index) {
	      var _this7 = this;
	
	      restfulService.destroy('event_paper_type_evaluation_type', null, evaluation.id).then(function (_) {
	        _this7.eventPaperTypes[index].evaluation_types = _this7.eventPaperTypes[index].evaluation_types.filter(function (item) {
	          return item.id !== evaluation.id;
	        });
	        notifyService.success({ hideLoader: true });
	        _this7.isSubmitted = false;
	      }).catch(function (e) {
	        _this7.isSubmitted = false;
	        console.log(e);
	      });
	    }
	  }
	};

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(32);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _promise = __webpack_require__(27);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _ValidationMessage = __webpack_require__(49);
	
	var _ValidationMessage2 = _interopRequireDefault(_ValidationMessage);
	
	var _restfulService = __webpack_require__(6);
	
	var restfulService = _interopRequireWildcard(_restfulService);
	
	var _notifyService = __webpack_require__(8);
	
	var notifyService = _interopRequireWildcard(_notifyService);
	
	var _dataService = __webpack_require__(21);
	
	var _dataService2 = _interopRequireDefault(_dataService);
	
	var _YesNo = __webpack_require__(254);
	
	var _YesNo2 = _interopRequireDefault(_YesNo);
	
	var _lodash = __webpack_require__(3);
	
	var _helper = __webpack_require__(18);
	
	var _helper2 = _interopRequireDefault(_helper);
	
	var _validators = __webpack_require__(10);
	
	var _bus = __webpack_require__(4);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	var _types = __webpack_require__(347);
	
	var TYPES = _interopRequireWildcard(_types);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'event-modalities',
	  components: { ListYesNo: _YesNo2.default, ValidationMessage: _ValidationMessage2.default },
	  mixins: [_helper2.default],
	  data: function data() {
	    return {
	      isSubmitted: false,
	      isLoadingData: true,
	      modalPriceVisible: false,
	      modalModalityVisible: false,
	      isSearchingInstitution: false,
	      isResetPrice: false,
	      event: {
	        id: '',
	        event_id: null,
	        modalities: []
	      },
	      modality: {
	        event_id: '',
	        modality_id: '',
	        layout_id: '',
	        not_charged: false,
	        release_date_certificate: '',
	        literacies: [],
	        institutions_in: [],
	        institutions_not_in: []
	      },
	      dependencies: {
	        literacies: [],
	        modalities: [],
	        layouts: [],
	        institutions: []
	      },
	      price: {
	        event_modality_id: '',
	        start_datetime: '',
	        end_datetime: '',
	        amount: 0
	      },
	      moneyMask: {
	        decimal: ',',
	        thousands: '.',
	        prefix: 'R$ ',
	        precision: 2,
	        masked: false
	      }
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.getDependencies().then(function (_) {
	      var id = _this.$route.params.id || null;
	      _this.loadData(id);
	    });
	  },
	
	  validations: {
	    modality: {
	      modality_id: { required: _validators.required },
	      event_id: { required: _validators.required },
	      release_date_certificate: { required: _validators.required },
	      literacies: {
	        required: (0, _validators.requiredIf)(function () {
	          return this.event.event_id;
	        })
	      }
	    },
	    price: {
	      event_modality_id: { required: _validators.required },
	      start_datetime: { required: _validators.required },
	      end_datetime: { required: _validators.required },
	      amount: { required: _validators.required }
	    }
	  },
	  methods: {
	    loadData: function loadData(id) {
	      var _this2 = this;
	
	      _bus2.default.$emit('show-loader');
	      if (id) {
	        this.isEdit = true;
	        restfulService.get('event', null, id, null, ['modalities.modality', 'modalities.literacies.literacy', 'modalities.prices', 'modalities.currentPrice', 'modalities.institutions_in', 'modalities.institutions_not_in']).then(function (response) {
	          _this2.event.id = response.id;
	          _this2.event.event_id = response.event_id;
	          _this2.event.modalities = response.modalities;
	          _this2.isLoadingData = false;
	          _bus2.default.$emit('hide-loader');
	        }).catch(function (e) {
	          console.log(e);
	          _bus2.default.$emit('hide-loader');
	          _this2.isLoadingData = false;
	        });
	      } else {
	        _bus2.default.$emit('hide-loader');
	        this.isLoadingData = false;
	      }
	    },
	    getDependencies: function getDependencies() {
	      var _this3 = this;
	
	      return new _promise2.default(function (resolve) {
	        _dataService2.default.get([{ domain: 'modality' }, { domain: 'literacy' }, { domain: 'layout' }]).then(function (result) {
	          result.modalities.forEach(function (item) {
	            item.disabled = item.key === TYPES.MODALITY_KEY_EVENTO_PRINCIPAL;
	          });
	          _this3.dependencies = (0, _extends3.default)({}, _this3.dependencies, result);
	          resolve();
	        });
	      });
	    },
	    onSearchInstitution: function onSearchInstitution(query) {
	      var _this4 = this;
	
	      if (query !== '') {
	        this.isSearchingInstitution = true;
	        var data = { query: query };
	        restfulService.post('institution', 'search', null, data).then(function (response) {
	          _this4.dependencies.institutions.splice(0);
	          _this4.dependencies.institutions = [].concat((0, _toConsumableArray3.default)(_this4.dependencies.institutions), (0, _toConsumableArray3.default)(response));
	          _this4.isSearchingInstitution = false;
	        }).catch(function (e) {
	          console.log(e);
	        });
	      }
	    },
	    onHandleModalModality: function onHandleModalModality() {
	      this.modalModalityVisible = !this.modalModalityVisible;
	    },
	    onAddNewModality: function onAddNewModality() {
	      this.resetModality();
	      this.onHandleModalModality();
	    },
	    onEditModality: function onEditModality(item) {
	      var _this5 = this;
	
	      var currentModality = (0, _lodash.cloneDeep)(item);
	      this.dependencies.institutions.splice(0);
	      if (currentModality.institutions_in) {
	        currentModality.institutions_in.forEach(function (item) {
	          _this5.dependencies.institutions.push({
	            id: item.institution_id,
	            name: item.institution.name
	          });
	        });
	        currentModality.institutions_in = currentModality.institutions_in.map(function (item) {
	          return item.institution_id;
	        });
	      }
	      if (this.modality.institutions_not_in) {
	        currentModality.institutions_not_in.forEach(function (item) {
	          _this5.dependencies.institutions.push({
	            id: item.institution_id,
	            name: item.institution.name
	          });
	        });
	        currentModality.institutions_not_in = currentModality.institutions_not_in.map(function (item) {
	          return item.institution_id;
	        });
	      }
	      currentModality.literacies = currentModality.literacies.map(function (item) {
	        return item.literacy_id;
	      });
	      this.modality = currentModality;
	      this.onHandleModalModality();
	    },
	    resetModality: function resetModality() {
	      this.modality = {
	        event_id: this.event.id,
	        modality_id: '',
	        layout_id: '',
	        not_charged: false,
	        release_date_certificate: '',
	        literacies: [],
	        institutions_in: [],
	        institutions_not_in: []
	      };
	      this.$v.modality.$reset();
	    },
	    onSaveModality: function onSaveModality() {
	      var _this6 = this;
	
	      this.isSubmitted = true;
	      var data = (0, _lodash.clone)(this.modality);
	      data.event_id = this.event.id;
	      data.release_date_certificate = this.dateTimeFormat(data.release_date_certificate, 'en');
	      delete data.prices;
	      delete data.modality;
	
	      restfulService.save('event_modality', null, null, data).then(function () {
	        notifyService.success({ hideLoader: true });
	        _this6.onHandleModalModality();
	        var id = _this6.$route.params.id || null;
	        _this6.isSubmitted = false;
	        _this6.loadData(id);
	      }).catch(function (e) {
	        _this6.isSubmitted = false;
	        _bus2.default.$emit('hide-loader');
	        console.log(e);
	      });
	    },
	    onDeleteModality: function onDeleteModality(modality) {
	      var _this7 = this;
	
	      restfulService.destroy('event_modality', null, modality.id).then(function () {
	        notifyService.success({ hideLoader: true, message: 'Modalidade removida com sucesso!' });
	        _this7.event.modalities = _this7.event.modalities.filter(function (item) {
	          return item.id !== modality.id;
	        });
	      }).catch(function (e) {
	        console.log(e);
	      });
	    },
	    onHandleModalPrice: function onHandleModalPrice(item) {
	      this.modality = (0, _lodash.cloneDeep)(item);
	      this.price.event_modality_id = item.id;
	      this.modalPriceVisible = !this.modalPriceVisible;
	    },
	    resetPrice: function resetPrice() {
	      var _this8 = this;
	
	      this.isResetPrice = true;
	      this.price = {
	        event_modality_id: this.modality.id,
	        start_datetime: '',
	        end_datetime: '',
	        amount: 0
	      };
	      setTimeout(function () {
	        _this8.isResetPrice = false;
	      }, 100);
	      this.$v.price.$reset();
	    },
	    onSavePrice: function onSavePrice() {
	      var _this9 = this;
	
	      var data = (0, _lodash.clone)(this.price);
	      data.start_datetime = this.dateTimeFormat(data.start_datetime, 'en');
	      data.end_datetime = this.dateTimeFormat(data.end_datetime, 'en');
	      data.amount = this.currencyBrToEn(data.amount);
	      data.event_modality_id = this.modality.id;
	      restfulService.post('price', null, null, data).then(function (response) {
	        notifyService.success({ hideLoader: true });
	        var currentModality = (0, _lodash.cloneDeep)(_this9.modality);
	        currentModality.prices.push(response);
	        _this9.modality.prices.push(response);
	        var modalityIndex = _this9.event.modalities.map(function (item) {
	          return item.id;
	        }).indexOf(currentModality.id);
	        _this9.event.modalities.splice(modalityIndex, 1, currentModality);
	        _this9.resetPrice();
	      }).catch(function (e) {
	        console.log(e);
	      });
	    },
	    onDeletePrice: function onDeletePrice(price) {
	      var _this10 = this;
	
	      restfulService.destroy('price', null, price.id).then(function () {
	        notifyService.success({ hideLoader: true, message: 'Valor removido com sucesso!' });
	        var currentModality = (0, _lodash.cloneDeep)(_this10.modality);
	        currentModality.prices = currentModality.prices.filter(function (item) {
	          return item.id !== price.id;
	        });
	        var modalityIndex = _this10.event.modalities.map(function (item) {
	          return item.id;
	        }).indexOf(currentModality.id);
	        _this10.event.modalities.splice(modalityIndex, 1, currentModality);
	        _this10.modality.prices = currentModality.prices.filter(function (item) {
	          return item.id !== price.id;
	        });
	      }).catch(function (e) {
	        console.log(e);
	      });
	    }
	  }
	};

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(27);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _ValidationMessage = __webpack_require__(49);
	
	var _ValidationMessage2 = _interopRequireDefault(_ValidationMessage);
	
	var _restfulService = __webpack_require__(6);
	
	var restfulService = _interopRequireWildcard(_restfulService);
	
	var _notifyService = __webpack_require__(8);
	
	var notifyService = _interopRequireWildcard(_notifyService);
	
	var _dataService = __webpack_require__(21);
	
	var _dataService2 = _interopRequireDefault(_dataService);
	
	var _bus = __webpack_require__(4);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	var _validators = __webpack_require__(10);
	
	var _helper = __webpack_require__(18);
	
	var _helper2 = _interopRequireDefault(_helper);
	
	var _lodash = __webpack_require__(3);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultPaperType = {
	  id: '',
	  submission_start_datetime: '',
	  submission_end_datetime: '',
	  knowledge_area: false,
	  edit_limit_days: 0,
	  author_limit: 0,
	  max_submission_author: 0,
	  keywords_limit: 0,
	  screening: false,
	  author_subscribed: false,
	  advisor: false,
	  max_limit_advisor: 0,
	  co_advisor: false,
	  max_limit_co_advisor: 0,
	  order: 0,
	  template: '',
	  paper_type: {
	    id: '',
	    name: ''
	  },
	  fields: []
	};
	
	exports.default = {
	  name: 'event-paper-types',
	  components: { ValidationMessage: _ValidationMessage2.default },
	  mixins: [_helper2.default],
	  data: function data() {
	    return {
	      isSubmitted: false,
	      isLoadingData: true,
	      modalPaperTypeVisible: false,
	      paperTypeSelect: '',
	      eventPaperTypes: [],
	      dependencies: {
	        paper_types: [],
	        fields: []
	      },
	      event: { id: '' },
	      paperType: (0, _lodash.clone)(defaultPaperType)
	    };
	  },
	
	  validations: {
	    paperType: {
	      submission_start_datetime: { required: _validators.required },
	      submission_end_datetime: { required: _validators.required }
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.getDependencies().then(function (_) {
	      var id = _this.$route.params.id || null;
	      _this.loadData(id);
	    });
	  },
	
	  methods: {
	    getDependencies: function getDependencies() {
	      var _this2 = this;
	
	      return new _promise2.default(function (resolve) {
	        _dataService2.default.get([{ domain: 'paper_type' }, { domain: 'field' }]).then(function (result) {
	          _this2.dependencies = result;
	          resolve();
	        });
	      });
	    },
	    loadData: function loadData(id) {
	      var _this3 = this;
	
	      _bus2.default.$emit('show-loader');
	      if (id) {
	        this.isEdit = true;
	        restfulService.get('event', null, id, null, ['paper_types.paper_type', 'paper_types.fields.field']).then(function (response) {
	          _this3.event.id = response.id;
	          _this3.eventPaperTypes = response.paper_types;
	          _this3.isLoadingData = false;
	          _bus2.default.$emit('hide-loader');
	        }).catch(function (e) {
	          console.log(e);
	          _bus2.default.$emit('hide-loader');
	          _this3.isLoadingData = false;
	        });
	      } else {
	        _bus2.default.$emit('hide-loader');
	        this.isLoadingData = false;
	      }
	    },
	    checkPaperTypeSelected: function checkPaperTypeSelected(id) {
	      return this.eventPaperTypes.some(function (item) {
	        return item.paper_type_id === id;
	      });
	    },
	    selectPaperType: function selectPaperType() {
	      var _this4 = this;
	
	      if (this.paperTypeSelect && this.paperTypeSelect !== '') {
	        var hasPaperType = this.eventPaperTypes.some(function (item) {
	          return item.paper_type_id === _this4.paperTypeSelect;
	        });
	        if (!hasPaperType) {
	          var data = (0, _lodash.clone)(defaultPaperType);
	          data.paper_type = (0, _lodash.find)(this.dependencies.paper_types, function (item) {
	            return item.id === _this4.paperTypeSelect;
	          });
	          data.paper_type_id = data.paper_type.id;
	          data.order = this.eventPaperTypes.length + 1;
	          this.savePaperType(data).then(function (response) {
	            data.id = response.id;
	            _this4.eventPaperTypes.push(data);
	            _this4.paperTypeSelect = '';
	            _this4.editPaperType(data);
	            notifyService.success({ hideLoader: true });
	            _bus2.default.$emit('hide-loader');
	            _this4.isSubmitted = false;
	          }).catch(function (e) {
	            _this4.isSubmitted = false;
	            _bus2.default.$emit('hide-loader');
	            console.log(e);
	          });
	        }
	      }
	    },
	    onHandleModalPaperType: function onHandleModalPaperType() {
	      this.modalPaperTypeVisible = !this.modalPaperTypeVisible;
	    },
	    editPaperType: function editPaperType(item) {
	      var _this5 = this;
	
	      var paperType = (0, _lodash.cloneDeep)(item);
	      var fields = (0, _lodash.cloneDeep)(this.dependencies.fields);
	      fields.forEach(function (item) {
	        _this5.$set(item, 'checked', paperType.fields.some(function (field) {
	          return field.field_id === item.id;
	        }));
	      });
	      paperType.fields.splice(0);
	      paperType.fields = fields;
	      this.paperType = paperType;
	      this.modalPaperTypeVisible = !this.modalPaperTypeVisible;
	    },
	    savePaperType: function savePaperType(paperType) {
	      _bus2.default.$emit('show-loader');
	      this.isSubmitted = true;
	      var data = (0, _lodash.cloneDeep)(paperType);
	      data.event_id = this.event.id;
	      data.submission_start_datetime = this.dateTimeFormat(data.submission_start_datetime, 'en');
	      if (data.submission_start_datetime.length === 0) {
	        delete data.submission_start_datetime;
	      }
	      data.submission_end_datetime = this.dateTimeFormat(data.submission_end_datetime, 'en');
	      if (data.submission_end_datetime.length === 0) {
	        delete data.submission_end_datetime;
	      }
	      return restfulService.save('event_paper_type', null, null, data);
	    },
	    onSavePaperType: function onSavePaperType() {
	      var _this6 = this;
	
	      _bus2.default.$emit('show-loader');
	      var data = (0, _lodash.cloneDeep)(this.paperType);
	      this.savePaperType(data).then(function (response) {
	        _this6.loadData(_this6.event.id);
	        notifyService.success({ hideLoader: true });
	        _this6.isSubmitted = false;
	        _this6.onHandleModalPaperType();
	        _bus2.default.$emit('hide-loader');
	      }).catch(function (e) {
	        _this6.isSubmitted = false;
	        _bus2.default.$emit('hide-loader');
	        console.log(e);
	      });
	    },
	    removePaperType: function removePaperType(paperType) {
	      var _this7 = this;
	
	      restfulService.destroy('event_paper_type', null, paperType.id).then(function (_) {
	        _this7.eventPaperTypes = _this7.eventPaperTypes.filter(function (item) {
	          return item.paper_type_id !== paperType.paper_type_id;
	        });
	        notifyService.success({ hideLoader: true });
	        _this7.isSubmitted = false;
	      }).catch(function (e) {
	        _this7.isSubmitted = false;
	        console.log(e);
	      });
	    }
	  }
	};

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Header = __webpack_require__(5);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _restfulService = __webpack_require__(6);
	
	var restfulService = _interopRequireWildcard(_restfulService);
	
	var _bus = __webpack_require__(4);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	var _lodash = __webpack_require__(3);
	
	var _highchartsVue = __webpack_require__(131);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ListHeader: _Header2.default, highcharts: _highchartsVue.Chart },
	  data: function data() {
	    return {
	      activeTab: 'registration_list',
	      searchAppraiser: '',
	      reports: {
	        registrations_list: [],
	        registrations: [],
	        events: [],
	        modalities: [],
	        papers_review: []
	      },
	      chartPieOptions: {
	        chart: {
	          plotBackgroundColor: null,
	          plotBorderWidth: null,
	          plotShadow: false,
	          type: 'pie'
	        },
	        title: { text: '' },
	        tooltip: { pointFormat: '{series.name}: <b>{point.y}</b>' },
	        plotOptions: {
	          pie: {
	            allowPointSelect: true,
	            cursor: 'pointer',
	            dataLabels: {
	              enabled: true,
	              format: '<b>{point.name}</b>: {point.y}',
	              style: {
	                color: 'black'
	              }
	            }
	          }
	        },
	        series: [{
	          name: '',
	          colorByPoint: true,
	          data: []
	        }]
	      },
	      chartSemiCircleOptions: {
	        chart: {
	          plotBackgroundColor: null,
	          plotBorderWidth: 0,
	          plotShadow: false
	        },
	        title: { text: '' },
	        tooltip: {
	          pointFormat: '{series.name}: <b>{point.y}</b>'
	        },
	        plotOptions: {
	          pie: {
	            dataLabels: {
	              enabled: true,
	              format: '<b>{point.name}</b>: {point.y}',
	              distance: -50,
	              style: {
	                fontWeight: 'bold',
	                color: 'white'
	              }
	            }
	          }
	        },
	        series: [{
	          type: 'pie',
	          name: '',
	          innerSize: '20%',
	          data: []
	        }]
	      }
	    };
	  },
	
	  computed: {
	    pageTitle: function pageTitle() {
	      return 'Relatórios';
	    },
	    totalRegistrations: function totalRegistrations() {
	      var total = 0;
	      this.reports.registrations.forEach(function (item) {
	        total += item.total;
	      });
	      return total;
	    },
	    totalAmountRegistrations: function totalAmountRegistrations() {
	      var total = 0;
	      this.reports.registrations.forEach(function (item) {
	        total += item.total_amount;
	      });
	      return total;
	    },
	    papersReviewList: function papersReviewList() {
	      var _this = this;
	
	      return (0, _lodash.orderBy)(this.reports.papers_review.filter(function (item) {
	        return item.name.toLowerCase().includes(_this.searchAppraiser.toLowerCase());
	      }), ['total'], ['desc']);
	    }
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    var id = this.$route.params.id || null;
	    if (id) {
	      restfulService.get('event', 'reports/dashboard', id).then(function (response) {
	        _this2.reports = response;
	        _bus2.default.$emit('hide-loader');
	      }).catch(function (err) {
	        console.log(err);
	        _bus2.default.$emit('hide-loader');
	      });
	    } else {
	      _bus2.default.$emit('hide-loader');
	    }
	  },
	
	  methods: {
	    mountChartPieOptions: function mountChartPieOptions(items) {
	      var chartPieOptions = (0, _lodash.cloneDeep)(this.chartPieOptions);
	      chartPieOptions.series.splice(0);
	      chartPieOptions.series.push({
	        name: 'Total de Inscritos',
	        colorByPoint: true,
	        data: []
	      });
	      items.forEach(function (item) {
	        chartPieOptions.series[0].data.push({
	          name: item.literacy_name,
	          y: item.total
	        });
	      });
	      return chartPieOptions;
	    },
	    mountChartSemiCircleOptions: function mountChartSemiCircleOptions(items) {
	      var chartSemiCircleOptions = (0, _lodash.cloneDeep)(this.chartSemiCircleOptions);
	      chartSemiCircleOptions.series.splice(0);
	      chartSemiCircleOptions.series.push({
	        type: 'pie',
	        name: 'Total de Inscritos',
	        innerSize: '50%',
	        data: []
	      });
	      items.forEach(function (item) {
	        chartSemiCircleOptions.series[0].data.push({
	          name: item.status_name,
	          y: item.total
	        });
	      });
	      return chartSemiCircleOptions;
	    }
	  }
	};

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _set = __webpack_require__(104);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _toConsumableArray2 = __webpack_require__(32);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _Header = __webpack_require__(5);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _restfulService = __webpack_require__(6);
	
	var restfulService = _interopRequireWildcard(_restfulService);
	
	var _bus = __webpack_require__(4);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ListHeader: _Header2.default },
	  data: function data() {
	    return {
	      activeTab: 'advisors-urcamp',
	      mainEventId: null,
	      list: [],
	      filters: {
	        ref_pessoa: '',
	        name: '',
	        sub_event: '',
	        campus: '',
	        course: '',
	        status: '',
	        institution: ''
	      }
	    };
	  },
	
	  computed: {
	    pageTitle: function pageTitle() {
	      return 'Relatórios Gerenciais';
	    },
	    listFiltered: function listFiltered() {
	      var _this = this;
	
	      var list = this.list;
	      if (this.filters.ref_pessoa) {
	        list = list.filter(function (item) {
	          return item.ref_pessoa && item.ref_pessoa.toString().includes(_this.filters.ref_pessoa.toString());
	        });
	      }
	      if (this.filters.name) {
	        list = list.filter(function (item) {
	          return item.nome && item.nome.toLowerCase().includes(_this.filters.name.toLowerCase());
	        });
	      }
	      if (this.filters.sub_event) {
	        list = list.filter(function (item) {
	          return item.subevento && item.subevento.includes(_this.filters.sub_event);
	        });
	      }
	      if (this.filters.campus) {
	        list = list.filter(function (item) {
	          return item.campus && item.campus.includes(_this.filters.campus);
	        });
	      }
	      if (this.filters.course) {
	        list = list.filter(function (item) {
	          return item.curso && item.curso.includes(_this.filters.course);
	        });
	      }
	      if (this.filters.status) {
	        list = list.filter(function (item) {
	          return item.status && item.status.includes(_this.filters.status);
	        });
	      }
	      if (this.filters.institution) {
	        list = list.filter(function (item) {
	          return item.instituicao && item.instituicao.includes(_this.filters.institution);
	        });
	      }
	      return list;
	    },
	    listEvents: function listEvents() {
	      return [].concat((0, _toConsumableArray3.default)(new _set2.default(this.list.map(function (item) {
	        return item.subevento;
	      })))).sort();
	    },
	    listCampus: function listCampus() {
	      return [].concat((0, _toConsumableArray3.default)(new _set2.default(this.list.map(function (item) {
	        return item.campus;
	      })))).sort();
	    },
	    listCourse: function listCourse() {
	      return [].concat((0, _toConsumableArray3.default)(new _set2.default(this.list.map(function (item) {
	        return item.curso;
	      })))).sort();
	    },
	    listStatus: function listStatus() {
	      return [].concat((0, _toConsumableArray3.default)(new _set2.default(this.list.map(function (item) {
	        return item.status;
	      })))).sort();
	    },
	    listInstitution: function listInstitution() {
	      return [].concat((0, _toConsumableArray3.default)(new _set2.default(this.list.map(function (item) {
	        return item.instituicao;
	      })))).sort();
	    }
	  },
	  mounted: function mounted() {
	    this.mainEventId = this.$route.params.id || null;
	    this.loadList(this.activeTab);
	  },
	
	  watch: {
	    activeTab: function activeTab(newValue, oldValue) {
	      if (newValue !== oldValue) {
	        this.loadList(newValue);
	      }
	    }
	  },
	  methods: {
	    loadList: function loadList(route) {
	      var _this2 = this;
	
	      _bus2.default.$emit('show-loader');
	      this.list.splice(0);
	      restfulService.get('event', 'reports/' + route, this.mainEventId).then(function (response) {
	        _this2.list = response;
	        _bus2.default.$emit('hide-loader');
	      }).catch(function (err) {
	        console.log(err);
	        _bus2.default.$emit('hide-loader');
	      });
	    },
	    onFilterClean: function onFilterClean() {
	      this.filters = {
	        ref_pessoa: '',
	        name: '',
	        sub_event: '',
	        campus: '',
	        course: '',
	        status: ''
	      };
	    }
	  }
	};

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _set = __webpack_require__(104);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _toConsumableArray2 = __webpack_require__(32);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _Header = __webpack_require__(5);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _restfulService = __webpack_require__(6);
	
	var restfulService = _interopRequireWildcard(_restfulService);
	
	var _bus = __webpack_require__(4);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	var _lodash = __webpack_require__(3);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ListHeader: _Header2.default },
	  data: function data() {
	    return {
	      activeTab: 'premiacao-eventos',
	      mainEventId: null,
	      list: [],
	      filters: {
	        subevento: '',
	        area_conhecimento: '',
	        curso: '',
	        instituicao: '',
	        orientador: ''
	      }
	    };
	  },
	
	  computed: {
	    pageTitle: function pageTitle() {
	      return 'Relatórios Finais';
	    },
	    listFiltered: function listFiltered() {
	      var _this = this;
	
	      var list = this.list;
	      if (this.filters.subevento) {
	        list = list.filter(function (item) {
	          return item.subevento && item.subevento.includes(_this.filters.subevento);
	        });
	      }
	      if (this.filters.area_conhecimento) {
	        list = list.filter(function (item) {
	          return item.area_conhecimento && item.area_conhecimento.includes(_this.filters.area_conhecimento);
	        });
	      }
	      if (this.filters.curso) {
	        list = list.filter(function (item) {
	          return item.curso && item.curso.includes(_this.filters.curso);
	        });
	      }
	      if (this.filters.instituicao) {
	        list = list.filter(function (item) {
	          return item.instituicao && item.instituicao.includes(_this.filters.instituicao);
	        });
	      }
	      if (this.filters.orientador) {
	        list = list.filter(function (item) {
	          return item.orientador && item.orientador.includes(_this.filters.orientador);
	        });
	      }
	      if (this.activeTab === 'premiacao-eventos') {
	        return (0, _lodash.orderBy)(list, ['subevento', 'area_conhecimento', 'media_geral'], ['asc', 'asc', 'desc']);
	      }
	      if (this.activeTab === 'merito-institucional') {
	        return (0, _lodash.orderBy)(list, ['total'], ['desc']);
	      }
	      return list;
	    },
	    listSubeventos: function listSubeventos() {
	      return [].concat((0, _toConsumableArray3.default)(new _set2.default(this.list.filter(function (item) {
	        return item.subevento;
	      }).map(function (item) {
	        return item.subevento;
	      })))).sort();
	    },
	    listAreaConhecimento: function listAreaConhecimento() {
	      return [].concat((0, _toConsumableArray3.default)(new _set2.default(this.list.filter(function (item) {
	        return item.area_conhecimento;
	      }).map(function (item) {
	        return item.area_conhecimento;
	      })))).sort();
	    },
	    listCursos: function listCursos() {
	      return [].concat((0, _toConsumableArray3.default)(new _set2.default(this.list.filter(function (item) {
	        return item.curso;
	      }).map(function (item) {
	        return item.curso;
	      })))).sort();
	    },
	    listInstituicoes: function listInstituicoes() {
	      return [].concat((0, _toConsumableArray3.default)(new _set2.default(this.list.filter(function (item) {
	        return item.instituicao;
	      }).map(function (item) {
	        return item.instituicao;
	      })))).sort();
	    },
	    listOrientadores: function listOrientadores() {
	      return [].concat((0, _toConsumableArray3.default)(new _set2.default(this.list.filter(function (item) {
	        return item.orientador;
	      }).map(function (item) {
	        return item.orientador;
	      })))).sort();
	    }
	  },
	  mounted: function mounted() {
	    this.mainEventId = this.$route.params.id || null;
	    this.loadList(this.activeTab);
	  },
	
	  watch: {
	    activeTab: function activeTab(newValue, oldValue) {
	      if (newValue !== oldValue) {
	        this.loadList(newValue);
	      }
	    }
	  },
	  methods: {
	    loadList: function loadList(route) {
	      var _this2 = this;
	
	      _bus2.default.$emit('show-loader');
	      this.list.splice(0);
	      restfulService.get('event', 'reports/' + route, this.mainEventId).then(function (response) {
	        _this2.list = [].concat((0, _toConsumableArray3.default)(response));
	        _bus2.default.$emit('hide-loader');
	      }).catch(function (err) {
	        console.log(err);
	        _bus2.default.$emit('hide-loader');
	      });
	    },
	    onFilterClean: function onFilterClean() {
	      this.filters = {
	        subevento: '',
	        area_conhecimento: '',
	        curso: '',
	        instituicao: '',
	        orientador: ''
	      };
	    }
	  }
	};

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(32);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _Header = __webpack_require__(5);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _restfulService = __webpack_require__(6);
	
	var restfulService = _interopRequireWildcard(_restfulService);
	
	var _bus = __webpack_require__(4);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	var _lodash = __webpack_require__(3);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ListHeader: _Header2.default },
	  data: function data() {
	    return {
	      activeTab: 'minicursos',
	      mainEventId: null,
	      list: [],
	      filters: {
	        subevento: '',
	        orientador: ''
	      }
	    };
	  },
	
	  computed: {
	    pageTitle: function pageTitle() {
	      return 'Minicursos';
	    },
	    listFiltered: function listFiltered() {
	      var list = this.list;
	      if (this.activeTab === 'minicursos') {
	        return (0, _lodash.orderBy)(list, ['start_datetime'], ['asc']);
	      }
	      return list;
	    }
	  },
	  mounted: function mounted() {
	    this.mainEventId = this.$route.params.id || null;
	    this.loadList(this.activeTab);
	  },
	
	  watch: {
	    activeTab: function activeTab(newValue, oldValue) {
	      if (newValue !== oldValue) {
	        this.loadList(newValue);
	      }
	    }
	  },
	  methods: {
	    loadList: function loadList(route) {
	      var _this = this;
	
	      _bus2.default.$emit('show-loader');
	      this.list.splice(0);
	      restfulService.get('event', 'reports/' + route, this.mainEventId).then(function (response) {
	        _this.list = [].concat((0, _toConsumableArray3.default)(response));
	        _bus2.default.$emit('hide-loader');
	      }).catch(function (err) {
	        console.log(err);
	        _bus2.default.$emit('hide-loader');
	      });
	    },
	    calculaCor: function calculaCor(inscritos, vagas) {
	      var percentual = this.calculaPercentualInscritos(inscritos, vagas);
	      if (percentual > 60) {
	        return 'green';
	      } else if (percentual > 30) {
	        return 'orange';
	      } else {
	        return 'red';
	      }
	    },
	    calculaPercentualInscritos: function calculaPercentualInscritos(inscritos, vagas) {
	      return Math.round(inscritos / vagas * 100);
	    }
	  }
	};

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(27);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _Header = __webpack_require__(5);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _restfulService = __webpack_require__(6);
	
	var restfulService = _interopRequireWildcard(_restfulService);
	
	var _bus = __webpack_require__(4);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ListHeader: _Header2.default },
	  props: ['event'],
	  data: function data() {
	    return {
	      isLoadingData: true,
	      registrations: [],
	      papers: []
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    var id = this.event.id || null;
	
	    if (id) {
	      _bus2.default.$emit('show-loader');
	      _promise2.default.all([this.loadRegistrations(id), this.loadPapers(id)]).then(function (_) {
	        _this.isLoadingData = false;
	        _bus2.default.$emit('hide-loader');
	      }).catch(function (reason) {
	        console.warn('Erro ao buscar!', reason);
	      });
	    }
	  },
	
	  methods: {
	    loadRegistrations: function loadRegistrations(id) {
	      var _this2 = this;
	
	      return new _promise2.default(function (resolve, reject) {
	        var searchData = {
	          'modalities.event_modality': { has: [{ event_id: id }] },
	          orderBy: [{
	            column: 'created_at',
	            direction: 'DESC'
	          }]
	        };
	        restfulService.search('registration', null, searchData, null, ['person', 'status'], 1, 10).then(function (response) {
	          _this2.registrations = response.data;
	          resolve();
	        }).catch(function (err) {
	          console.log(err);
	          reject(err);
	        });
	      });
	    },
	    loadPapers: function loadPapers(id) {
	      var _this3 = this;
	
	      return new _promise2.default(function (resolve, reject) {
	        var searchData = {
	          'registration.modalities.event_modality': { has: [{ event_id: id }] },
	          orderBy: [{
	            column: 'date_submitted',
	            direction: 'DESC'
	          }]
	        };
	        restfulService.search('paper', null, searchData, null, ['registration.person', 'status', 'contents'], 1, 10).then(function (response) {
	          _this3.papers = response.data;
	          resolve();
	        }).catch(function (err) {
	          console.log(err);
	          reject(err);
	        });
	      });
	    }
	  }
	};

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(63);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Main = __webpack_require__(11);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Header = __webpack_require__(5);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _ShowButton = __webpack_require__(93);
	
	var _ShowButton2 = _interopRequireDefault(_ShowButton);
	
	var _EditButton = __webpack_require__(13);
	
	var _EditButton2 = _interopRequireDefault(_EditButton);
	
	var _DeleteButton = __webpack_require__(12);
	
	var _DeleteButton2 = _interopRequireDefault(_DeleteButton);
	
	var _PaperStatusLabel = __webpack_require__(673);
	
	var _PaperStatusLabel2 = _interopRequireDefault(_PaperStatusLabel);
	
	var _PaperShow = __webpack_require__(672);
	
	var _PaperShow2 = _interopRequireDefault(_PaperShow);
	
	var _PaperEvaluationsLabel = __webpack_require__(670);
	
	var _PaperEvaluationsLabel2 = _interopRequireDefault(_PaperEvaluationsLabel);
	
	var _restfulService = __webpack_require__(6);
	
	var restfulService = _interopRequireWildcard(_restfulService);
	
	var _notifyService = __webpack_require__(8);
	
	var notifyService = _interopRequireWildcard(_notifyService);
	
	var _bus = __webpack_require__(4);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	var _helper = __webpack_require__(18);
	
	var _helper2 = _interopRequireDefault(_helper);
	
	var _vuex = __webpack_require__(9);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultSearchData = {
	  event_id: null,
	  status: []
	};
	
	exports.default = {
	  components: {
	    ListMain: _Main2.default,
	    ListHeader: _Header2.default,
	    ListShowButton: _ShowButton2.default,
	    ListEditButton: _EditButton2.default,
	    ListDeleteButton: _DeleteButton2.default,
	    PaperStatusLabel: _PaperStatusLabel2.default,
	    PaperShow: _PaperShow2.default,
	    PaperEvaluationsLabel: _PaperEvaluationsLabel2.default
	  },
	  mixins: [_helper2.default],
	  data: function data() {
	    return {
	      isLoadingData: true,
	      isSubmitted: false,
	      isPaperVisible: false,
	      statusKey: '',
	      filters: {
	        id: ''
	      },
	      dependencies: {},
	      paper: {
	        notes: ''
	      }
	    };
	  },
	
	  watch: {
	    '$route': function $route(to) {
	      if (to.name === 'event.index.papers') {
	        this.loadList();
	      }
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.loadList();
	    _bus2.default.$on('papers-reload-list', function () {
	      _this.loadList();
	    });
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['listStore']), {
	    isOnEvaluation: function isOnEvaluation() {
	      return this.$route.params.statusKey === 'em_avaliacao';
	    },
	    allPapersEvaluated: function allPapersEvaluated() {
	      return this.listStore.listData.every(function (item) {
	        return item.reviews.filter(function (review) {
	          return review.last_action.status.key === 'atribuido' || review.last_action.status.key === 'aceito' || review.last_action.status.key === 'avaliado';
	        }).length === item.reviews.filter(function (review) {
	          return review.last_action.status.key === 'avaliado';
	        }).length;
	      });
	    },
	    listFiltered: function listFiltered() {
	      var _this2 = this;
	
	      if (this.isOnEvaluation) {
	        return this.listStore.listData.sort(function (a, b) {
	          if (!a.event_paper_type.evaluation_type) {
	            return 0;
	          } else {
	            return _this2.getEvaluationProgress(a) > _this2.getEvaluationProgress(b) ? 1 : _this2.getEvaluationProgress(b) > _this2.getEvaluationProgress(a) ? -1 : 0;
	          }
	        });
	      }
	      return this.listStore.listData;
	    }
	  }),
	  methods: {
	    loadList: function loadList() {
	      var _this3 = this;
	
	      this.isPaperVisible = false;
	      var id = this.$route.params.id || null;
	      var statusKey = this.$route.params.statusKey || null;
	      this.statusKey = statusKey;
	      var perPage = this.listStore.listPerPage;
	      var searchData = {
	        event_id: id,
	        status: null
	      };
	      if (statusKey) {
	        searchData.status = [];
	        searchData.status.push(statusKey);
	        if (statusKey === 'finalizado') {
	          searchData.status.push('reprovado');
	          searchData.status.push('aguardando_publicacao');
	        }
	      }
	      if (statusKey === 'em_avaliacao') {
	        perPage = 'all';
	      }
	      defaultSearchData = (0, _assign2.default)({}, searchData);
	      _bus2.default.$emit('list-init', {
	        domain: 'paper',
	        route: 'manager',
	        customSearch: true,
	        data: searchData,
	        perPage: perPage
	      }, function () {
	        _bus2.default.$emit('hide-loader');
	        _this3.isLoadingData = false;
	      });
	    },
	    onFilter: function onFilter() {
	      var searchData = (0, _assign2.default)({}, defaultSearchData);
	      if (this.filters.id) {
	        searchData.id = this.filters.id;
	      }
	      _bus2.default.$emit('list-filter', this.filters, searchData);
	    },
	    onFilterClean: function onFilterClean() {
	      this.filters = {};
	      _bus2.default.$emit('list-filter-clean', this.filters, defaultSearchData);
	    },
	    onDestroy: function onDestroy(item) {
	      _bus2.default.$emit('list-destroy-item', item);
	    },
	    getEvaluationProgress: function getEvaluationProgress(paper) {
	      var reviews = paper.reviews.filter(function (item) {
	        return item.last_action.status.key === 'atribuido' || item.last_action.status.key === 'aceito' || item.last_action.status.key === 'avaliado';
	      });
	      var minEvaluationsNumber = paper.event_paper_type.evaluation_type.min_evaluations_number;
	      var reviewsEvaluated = paper.reviews.filter(function (item) {
	        return item.last_action.status.key === 'avaliado';
	      });
	      if (reviews.length > 0) {
	        if (reviews.length > minEvaluationsNumber) {
	          minEvaluationsNumber = reviews.length;
	        }
	        return parseInt(reviewsEvaluated.length * 100 / minEvaluationsNumber);
	      }
	      return 0;
	    },
	    getTotalAvaliacoesInloco: function getTotalAvaliacoesInloco(reviews) {
	      var statusAllowed = [3, 7, 8];
	      var reviewsInloco = reviews.filter(function (item) {
	        return statusAllowed.indexOf(item.last_action.paper_status_id) > -1 && item.event_paper_type_evaluation_type.evaluation_type_id === 2;
	      });
	      return reviewsInloco.length;
	    },
	
	    isInvoicePaid: function isInvoicePaid(paper) {
	      console.log(paper.registration.status.key);
	      return paper.registration.status.key === 'pago' || paper.registration.status.key === 'sem_custo';
	    },
	    isEditDaysAvailable: function isEditDaysAvailable(paper) {
	      return paper.event_paper_type.edit_limit_days > 0 && this.momentInstance(paper.date_submitted).add(paper.event_paper_type.edit_limit_days, 'days').isBetween(this.momentNow(), this.momentNow().add(paper.event_paper_type.edit_limit_days, 'days'));
	    },
	    canBeApproved: function canBeApproved(paper) {
	      return this.isInvoicePaid(paper) && paper.event_paper_type.edit_limit_days === 0 || this.isInvoicePaid(paper) && !this.isEditDaysAvailable(paper);
	    },
	    showPaper: function showPaper(paper) {
	      var _this4 = this;
	
	      _bus2.default.$emit('show-loader');
	      this.isPaperVisible = false;
	      restfulService.get('paper', 'manage', paper.id).then(function (response) {
	        _this4.paper = response;
	        _this4.isPaperVisible = true;
	        setTimeout(function () {
	          _this4.$scrollTo('#paper-content');
	          _bus2.default.$emit('hide-loader');
	        }, 500);
	      }).catch(function (e) {
	        _this4.isPaperVisible = false;
	        console.log(e);
	      });
	    },
	    onSavePaper: function onSavePaper(data) {
	      var _this5 = this;
	
	      _bus2.default.$emit('show-loader');
	      this.isSubmitted = true;
	      restfulService.put('paper', 'update-status', data.id, data).then(function () {
	        notifyService.success({ hideLoader: true });
	        _this5.isSubmitted = false;
	        _this5.isPaperVisible = false;
	        _this5.paper = {};
	        _this5.loadList();
	      }).catch(function (e) {
	        _this5.isSubmitted = false;
	        console.log(e);
	      });
	    },
	    onFinishPapersWeb: function onFinishPapersWeb() {
	      var _this6 = this;
	
	      _bus2.default.$emit('show-loader');
	      this.isSubmitted = true;
	      var data = {};
	      var eventId = this.$route.params.id;
	      restfulService.put('event', 'finish-papers-web', eventId, data).then(function () {
	        notifyService.success({ hideLoader: true });
	        _this6.isSubmitted = false;
	        _this6.isPaperVisible = false;
	        _this6.paper = {};
	        _this6.loadList();
	      }).catch(function (e) {
	        _this6.isSubmitted = false;
	        console.log(e);
	      });
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.listStore.listData = [];
	  },
	  beforeDestroy: function beforeDestroy() {
	    _bus2.default.$off('papers-reload-list');
	  }
	};

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(63);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _Main = __webpack_require__(11);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Header = __webpack_require__(5);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _EditButton = __webpack_require__(13);
	
	var _EditButton2 = _interopRequireDefault(_EditButton);
	
	var _DeleteButton = __webpack_require__(12);
	
	var _DeleteButton2 = _interopRequireDefault(_DeleteButton);
	
	var _RegistrationStatusLabel = __webpack_require__(257);
	
	var _RegistrationStatusLabel2 = _interopRequireDefault(_RegistrationStatusLabel);
	
	var _restfulService = __webpack_require__(6);
	
	var restfulService = _interopRequireWildcard(_restfulService);
	
	var _notifyService = __webpack_require__(8);
	
	var notifyService = _interopRequireWildcard(_notifyService);
	
	var _dataService = __webpack_require__(21);
	
	var _dataService2 = _interopRequireDefault(_dataService);
	
	var _helper = __webpack_require__(18);
	
	var _helper2 = _interopRequireDefault(_helper);
	
	var _bus = __webpack_require__(4);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	var _lodash = __webpack_require__(3);
	
	var _vuex = __webpack_require__(9);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultSearchData = {
	  event_main_id: null
	};
	
	exports.default = {
	  components: { ListMain: _Main2.default, ListHeader: _Header2.default, ListEditButton: _EditButton2.default, ListDeleteButton: _DeleteButton2.default, RegistrationStatusLabel: _RegistrationStatusLabel2.default },
	  mixins: [_helper2.default],
	  data: function data() {
	    return {
	      isLoadingData: true,
	      filters: { ref_pessoa: '', status_id: '', dates: [], modality_id: '', filter_by_current_event: true, show_modalities: false },
	      dependencies: {}
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.getDependencies();
	    var eventMainId = this.$route.params.eventMainId || null;
	    var id = this.$route.params.id || null;
	    defaultSearchData.event_main_id = eventMainId;
	    var searchData = (0, _assign2.default)({ 'modalities.event_modality': { has: [{ event_id: id }] } }, defaultSearchData);
	    _bus2.default.$emit('list-init', {
	      domain: 'registration',
	      relations: ['status', 'person', 'papers', 'modalities.event_modality.event', 'modalities.activities'],
	      data: searchData
	    }, function () {
	      _this.isLoadingData = false;
	    });
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['listStore']), {
	    totalAmount: function totalAmount() {
	      return this.currencyEnToBr(this.listStore.listData.filter(function (item) {
	        return item.status.key !== 'pago' && item.status.key !== 'cancelado';
	      }).reduce(function (total, nextItem) {
	        return total + (nextItem.invoice ? parseFloat(nextItem.invoice.amount) : 0);
	      }, 0));
	    },
	    totalAmountPaid: function totalAmountPaid() {
	      return this.currencyEnToBr(this.listStore.listData.filter(function (item) {
	        return item.status.key === 'pago';
	      }).reduce(function (total, nextItem) {
	        return total + (nextItem.invoice ? parseFloat(nextItem.invoice.amount) : 0);
	      }, 0));
	    }
	  }),
	  methods: {
	    getDependencies: function getDependencies() {
	      var _this2 = this;
	
	      _dataService2.default.get([{ domain: 'status' }, { domain: 'modality' }]).then(function (result) {
	        _this2.dependencies = result;
	      });
	    },
	    onFilter: function onFilter() {
	      var id = this.$route.params.id || null;
	      var mainEventId = this.$route.params.mainEventId || null;
	      var searchData = (0, _assign2.default)({}, defaultSearchData);
	      if (this.filters.filter_by_current_event) {
	        searchData['modalities.event_modality'] = { has: [{ event_id: id }] };
	      } else {
	        searchData.event_main_id = mainEventId;
	      }
	      if (this.filters.status_id) {
	        searchData.status_id = this.filters.status_id;
	      }
	      if (!(0, _lodash.isEmpty)(this.filters.ref_pessoa)) {
	        searchData.person = { has: [{ ref_pessoa: { ilike: '%' + this.filters.ref_pessoa + '%' } }] };
	      }
	      if (this.filters.modality_id) {
	        if (searchData['modalities.event_modality']) {
	          searchData['modalities.event_modality'].has.push({ modality_id: this.filters.modality_id });
	        } else {
	          searchData['modalities.event_modality'] = { has: [{ modality_id: this.filters.modality_id }] };
	        }
	      }
	      if (this.filters.dates) {
	        var startDate = this.dateFormat(this.filters.dates[0], 'en');
	        var endDate = this.dateFormat(this.filters.dates[1], 'en');
	        if (startDate.length > 0 && endDate.length > 0) {
	          searchData.created_at = {
	            between: [startDate + ' 00:00:00', endDate + ' 23:59:59']
	          };
	        } else if (startDate.length > 0 && endDate.length === 0) {
	          searchData.created_at = {
	            between: [startDate, startDate]
	          };
	        } else if (startDate.length === 0 && endDate.length > 0) {
	          searchData.created_at = {
	            between: [endDate, endDate]
	          };
	        }
	      } else {
	        this.filters.dates = [];
	      }
	      _bus2.default.$emit('list-filter', this.filters, searchData);
	    },
	    onFilterClean: function onFilterClean() {
	      var id = this.$route.params.id || null;
	      var searchData = (0, _assign2.default)({ 'modalities.event_modality': { has: [{ event_id: id }] } }, defaultSearchData);
	      this.filters = {
	        ref_pessoa: '',
	        status_id: '',
	        dates: [],
	        modality_id: '',
	        filter_by_current_event: true
	      };
	      _bus2.default.$emit('list-filter-clean', this.filters, searchData);
	    },
	    onDestroy: function onDestroy(item) {
	      _bus2.default.$emit('list-destroy-item', item);
	    },
	    cancelRegistration: function cancelRegistration(registration) {
	      var _this3 = this;
	
	      this.isSubmitted = true;
	      this.$swal({
	        title: 'Deseja realmente cancelar sua inscrição?',
	        text: 'Essa ação não pode ser revertida!',
	        type: 'warning',
	        showCancelButton: true,
	        confirmButtonColor: '#3085d6',
	        cancelButtonColor: '#d33',
	        confirmButtonText: 'Sim, continuar!'
	      }).then(function () {
	        _bus2.default.$emit('show-loader');
	        restfulService.put('registration', 'cancel', registration.id).then(function (response) {
	          _this3.isSubmitted = false;
	          notifyService.success({ hideLoader: true, message: 'A inscrição foi cancelada com sucesso.' });
	          _this3.onFilter();
	          _bus2.default.$emit('hide-loader');
	        }).catch(function (e) {
	          _this3.isSubmitted = false;
	          _bus2.default.$emit('hide-loader');
	          console.log(e);
	        });
	      }).catch(function (e) {
	        console.log(e);
	        _bus2.default.$emit('hide-loader');
	      });
	    },
	    addActivity: function addActivity(registrationId, eventModalityRegistrationId) {
	      var _this4 = this;
	
	      var data = {
	        registration_id: registrationId,
	        event_modality_registration_id: eventModalityRegistrationId
	      };
	
	      this.isSubmitted = true;
	      this.$swal({
	        title: 'Deseja realmente inserir a presença?',
	        text: 'Essa ação não pode ser revertida!',
	        type: 'warning',
	        showCancelButton: true,
	        confirmButtonColor: '#3085d6',
	        cancelButtonColor: '#d33',
	        confirmButtonText: 'Sim, continuar!'
	      }).then(function () {
	        _bus2.default.$emit('show-loader');
	        restfulService.post('registration', 'activities/add', null, data).then(function (response) {
	          _this4.isSubmitted = false;
	          notifyService.success({ hideLoader: true, message: 'A presença foi registrada com sucesso.' });
	          _this4.onFilter();
	          _bus2.default.$emit('hide-loader');
	        }).catch(function (e) {
	          _this4.isSubmitted = false;
	          _bus2.default.$emit('hide-loader');
	          console.log(e);
	        });
	      }).catch(function (e) {
	        console.log(e);
	        _bus2.default.$emit('hide-loader');
	      });
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.listStore.listData = [];
	  }
	};

/***/ }),
/* 399 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'paper-evaluations-label',
	  props: ['evaluations'],
	  computed: {
	    labelType: function labelType() {
	      return this.evaluations > 1 ? 'success' : 'danger';
	    }
	  }
	};

/***/ }),
/* 400 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'registration-status-label',
	  props: ['statusId', 'statusName'],
	  computed: {
	    labelType: function labelType() {
	      switch (this.statusId) {
	        case 1:
	          return 'success';
	        case 2:
	          return 'default';
	        case 3:
	          return 'danger';
	        case 4:
	          return 'warning';
	        default:
	          return 'gray';
	      }
	    }
	  }
	};

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Responses = __webpack_require__(676);
	
	var _Responses2 = _interopRequireDefault(_Responses);
	
	var _Appraisers = __webpack_require__(675);
	
	var _Appraisers2 = _interopRequireDefault(_Appraisers);
	
	var _helper = __webpack_require__(18);
	
	var _helper2 = _interopRequireDefault(_helper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { PaperShowEvaluationResponses: _Responses2.default, PaperShowEvaluationAppraisers: _Appraisers2.default },
	  mixins: [_helper2.default],
	  name: 'paper-show-evaluation',
	  props: ['paper'],
	  data: function data() {
	    return {};
	  },
	
	  computed: {
	    paperStatusKey: function paperStatusKey() {
	      return this.paper.status.key;
	    },
	    isInvoiceOpened: function isInvoiceOpened() {
	      return this.paper.registration.status.key === 'em_aberto';
	    },
	    isInvoicePaid: function isInvoicePaid() {
	      return this.paper.registration.status.key === 'pago';
	    },
	    isEditDaysAvailable: function isEditDaysAvailable() {
	      return this.paper.event_paper_type.edit_limit_days > 0 && this.momentInstance(this.paper.date_submitted).add(this.paper.event_paper_type.edit_limit_days, 'days').isBetween(this.momentNow(), this.momentNow().add(this.paper.event_paper_type.edit_limit_days, 'days'));
	    },
	    canBeEvaluated: function canBeEvaluated() {
	      return this.paperStatusKey !== 'nao_designado' && this.paperStatusKey !== 'reprovado_pela_triagem';
	    },
	    canBeApproved: function canBeApproved() {
	      return this.isInvoicePaid && this.paper.event_paper_type.edit_limit_days === 0 || !this.isEditDaysAvailable;
	    }
	  },
	  methods: {
	    reviews: function reviews(eventPaperTypeEvaluationTypeId) {
	      return this.paper.reviews.filter(function (item) {
	        return item.event_paper_type_evaluation_type_id === eventPaperTypeEvaluationTypeId;
	      });
	    }
	  }
	};

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ValidationMessage = __webpack_require__(49);
	
	var _ValidationMessage2 = _interopRequireDefault(_ValidationMessage);
	
	var _Screening = __webpack_require__(674);
	
	var _Screening2 = _interopRequireDefault(_Screening);
	
	var _Evaluation = __webpack_require__(671);
	
	var _Evaluation2 = _interopRequireDefault(_Evaluation);
	
	var _helper = __webpack_require__(18);
	
	var _helper2 = _interopRequireDefault(_helper);
	
	var _validators = __webpack_require__(10);
	
	var _lodash = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ValidationMessage: _ValidationMessage2.default, PaperShowScreening: _Screening2.default, PaperShowEvaluation: _Evaluation2.default },
	  mixins: [_helper2.default],
	  props: ['model', 'loadList'],
	  data: function data() {
	    return {
	      isSubmitted: false,
	      isPaperVisible: false,
	      isSearchingAppraiser: false,
	      paper: {
	        notes: ''
	      },
	      dependencies: {
	        appraisers: [],
	        filteredAppraisers: []
	      },
	      appraisers: []
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.model.contents = (0, _lodash.orderBy)(this.model.contents, ['event_paper_type_field.field.type'], ['desc']);
	    this.paper = this.model;
	    setTimeout(function () {
	      _this.isPaperVisible = true;
	    }, 500);
	  },
	
	  computed: {
	    paperStatusKey: function paperStatusKey() {
	      return this.paper.status.key;
	    },
	    showPaperPreview: function showPaperPreview() {
	      return this.paperStatusKey === 'nao_designado';
	    },
	    getPaperFilePath: function getPaperFilePath() {
	      return this.paper.file ? this.paper.file.show_file_path : '';
	    }
	  },
	  validations: function validations() {
	    return {
	      paper: {
	        notes: { required: _validators.required }
	      },
	      appraisers: {
	        required: _validators.required,
	        minLength: (0, _validators.minLength)(this.showEvaluations ? 1 : this.paper.event_paper_type.evaluation_type ? this.minEvaluations : 0),
	        $each: {
	          appraiser_id: { required: _validators.required }
	        }
	      }
	    };
	  }
	};

/***/ }),
/* 403 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'paper-status-label',
	  props: ['statusId', 'statusKey', 'statusName']
	};

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _restfulService = __webpack_require__(6);
	
	var restfulService = _interopRequireWildcard(_restfulService);
	
	var _notifyService = __webpack_require__(8);
	
	var notifyService = _interopRequireWildcard(_notifyService);
	
	var _bus = __webpack_require__(4);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	var _helper = __webpack_require__(18);
	
	var _helper2 = _interopRequireDefault(_helper);
	
	var _validators = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = {
	  mixins: [_helper2.default],
	  name: 'paper-show-screening',
	  props: ['paper'],
	  data: function data() {
	    return {
	      isSubmitted: false
	    };
	  },
	
	  validations: function validations() {
	    return {
	      paper: {
	        notes: { required: _validators.required }
	      }
	    };
	  },
	  computed: {
	    paperStatusKey: function paperStatusKey() {
	      return this.paper.status.key;
	    },
	    isInvoiceOpened: function isInvoiceOpened() {
	      return this.paper.registration.status.key === 'em_aberto';
	    },
	    isInvoicePaid: function isInvoicePaid() {
	      return this.paper.registration.status.key === 'pago';
	    },
	    isEditDaysAvailable: function isEditDaysAvailable() {
	      return this.paper.event_paper_type.edit_limit_days > 0 && this.momentInstance(this.paper.date_submitted).add(this.paper.event_paper_type.edit_limit_days, 'days').isBetween(this.momentNow(), this.momentNow().add(this.paper.event_paper_type.edit_limit_days, 'days'));
	    },
	    canBeApproved: function canBeApproved() {
	      return this.isInvoicePaid && this.paper.event_paper_type.edit_limit_days === 0 || this.isInvoicePaid && !this.isEditDaysAvailable || !this.isEditDaysAvailable || this.paper.event_paper_type.edit_limit_days === 0;
	    },
	    hasScreening: function hasScreening() {
	      return this.paper.event_paper_type.screening;
	    },
	    showScreeningOption: function showScreeningOption() {
	      return this.hasScreening && this.paperStatusKey === 'nao_designado' || !this.hasScreening && this.paperStatusKey === 'aprovado_pela_triagem';
	    }
	  },
	  methods: {
	    onAcceptPaper: function onAcceptPaper() {
	      _bus2.default.$emit('show-loader');
	      var data = {
	        id: this.paper.id,
	        status: 'accept',
	        notes: this.paper.notes
	      };
	      this.onScreeningPaper(data);
	    },
	    onRejectPaper: function onRejectPaper() {
	      _bus2.default.$emit('show-loader');
	      var data = {
	        id: this.paper.id,
	        status: 'rejected',
	        notes: this.paper.notes
	      };
	      this.onScreeningPaper(data);
	    },
	    onScreeningPaper: function onScreeningPaper(data) {
	      var _this = this;
	
	      _bus2.default.$emit('show-loader');
	      this.isSubmitted = true;
	      restfulService.put('paper', 'update-status', data.id, data).then(function () {
	        notifyService.success({ hideLoader: true });
	        _bus2.default.$emit('papers-reload-list');
	        _this.isSubmitted = false;
	      }).catch(function (e) {
	        _this.isSubmitted = false;
	        _bus2.default.$emit('hide-loader');
	        console.log(e);
	      });
	    }
	  }
	};

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(32);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _restfulService = __webpack_require__(6);
	
	var restfulService = _interopRequireWildcard(_restfulService);
	
	var _notifyService = __webpack_require__(8);
	
	var notifyService = _interopRequireWildcard(_notifyService);
	
	var _bus = __webpack_require__(4);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	var _helper = __webpack_require__(18);
	
	var _helper2 = _interopRequireDefault(_helper);
	
	var _validators = __webpack_require__(10);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_helper2.default],
	  name: 'paper-show-evaluation-appraisers',
	  props: ['paper', 'reviews', 'evaluationType'],
	  data: function data() {
	    return {
	      isSubmitted: false,
	      isSearchingAppraiser: false,
	      dependencies: {
	        appraisers: [],
	        filteredAppraisers: []
	      },
	      appraisers: []
	    };
	  },
	
	  validations: function validations() {
	    return {
	      appraisers: {
	        required: _validators.required,
	        minLength: (0, _validators.minLength)(this.showEvaluations ? 1 : this.evaluationType ? this.minEvaluations : 0),
	        $each: {
	          appraiser_id: { required: _validators.required }
	        }
	      }
	    };
	  },
	  computed: {
	    minEvaluations: function minEvaluations() {
	      return this.evaluationType ? this.evaluationType.min_evaluations_number - this.reviews.length : 0;
	    }
	  },
	  mounted: function mounted() {
	    var appraisers = [];
	    for (var i = 0; i < this.minEvaluations; i++) {
	      appraisers.push({
	        appraiser_id: ''
	      });
	    }
	    this.appraisers = [].concat(appraisers);
	    this.getAppraisers(this.paper.event_paper_type.event_id);
	  },
	
	  methods: {
	    addSingleAppraiser: function addSingleAppraiser() {
	      if (this.appraisers.length === 0) {
	        this.getAppraisers(this.paper.event_paper_type.event_id);
	      }
	      this.appraisers.push({ appraiser_id: '' });
	      this.$v.appraisers.$reset();
	    },
	    getAppraisers: function getAppraisers(eventId) {
	      var _this = this;
	
	      this.dependencies.appraisers.splice(0);
	      this.dependencies.filteredAppraisers.splice(0);
	      var data = { event_id: eventId };
	      restfulService.post('registration', 'appraisers', null, data).then(function (response) {
	        response.forEach(function (item) {
	          item.show = true;
	        });
	        _this.dependencies.appraisers = [].concat((0, _toConsumableArray3.default)(response));
	        _this.dependencies.filteredAppraisers = [].concat((0, _toConsumableArray3.default)(response));
	      }).catch(function (e) {
	        console.log(e);
	      });
	    },
	    selectAppraiser: function selectAppraiser() {
	      var _this2 = this;
	
	      this.dependencies.appraisers.forEach(function (item) {
	        item.show = !_this2.appraisers.some(function (appraiser) {
	          return appraiser.appraiser_id === item.id;
	        });
	      });
	    },
	    removeAppraiser: function removeAppraiser(index) {
	      this.appraisers.splice(index, 1);
	      this.selectAppraiser();
	    },
	    onAssignAppraisers: function onAssignAppraisers() {
	      var _this3 = this;
	
	      _bus2.default.$emit('show-loader');
	      this.isSubmitted = true;
	      var data = {
	        id: this.paper.id,
	        evaluation_type_id: this.evaluationType.id,
	        appraisers: this.appraisers
	      };
	      restfulService.post('paper', 'assign-appraisers', data.id, data).then(function () {
	        notifyService.success({ hideLoader: true });
	        _bus2.default.$emit('papers-reload-list');
	        _this3.isSubmitted = false;
	      }).catch(function (e) {
	        _this3.isSubmitted = false;
	        _bus2.default.$emit('hide-loader');
	        console.log(e);
	      });
	    }
	  }
	};

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _restfulService = __webpack_require__(6);
	
	var restfulService = _interopRequireWildcard(_restfulService);
	
	var _notifyService = __webpack_require__(8);
	
	var notifyService = _interopRequireWildcard(_notifyService);
	
	var _bus = __webpack_require__(4);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	var _helper = __webpack_require__(18);
	
	var _helper2 = _interopRequireDefault(_helper);
	
	var _sweetalert = __webpack_require__(42);
	
	var _sweetalert2 = _interopRequireDefault(_sweetalert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = {
	  mixins: [_helper2.default],
	  name: 'paper-show-evaluation-responses',
	  props: ['paper', 'reviews', 'evaluationType'],
	  data: function data() {
	    return {
	      isSubmitted: false
	    };
	  },
	
	  computed: {
	    averageEvaluations: function averageEvaluations() {
	      var totalEvaluations = 0;
	      var evaluations = 0;
	      this.reviews.forEach(function (item) {
	        if (item.responses.length) {
	          item.responses.forEach(function (response) {
	            totalEvaluations++;
	            evaluations += parseFloat(response.value);
	          });
	        }
	      });
	      if (totalEvaluations > 0) {
	        return (evaluations / totalEvaluations).toFixed(2);
	      }
	      return 'Aguardando avaliações';
	    },
	    paperStatusKey: function paperStatusKey() {
	      return this.paper.status.key;
	    }
	  },
	  methods: {
	    cancelEvaluation: function cancelEvaluation(review) {
	      var _this = this;
	
	      _bus2.default.$emit('show-loader');
	      this.isSubmitted = true;
	      var data = {
	        id: review.id
	      };
	      restfulService.put('paper_review', 'cancel', data.id, data).then(function () {
	        notifyService.success({ hideLoader: true });
	        _bus2.default.$emit('papers-reload-list');
	        _this.isSubmitted = false;
	        _bus2.default.$emit('hide-loader');
	      }).catch(function (e) {
	        _this.isSubmitted = false;
	        _bus2.default.$emit('hide-loader');
	        console.log(e);
	      });
	    },
	    resetEvaluation: function resetEvaluation(review) {
	      var _this2 = this;
	
	      (0, _sweetalert2.default)({
	        title: 'Deseja realmente remover as notas dessa avaliação?',
	        text: 'Essa ação não pode ser revertida, o avaliador terá que preencher todas as notas dos critérios novamente!',
	        type: 'warning',
	        showCancelButton: true,
	        confirmButtonColor: '#3085d6',
	        cancelButtonColor: '#d33',
	        confirmButtonText: 'Sim, continuar!'
	      }).then(function () {
	        _bus2.default.$emit('show-loader');
	        _this2.isSubmitted = true;
	        var data = {
	          id: review.id
	        };
	        restfulService.put('paper_review', 'reset', data.id, data).then(function () {
	          notifyService.success({ hideLoader: true });
	          _bus2.default.$emit('papers-reload-list');
	          _this2.isSubmitted = false;
	          _bus2.default.$emit('hide-loader');
	        }).catch(function (e) {
	          _this2.isSubmitted = false;
	          _bus2.default.$emit('hide-loader');
	          console.log(e);
	        });
	      }).catch(function (e) {
	        _this2.isSubmitted = false;
	        _bus2.default.$emit('hide-loader');
	      });
	    },
	    averageResponsesEvaluation: function averageResponsesEvaluation(item) {
	      var totalEvaluations = 0;
	      var evaluations = 0;
	      item.responses.forEach(function (response) {
	        totalEvaluations++;
	        evaluations += parseFloat(response.value);
	      });
	      if (totalEvaluations > 0) {
	        return (evaluations / totalEvaluations).toFixed(2);
	      }
	      return 0;
	    }
	  }
	};

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Header = __webpack_require__(5);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _SaveButton = __webpack_require__(16);
	
	var _SaveButton2 = _interopRequireDefault(_SaveButton);
	
	var _CancelButton = __webpack_require__(14);
	
	var _CancelButton2 = _interopRequireDefault(_CancelButton);
	
	var _restfulService = __webpack_require__(6);
	
	var restfulService = _interopRequireWildcard(_restfulService);
	
	var _notifyService = __webpack_require__(8);
	
	var notifyService = _interopRequireWildcard(_notifyService);
	
	var _lodash = __webpack_require__(3);
	
	var _validators = __webpack_require__(10);
	
	var _bus = __webpack_require__(4);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ListHeader: _Header2.default, FormSaveButton: _SaveButton2.default, FormCancelButton: _CancelButton2.default },
	  data: function data() {
	    return {
	      isEdit: false,
	      isSubmitted: false,
	      isLoadingData: true,
	      form: {
	        name: '',
	        description: '',
	        type: '',
	        min_size: '',
	        max_size: ''
	      },
	      dependencies: {
	        type: [{
	          value: 'text',
	          label: 'Texto'
	        }, {
	          value: 'textarea',
	          label: 'Área de Texto'
	        }, {
	          value: 'file',
	          label: 'Arquivo'
	        }]
	      }
	    };
	  },
	
	  validations: {
	    form: {
	      name: { required: _validators.required },
	      description: { required: _validators.required },
	      type: { required: _validators.required },
	      min_size: { required: _validators.required },
	      max_size: { required: _validators.required }
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    var id = this.$route.params.id || null;
	    if (id) {
	      this.isEdit = true;
	      restfulService.get('field', null, id).then(function (response) {
	        _this.form = response;
	        _this.isLoadingData = false;
	        _bus2.default.$emit('hide-loader');
	      }).catch(function (e) {
	        console.log(e);
	        _this.isLoadingData = false;
	        _bus2.default.$emit('hide-loader');
	      });
	    } else {
	      this.isLoadingData = false;
	      _bus2.default.$emit('hide-loader');
	    }
	  },
	
	  methods: {
	    onSend: function onSend() {
	      var _this2 = this;
	
	      this.isSubmitted = true;
	      var data = (0, _lodash.clone)(this.form);
	      restfulService.save('field', null, null, data).then(function () {
	        notifyService.success({ hideLoader: true });
	        _this2.isSubmitted = false;
	        _this2.$router.push({ name: 'field.index' });
	      }).catch(function (e) {
	        _this2.isSubmitted = false;
	        console.log(e);
	      });
	    }
	  }
	};

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Main = __webpack_require__(11);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Header = __webpack_require__(5);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _EditButton = __webpack_require__(13);
	
	var _EditButton2 = _interopRequireDefault(_EditButton);
	
	var _DeleteButton = __webpack_require__(12);
	
	var _DeleteButton2 = _interopRequireDefault(_DeleteButton);
	
	var _bus = __webpack_require__(4);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	var _lodash = __webpack_require__(3);
	
	var _vuex = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ListMain: _Main2.default, ListHeader: _Header2.default, ListEditButton: _EditButton2.default, ListDeleteButton: _DeleteButton2.default },
	  data: function data() {
	    return {
	      isLoadingData: true,
	      filters: {},
	      dependencies: {}
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    _bus2.default.$emit('list-init', { domain: 'field' }, function () {
	      _this.isLoadingData = false;
	    });
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['listStore'])),
	  methods: {
	    onFilter: function onFilter() {
	      var searchData = {};
	      if (!(0, _lodash.isEmpty)(this.filters.name)) {
	        searchData.name = {
	          'ilike': '%' + this.filters.name + '%'
	        };
	      }
	      _bus2.default.$emit('list-filter', this.filters, searchData);
	    },
	    onFilterClean: function onFilterClean() {
	      this.filters = {};
	      _bus2.default.$emit('list-filter-clean', this.filters);
	    },
	    onDestroy: function onDestroy(item) {
	      _bus2.default.$emit('list-destroy-item', item);
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.listStore.listData = [];
	  }
	};

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Header = __webpack_require__(5);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _SaveButton = __webpack_require__(16);
	
	var _SaveButton2 = _interopRequireDefault(_SaveButton);
	
	var _CancelButton = __webpack_require__(14);
	
	var _CancelButton2 = _interopRequireDefault(_CancelButton);
	
	var _restfulService = __webpack_require__(6);
	
	var restfulService = _interopRequireWildcard(_restfulService);
	
	var _notifyService = __webpack_require__(8);
	
	var notifyService = _interopRequireWildcard(_notifyService);
	
	var _lodash = __webpack_require__(3);
	
	var _validators = __webpack_require__(10);
	
	var _bus = __webpack_require__(4);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ListHeader: _Header2.default, FormSaveButton: _SaveButton2.default, FormCancelButton: _CancelButton2.default },
	  data: function data() {
	    return {
	      isEdit: false,
	      isSubmitted: false,
	      isLoadingData: true,
	      form: {
	        name: '',
	        initials: '',
	        description: ''
	      },
	      dependencies: {}
	    };
	  },
	
	  validations: {
	    form: {
	      name: { required: _validators.required },
	      initials: { required: _validators.required }
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    var id = this.$route.params.id || null;
	    if (id) {
	      this.isEdit = true;
	      restfulService.get('institution', null, id).then(function (response) {
	        _this.form = response;
	        _this.isLoadingData = false;
	        _bus2.default.$emit('hide-loader');
	      }).catch(function (e) {
	        console.log(e);
	        _this.isLoadingData = false;
	        _bus2.default.$emit('hide-loader');
	      });
	    } else {
	      this.isLoadingData = false;
	      _bus2.default.$emit('hide-loader');
	    }
	  },
	
	  methods: {
	    onSend: function onSend() {
	      var _this2 = this;
	
	      this.isSubmitted = true;
	      var data = (0, _lodash.clone)(this.form);
	      restfulService.save('institution', null, null, data).then(function () {
	        notifyService.success({ hideLoader: true });
	        _this2.isSubmitted = false;
	        _this2.$router.push({ name: 'institution.index' });
	      }).catch(function (e) {
	        _this2.isSubmitted = false;
	        console.log(e);
	      });
	    }
	  }
	};

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Main = __webpack_require__(11);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Header = __webpack_require__(5);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _EditButton = __webpack_require__(13);
	
	var _EditButton2 = _interopRequireDefault(_EditButton);
	
	var _DeleteButton = __webpack_require__(12);
	
	var _DeleteButton2 = _interopRequireDefault(_DeleteButton);
	
	var _bus = __webpack_require__(4);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	var _lodash = __webpack_require__(3);
	
	var _vuex = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ListMain: _Main2.default, ListHeader: _Header2.default, ListEditButton: _EditButton2.default, ListDeleteButton: _DeleteButton2.default },
	  data: function data() {
	    return {
	      isLoadingData: true,
	      filters: {},
	      dependencies: {}
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    _bus2.default.$emit('list-init', { domain: 'institution' }, function () {
	      _this.isLoadingData = false;
	    });
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['listStore'])),
	  methods: {
	    onFilter: function onFilter() {
	      var searchData = {};
	      if (!(0, _lodash.isEmpty)(this.filters.name)) {
	        searchData.name = {
	          'ilike': '%' + this.filters.name + '%'
	        };
	      }
	      _bus2.default.$emit('list-filter', this.filters, searchData);
	    },
	    onFilterClean: function onFilterClean() {
	      this.filters = {};
	      _bus2.default.$emit('list-filter-clean', this.filters);
	    },
	    onDestroy: function onDestroy(item) {
	      _bus2.default.$emit('list-destroy-item', item);
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.listStore.listData = [];
	  }
	};

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Header = __webpack_require__(5);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _SaveButton = __webpack_require__(16);
	
	var _SaveButton2 = _interopRequireDefault(_SaveButton);
	
	var _CancelButton = __webpack_require__(14);
	
	var _CancelButton2 = _interopRequireDefault(_CancelButton);
	
	var _dataService = __webpack_require__(21);
	
	var _dataService2 = _interopRequireDefault(_dataService);
	
	var _restfulService = __webpack_require__(6);
	
	var restfulService = _interopRequireWildcard(_restfulService);
	
	var _notifyService = __webpack_require__(8);
	
	var notifyService = _interopRequireWildcard(_notifyService);
	
	var _lodash = __webpack_require__(3);
	
	var _validators = __webpack_require__(10);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ListHeader: _Header2.default, FormSaveButton: _SaveButton2.default, FormCancelButton: _CancelButton2.default },
	  data: function data() {
	    return {
	      isEdit: false,
	      isSubmitted: false,
	      isLoadingData: true,
	      form: {
	        institution_id: '',
	        name: '',
	        description: ''
	      },
	      dependencies: {}
	    };
	  },
	
	  validations: {
	    form: {
	      institution_id: { required: _validators.required },
	      name: { required: _validators.required }
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.getDependencies();
	    var id = this.$route.params.id || null;
	    if (id) {
	      this.isEdit = true;
	      restfulService.get('institution_unit', null, id).then(function (response) {
	        _this.form = response;
	        _this.isLoadingData = false;
	      }).catch(function (e) {
	        console.log(e);
	        _this.isLoadingData = false;
	      });
	    } else {
	      this.isLoadingData = false;
	    }
	  },
	
	  methods: {
	    getDependencies: function getDependencies() {
	      var _this2 = this;
	
	      _dataService2.default.get([{ domain: 'institution' }]).then(function (result) {
	        _this2.dependencies = result;
	      });
	    },
	    onSend: function onSend() {
	      var _this3 = this;
	
	      this.isSubmitted = true;
	      var data = (0, _lodash.clone)(this.form);
	      restfulService.save('institution_unit', null, null, data).then(function () {
	        notifyService.success({ hideLoader: true });
	        _this3.isSubmitted = false;
	        _this3.$router.push({ name: 'institution_unit.index' });
	      }).catch(function (e) {
	        _this3.isSubmitted = false;
	        console.log(e);
	      });
	    }
	  }
	};

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Main = __webpack_require__(11);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Header = __webpack_require__(5);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _EditButton = __webpack_require__(13);
	
	var _EditButton2 = _interopRequireDefault(_EditButton);
	
	var _DeleteButton = __webpack_require__(12);
	
	var _DeleteButton2 = _interopRequireDefault(_DeleteButton);
	
	var _bus = __webpack_require__(4);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	var _lodash = __webpack_require__(3);
	
	var _vuex = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ListMain: _Main2.default, ListHeader: _Header2.default, ListEditButton: _EditButton2.default, ListDeleteButton: _DeleteButton2.default },
	  data: function data() {
	    return {
	      isLoadingData: true,
	      filters: {},
	      dependencies: {}
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    _bus2.default.$emit('list-init', { domain: 'institution_unit', relations: ['institution'] }, function () {
	      _this.isLoadingData = false;
	    });
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['listStore'])),
	  methods: {
	    onFilter: function onFilter() {
	      var searchData = {};
	      if (!(0, _lodash.isEmpty)(this.filters.name)) {
	        searchData.name = {
	          'ilike': '%' + this.filters.name + '%'
	        };
	      }
	      _bus2.default.$emit('list-filter', this.filters, searchData);
	    },
	    onFilterClean: function onFilterClean() {
	      this.filters = {};
	      _bus2.default.$emit('list-filter-clean', this.filters);
	    },
	    onDestroy: function onDestroy(item) {
	      _bus2.default.$emit('list-destroy-item', item);
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.listStore.listData = [];
	  }
	};

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Header = __webpack_require__(5);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _SaveButton = __webpack_require__(16);
	
	var _SaveButton2 = _interopRequireDefault(_SaveButton);
	
	var _CancelButton = __webpack_require__(14);
	
	var _CancelButton2 = _interopRequireDefault(_CancelButton);
	
	var _restfulService = __webpack_require__(6);
	
	var restfulService = _interopRequireWildcard(_restfulService);
	
	var _notifyService = __webpack_require__(8);
	
	var notifyService = _interopRequireWildcard(_notifyService);
	
	var _lodash = __webpack_require__(3);
	
	var _validators = __webpack_require__(10);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ListHeader: _Header2.default, FormSaveButton: _SaveButton2.default, FormCancelButton: _CancelButton2.default },
	  data: function data() {
	    return {
	      isEdit: false,
	      isSubmitted: false,
	      isLoadingData: true,
	      form: {
	        name: '',
	        nationality: ''
	      },
	      dependencies: {}
	    };
	  },
	
	  validations: {
	    form: {
	      name: { required: _validators.required },
	      nationality: { required: _validators.required }
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    var id = this.$route.params.id || null;
	    if (id) {
	      this.isEdit = true;
	      restfulService.get('knowledge_area', null, id).then(function (response) {
	        _this.form = response;
	        _this.isLoadingData = false;
	      }).catch(function (e) {
	        console.log(e);
	        _this.isLoadingData = false;
	      });
	    } else {
	      this.isLoadingData = false;
	    }
	  },
	
	  methods: {
	    onSend: function onSend() {
	      var _this2 = this;
	
	      this.isSubmitted = true;
	      var data = (0, _lodash.clone)(this.form);
	      restfulService.save('knowledge_area', null, null, data).then(function () {
	        notifyService.success({ hideLoader: true });
	        _this2.isSubmitted = false;
	        _this2.$router.push({ name: 'knowledge_area.index' });
	      }).catch(function (e) {
	        _this2.isSubmitted = false;
	        console.log(e);
	      });
	    }
	  }
	};

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Main = __webpack_require__(11);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Header = __webpack_require__(5);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _EditButton = __webpack_require__(13);
	
	var _EditButton2 = _interopRequireDefault(_EditButton);
	
	var _DeleteButton = __webpack_require__(12);
	
	var _DeleteButton2 = _interopRequireDefault(_DeleteButton);
	
	var _bus = __webpack_require__(4);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	var _lodash = __webpack_require__(3);
	
	var _vuex = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ListMain: _Main2.default, ListHeader: _Header2.default, ListEditButton: _EditButton2.default, ListDeleteButton: _DeleteButton2.default },
	  data: function data() {
	    return {
	      isLoadingData: true,
	      filters: {},
	      dependencies: {}
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    _bus2.default.$emit('list-init', { domain: 'knowledge_area' }, function () {
	      _this.isLoadingData = false;
	    });
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['listStore'])),
	  methods: {
	    onFilter: function onFilter() {
	      var searchData = {};
	      if (!(0, _lodash.isEmpty)(this.filters.name)) {
	        searchData.name = {
	          'ilike': '%' + this.filters.name + '%'
	        };
	      }
	      _bus2.default.$emit('list-filter', this.filters, searchData);
	    },
	    onFilterClean: function onFilterClean() {
	      this.filters = {};
	      _bus2.default.$emit('list-filter-clean', this.filters);
	    },
	    onDestroy: function onDestroy(item) {
	      _bus2.default.$emit('list-destroy-item', item);
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.listStore.listData = [];
	  }
	};

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Header = __webpack_require__(5);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _SaveButton = __webpack_require__(16);
	
	var _SaveButton2 = _interopRequireDefault(_SaveButton);
	
	var _CancelButton = __webpack_require__(14);
	
	var _CancelButton2 = _interopRequireDefault(_CancelButton);
	
	var _SingleUpload = __webpack_require__(253);
	
	var _SingleUpload2 = _interopRequireDefault(_SingleUpload);
	
	var _Tinymce = __webpack_require__(92);
	
	var _Tinymce2 = _interopRequireDefault(_Tinymce);
	
	var _restfulService = __webpack_require__(6);
	
	var restfulService = _interopRequireWildcard(_restfulService);
	
	var _dataService = __webpack_require__(21);
	
	var _dataService2 = _interopRequireDefault(_dataService);
	
	var _notifyService = __webpack_require__(8);
	
	var notifyService = _interopRequireWildcard(_notifyService);
	
	var _lodash = __webpack_require__(3);
	
	var _validators = __webpack_require__(10);
	
	var _bus = __webpack_require__(4);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	var _config = __webpack_require__(50);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ListHeader: _Header2.default, FormSaveButton: _SaveButton2.default, FormCancelButton: _CancelButton2.default, FormSingleUpload: _SingleUpload2.default, FormTinymce: _Tinymce2.default },
	  data: function data() {
	    return {
	      isEdit: false,
	      isSubmitted: false,
	      isLoadingData: true,
	      form: {
	        name: '',
	        description: '',
	        image: {
	          name: '',
	          type: '',
	          size: '',
	          base64: ''
	        },
	        image_back_page: {
	          name: '',
	          type: '',
	          size: '',
	          base64: ''
	        },
	        content: ''
	      },
	      dependencies: {},
	      selectedSignature: []
	    };
	  },
	
	  validations: {
	    form: {
	      name: { required: _validators.required },
	      description: { required: _validators.required },
	      image: { required: _validators.required },
	      content: { required: _validators.required }
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.getDependencies();
	    var id = this.$route.params.id || null;
	    if (id) {
	      this.isEdit = true;
	      restfulService.get('layout', null, id, null, ['signatures']).then(function (response) {
	        var image = {
	          name: response.image,
	          type: '',
	          size: '',
	          base64: ''
	        };
	        response.image = image;
	        var imageBackPage = {
	          name: response.image_back_page,
	          type: '',
	          size: '',
	          base64: ''
	        };
	        response.image_back_page = imageBackPage;
	        _this.form = response;
	        _this.selectedSignature = response.signatures.map(function (item) {
	          return item.id;
	        });
	        _this.isLoadingData = false;
	        _bus2.default.$emit('hide-loader');
	      }).catch(function (e) {
	        console.log(e);
	        _this.isLoadingData = false;
	        _bus2.default.$emit('hide-loader');
	      });
	    } else {
	      this.isLoadingData = false;
	      _bus2.default.$emit('hide-loader');
	    }
	  },
	
	  computed: {
	    getLayoutImage: function getLayoutImage() {
	      return _config2.default.basePath + 'files/' + this.form.image.name;
	    },
	    getLayoutImageBackPage: function getLayoutImageBackPage() {
	      return _config2.default.basePath + 'files/' + this.form.image_back_page.name;
	    }
	  },
	  methods: {
	    getDependencies: function getDependencies() {
	      var _this2 = this;
	
	      _dataService2.default.get([{ domain: 'signature' }]).then(function (result) {
	        _this2.dependencies = result;
	      });
	    },
	    onSend: function onSend() {
	      var _this3 = this;
	
	      this.isSubmitted = true;
	      var data = (0, _lodash.clone)(this.form);
	      data.signature = this.selectedSignature;
	      restfulService.save('layout', null, null, data).then(function () {
	        notifyService.success({ hideLoader: true });
	        _this3.isSubmitted = false;
	        _this3.$router.push({ name: 'layout.index' });
	      }).catch(function (e) {
	        _this3.isSubmitted = false;
	        console.log(e);
	      });
	    }
	  }
	};

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Main = __webpack_require__(11);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Header = __webpack_require__(5);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _EditButton = __webpack_require__(13);
	
	var _EditButton2 = _interopRequireDefault(_EditButton);
	
	var _DeleteButton = __webpack_require__(12);
	
	var _DeleteButton2 = _interopRequireDefault(_DeleteButton);
	
	var _bus = __webpack_require__(4);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	var _lodash = __webpack_require__(3);
	
	var _vuex = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ListMain: _Main2.default, ListHeader: _Header2.default, ListEditButton: _EditButton2.default, ListDeleteButton: _DeleteButton2.default },
	  data: function data() {
	    return {
	      isLoadingData: true,
	      filters: {},
	      dependencies: {}
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    _bus2.default.$emit('list-init', { domain: 'layout' }, function () {
	      _this.isLoadingData = false;
	    });
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['listStore'])),
	  methods: {
	    onFilter: function onFilter() {
	      var searchData = {};
	      if (!(0, _lodash.isEmpty)(this.filters.name)) {
	        searchData.name = {
	          'ilike': '%' + this.filters.name + '%'
	        };
	      }
	      _bus2.default.$emit('list-filter', this.filters, searchData);
	    },
	    onFilterClean: function onFilterClean() {
	      this.filters = {};
	      _bus2.default.$emit('list-filter-clean', this.filters);
	    },
	    onDestroy: function onDestroy(item) {
	      _bus2.default.$emit('list-destroy-item', item);
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.listStore.listData = [];
	  }
	};

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Header = __webpack_require__(5);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _SaveButton = __webpack_require__(16);
	
	var _SaveButton2 = _interopRequireDefault(_SaveButton);
	
	var _CancelButton = __webpack_require__(14);
	
	var _CancelButton2 = _interopRequireDefault(_CancelButton);
	
	var _restfulService = __webpack_require__(6);
	
	var restfulService = _interopRequireWildcard(_restfulService);
	
	var _notifyService = __webpack_require__(8);
	
	var notifyService = _interopRequireWildcard(_notifyService);
	
	var _lodash = __webpack_require__(3);
	
	var _validators = __webpack_require__(10);
	
	var _bus = __webpack_require__(4);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ListHeader: _Header2.default, FormSaveButton: _SaveButton2.default, FormCancelButton: _CancelButton2.default },
	  data: function data() {
	    return {
	      isEdit: false,
	      isSubmitted: false,
	      isLoadingData: true,
	      form: {
	        name: '',
	        description: '',
	        order: ''
	      },
	      dependencies: {}
	    };
	  },
	
	  validations: {
	    form: {
	      name: { required: _validators.required },
	      description: { required: _validators.required },
	      order: { required: _validators.required }
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    var id = this.$route.params.id || null;
	    if (id) {
	      this.isEdit = true;
	      restfulService.get('literacy', null, id).then(function (response) {
	        _this.form = response;
	        _this.isLoadingData = false;
	        _bus2.default.$emit('hide-loader');
	      }).catch(function (e) {
	        console.log(e);
	        _this.isLoadingData = false;
	        _bus2.default.$emit('hide-loader');
	      });
	    } else {
	      this.isLoadingData = false;
	      _bus2.default.$emit('hide-loader');
	    }
	  },
	
	  methods: {
	    onSend: function onSend() {
	      var _this2 = this;
	
	      this.isSubmitted = true;
	      var data = (0, _lodash.clone)(this.form);
	      restfulService.save('literacy', null, null, data).then(function () {
	        notifyService.success({ hideLoader: true });
	        _this2.isSubmitted = false;
	        _this2.$router.push({ name: 'literacy.index' });
	      }).catch(function (e) {
	        _this2.isSubmitted = false;
	        console.log(e);
	      });
	    }
	  }
	};

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Main = __webpack_require__(11);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Header = __webpack_require__(5);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _EditButton = __webpack_require__(13);
	
	var _EditButton2 = _interopRequireDefault(_EditButton);
	
	var _DeleteButton = __webpack_require__(12);
	
	var _DeleteButton2 = _interopRequireDefault(_DeleteButton);
	
	var _bus = __webpack_require__(4);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	var _lodash = __webpack_require__(3);
	
	var _vuex = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ListMain: _Main2.default, ListHeader: _Header2.default, ListEditButton: _EditButton2.default, ListDeleteButton: _DeleteButton2.default },
	  data: function data() {
	    return {
	      isLoadingData: true,
	      filters: {},
	      dependencies: {}
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    _bus2.default.$emit('list-init', { domain: 'literacy' }, function () {
	      _this.isLoadingData = false;
	    });
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['listStore'])),
	  methods: {
	    onFilter: function onFilter() {
	      var searchData = {};
	      if (!(0, _lodash.isEmpty)(this.filters.name)) {
	        searchData.name = {
	          'ilike': '%' + this.filters.name + '%'
	        };
	      }
	      _bus2.default.$emit('list-filter', this.filters, searchData);
	    },
	    onFilterClean: function onFilterClean() {
	      this.filters = {};
	      _bus2.default.$emit('list-filter-clean', this.filters);
	    },
	    onDestroy: function onDestroy(item) {
	      _bus2.default.$emit('list-destroy-item', item);
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.listStore.listData = [];
	  }
	};

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Header = __webpack_require__(5);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _SaveButton = __webpack_require__(16);
	
	var _SaveButton2 = _interopRequireDefault(_SaveButton);
	
	var _CancelButton = __webpack_require__(14);
	
	var _CancelButton2 = _interopRequireDefault(_CancelButton);
	
	var _restfulService = __webpack_require__(6);
	
	var restfulService = _interopRequireWildcard(_restfulService);
	
	var _notifyService = __webpack_require__(8);
	
	var notifyService = _interopRequireWildcard(_notifyService);
	
	var _lodash = __webpack_require__(3);
	
	var _validators = __webpack_require__(10);
	
	var _bus = __webpack_require__(4);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ListHeader: _Header2.default, FormSaveButton: _SaveButton2.default, FormCancelButton: _CancelButton2.default },
	  data: function data() {
	    return {
	      isEdit: false,
	      isSubmitted: false,
	      isLoadingData: true,
	      form: {
	        name: '',
	        description: ''
	      },
	      dependencies: {}
	    };
	  },
	
	  validations: {
	    form: {
	      name: { required: _validators.required },
	      description: { required: _validators.required }
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    var id = this.$route.params.id || null;
	    if (id) {
	      this.isEdit = true;
	      restfulService.get('modality', null, id).then(function (response) {
	        _this.form = response;
	        _this.isLoadingData = false;
	        _bus2.default.$emit('hide-loader');
	      }).catch(function (e) {
	        console.log(e);
	        _this.isLoadingData = false;
	        _bus2.default.$emit('hide-loader');
	      });
	    } else {
	      this.isLoadingData = false;
	      _bus2.default.$emit('hide-loader');
	    }
	  },
	
	  methods: {
	    onSend: function onSend() {
	      var _this2 = this;
	
	      this.isSubmitted = true;
	      var data = (0, _lodash.clone)(this.form);
	      restfulService.save('modality', null, null, data).then(function () {
	        notifyService.success({ hideLoader: true });
	        _this2.isSubmitted = false;
	        _this2.$router.push({ name: 'modality.index' });
	      }).catch(function (e) {
	        _this2.isSubmitted = false;
	        console.log(e);
	      });
	    }
	  }
	};

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Main = __webpack_require__(11);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Header = __webpack_require__(5);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _EditButton = __webpack_require__(13);
	
	var _EditButton2 = _interopRequireDefault(_EditButton);
	
	var _DeleteButton = __webpack_require__(12);
	
	var _DeleteButton2 = _interopRequireDefault(_DeleteButton);
	
	var _bus = __webpack_require__(4);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	var _lodash = __webpack_require__(3);
	
	var _vuex = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ListMain: _Main2.default, ListHeader: _Header2.default, ListEditButton: _EditButton2.default, ListDeleteButton: _DeleteButton2.default },
	  data: function data() {
	    return {
	      isLoadingData: true,
	      filters: {},
	      dependencies: {}
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    _bus2.default.$emit('list-init', { domain: 'modality' }, function () {
	      _this.isLoadingData = false;
	    });
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['listStore'])),
	  methods: {
	    onFilter: function onFilter() {
	      var searchData = {};
	      if (!(0, _lodash.isEmpty)(this.filters.name)) {
	        searchData.name = {
	          'ilike': '%' + this.filters.name + '%'
	        };
	      }
	      _bus2.default.$emit('list-filter', this.filters, searchData);
	    },
	    onFilterClean: function onFilterClean() {
	      this.filters = {};
	      _bus2.default.$emit('list-filter-clean', this.filters);
	    },
	    onDestroy: function onDestroy(item) {
	      _bus2.default.$emit('list-destroy-item', item);
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.listStore.listData = [];
	  }
	};

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Header = __webpack_require__(5);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _SaveButton = __webpack_require__(16);
	
	var _SaveButton2 = _interopRequireDefault(_SaveButton);
	
	var _CancelButton = __webpack_require__(14);
	
	var _CancelButton2 = _interopRequireDefault(_CancelButton);
	
	var _restfulService = __webpack_require__(6);
	
	var restfulService = _interopRequireWildcard(_restfulService);
	
	var _notifyService = __webpack_require__(8);
	
	var notifyService = _interopRequireWildcard(_notifyService);
	
	var _lodash = __webpack_require__(3);
	
	var _validators = __webpack_require__(10);
	
	var _bus = __webpack_require__(4);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ListHeader: _Header2.default, FormSaveButton: _SaveButton2.default, FormCancelButton: _CancelButton2.default },
	  data: function data() {
	    return {
	      isEdit: false,
	      isSubmitted: false,
	      isLoadingData: true,
	      form: {
	        name: '',
	        public_name: '',
	        description: ''
	      },
	      dependencies: {}
	    };
	  },
	
	  validations: {
	    form: {
	      name: { required: _validators.required },
	      public_name: { required: _validators.required },
	      description: { required: _validators.required }
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    var id = this.$route.params.id || null;
	    if (id) {
	      this.isEdit = true;
	      restfulService.get('paper_status', null, id).then(function (response) {
	        _this.form = response;
	        _this.isLoadingData = false;
	        _bus2.default.$emit('hide-loader');
	      }).catch(function (e) {
	        console.log(e);
	        _this.isLoadingData = false;
	        _bus2.default.$emit('hide-loader');
	      });
	    } else {
	      this.isLoadingData = false;
	      _bus2.default.$emit('hide-loader');
	    }
	  },
	
	  methods: {
	    onSend: function onSend() {
	      var _this2 = this;
	
	      this.isSubmitted = true;
	      var data = (0, _lodash.clone)(this.form);
	      restfulService.save('paper_status', null, null, data).then(function () {
	        notifyService.success({ hideLoader: true });
	        _this2.isSubmitted = false;
	        _this2.$router.push({ name: 'paper_status.index' });
	      }).catch(function (e) {
	        _this2.isSubmitted = false;
	        console.log(e);
	      });
	    }
	  }
	};

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Main = __webpack_require__(11);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Header = __webpack_require__(5);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _EditButton = __webpack_require__(13);
	
	var _EditButton2 = _interopRequireDefault(_EditButton);
	
	var _DeleteButton = __webpack_require__(12);
	
	var _DeleteButton2 = _interopRequireDefault(_DeleteButton);
	
	var _bus = __webpack_require__(4);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	var _lodash = __webpack_require__(3);
	
	var _vuex = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ListMain: _Main2.default, ListHeader: _Header2.default, ListEditButton: _EditButton2.default, ListDeleteButton: _DeleteButton2.default },
	  data: function data() {
	    return {
	      isLoadingData: true,
	      filters: {},
	      dependencies: {}
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    _bus2.default.$emit('list-init', { domain: 'paper_status' }, function () {
	      _this.isLoadingData = false;
	    });
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['listStore'])),
	  methods: {
	    onFilter: function onFilter() {
	      var searchData = {};
	      if (!(0, _lodash.isEmpty)(this.filters.name)) {
	        searchData.name = {
	          'ilike': '%' + this.filters.name + '%'
	        };
	      }
	      _bus2.default.$emit('list-filter', this.filters, searchData);
	    },
	    onFilterClean: function onFilterClean() {
	      this.filters = {};
	      _bus2.default.$emit('list-filter-clean', this.filters);
	    },
	    onDestroy: function onDestroy(item) {
	      _bus2.default.$emit('list-destroy-item', item);
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.listStore.listData = [];
	  }
	};

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Header = __webpack_require__(5);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _SaveButton = __webpack_require__(16);
	
	var _SaveButton2 = _interopRequireDefault(_SaveButton);
	
	var _CancelButton = __webpack_require__(14);
	
	var _CancelButton2 = _interopRequireDefault(_CancelButton);
	
	var _restfulService = __webpack_require__(6);
	
	var restfulService = _interopRequireWildcard(_restfulService);
	
	var _notifyService = __webpack_require__(8);
	
	var notifyService = _interopRequireWildcard(_notifyService);
	
	var _lodash = __webpack_require__(3);
	
	var _validators = __webpack_require__(10);
	
	var _bus = __webpack_require__(4);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ListHeader: _Header2.default, FormSaveButton: _SaveButton2.default, FormCancelButton: _CancelButton2.default },
	  data: function data() {
	    return {
	      isEdit: false,
	      isSubmitted: false,
	      isLoadingData: true,
	      form: {
	        name: '',
	        description: ''
	      },
	      dependencies: {}
	    };
	  },
	
	  validations: {
	    form: {
	      name: { required: _validators.required },
	      description: { required: _validators.required }
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    var id = this.$route.params.id || null;
	    if (id) {
	      this.isEdit = true;
	      restfulService.get('paper_type', null, id).then(function (response) {
	        _this.form = response;
	        _this.isLoadingData = false;
	        _bus2.default.$emit('hide-loader');
	      }).catch(function (e) {
	        console.log(e);
	        _this.isLoadingData = false;
	        _bus2.default.$emit('hide-loader');
	      });
	    } else {
	      this.isLoadingData = false;
	      _bus2.default.$emit('hide-loader');
	    }
	  },
	
	  methods: {
	    onSend: function onSend() {
	      var _this2 = this;
	
	      this.isSubmitted = true;
	      var data = (0, _lodash.clone)(this.form);
	      restfulService.save('paper_type', null, null, data).then(function () {
	        notifyService.success({ hideLoader: true });
	        _this2.isSubmitted = false;
	        _this2.$router.push({ name: 'paper_type.index' });
	      }).catch(function (e) {
	        _this2.isSubmitted = false;
	        console.log(e);
	      });
	    }
	  }
	};

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Main = __webpack_require__(11);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Header = __webpack_require__(5);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _EditButton = __webpack_require__(13);
	
	var _EditButton2 = _interopRequireDefault(_EditButton);
	
	var _DeleteButton = __webpack_require__(12);
	
	var _DeleteButton2 = _interopRequireDefault(_DeleteButton);
	
	var _bus = __webpack_require__(4);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	var _lodash = __webpack_require__(3);
	
	var _vuex = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ListMain: _Main2.default, ListHeader: _Header2.default, ListEditButton: _EditButton2.default, ListDeleteButton: _DeleteButton2.default },
	  data: function data() {
	    return {
	      isLoadingData: true,
	      filters: {},
	      dependencies: {}
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    _bus2.default.$emit('list-init', { domain: 'paper_type' }, function () {
	      _this.isLoadingData = false;
	    });
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['listStore'])),
	  methods: {
	    onFilter: function onFilter() {
	      var searchData = {};
	      if (!(0, _lodash.isEmpty)(this.filters.name)) {
	        searchData.name = {
	          'ilike': '%' + this.filters.name + '%'
	        };
	      }
	      _bus2.default.$emit('list-filter', this.filters, searchData);
	    },
	    onFilterClean: function onFilterClean() {
	      this.filters = {};
	      _bus2.default.$emit('list-filter-clean', this.filters);
	    },
	    onDestroy: function onDestroy(item) {
	      _bus2.default.$emit('list-destroy-item', item);
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.listStore.listData = [];
	  }
	};

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Header = __webpack_require__(5);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _SaveButton = __webpack_require__(16);
	
	var _SaveButton2 = _interopRequireDefault(_SaveButton);
	
	var _CancelButton = __webpack_require__(14);
	
	var _CancelButton2 = _interopRequireDefault(_CancelButton);
	
	var _restfulService = __webpack_require__(6);
	
	var restfulService = _interopRequireWildcard(_restfulService);
	
	var _notifyService = __webpack_require__(8);
	
	var notifyService = _interopRequireWildcard(_notifyService);
	
	var _lodash = __webpack_require__(3);
	
	var _validators = __webpack_require__(10);
	
	var _bus = __webpack_require__(4);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ListHeader: _Header2.default, FormSaveButton: _SaveButton2.default, FormCancelButton: _CancelButton2.default },
	  data: function data() {
	    return {
	      isEdit: false,
	      isSubmitted: false,
	      isLoadingData: true,
	      isSearchingCity: false,
	      form: {
	        city_id: '',
	        address: '',
	        description: ''
	      },
	      dependencies: {
	        cities: []
	      }
	    };
	  },
	
	  validations: {
	    form: {
	      city_id: { required: _validators.required },
	      address: { required: _validators.required },
	      description: { required: _validators.required }
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    var id = this.$route.params.id || null;
	    if (id) {
	      this.isEdit = true;
	      restfulService.get('place', null, id).then(function (response) {
	        _this.form = response;
	        _this.$set(_this.dependencies.cities, 0, response.city);
	        _this.isLoadingData = false;
	        _bus2.default.$emit('hide-loader');
	      }).catch(function (e) {
	        console.log(e);
	        _this.isLoadingData = false;
	        _bus2.default.$emit('hide-loader');
	      });
	    } else {
	      this.isLoadingData = false;
	      _bus2.default.$emit('hide-loader');
	    }
	  },
	
	  methods: {
	    onSearchCity: function onSearchCity(query) {
	      var _this2 = this;
	
	      this.dependencies.cities = [];
	      if (query !== '') {
	        this.isSearchingCity = true;
	        var data = {
	          query: query
	        };
	        restfulService.post('city', 'search', null, data).then(function (response) {
	          _this2.dependencies.cities = (0, _extends3.default)({}, _this2.dependencies.cities, response);
	          _this2.isSearchingCity = false;
	        }).catch(function (e) {
	          console.log(e);
	        });
	      }
	    },
	    onSend: function onSend() {
	      var _this3 = this;
	
	      this.isSubmitted = true;
	      var data = (0, _lodash.clone)(this.form);
	      restfulService.save('place', null, null, data).then(function () {
	        notifyService.success({ hideLoader: true });
	        _this3.isSubmitted = false;
	        _this3.$router.push({ name: 'place.index' });
	      }).catch(function (e) {
	        _this3.isSubmitted = false;
	        console.log(e);
	      });
	    }
	  }
	};

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Main = __webpack_require__(11);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Header = __webpack_require__(5);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _EditButton = __webpack_require__(13);
	
	var _EditButton2 = _interopRequireDefault(_EditButton);
	
	var _DeleteButton = __webpack_require__(12);
	
	var _DeleteButton2 = _interopRequireDefault(_DeleteButton);
	
	var _bus = __webpack_require__(4);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	var _lodash = __webpack_require__(3);
	
	var _vuex = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ListMain: _Main2.default, ListHeader: _Header2.default, ListEditButton: _EditButton2.default, ListDeleteButton: _DeleteButton2.default },
	  data: function data() {
	    return {
	      isLoadingData: true,
	      filters: {},
	      dependencies: {}
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    _bus2.default.$emit('list-init', { domain: 'place' }, function () {
	      _this.isLoadingData = false;
	    });
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['listStore'])),
	  methods: {
	    onFilter: function onFilter() {
	      var searchData = {};
	      if (!(0, _lodash.isEmpty)(this.filters.address)) {
	        searchData.address = {
	          'ilike': '%' + this.filters.address + '%'
	        };
	      }
	      _bus2.default.$emit('list-filter', this.filters, searchData);
	    },
	    onFilterClean: function onFilterClean() {
	      this.filters = {};
	      _bus2.default.$emit('list-filter-clean', this.filters);
	    },
	    onDestroy: function onDestroy(item) {
	      _bus2.default.$emit('list-destroy-item', item);
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.listStore.listData = [];
	  }
	};

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Header = __webpack_require__(5);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _SaveButton = __webpack_require__(16);
	
	var _SaveButton2 = _interopRequireDefault(_SaveButton);
	
	var _CancelButton = __webpack_require__(14);
	
	var _CancelButton2 = _interopRequireDefault(_CancelButton);
	
	var _dataService = __webpack_require__(21);
	
	var _dataService2 = _interopRequireDefault(_dataService);
	
	var _restfulService = __webpack_require__(6);
	
	var restfulService = _interopRequireWildcard(_restfulService);
	
	var _notifyService = __webpack_require__(8);
	
	var notifyService = _interopRequireWildcard(_notifyService);
	
	var _lodash = __webpack_require__(3);
	
	var _validators = __webpack_require__(10);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ListHeader: _Header2.default, FormSaveButton: _SaveButton2.default, FormCancelButton: _CancelButton2.default },
	  data: function data() {
	    return {
	      isEdit: false,
	      isSubmitted: false,
	      isLoadingData: true,
	      form: {
	        country_id: '',
	        name: '',
	        initials: ''
	      },
	      dependencies: {}
	    };
	  },
	
	  validations: {
	    form: {
	      country_id: { required: _validators.required },
	      name: { required: _validators.required },
	      initials: {
	        required: _validators.required,
	        minLength: (0, _validators.minLength)(2),
	        maxLength: (0, _validators.maxLength)(2)
	      }
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.getDependencies();
	    var id = this.$route.params.id || null;
	    if (id) {
	      this.isEdit = true;
	      restfulService.get('registration', null, id).then(function (response) {
	        _this.form = response;
	        _this.isLoadingData = false;
	      }).catch(function (e) {
	        console.log(e);
	        _this.isLoadingData = false;
	      });
	    } else {
	      this.isLoadingData = false;
	    }
	  },
	
	  methods: {
	    getDependencies: function getDependencies() {
	      var _this2 = this;
	
	      _dataService2.default.get([{ domain: 'country' }]).then(function (result) {
	        _this2.dependencies = result;
	      });
	    },
	    onSend: function onSend() {
	      var _this3 = this;
	
	      this.isSubmitted = true;
	      var data = (0, _lodash.clone)(this.form);
	      restfulService.save('registration', null, null, data).then(function () {
	        notifyService.success({ hideLoader: true });
	        _this3.isSubmitted = false;
	        _this3.$router.push({ name: 'registration.index' });
	      }).catch(function (e) {
	        _this3.isSubmitted = false;
	        console.log(e);
	      });
	    }
	  }
	};

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Main = __webpack_require__(11);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Header = __webpack_require__(5);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _EditButton = __webpack_require__(13);
	
	var _EditButton2 = _interopRequireDefault(_EditButton);
	
	var _DeleteButton = __webpack_require__(12);
	
	var _DeleteButton2 = _interopRequireDefault(_DeleteButton);
	
	var _StatusLabel = __webpack_require__(699);
	
	var _StatusLabel2 = _interopRequireDefault(_StatusLabel);
	
	var _dataService = __webpack_require__(21);
	
	var _dataService2 = _interopRequireDefault(_dataService);
	
	var _helper = __webpack_require__(18);
	
	var _helper2 = _interopRequireDefault(_helper);
	
	var _bus = __webpack_require__(4);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	var _lodash = __webpack_require__(3);
	
	var _vuex = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ListMain: _Main2.default, ListHeader: _Header2.default, ListEditButton: _EditButton2.default, ListDeleteButton: _DeleteButton2.default, RegistrationStatusLabel: _StatusLabel2.default },
	  mixins: [_helper2.default],
	  data: function data() {
	    return {
	      isLoadingData: true,
	      filters: { ref_pessoa: '', status_id: '', dates: [], modality_id: '' },
	      dependencies: {}
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.getDependencies();
	    _bus2.default.$emit('list-init', {
	      domain: 'registration',
	      relations: ['main_event', 'status', 'person', 'modalities.event_modality.modality']
	    }, function () {
	      _this.isLoadingData = false;
	    });
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['listStore'])),
	  methods: {
	    getDependencies: function getDependencies() {
	      var _this2 = this;
	
	      _dataService2.default.get([{ domain: 'status' }, { domain: 'modality' }]).then(function (result) {
	        _this2.dependencies = result;
	      });
	    },
	    onFilter: function onFilter() {
	      var searchData = {};
	      if (this.filters.status_id) {
	        searchData.status_id = this.filters.status_id;
	      }
	      if (!(0, _lodash.isEmpty)(this.filters.ref_pessoa)) {
	        searchData.person = {
	          has: [{
	            ref_pessoa: {
	              ilike: '%' + this.filters.ref_pessoa + '%'
	            }
	          }]
	        };
	      }
	      if (this.filters.modality_id) {
	        searchData.modalities = {
	          has: [{
	            event_modality: {
	              has: [{
	                modality_id: this.filters.modality_id
	              }]
	            }
	          }]
	        };
	      }
	      var startDate = this.dateFormat(this.filters.dates[0], 'en');
	      var endDate = this.dateFormat(this.filters.dates[1], 'en');
	      if (startDate.length > 0 && endDate.length > 0) {
	        searchData.created_at = {
	          between: [startDate + ' 00:00:00', endDate + ' 23:59:59']
	        };
	      } else if (startDate.length > 0 && endDate.length === 0) {
	        searchData.created_at = {
	          between: [startDate, startDate]
	        };
	      } else if (startDate.length === 0 && endDate.length > 0) {
	        searchData.created_at = {
	          between: [endDate, endDate]
	        };
	      }
	      _bus2.default.$emit('list-filter', this.filters, searchData);
	    },
	    onFilterClean: function onFilterClean() {
	      this.filters = { ref_pessoa: '', status_id: '', dates: [], modality_id: '' };
	      _bus2.default.$emit('list-filter-clean', this.filters);
	    },
	    onDestroy: function onDestroy(item) {
	      _bus2.default.$emit('list-destroy-item', item);
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.listStore.listData = [];
	  }
	};

/***/ }),
/* 429 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'registration-status-label',
	  props: ['statusId', 'statusName'],
	  computed: {
	    labelType: function labelType() {
	      switch (this.statusId) {
	        case 1:
	          return 'success';
	        case 2:
	          return 'default';
	        case 3:
	          return 'danger';
	        case 4:
	          return 'warning';
	        default:
	          return 'gray';
	      }
	    }
	  }
	};

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Header = __webpack_require__(5);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _SaveButton = __webpack_require__(16);
	
	var _SaveButton2 = _interopRequireDefault(_SaveButton);
	
	var _CancelButton = __webpack_require__(14);
	
	var _CancelButton2 = _interopRequireDefault(_CancelButton);
	
	var _restfulService = __webpack_require__(6);
	
	var restfulService = _interopRequireWildcard(_restfulService);
	
	var _notifyService = __webpack_require__(8);
	
	var notifyService = _interopRequireWildcard(_notifyService);
	
	var _lodash = __webpack_require__(3);
	
	var _validators = __webpack_require__(10);
	
	var _bus = __webpack_require__(4);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ListHeader: _Header2.default, FormSaveButton: _SaveButton2.default, FormCancelButton: _CancelButton2.default },
	  data: function data() {
	    return {
	      isEdit: false,
	      isSubmitted: false,
	      isLoadingData: true,
	      form: {
	        name: '',
	        description: ''
	      },
	      dependencies: {}
	    };
	  },
	
	  validations: {
	    form: {
	      name: { required: _validators.required },
	      description: { required: _validators.required }
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    var id = this.$route.params.id || null;
	    if (id) {
	      this.isEdit = true;
	      restfulService.get('registration_status', null, id).then(function (response) {
	        _this.form = response;
	        _this.isLoadingData = false;
	        _bus2.default.$emit('hide-loader');
	      }).catch(function (e) {
	        console.log(e);
	        _this.isLoadingData = false;
	        _bus2.default.$emit('hide-loader');
	      });
	    } else {
	      this.isLoadingData = false;
	      _bus2.default.$emit('hide-loader');
	    }
	  },
	
	  methods: {
	    onSend: function onSend() {
	      var _this2 = this;
	
	      this.isSubmitted = true;
	      var data = (0, _lodash.clone)(this.form);
	      restfulService.save('registration_status', null, null, data).then(function () {
	        notifyService.success({ hideLoader: true });
	        _this2.isSubmitted = false;
	        _this2.$router.push({ name: 'registration_status.index' });
	      }).catch(function (e) {
	        _this2.isSubmitted = false;
	        console.log(e);
	      });
	    }
	  }
	};

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Main = __webpack_require__(11);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Header = __webpack_require__(5);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _EditButton = __webpack_require__(13);
	
	var _EditButton2 = _interopRequireDefault(_EditButton);
	
	var _DeleteButton = __webpack_require__(12);
	
	var _DeleteButton2 = _interopRequireDefault(_DeleteButton);
	
	var _bus = __webpack_require__(4);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	var _lodash = __webpack_require__(3);
	
	var _vuex = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ListMain: _Main2.default, ListHeader: _Header2.default, ListEditButton: _EditButton2.default, ListDeleteButton: _DeleteButton2.default },
	  data: function data() {
	    return {
	      isLoadingData: true,
	      filters: {},
	      dependencies: {}
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    _bus2.default.$emit('list-init', { domain: 'registration_status' }, function () {
	      _this.isLoadingData = false;
	    });
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['listStore'])),
	  methods: {
	    onFilter: function onFilter() {
	      var searchData = {};
	      if (!(0, _lodash.isEmpty)(this.filters.name)) {
	        searchData.name = {
	          'ilike': '%' + this.filters.name + '%'
	        };
	      }
	      _bus2.default.$emit('list-filter', this.filters, searchData);
	    },
	    onFilterClean: function onFilterClean() {
	      this.filters = {};
	      _bus2.default.$emit('list-filter-clean', this.filters);
	    },
	    onDestroy: function onDestroy(item) {
	      _bus2.default.$emit('list-destroy-item', item);
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.listStore.listData = [];
	  }
	};

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Header = __webpack_require__(5);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _SaveButton = __webpack_require__(16);
	
	var _SaveButton2 = _interopRequireDefault(_SaveButton);
	
	var _CancelButton = __webpack_require__(14);
	
	var _CancelButton2 = _interopRequireDefault(_CancelButton);
	
	var _restfulService = __webpack_require__(6);
	
	var restfulService = _interopRequireWildcard(_restfulService);
	
	var _notifyService = __webpack_require__(8);
	
	var notifyService = _interopRequireWildcard(_notifyService);
	
	var _dataService = __webpack_require__(21);
	
	var _dataService2 = _interopRequireDefault(_dataService);
	
	var _lodash = __webpack_require__(3);
	
	var _validators = __webpack_require__(10);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ListHeader: _Header2.default, FormSaveButton: _SaveButton2.default, FormCancelButton: _CancelButton2.default },
	  data: function data() {
	    return {
	      isEdit: false,
	      isSubmitted: false,
	      isLoadingData: true,
	      form: {
	        name: ''
	      },
	      domains: []
	    };
	  },
	
	  validations: {
	    form: {
	      name: { required: _validators.required }
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.getDependencies();
	    var id = this.$route.params.id || null;
	    if (id) {
	      this.isEdit = true;
	      restfulService.get('role', null, id, null, ['permissions']).then(function (response) {
	        _this.domains.forEach(function (domain) {
	          domain.permissions.forEach(function (permission) {
	            _this.$set(permission, 'checked', response.permissions.some(function (item) {
	              return item.id === permission.id;
	            }));
	          });
	          _this.$set(domain, 'checked', domain.permissions.some(function (item) {
	            return item.checked;
	          }));
	        });
	        _this.form = response;
	        _this.isLoadingData = false;
	      }).catch(function (e) {
	        console.log(e);
	        _this.isLoadingData = false;
	      });
	    } else {
	      this.isLoadingData = false;
	    }
	  },
	
	  methods: {
	    getDependencies: function getDependencies() {
	      var _this2 = this;
	
	      _dataService2.default.get([{ domain: 'permission' }]).then(function (result) {
	        result.permissions.forEach(function (val) {
	          var nameSplit = val.name.split('.');
	          var realNameSplit = val.readable_name.split('|');
	          var name = realNameSplit[1] + ' ' + realNameSplit[0];
	          var exists = _this2.domains.some(function (val) {
	            return val.id === nameSplit[0];
	          });
	          if (exists === false) {
	            _this2.domains.push({
	              id: nameSplit[0],
	              name: realNameSplit[0],
	              permissions: [],
	              selecteds: [],
	              checked: true
	            });
	          }
	          var item = _this2.domains.filter(function (val) {
	            return val.id === nameSplit[0];
	          });
	          item[0].permissions.push({
	            id: val.id,
	            readable_name: name,
	            checked: true
	          });
	        });
	      });
	    },
	    onSelectAll: function onSelectAll(domain) {
	      domain.permissions.forEach(function (permission) {
	        permission.checked = domain.checked;
	      });
	    },
	    onSend: function onSend() {
	      var _this3 = this;
	
	      this.isSubmitted = true;
	      var data = (0, _lodash.clone)(this.form);
	      data.permissions = [];
	      this.domains.forEach(function (domain) {
	        domain.permissions.forEach(function (permission) {
	          if (permission.checked) {
	            data.permissions.push(permission);
	          }
	        });
	      });
	      restfulService.save('role', null, null, data).then(function () {
	        notifyService.success({ hideLoader: true });
	        _this3.isSubmitted = false;
	        _this3.$router.push({ name: 'role.index' });
	      }).catch(function (e) {
	        _this3.isSubmitted = false;
	        console.log(e);
	      });
	    }
	  }
	};

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Main = __webpack_require__(11);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Header = __webpack_require__(5);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _EditButton = __webpack_require__(13);
	
	var _EditButton2 = _interopRequireDefault(_EditButton);
	
	var _DeleteButton = __webpack_require__(12);
	
	var _DeleteButton2 = _interopRequireDefault(_DeleteButton);
	
	var _bus = __webpack_require__(4);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	var _lodash = __webpack_require__(3);
	
	var _vuex = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ListMain: _Main2.default, ListHeader: _Header2.default, ListEditButton: _EditButton2.default, ListDeleteButton: _DeleteButton2.default },
	  data: function data() {
	    return {
	      isLoadingData: true,
	      filters: {},
	      dependencies: {}
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    _bus2.default.$emit('list-init', { domain: 'role' }, function () {
	      _this.isLoadingData = false;
	    });
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['listStore'])),
	  methods: {
	    onFilter: function onFilter() {
	      var searchData = {};
	      if (!(0, _lodash.isEmpty)(this.filters.nome)) {
	        searchData.name = {
	          'ilike': '%' + this.filters.nome + '%'
	        };
	      }
	      _bus2.default.$emit('list-filter', this.filters, searchData);
	    },
	    onFilterClean: function onFilterClean() {
	      this.filters = {};
	      _bus2.default.$emit('list-filter-clean', this.filters);
	    },
	    onDestroy: function onDestroy(item) {
	      _bus2.default.$emit('list-destroy-item', item);
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.listStore.listData = [];
	  }
	};

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Header = __webpack_require__(5);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _SaveButton = __webpack_require__(16);
	
	var _SaveButton2 = _interopRequireDefault(_SaveButton);
	
	var _CancelButton = __webpack_require__(14);
	
	var _CancelButton2 = _interopRequireDefault(_CancelButton);
	
	var _SingleUpload = __webpack_require__(253);
	
	var _SingleUpload2 = _interopRequireDefault(_SingleUpload);
	
	var _Tinymce = __webpack_require__(92);
	
	var _Tinymce2 = _interopRequireDefault(_Tinymce);
	
	var _restfulService = __webpack_require__(6);
	
	var restfulService = _interopRequireWildcard(_restfulService);
	
	var _notifyService = __webpack_require__(8);
	
	var notifyService = _interopRequireWildcard(_notifyService);
	
	var _lodash = __webpack_require__(3);
	
	var _validators = __webpack_require__(10);
	
	var _bus = __webpack_require__(4);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	var _config = __webpack_require__(50);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ListHeader: _Header2.default, FormSaveButton: _SaveButton2.default, FormCancelButton: _CancelButton2.default, FormSingleUpload: _SingleUpload2.default, FormTinymce: _Tinymce2.default },
	  data: function data() {
	    return {
	      isEdit: false,
	      isSubmitted: false,
	      isLoadingData: true,
	      form: {
	        name: '',
	        description: '',
	        image: {
	          name: '',
	          type: '',
	          size: '',
	          base64: ''
	        },
	        content: ''
	      },
	      dependencies: {}
	    };
	  },
	
	  validations: {
	    form: {
	      name: { required: _validators.required },
	      description: { required: _validators.required },
	      image: { required: _validators.required }
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    var id = this.$route.params.id || null;
	    if (id) {
	      this.isEdit = true;
	      restfulService.get('signature', null, id).then(function (response) {
	        var image = {
	          name: response.image,
	          type: '',
	          size: '',
	          base64: ''
	        };
	        response.image = image;
	        _this.form = response;
	        _this.isLoadingData = false;
	        _bus2.default.$emit('hide-loader');
	      }).catch(function (e) {
	        console.log(e);
	        _this.isLoadingData = false;
	        _bus2.default.$emit('hide-loader');
	      });
	    } else {
	      this.isLoadingData = false;
	      _bus2.default.$emit('hide-loader');
	    }
	  },
	
	  computed: {
	    getSignatureImage: function getSignatureImage() {
	      return _config2.default.basePath + 'files/' + this.form.image.name;
	    }
	  },
	  methods: {
	    onSend: function onSend() {
	      var _this2 = this;
	
	      this.isSubmitted = true;
	      var data = (0, _lodash.clone)(this.form);
	      restfulService.save('signature', null, null, data).then(function () {
	        notifyService.success({ hideLoader: true });
	        _this2.isSubmitted = false;
	        _this2.$router.push({ name: 'signature.index' });
	      }).catch(function (e) {
	        _this2.isSubmitted = false;
	        console.log(e);
	      });
	    }
	  }
	};

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Main = __webpack_require__(11);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Header = __webpack_require__(5);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _EditButton = __webpack_require__(13);
	
	var _EditButton2 = _interopRequireDefault(_EditButton);
	
	var _DeleteButton = __webpack_require__(12);
	
	var _DeleteButton2 = _interopRequireDefault(_DeleteButton);
	
	var _ShowButton = __webpack_require__(93);
	
	var _ShowButton2 = _interopRequireDefault(_ShowButton);
	
	var _bus = __webpack_require__(4);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	var _lodash = __webpack_require__(3);
	
	var _vuex = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ListMain: _Main2.default, ListHeader: _Header2.default, ListEditButton: _EditButton2.default, ListShowButton: _ShowButton2.default, ListDeleteButton: _DeleteButton2.default },
	  data: function data() {
	    return {
	      isLoadingData: true,
	      filters: {},
	      dependencies: {}
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    _bus2.default.$emit('list-init', { domain: 'signature' }, function () {
	      _this.isLoadingData = false;
	    });
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['listStore'])),
	  methods: {
	    onFilter: function onFilter() {
	      var searchData = {};
	      if (!(0, _lodash.isEmpty)(this.filters.name)) {
	        searchData.name = {
	          'ilike': '%' + this.filters.name + '%'
	        };
	      }
	      _bus2.default.$emit('list-filter', this.filters, searchData);
	    },
	    onFilterClean: function onFilterClean() {
	      this.filters = {};
	      _bus2.default.$emit('list-filter-clean', this.filters);
	    },
	    onDestroy: function onDestroy(item) {
	      _bus2.default.$emit('list-destroy-item', item);
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.listStore.listData = [];
	  }
	};

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Header = __webpack_require__(5);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _SaveButton = __webpack_require__(16);
	
	var _SaveButton2 = _interopRequireDefault(_SaveButton);
	
	var _CancelButton = __webpack_require__(14);
	
	var _CancelButton2 = _interopRequireDefault(_CancelButton);
	
	var _dataService = __webpack_require__(21);
	
	var _dataService2 = _interopRequireDefault(_dataService);
	
	var _restfulService = __webpack_require__(6);
	
	var restfulService = _interopRequireWildcard(_restfulService);
	
	var _notifyService = __webpack_require__(8);
	
	var notifyService = _interopRequireWildcard(_notifyService);
	
	var _lodash = __webpack_require__(3);
	
	var _validators = __webpack_require__(10);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ListHeader: _Header2.default, FormSaveButton: _SaveButton2.default, FormCancelButton: _CancelButton2.default },
	  data: function data() {
	    return {
	      isEdit: false,
	      isSubmitted: false,
	      isLoadingData: true,
	      form: {
	        country_id: '',
	        name: '',
	        initials: ''
	      },
	      dependencies: {}
	    };
	  },
	
	  validations: {
	    form: {
	      country_id: { required: _validators.required },
	      name: { required: _validators.required },
	      initials: {
	        required: _validators.required,
	        minLength: (0, _validators.minLength)(2),
	        maxLength: (0, _validators.maxLength)(2)
	      }
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.getDependencies();
	    var id = this.$route.params.id || null;
	    if (id) {
	      this.isEdit = true;
	      restfulService.get('state', null, id).then(function (response) {
	        _this.form = response;
	        _this.isLoadingData = false;
	      }).catch(function (e) {
	        console.log(e);
	        _this.isLoadingData = false;
	      });
	    } else {
	      this.isLoadingData = false;
	    }
	  },
	
	  methods: {
	    getDependencies: function getDependencies() {
	      var _this2 = this;
	
	      _dataService2.default.get([{ domain: 'country' }]).then(function (result) {
	        _this2.dependencies = result;
	      });
	    },
	    onSend: function onSend() {
	      var _this3 = this;
	
	      this.isSubmitted = true;
	      var data = (0, _lodash.clone)(this.form);
	      restfulService.save('state', null, null, data).then(function () {
	        notifyService.success({ hideLoader: true });
	        _this3.isSubmitted = false;
	        _this3.$router.push({ name: 'state.index' });
	      }).catch(function (e) {
	        _this3.isSubmitted = false;
	        console.log(e);
	      });
	    }
	  }
	};

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Main = __webpack_require__(11);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Header = __webpack_require__(5);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _EditButton = __webpack_require__(13);
	
	var _EditButton2 = _interopRequireDefault(_EditButton);
	
	var _DeleteButton = __webpack_require__(12);
	
	var _DeleteButton2 = _interopRequireDefault(_DeleteButton);
	
	var _bus = __webpack_require__(4);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	var _lodash = __webpack_require__(3);
	
	var _vuex = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ListMain: _Main2.default, ListHeader: _Header2.default, ListEditButton: _EditButton2.default, ListDeleteButton: _DeleteButton2.default },
	  data: function data() {
	    return {
	      isLoadingData: true,
	      filters: {},
	      dependencies: {}
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    _bus2.default.$emit('list-init', { domain: 'state', relations: ['country'] }, function () {
	      _this.isLoadingData = false;
	    });
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['listStore'])),
	  methods: {
	    onFilter: function onFilter() {
	      var searchData = {};
	      if (!(0, _lodash.isEmpty)(this.filters.name)) {
	        searchData.name = {
	          'ilike': '%' + this.filters.name + '%'
	        };
	      }
	      _bus2.default.$emit('list-filter', this.filters, searchData);
	    },
	    onFilterClean: function onFilterClean() {
	      this.filters = {};
	      _bus2.default.$emit('list-filter-clean', this.filters);
	    },
	    onDestroy: function onDestroy(item) {
	      _bus2.default.$emit('list-destroy-item', item);
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.listStore.listData = [];
	  }
	};

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Header = __webpack_require__(5);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _SaveButton = __webpack_require__(16);
	
	var _SaveButton2 = _interopRequireDefault(_SaveButton);
	
	var _CancelButton = __webpack_require__(14);
	
	var _CancelButton2 = _interopRequireDefault(_CancelButton);
	
	var _restfulService = __webpack_require__(6);
	
	var restfulService = _interopRequireWildcard(_restfulService);
	
	var _dataService = __webpack_require__(21);
	
	var _dataService2 = _interopRequireDefault(_dataService);
	
	var _notifyService = __webpack_require__(8);
	
	var notifyService = _interopRequireWildcard(_notifyService);
	
	var _lodash = __webpack_require__(3);
	
	var _validators = __webpack_require__(10);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ListHeader: _Header2.default, FormSaveButton: _SaveButton2.default, FormCancelButton: _CancelButton2.default },
	  data: function data() {
	    return {
	      isEdit: false,
	      isSubmitted: false,
	      isLoadingData: true,
	      form: {
	        ref_pessoa: '',
	        pessoa: {
	          nome: ''
	        }
	      },
	      dependencies: {},
	      selectedRoles: []
	    };
	  },
	
	  validations: {
	    form: {
	      ref_pessoa: { required: _validators.required }
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.getDependencies();
	    var id = this.$route.params.id || null;
	    if (id) {
	      this.isEdit = true;
	      restfulService.get('user', null, id, null, ['roles']).then(function (response) {
	        _this.form = response;
	        _this.selectedRoles = response.roles.map(function (item) {
	          return item.id;
	        });
	        _this.isLoadingData = false;
	      }).catch(function (e) {
	        console.log(e);
	        _this.isLoadingData = false;
	      });
	    } else {
	      this.isLoadingData = false;
	    }
	  },
	
	  methods: {
	    getDependencies: function getDependencies() {
	      var _this2 = this;
	
	      _dataService2.default.get([{ domain: 'role' }]).then(function (result) {
	        _this2.dependencies = result;
	      });
	    },
	    onSend: function onSend() {
	      var _this3 = this;
	
	      this.isSubmitted = true;
	      var data = (0, _lodash.clone)(this.form);
	      data.roles = this.selectedRoles;
	      restfulService.save('user', null, null, data).then(function () {
	        notifyService.success({ hideLoader: true });
	        _this3.isSubmitted = false;
	        _this3.$router.push({ name: 'user.index' });
	      }).catch(function (e) {
	        _this3.isSubmitted = false;
	        console.log(e);
	      });
	    }
	  }
	};

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Main = __webpack_require__(11);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Header = __webpack_require__(5);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _EditButton = __webpack_require__(13);
	
	var _EditButton2 = _interopRequireDefault(_EditButton);
	
	var _DeleteButton = __webpack_require__(12);
	
	var _DeleteButton2 = _interopRequireDefault(_DeleteButton);
	
	var _bus = __webpack_require__(4);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	var _lodash = __webpack_require__(3);
	
	var _vuex = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { ListMain: _Main2.default, ListHeader: _Header2.default, ListEditButton: _EditButton2.default, ListDeleteButton: _DeleteButton2.default },
	  data: function data() {
	    return {
	      isLoadingData: true,
	      filters: {},
	      dependencies: {}
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    _bus2.default.$emit('list-init', { domain: 'user' }, function () {
	      _this.isLoadingData = false;
	    });
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['listStore'])),
	  methods: {
	    onFilter: function onFilter() {
	      var searchData = {};
	      if (!(0, _lodash.isEmpty)(this.filters.nome)) {
	        searchData.name = {
	          'ilike': '%' + this.filters.nome + '%'
	        };
	      }
	      _bus2.default.$emit('list-filter', this.filters, searchData);
	    },
	    onFilterClean: function onFilterClean() {
	      this.filters = {};
	      _bus2.default.$emit('list-filter-clean', this.filters);
	    },
	    onDestroy: function onDestroy(item) {
	      _bus2.default.$emit('list-destroy-item', item);
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.listStore.listData = [];
	  }
	};

/***/ }),
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 513 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 514 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 515 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 516 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 517 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 518 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 519 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 520 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 521 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 522 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 523 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 524 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 525 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 526 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 527 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 528 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 529 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 530 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 531 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 532 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 533 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 534 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 535 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 536 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 537 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 538 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 539 */,
/* 540 */,
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 132,
		"./af.js": 132,
		"./ar": 139,
		"./ar-dz": 133,
		"./ar-dz.js": 133,
		"./ar-kw": 134,
		"./ar-kw.js": 134,
		"./ar-ly": 135,
		"./ar-ly.js": 135,
		"./ar-ma": 136,
		"./ar-ma.js": 136,
		"./ar-sa": 137,
		"./ar-sa.js": 137,
		"./ar-tn": 138,
		"./ar-tn.js": 138,
		"./ar.js": 139,
		"./az": 140,
		"./az.js": 140,
		"./be": 141,
		"./be.js": 141,
		"./bg": 142,
		"./bg.js": 142,
		"./bm": 143,
		"./bm.js": 143,
		"./bn": 144,
		"./bn.js": 144,
		"./bo": 145,
		"./bo.js": 145,
		"./br": 146,
		"./br.js": 146,
		"./bs": 147,
		"./bs.js": 147,
		"./ca": 148,
		"./ca.js": 148,
		"./cs": 149,
		"./cs.js": 149,
		"./cv": 150,
		"./cv.js": 150,
		"./cy": 151,
		"./cy.js": 151,
		"./da": 152,
		"./da.js": 152,
		"./de": 155,
		"./de-at": 153,
		"./de-at.js": 153,
		"./de-ch": 154,
		"./de-ch.js": 154,
		"./de.js": 155,
		"./dv": 156,
		"./dv.js": 156,
		"./el": 157,
		"./el.js": 157,
		"./en-au": 158,
		"./en-au.js": 158,
		"./en-ca": 159,
		"./en-ca.js": 159,
		"./en-gb": 160,
		"./en-gb.js": 160,
		"./en-ie": 161,
		"./en-ie.js": 161,
		"./en-nz": 162,
		"./en-nz.js": 162,
		"./eo": 163,
		"./eo.js": 163,
		"./es": 166,
		"./es-do": 164,
		"./es-do.js": 164,
		"./es-us": 165,
		"./es-us.js": 165,
		"./es.js": 166,
		"./et": 167,
		"./et.js": 167,
		"./eu": 168,
		"./eu.js": 168,
		"./fa": 169,
		"./fa.js": 169,
		"./fi": 170,
		"./fi.js": 170,
		"./fo": 171,
		"./fo.js": 171,
		"./fr": 174,
		"./fr-ca": 172,
		"./fr-ca.js": 172,
		"./fr-ch": 173,
		"./fr-ch.js": 173,
		"./fr.js": 174,
		"./fy": 175,
		"./fy.js": 175,
		"./gd": 176,
		"./gd.js": 176,
		"./gl": 177,
		"./gl.js": 177,
		"./gom-latn": 178,
		"./gom-latn.js": 178,
		"./gu": 179,
		"./gu.js": 179,
		"./he": 180,
		"./he.js": 180,
		"./hi": 181,
		"./hi.js": 181,
		"./hr": 182,
		"./hr.js": 182,
		"./hu": 183,
		"./hu.js": 183,
		"./hy-am": 184,
		"./hy-am.js": 184,
		"./id": 185,
		"./id.js": 185,
		"./is": 186,
		"./is.js": 186,
		"./it": 187,
		"./it.js": 187,
		"./ja": 188,
		"./ja.js": 188,
		"./jv": 189,
		"./jv.js": 189,
		"./ka": 190,
		"./ka.js": 190,
		"./kk": 191,
		"./kk.js": 191,
		"./km": 192,
		"./km.js": 192,
		"./kn": 193,
		"./kn.js": 193,
		"./ko": 194,
		"./ko.js": 194,
		"./ky": 195,
		"./ky.js": 195,
		"./lb": 196,
		"./lb.js": 196,
		"./lo": 197,
		"./lo.js": 197,
		"./lt": 198,
		"./lt.js": 198,
		"./lv": 199,
		"./lv.js": 199,
		"./me": 200,
		"./me.js": 200,
		"./mi": 201,
		"./mi.js": 201,
		"./mk": 202,
		"./mk.js": 202,
		"./ml": 203,
		"./ml.js": 203,
		"./mr": 204,
		"./mr.js": 204,
		"./ms": 206,
		"./ms-my": 205,
		"./ms-my.js": 205,
		"./ms.js": 206,
		"./mt": 207,
		"./mt.js": 207,
		"./my": 208,
		"./my.js": 208,
		"./nb": 209,
		"./nb.js": 209,
		"./ne": 210,
		"./ne.js": 210,
		"./nl": 212,
		"./nl-be": 211,
		"./nl-be.js": 211,
		"./nl.js": 212,
		"./nn": 213,
		"./nn.js": 213,
		"./pa-in": 214,
		"./pa-in.js": 214,
		"./pl": 215,
		"./pl.js": 215,
		"./pt": 217,
		"./pt-br": 216,
		"./pt-br.js": 216,
		"./pt.js": 217,
		"./ro": 218,
		"./ro.js": 218,
		"./ru": 219,
		"./ru.js": 219,
		"./sd": 220,
		"./sd.js": 220,
		"./se": 221,
		"./se.js": 221,
		"./si": 222,
		"./si.js": 222,
		"./sk": 223,
		"./sk.js": 223,
		"./sl": 224,
		"./sl.js": 224,
		"./sq": 225,
		"./sq.js": 225,
		"./sr": 227,
		"./sr-cyrl": 226,
		"./sr-cyrl.js": 226,
		"./sr.js": 227,
		"./ss": 228,
		"./ss.js": 228,
		"./sv": 229,
		"./sv.js": 229,
		"./sw": 230,
		"./sw.js": 230,
		"./ta": 231,
		"./ta.js": 231,
		"./te": 232,
		"./te.js": 232,
		"./tet": 233,
		"./tet.js": 233,
		"./th": 234,
		"./th.js": 234,
		"./tl-ph": 235,
		"./tl-ph.js": 235,
		"./tlh": 236,
		"./tlh.js": 236,
		"./tr": 237,
		"./tr.js": 237,
		"./tzl": 238,
		"./tzl.js": 238,
		"./tzm": 240,
		"./tzm-latn": 239,
		"./tzm-latn.js": 239,
		"./tzm.js": 240,
		"./uk": 241,
		"./uk.js": 241,
		"./ur": 242,
		"./ur.js": 242,
		"./uz": 244,
		"./uz-latn": 243,
		"./uz-latn.js": 243,
		"./uz.js": 244,
		"./vi": 245,
		"./vi.js": 245,
		"./x-pseudo": 246,
		"./x-pseudo.js": 246,
		"./yo": 247,
		"./yo.js": 247,
		"./zh-cn": 248,
		"./zh-cn.js": 248,
		"./zh-hk": 249,
		"./zh-hk.js": 249,
		"./zh-tw": 250,
		"./zh-tw.js": 250
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 541;


/***/ }),
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(528)
	__webpack_require__(529)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(357),
	  /* template */
	  __webpack_require__(762),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(363),
	  /* template */
	  __webpack_require__(751),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(525)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(367),
	  /* template */
	  __webpack_require__(749),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(371),
	  /* template */
	  __webpack_require__(766),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(372),
	  /* template */
	  __webpack_require__(739),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(520)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(373),
	  /* template */
	  __webpack_require__(736),
	  /* scopeId */
	  "data-v-2fdaa724",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(374),
	  /* template */
	  __webpack_require__(752),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(375),
	  /* template */
	  __webpack_require__(789),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(376),
	  /* template */
	  __webpack_require__(720),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(377),
	  /* template */
	  __webpack_require__(733),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(378),
	  /* template */
	  __webpack_require__(742),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(379),
	  /* template */
	  __webpack_require__(767),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(380),
	  /* template */
	  __webpack_require__(721),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(381),
	  /* template */
	  __webpack_require__(746),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(523)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(382),
	  /* template */
	  __webpack_require__(745),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(383),
	  /* template */
	  __webpack_require__(772),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(516)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(384),
	  /* template */
	  __webpack_require__(716),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(526)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(385),
	  /* template */
	  __webpack_require__(753),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(518)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(386),
	  /* template */
	  __webpack_require__(722),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(387),
	  /* template */
	  __webpack_require__(784),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(519)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(389),
	  /* template */
	  __webpack_require__(723),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(527)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(392),
	  /* template */
	  __webpack_require__(759),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(393),
	  /* template */
	  __webpack_require__(729),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(394),
	  /* template */
	  __webpack_require__(710),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(395),
	  /* template */
	  __webpack_require__(719),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(396),
	  /* template */
	  __webpack_require__(756),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(397),
	  /* template */
	  __webpack_require__(785),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(531)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(398),
	  /* template */
	  __webpack_require__(770),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(399),
	  /* template */
	  __webpack_require__(713),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(401),
	  /* template */
	  __webpack_require__(740),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(517)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(402),
	  /* template */
	  __webpack_require__(717),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(536)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(403),
	  /* template */
	  __webpack_require__(791),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(404),
	  /* template */
	  __webpack_require__(778),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(405),
	  /* template */
	  __webpack_require__(777),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(406),
	  /* template */
	  __webpack_require__(771),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(407),
	  /* template */
	  __webpack_require__(732),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(408),
	  /* template */
	  __webpack_require__(755),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(409),
	  /* template */
	  __webpack_require__(714),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(410),
	  /* template */
	  __webpack_require__(735),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(411),
	  /* template */
	  __webpack_require__(773),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(412),
	  /* template */
	  __webpack_require__(779),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(413),
	  /* template */
	  __webpack_require__(743),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(530)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(414),
	  /* template */
	  __webpack_require__(769),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(521)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(415),
	  /* template */
	  __webpack_require__(738),
	  /* scopeId */
	  "data-v-330887bb",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(416),
	  /* template */
	  __webpack_require__(760),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(417),
	  /* template */
	  __webpack_require__(727),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(418),
	  /* template */
	  __webpack_require__(728),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(419),
	  /* template */
	  __webpack_require__(758),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(420),
	  /* template */
	  __webpack_require__(786),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(421),
	  /* template */
	  __webpack_require__(754),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(422),
	  /* template */
	  __webpack_require__(787),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(423),
	  /* template */
	  __webpack_require__(724),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(424),
	  /* template */
	  __webpack_require__(731),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(425),
	  /* template */
	  __webpack_require__(765),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(426),
	  /* template */
	  __webpack_require__(783),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(427),
	  /* template */
	  __webpack_require__(750),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(537)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(428),
	  /* template */
	  __webpack_require__(792),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(522)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(429),
	  /* template */
	  __webpack_require__(741),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(430),
	  /* template */
	  __webpack_require__(768),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(431),
	  /* template */
	  __webpack_require__(715),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(533)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(432),
	  /* template */
	  __webpack_require__(780),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(433),
	  /* template */
	  __webpack_require__(744),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(524)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(434),
	  /* template */
	  __webpack_require__(747),
	  /* scopeId */
	  "data-v-48d6525a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(435),
	  /* template */
	  __webpack_require__(718),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(436),
	  /* template */
	  __webpack_require__(763),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(437),
	  /* template */
	  __webpack_require__(711),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(438),
	  /* template */
	  __webpack_require__(776),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(439),
	  /* template */
	  __webpack_require__(726),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 710 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('ListHeader', {
	    attrs: {
	      "title": _vm.pageTitle,
	      "back-route": "event.index"
	    }
	  }), _vm._v(" "), _c('el-card', {
	    staticClass: "el-card__search_list box-card",
	    staticStyle: {
	      "margin-bottom": "30px"
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('span', [_vm._v("Filtrar Listagem")]), _vm._v(" "), _c('div', [_c('el-button', {
	    attrs: {
	      "type": "default"
	    },
	    on: {
	      "click": _vm.onFilterClean
	    }
	  }, [_vm._v("Limpar todos filtros")])], 1)]), _vm._v(" "), _c('el-form', {
	    staticClass: "demo-form-inline",
	    attrs: {
	      "inline": true,
	      "model": _vm.filters
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Evento"
	    }
	  }, [_c('el-select', {
	    staticClass: "el-select-full",
	    attrs: {
	      "clearable": "",
	      "placeholder": "Filtrar por Evento",
	      "empty-text": "Nenhum registro encontrado"
	    },
	    model: {
	      value: (_vm.filters.subevento),
	      callback: function($$v) {
	        _vm.$set(_vm.filters, "subevento", $$v)
	      },
	      expression: "filters.subevento"
	    }
	  }, _vm._l((_vm.listSubeventos), function(item) {
	    return _c('el-option', {
	      key: item,
	      attrs: {
	        "label": item,
	        "value": item
	      }
	    })
	  }))], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "Grande Área CNPQ"
	    }
	  }, [_c('el-select', {
	    staticClass: "el-select-full",
	    attrs: {
	      "clearable": "",
	      "placeholder": "Filtrar por Grande Área CNPQ",
	      "empty-text": "Nenhum registro encontrado"
	    },
	    model: {
	      value: (_vm.filters.area_conhecimento),
	      callback: function($$v) {
	        _vm.$set(_vm.filters, "area_conhecimento", $$v)
	      },
	      expression: "filters.area_conhecimento"
	    }
	  }, _vm._l((_vm.listAreaConhecimento), function(item) {
	    return _c('el-option', {
	      key: item,
	      attrs: {
	        "label": item,
	        "value": item
	      }
	    })
	  }))], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "Curso"
	    }
	  }, [_c('el-select', {
	    staticClass: "el-select-full",
	    attrs: {
	      "clearable": "",
	      "placeholder": "Filtrar por Curso",
	      "empty-text": "Nenhum registro encontrado"
	    },
	    model: {
	      value: (_vm.filters.curso),
	      callback: function($$v) {
	        _vm.$set(_vm.filters, "curso", $$v)
	      },
	      expression: "filters.curso"
	    }
	  }, _vm._l((_vm.listCursos), function(item) {
	    return _c('el-option', {
	      key: item,
	      attrs: {
	        "label": item,
	        "value": item
	      }
	    })
	  }))], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "Instituição"
	    }
	  }, [_c('el-select', {
	    staticClass: "el-select-full",
	    attrs: {
	      "clearable": "",
	      "placeholder": "Filtrar por Instituição",
	      "empty-text": "Nenhum registro encontrado"
	    },
	    model: {
	      value: (_vm.filters.instituicao),
	      callback: function($$v) {
	        _vm.$set(_vm.filters, "instituicao", $$v)
	      },
	      expression: "filters.instituicao"
	    }
	  }, _vm._l((_vm.listInstituicoes), function(item) {
	    return _c('el-option', {
	      key: item,
	      attrs: {
	        "label": item,
	        "value": item
	      }
	    })
	  }))], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "Orientador"
	    }
	  }, [_c('el-select', {
	    staticClass: "el-select-full",
	    attrs: {
	      "clearable": "",
	      "placeholder": "Filtrar por Orientador",
	      "empty-text": "Nenhum registro encontrado"
	    },
	    model: {
	      value: (_vm.filters.orientador),
	      callback: function($$v) {
	        _vm.$set(_vm.filters, "orientador", $$v)
	      },
	      expression: "filters.orientador"
	    }
	  }, _vm._l((_vm.listOrientadores), function(item) {
	    return _c('el-option', {
	      key: item,
	      attrs: {
	        "label": item,
	        "value": item
	      }
	    })
	  }))], 1)], 1)], 1), _vm._v(" "), _c('el-tabs', {
	    attrs: {
	      "type": "card"
	    },
	    model: {
	      value: (_vm.activeTab),
	      callback: function($$v) {
	        _vm.activeTab = $$v
	      },
	      expression: "activeTab"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "name": "premiacao-eventos",
	      "label": "Relatório Premiação Eventos"
	    }
	  }, [_c('div', {
	    staticClass: "responsive-table"
	  }, [(_vm.activeTab === 'premiacao-eventos') ? _c('table', {
	    staticClass: "custom-table-list"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticStyle: {
	      "font-size": "18px"
	    },
	    attrs: {
	      "colspan": "12"
	    }
	  }, [_vm._v("Total: " + _vm._s(_vm.listFiltered.length))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Evento")]), _vm._v(" "), _c('th', [_vm._v("Grande Área CNPQ")]), _vm._v(" "), _c('th', [_vm._v("Curso")]), _vm._v(" "), _c('th', [_vm._v("Instituição")]), _vm._v(" "), _c('th', [_vm._v("Simpósio Temático")]), _vm._v(" "), _c('th', [_vm._v("Código do Trabalho/Título")]), _vm._v(" "), _c('th', [_vm._v("Autor/E-mail")]), _vm._v(" "), _c('th', [_vm._v("Coautores")]), _vm._v(" "), _c('th', [_vm._v("Orientador")]), _vm._v(" "), _c('th', [_vm._v("Média WEB")]), _vm._v(" "), _c('th', [_vm._v("Média InLOCO")]), _vm._v(" "), _c('th', [_vm._v("Média Geral")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listFiltered), function(item) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(item.subevento))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.area_conhecimento))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.curso))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.instituicao))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.simposio_tematico))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.cod_trabalho) + " - " + _vm._s(item.titulo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.autor) + " (" + _vm._s(item.email) + ")")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.coautores))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.orientador))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.media_web))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.media_inloco))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.media_geral))])])
	  }))]) : _vm._e()])]), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "name": "merito-institucional",
	      "label": "Relatório Mérito Institucional"
	    }
	  }, [_c('div', {
	    staticClass: "responsive-table"
	  }, [(_vm.activeTab === 'merito-institucional') ? _c('table', {
	    staticClass: "custom-table-list"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticStyle: {
	      "font-size": "18px"
	    },
	    attrs: {
	      "colspan": "12"
	    }
	  }, [_vm._v("Total: " + _vm._s(_vm.listFiltered.length))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Evento")]), _vm._v(" "), _c('th', [_vm._v("Orientador")]), _vm._v(" "), _c('th', [_vm._v("Total Trabalhos Orientados")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listFiltered), function(item) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(item.subevento))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.orientador))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.total))])])
	  }))]) : _vm._e()])])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 711 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('ListHeader', {
	    attrs: {
	      "title": "Estados",
	      "store-route-name": "state.store"
	    }
	  }), _vm._v(" "), _c('ListMain', [_c('div', {
	    attrs: {
	      "slot": "filters"
	    },
	    slot: "filters"
	  }, [_c('el-card', {
	    staticClass: "el-card__search_list box-card"
	  }, [_c('div', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('span', [_vm._v("Filtrar Listagem")]), _vm._v(" "), _c('div', [_c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": _vm.onFilter
	    }
	  }, [_vm._v("Pesquisar")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "default"
	    },
	    on: {
	      "click": _vm.onFilterClean
	    }
	  }, [_vm._v("Limpar")])], 1)]), _vm._v(" "), _c('el-form', {
	    staticClass: "demo-form-inline",
	    attrs: {
	      "inline": true,
	      "model": _vm.filters
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Nome"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "placeholder": "Filtrar por nome"
	    },
	    model: {
	      value: (_vm.filters.name),
	      callback: function($$v) {
	        _vm.$set(_vm.filters, "name", $$v)
	      },
	      expression: "filters.name"
	    }
	  })], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.isLoadingData) ? _c('div', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, [_c('h2', [_vm._v("Lista de Estados")]), _vm._v(" "), _c('table', {
	    staticClass: "custom-table-list"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("País")]), _vm._v(" "), _c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("UF")]), _vm._v(" "), _c('th', {
	    staticClass: "btn-actions"
	  }, [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listStore.listData), function(item) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.country.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.initials))]), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "btn-actions"
	    }, [_c('ListEditButton', {
	      attrs: {
	        "route-name": "state.update",
	        "item": item,
	        "domain": "state"
	      }
	    }), _vm._v(" "), _c('ListDeleteButton', {
	      attrs: {
	        "item": item,
	        "domain": "state"
	      }
	    })], 1)])])
	  }))])]) : _vm._e()])], 1)
	},staticRenderFns: []}

/***/ }),
/* 712 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (!_vm.isLoadingData) ? _c('div', [_c('el-form', {
	    ref: "formSelectPaperType",
	    attrs: {
	      "label-position": "top"
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Adicionar Tipo de Trabalho"
	    }
	  }, [_c('el-select', {
	    staticClass: "el-select-full",
	    attrs: {
	      "filterable": "",
	      "clearable": "",
	      "placeholder": "Selecione um tipo de trabalho",
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "change": _vm.selectPaperType
	    },
	    model: {
	      value: (_vm.paperTypeSelect),
	      callback: function($$v) {
	        _vm.paperTypeSelect = $$v
	      },
	      expression: "paperTypeSelect"
	    }
	  }, _vm._l((_vm.dependencies.paper_types), function(item) {
	    return _c('el-option', {
	      key: item.id,
	      attrs: {
	        "disabled": _vm.checkPaperTypeSelected(item.id),
	        "label": item.name,
	        "value": item.id
	      }
	    })
	  }))], 1)], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('table', {
	    staticClass: "custom-table-list paper-types-table"
	  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.eventPaperTypes), function(item) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(item.paper_type.name))]), _vm._v(" "), _c('td', [_c('div', [_c('strong', [_vm._v("Início:")]), _vm._v(" " + _vm._s(_vm._f("dateTimeEnToBr")(item.submission_start_datetime)))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Término:")]), _vm._v(" " + _vm._s(_vm._f("dateTimeEnToBr")(item.submission_end_datetime)))])]), _vm._v(" "), _c('td', [_c('div', [_c('strong', [_vm._v("Informar área do CNPq:")]), _vm._v(" " + _vm._s(item.knowledge_area ? 'Sim' : 'Não'))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Dias para edição:")]), _vm._v(" " + _vm._s(item.edit_limit_days))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Limite de autores:")]), _vm._v(" " + _vm._s(item.author_limit))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Limite de palavras-chave:")]), _vm._v(" " + _vm._s(item.keywords_limit))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Possui triagem:")]), _vm._v(" " + _vm._s(item.screening ? 'Sim' : 'Não'))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Co-autores precisam estar inscritos:")]), _vm._v(" " + _vm._s(item.author_subscribed ? 'Sim' : 'Não') + "\n                ")]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Precisa orientador:")]), _vm._v(" " + _vm._s(item.advisor ? 'Sim' : 'Não'))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Nº máximo de orientador(es):")]), _vm._v(" " + _vm._s(item.max_limit_advisor))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Precisa co-orientador:")]), _vm._v(" " + _vm._s(item.co_advisor ? 'Sim' : 'Não'))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Nº máximo de co-orientador(es):")]), _vm._v(" " + _vm._s(item.max_limit_co_advisor))])]), _vm._v(" "), _c('td', {
	      staticClass: "buttons"
	    }, [_c('el-button', {
	      staticClass: "edit-paper-type",
	      attrs: {
	        "type": "info",
	        "title": "Editar Tipo de Trabalho"
	      },
	      on: {
	        "click": function($event) {
	          _vm.editPaperType(item)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-edit"
	    })]), _vm._v(" "), _c('el-button', {
	      attrs: {
	        "type": "danger",
	        "title": "Remover Tipo de Trabalho"
	      },
	      on: {
	        "click": function($event) {
	          _vm.removePaperType(item)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-times"
	    })])], 1)])
	  }))]), _vm._v(" "), (_vm.modalPaperTypeVisible) ? _c('el-dialog', {
	    attrs: {
	      "title": 'Dados do tipo de trabalho: ' + _vm.paperType.paper_type.name,
	      "top": "5vh",
	      "visible": _vm.modalPaperTypeVisible
	    },
	    on: {
	      "update:visible": function($event) {
	        _vm.modalPaperTypeVisible = $event
	      }
	    }
	  }, [_c('el-form', {
	    ref: "formPaperType",
	    staticClass: "form-paper-type",
	    attrs: {
	      "label-position": "top"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.paperType.submission_start_datetime.$error
	    },
	    attrs: {
	      "label": "Data/Hora Início Submissões"
	    }
	  }, [_c('el-date-picker', {
	    attrs: {
	      "type": "datetime",
	      "format": "dd/MM/yyyy HH:mm",
	      "placeholder": "Data/Hora Início Submissões"
	    },
	    on: {
	      "input": function($event) {
	        _vm.$v.paperType.submission_start_datetime.$touch()
	      }
	    },
	    model: {
	      value: (_vm.paperType.submission_start_datetime),
	      callback: function($$v) {
	        _vm.$set(_vm.paperType, "submission_start_datetime", $$v)
	      },
	      expression: "paperType.submission_start_datetime"
	    }
	  }), _vm._v(" "), (!_vm.$v.paperType.submission_start_datetime.required && _vm.$v.paperType.submission_start_datetime.$dirty) ? _c('validation-message') : _vm._e()], 1)], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.paperType.submission_end_datetime.$error
	    },
	    attrs: {
	      "label": "Data/Hora Término Submissões"
	    }
	  }, [_c('el-date-picker', {
	    attrs: {
	      "type": "datetime",
	      "format": "dd/MM/yyyy HH:mm",
	      "placeholder": "Data/Hora Término Submissões"
	    },
	    on: {
	      "input": function($event) {
	        _vm.$v.paperType.submission_end_datetime.$touch()
	      }
	    },
	    model: {
	      value: (_vm.paperType.submission_end_datetime),
	      callback: function($$v) {
	        _vm.$set(_vm.paperType, "submission_end_datetime", $$v)
	      },
	      expression: "paperType.submission_end_datetime"
	    }
	  }), _vm._v(" "), (!_vm.$v.paperType.submission_end_datetime.required && _vm.$v.paperType.submission_end_datetime.$dirty) ? _c('validation-message') : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 8
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Informar área do CNPq?"
	    }
	  }, [_c('el-switch', {
	    attrs: {
	      "active-text": "SIM",
	      "inactive-text": "NÃO"
	    },
	    model: {
	      value: (_vm.paperType.knowledge_area),
	      callback: function($$v) {
	        _vm.$set(_vm.paperType, "knowledge_area", $$v)
	      },
	      expression: "paperType.knowledge_area"
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 8
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Possui triagem"
	    }
	  }, [_c('el-switch', {
	    attrs: {
	      "active-text": "SIM",
	      "inactive-text": "NÃO"
	    },
	    model: {
	      value: (_vm.paperType.screening),
	      callback: function($$v) {
	        _vm.$set(_vm.paperType, "screening", $$v)
	      },
	      expression: "paperType.screening"
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 8
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Co-author precisa estar inscrito"
	    }
	  }, [_c('el-switch', {
	    attrs: {
	      "active-text": "SIM",
	      "inactive-text": "NÃO"
	    },
	    model: {
	      value: (_vm.paperType.author_subscribed),
	      callback: function($$v) {
	        _vm.$set(_vm.paperType, "author_subscribed", $$v)
	      },
	      expression: "paperType.author_subscribed"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 8
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Precisa orientador"
	    }
	  }, [_c('el-switch', {
	    attrs: {
	      "active-text": "SIM",
	      "inactive-text": "NÃO"
	    },
	    model: {
	      value: (_vm.paperType.advisor),
	      callback: function($$v) {
	        _vm.$set(_vm.paperType, "advisor", $$v)
	      },
	      expression: "paperType.advisor"
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 8
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Nº máximo de orientador(es)"
	    }
	  }, [_c('el-input-number', {
	    attrs: {
	      "disabled": !_vm.paperType.advisor,
	      "min": 0,
	      "step": 1,
	      "max": 100
	    },
	    model: {
	      value: (_vm.paperType.max_limit_advisor),
	      callback: function($$v) {
	        _vm.$set(_vm.paperType, "max_limit_advisor", $$v)
	      },
	      expression: "paperType.max_limit_advisor"
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 8
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Limite de autores"
	    }
	  }, [_c('el-input-number', {
	    attrs: {
	      "min": 0,
	      "step": 1,
	      "max": 100
	    },
	    model: {
	      value: (_vm.paperType.author_limit),
	      callback: function($$v) {
	        _vm.$set(_vm.paperType, "author_limit", $$v)
	      },
	      expression: "paperType.author_limit"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 8
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Precisa co-orientador"
	    }
	  }, [_c('el-switch', {
	    attrs: {
	      "active-text": "SIM",
	      "inactive-text": "NÃO"
	    },
	    model: {
	      value: (_vm.paperType.co_advisor),
	      callback: function($$v) {
	        _vm.$set(_vm.paperType, "co_advisor", $$v)
	      },
	      expression: "paperType.co_advisor"
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 8
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Nº máximo de co-orientador(es)"
	    }
	  }, [_c('el-input-number', {
	    attrs: {
	      "disabled": !_vm.paperType.co_advisor,
	      "min": 0,
	      "step": 1,
	      "max": 100
	    },
	    model: {
	      value: (_vm.paperType.max_limit_co_advisor),
	      callback: function($$v) {
	        _vm.$set(_vm.paperType, "max_limit_co_advisor", $$v)
	      },
	      expression: "paperType.max_limit_co_advisor"
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 8
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Dias para edição"
	    }
	  }, [_c('el-input-number', {
	    attrs: {
	      "min": 0,
	      "step": 1,
	      "max": 100
	    },
	    model: {
	      value: (_vm.paperType.edit_limit_days),
	      callback: function($$v) {
	        _vm.$set(_vm.paperType, "edit_limit_days", $$v)
	      },
	      expression: "paperType.edit_limit_days"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Limite de palavras-chave"
	    }
	  }, [_c('el-input-number', {
	    attrs: {
	      "min": 0,
	      "step": 1,
	      "max": 100
	    },
	    model: {
	      value: (_vm.paperType.keywords_limit),
	      callback: function($$v) {
	        _vm.$set(_vm.paperType, "keywords_limit", $$v)
	      },
	      expression: "paperType.keywords_limit"
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [(false) ? _c('el-form-item', {
	    attrs: {
	      "label": "Limite de submissões por autor"
	    }
	  }, [_c('el-input-number', {
	    attrs: {
	      "min": 0,
	      "step": 1,
	      "max": 100
	    },
	    model: {
	      value: (_vm.paperType.max_submission_author),
	      callback: function($$v) {
	        _vm.$set(_vm.paperType, "max_submission_author", $$v)
	      },
	      expression: "paperType.max_submission_author"
	    }
	  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('h3', [_vm._v("Campos Obrigatórios da Submissão")]), _vm._v(" "), _c('div', {
	    staticClass: "fields-check"
	  }, _vm._l((_vm.paperType.fields), function(field) {
	    return _c('div', {
	      staticClass: "item",
	      class: {
	        '-checked': field.checked
	      },
	      on: {
	        "click": function($event) {
	          field.checked = !field.checked
	        }
	      }
	    }, [_c('div', {
	      staticClass: "name"
	    }, [_vm._v(_vm._s(field.name))]), _vm._v(" "), _c('div', {
	      staticClass: "description"
	    }, [_vm._v(_vm._s(field.description))]), _vm._v(" "), (field.type === 'text' || field.type === 'textarea') ? _c('div', {
	      staticClass: "size"
	    }, [_vm._v("\n                        Min: " + _vm._s(field.min_size) + " / Max: " + _vm._s(field.max_size) + " (caracteres)\n                    ")]) : _vm._e(), _vm._v(" "), (field.type === 'file') ? _c('div', {
	      staticClass: "size"
	    }, [_vm._v("\n                        Min: " + _vm._s(_vm.bytesToSize(field.min_size)) + " / Max: " + _vm._s(_vm.bytesToSize(field.max_size * 1024)) + "\n                    ")]) : _vm._e()])
	  }))], 1), _vm._v(" "), _c('div', {
	    staticClass: "dialog-footer",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('el-button', {
	    staticClass: "submit",
	    attrs: {
	      "type": "primary",
	      "disabled": _vm.$v.paperType.$invalid
	    },
	    on: {
	      "click": _vm.onSavePaperType
	    }
	  }, [_vm._v("\n                Salvar Alterações\n            ")]), _vm._v(" "), _c('el-button', {
	    on: {
	      "click": _vm.onHandleModalPaperType
	    }
	  }, [_vm._v("Fechar")])], 1)], 1) : _vm._e()], 1) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "header-flex"
	  }, [_c('h2', [_vm._v("Tipos de Trabalhos")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', [_vm._v("Tipo")]), _vm._v(" "), _c('th', [_vm._v("Submissões")]), _vm._v(" "), _c('th', [_vm._v("Configurações")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "60"
	    }
	  }, [_vm._v("Ações")])])])
	}]}

/***/ }),
/* 713 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('el-tag', {
	    attrs: {
	      "type": _vm.labelType
	    }
	  }, [_vm._v(_vm._s(_vm.evaluations))])
	},staticRenderFns: []}

/***/ }),
/* 714 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (!_vm.isLoadingData) ? _c('div', [_c('ListHeader', {
	    attrs: {
	      "title": "Instituição"
	    }
	  }), _vm._v(" "), _c('el-card', {
	    staticClass: "el-card__save_form box-card"
	  }, [_c('div', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('span', [_vm._v("Dados das Instituições")])]), _vm._v(" "), _c('el-form', {
	    ref: "form",
	    attrs: {
	      "model": _vm.form,
	      "label-width": "20%"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.onSend($event)
	      }
	    }
	  }, [_c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.form.name.$error
	    },
	    attrs: {
	      "label": "Nome"
	    }
	  }, [_c('el-input', {
	    on: {
	      "input": function($event) {
	        _vm.$v.form.name.$touch()
	      }
	    },
	    model: {
	      value: (_vm.form.name),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "name", $$v)
	      },
	      expression: "form.name"
	    }
	  }), _vm._v(" "), (_vm.$v.form.name.$error) ? _c('div', {
	    staticClass: "el-form-item__error"
	  }, [_vm._v("Esse campo é obrigatório")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.form.initials.$error
	    },
	    attrs: {
	      "label": "Sigla"
	    }
	  }, [_c('el-input', {
	    on: {
	      "input": function($event) {
	        _vm.$v.form.initials.$touch()
	      }
	    },
	    model: {
	      value: (_vm.form.initials),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "initials", $$v)
	      },
	      expression: "form.initials"
	    }
	  }), _vm._v(" "), (_vm.$v.form.initials.$error) ? _c('div', {
	    staticClass: "el-form-item__error"
	  }, [_vm._v("Esse campo é obrigatório")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "Descrição"
	    }
	  }, [_c('el-input', {
	    model: {
	      value: (_vm.form.description),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "description", $$v)
	      },
	      expression: "form.description"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', [_c('form-save-button', {
	    attrs: {
	      "event-click": _vm.onSend,
	      "is-disabled": _vm.isSubmitted || _vm.$v.$invalid,
	      "is-submitted": _vm.isSubmitted
	    }
	  }), _vm._v(" "), _c('form-cancel-button', {
	    attrs: {
	      "route-name": "institution.index"
	    }
	  })], 1)], 1)], 1)], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 715 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('ListHeader', {
	    attrs: {
	      "title": "Status de Inscrição",
	      "store-route-name": "registration_status.store"
	    }
	  }), _vm._v(" "), _c('ListMain', [_c('div', {
	    attrs: {
	      "slot": "filters"
	    },
	    slot: "filters"
	  }, [_c('el-card', {
	    staticClass: "el-card__search_list box-card"
	  }, [_c('div', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('span', [_vm._v("Filtrar Listagem")]), _vm._v(" "), _c('div', [_c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": _vm.onFilter
	    }
	  }, [_vm._v("Pesquisar")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "default"
	    },
	    on: {
	      "click": _vm.onFilterClean
	    }
	  }, [_vm._v("Limpar")])], 1)]), _vm._v(" "), _c('el-form', {
	    staticClass: "demo-form-inline",
	    attrs: {
	      "inline": true,
	      "model": _vm.filters
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Nome"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "placeholder": "Filtrar por nome"
	    },
	    nativeOn: {
	      "keydown": function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
	        $event.preventDefault();
	        _vm.onFilter($event)
	      }
	    },
	    model: {
	      value: (_vm.filters.name),
	      callback: function($$v) {
	        _vm.$set(_vm.filters, "name", $$v)
	      },
	      expression: "filters.name"
	    }
	  })], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.isLoadingData) ? _c('div', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, [_c('h2', [_vm._v("Lista de Status")]), _vm._v(" "), _c('table', {
	    staticClass: "custom-table-list"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Descrição")]), _vm._v(" "), _c('th', {
	    staticClass: "btn-actions"
	  }, [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listStore.listData), function(item) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.description))]), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "btn-actions"
	    }, [_c('ListEditButton', {
	      attrs: {
	        "route-name": "registration_status.update",
	        "item": item,
	        "domain": "registration_status"
	      }
	    }), _vm._v(" "), _c('ListDeleteButton', {
	      attrs: {
	        "item": item,
	        "domain": "registration_status"
	      }
	    })], 1)])])
	  }))])]) : _vm._e()])], 1)
	},staticRenderFns: []}

/***/ }),
/* 716 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('ListHeader', {
	    attrs: {
	      "title": _vm.event.title + ' - Eventos',
	      "back-route": "event.index"
	    }
	  }), _vm._v(" "), (_vm.list.length === 0) ? _c('list-empty', {
	    attrs: {
	      "description": "Nenhum evento encontrado"
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.list.length > 0) ? _c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('table', {
	    staticClass: "custom-table-list"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Evento")]), _vm._v(" "), _c('th', [_vm._v("Inscrições")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "align": "center"
	    }
	  }, [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.list), function(item) {
	    return _c('tr', {
	      class: {
	        '-no-access': !_vm.userHaveAccess(item.coordinators)
	      }
	    }, [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_c('div', [_vm._v("De: " + _vm._s(_vm._f("dateTimeEnToBr")(item.start_registration_datetime)))]), _vm._v(" "), _c('div', [_vm._v("Até: " + _vm._s(_vm._f("dateTimeEnToBr")(item.end_registration_datetime)))])]), _vm._v(" "), _c('td', {
	      attrs: {
	        "align": "center"
	      }
	    }, [_c('router-link', {
	      staticClass: "el-button el-button--primary",
	      attrs: {
	        "to": {
	          name: 'event.show.home',
	          params: {
	            eventMainId: _vm.event.id,
	            id: item.id
	          }
	        },
	        "title": "Gerenciar"
	      }
	    }, [_c('span', [_vm._v("Gerenciar")]), _vm._v(" "), _c('i', {
	      staticClass: "fa fa-cog"
	    })])], 1)])
	  }))])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [(_vm.chartLineOptionsRegistrations) ? _c('div', [_c('highcharts', {
	    key: 'registrations',
	    attrs: {
	      "options": _vm.chartLineOptionsRegistrations
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (false) ? _c('div', [_c('highcharts', {
	    key: 'papers',
	    attrs: {
	      "options": _vm.chartLineOptionsPapers
	    }
	  })], 1) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('router-link', {
	    staticClass: "el-button el-button--primary",
	    attrs: {
	      "to": {
	        name: 'event.presence',
	        params: {
	          id: _vm.event.id
	        }
	      },
	      "title": "Frequência"
	    }
	  }, [_c('span', [_vm._v("Gerenciar Frequência")]), _vm._v(" "), _c('i', {
	    staticClass: "el-icon-circle-check-outline"
	  })]), _vm._v(" "), (!_vm.userIsOnlySupportCommittee) ? _c('router-link', {
	    staticClass: "el-button el-button--info",
	    attrs: {
	      "to": {
	        name: 'event.report',
	        params: {
	          id: _vm.event.id
	        }
	      },
	      "title": "Relatórios"
	    }
	  }, [_c('span', [_vm._v("Relatórios")]), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-file-pdf-o"
	  })]) : _vm._e(), _vm._v(" "), (!_vm.userIsOnlySupportCommittee) ? _c('router-link', {
	    staticClass: "el-button el-button--warning",
	    attrs: {
	      "to": {
	        name: 'event.report-admin',
	        params: {
	          id: _vm.event.id
	        }
	      },
	      "title": "Relatórios"
	    }
	  }, [_c('span', [_vm._v("Relatórios Gerenciais")]), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-file-pdf-o"
	  })]) : _vm._e(), _vm._v(" "), (!_vm.userIsOnlySupportCommittee) ? _c('router-link', {
	    staticClass: "el-button el-button--danger",
	    attrs: {
	      "to": {
	        name: 'event.report-finals',
	        params: {
	          id: _vm.event.id
	        }
	      },
	      "title": "Relatórios"
	    }
	  }, [_c('span', [_vm._v("Relatórios Finais")]), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-file-pdf-o"
	  })]) : _vm._e(), _vm._v(" "), (!_vm.userIsOnlySupportCommittee) ? _c('router-link', {
	    staticClass: "el-button el-button--info",
	    attrs: {
	      "to": {
	        name: 'event.report-minicursos',
	        params: {
	          id: _vm.event.id
	        }
	      },
	      "title": "Relatórios"
	    }
	  }, [_c('span', [_vm._v("Relatórios Minicursos")]), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-file-pdf-o"
	  })]) : _vm._e()], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 717 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.isPaperVisible) ? _c('div', {
	    staticStyle: {
	      "padding-bottom": "200px"
	    }
	  }, [_c('hr'), _vm._v(" "), _c('h2', [_vm._v("Visualizando os dados da Submissão #" + _vm._s(_vm.paper.id))]), _vm._v(" "), _c('el-row', {
	    staticClass: "registration-data submission-data",
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 10
	    }
	  }, [_c('table', {
	    staticClass: "table-confirmation"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Dados da Submissão")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('strong', [_vm._v("Tipo de Trabalho:")]), _vm._v(" " + _vm._s(_vm.paper.event_paper_type.paper_type.name) + "\n                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', [_c('strong', [_vm._v("Submetido por:")]), _vm._v(" " + _vm._s(_vm.paper.registration.person.pessoa.nome) + "\n                            (" + _vm._s(_vm.paper.registration.person.ref_pessoa) + ")\n                        ")]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Data da Submissão:")]), _vm._v(" " + _vm._s(_vm._f("dateTimeEnToBr")(_vm.paper.date_submitted)))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', [_c('strong', [_vm._v("Status:")]), _vm._v(" " + _vm._s(_vm.paper.status.name))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Data da últ. atualização:")]), _vm._v(" " + _vm._s(_vm._f("dateTimeEnToBr")(_vm.paper.last_modified)) + "\n                        ")])])])])]), _vm._v(" "), _c('table', {
	    staticClass: "table-confirmation",
	    staticStyle: {
	      "table-layout": "fixed"
	    }
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Dados do Trabalho")])])]), _vm._v(" "), _c('tbody', [(_vm.paper.knowledge_area) ? _c('tr', [_c('td', [_c('strong', [_vm._v("Área do Conhecimento:")]), _vm._v(" " + _vm._s(_vm.paper.knowledge_area.full_name) + "\n                    ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.paper.contents), function(content) {
	    return _c('tr', [(content.event_paper_type_field.field.type !== 'file') ? _c('td', {
	      staticClass: "dont-break-out"
	    }, [_c('strong', [_vm._v(_vm._s(content.event_paper_type_field.field.name) + ":")]), _vm._v(" " + _vm._s(content.value) + "\n                    ")]) : _vm._e(), _vm._v(" "), (content.event_paper_type_field.field.type === 'file') ? _c('td', {
	      staticClass: "dont-break-out",
	      class: {
	        '-missing-file': content.value === ''
	      }
	    }, [(content.value && content.value !== '') ? _c('span', [_c('strong', [_vm._v(_vm._s(content.event_paper_type_field.field.name) + ":")]), _vm._v(" " + _vm._s(content.value) + " "), _c('span', {
	      staticClass: "paper-content-file-version"
	    }, [_vm._v("(Versão: " + _vm._s(content.version) + ")")])]) : _vm._e()]) : _vm._e()])
	  })], 2)])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 14
	    }
	  }, [_c('table', {
	    staticClass: "table-confirmation"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Autores")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.paper.authors), function(author) {
	    return _c('tr', [_c('td', [_c('div', [_c('strong', [_vm._v(_vm._s(author.author_type.name) + " " + _vm._s(author.seq))]), _vm._v(" "), (author.primary_contact) ? _c('span', [_vm._v(" - Contato Principal")]) : _vm._e()]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Nome Completo:")]), _vm._v(" " + _vm._s(author.first_name + ' ' + author.last_name) + "\n                        ")]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Email:")]), _vm._v(" " + _vm._s(author.email))])])])
	  }))]), _vm._v(" "), (_vm.paper) ? _c('paper-show-screening', {
	    attrs: {
	      "paper": _vm.paper
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.paper) ? _c('paper-show-evaluation', {
	    attrs: {
	      "paper": _vm.paper
	    }
	  }) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.showPaperPreview) ? _c('div', [_c('h3', [_vm._v("Preview do Trabalho")]), _vm._v(" "), (_vm.getPaperFilePath) ? _c('object', {
	    attrs: {
	      "data": _vm.getPaperFilePath,
	      "type": "application/pdf"
	    }
	  }, [_c('embed', {
	    attrs: {
	      "src": _vm.getPaperFilePath,
	      "type": "application/pdf"
	    }
	  })]) : _c('div', [_vm._v("\n            Arquivo não encontrado\n        ")])]) : _vm._e()], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 718 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('ListHeader', {
	    attrs: {
	      "title": "Assinatura dos Certificados",
	      "store-route-name": "signature.store"
	    }
	  }), _vm._v(" "), _c('ListMain', [_c('div', {
	    attrs: {
	      "slot": "filters"
	    },
	    slot: "filters"
	  }, [_c('el-card', {
	    staticClass: "el-card__search_list box-card"
	  }, [_c('div', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('span', [_vm._v("Filtrar")]), _vm._v(" "), _c('div', [_c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": _vm.onFilter
	    }
	  }, [_vm._v("Pesquisar")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "default"
	    },
	    on: {
	      "click": _vm.onFilterClean
	    }
	  }, [_vm._v("Limpar")])], 1)]), _vm._v(" "), _c('el-form', {
	    staticClass: "demo-form-inline",
	    attrs: {
	      "inline": true,
	      "model": _vm.filters
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Nome"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "placeholder": "Filtrar por nome"
	    },
	    nativeOn: {
	      "keydown": function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
	        $event.preventDefault();
	        _vm.onFilter($event)
	      }
	    },
	    model: {
	      value: (_vm.filters.name),
	      callback: function($$v) {
	        _vm.$set(_vm.filters, "name", $$v)
	      },
	      expression: "filters.name"
	    }
	  })], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.isLoadingData) ? _c('div', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, [_c('h2', [_vm._v("Lista de Campos")]), _vm._v(" "), _c('table', {
	    staticClass: "custom-table-list"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Descrição")]), _vm._v(" "), _c('th', {
	    staticClass: "btn-actions"
	  }, [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listStore.listData), function(item) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.description))]), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "btn-actions"
	    }, [_c('ListEditButton', {
	      attrs: {
	        "route-name": "signature.update",
	        "item": item,
	        "domain": "signature"
	      }
	    }), _vm._v(" "), _c('ListDeleteButton', {
	      attrs: {
	        "item": item,
	        "domain": "signature"
	      }
	    })], 1)])])
	  }))])]) : _vm._e()])], 1)
	},staticRenderFns: []}

/***/ }),
/* 719 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('ListHeader', {
	    attrs: {
	      "title": _vm.pageTitle,
	      "back-route": "event.index"
	    }
	  }), _vm._v(" "), _c('el-tabs', {
	    attrs: {
	      "type": "card"
	    },
	    model: {
	      value: (_vm.activeTab),
	      callback: function($$v) {
	        _vm.activeTab = $$v
	      },
	      expression: "activeTab"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "name": "minicursos",
	      "label": "Listagem de Minicursos"
	    }
	  }, [_c('div', {
	    staticClass: "responsive-table"
	  }, [(_vm.activeTab === 'minicursos') ? _c('table', {
	    staticClass: "custom-table-list"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticStyle: {
	      "font-size": "18px"
	    },
	    attrs: {
	      "colspan": "11"
	    }
	  }, [_vm._v("Total: " + _vm._s(_vm.listFiltered.length))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Cód. Minicurso")]), _vm._v(" "), _c('th', [_vm._v("Minicurso")]), _vm._v(" "), _c('th', [_vm._v("Data do Evento")]), _vm._v(" "), _c('th', [_vm._v("Total Inscritos/Vagas")]), _vm._v(" "), _c('th', {
	    staticClass: "btn-actions"
	  }, [_vm._v("Lista de Inscritos")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listFiltered), function(item) {
	    return _c('tr', [_c('td', {
	      attrs: {
	        "align": "center"
	      }
	    }, [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dateTimeEnToBr")(item.start_datetime)))]), _vm._v(" "), _c('td', {
	      attrs: {
	        "align": "center"
	      }
	    }, [_vm._v("\n                            " + _vm._s(item.modalities.length > 0 ? item.modalities[0].registrations.length : 0) + "/" + _vm._s(item.vacancies) + "\n                            "), _c('br'), _vm._v(" "), _c('el-progress', {
	      attrs: {
	        "percentage": _vm.calculaPercentualInscritos(item.modalities.length > 0 ? item.modalities[0].registrations.length : 0, item.vacancies),
	        "color": _vm.calculaCor(item.modalities.length > 0 ? item.modalities[0].registrations.length : 0, item.vacancies),
	        "text-inside": true,
	        "stroke-width": 18
	      }
	    })], 1), _vm._v(" "), _c('td', {
	      attrs: {
	        "align": "center"
	      }
	    }, [_c('a', {
	      staticClass: "el-button el-button--small",
	      attrs: {
	        "href": item.minicurso_pdf_path,
	        "target": "_blank",
	        "title": "Lista de Inscritos"
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-file-pdf-o"
	    })])])])
	  }))]) : _vm._e()])])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 720 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (!_vm.isLoadingData) ? _c('div', [_c('ListHeader', {
	    attrs: {
	      "title": "Países"
	    }
	  }), _vm._v(" "), _c('el-card', {
	    staticClass: "el-card__save_form box-card"
	  }, [_c('div', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('span', [_vm._v("Dados dos Países")])]), _vm._v(" "), _c('el-form', {
	    ref: "form",
	    attrs: {
	      "model": _vm.form,
	      "label-width": "20%"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.onSend($event)
	      }
	    }
	  }, [_c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.form.name.$error
	    },
	    attrs: {
	      "label": "Nome"
	    }
	  }, [_c('el-input', {
	    on: {
	      "input": function($event) {
	        _vm.$v.form.name.$touch()
	      }
	    },
	    model: {
	      value: (_vm.form.name),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "name", $$v)
	      },
	      expression: "form.name"
	    }
	  }), _vm._v(" "), (_vm.$v.form.name.$error) ? _c('div', {
	    staticClass: "el-form-item__error"
	  }, [_vm._v("Esse campo é obrigatório")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.form.nationality.$error
	    },
	    attrs: {
	      "label": "Nacionalidade"
	    }
	  }, [_c('el-input', {
	    on: {
	      "input": function($event) {
	        _vm.$v.form.nationality.$touch()
	      }
	    },
	    model: {
	      value: (_vm.form.nationality),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "nationality", $$v)
	      },
	      expression: "form.nationality"
	    }
	  }), _vm._v(" "), (_vm.$v.form.nationality.$error) ? _c('div', {
	    staticClass: "el-form-item__error"
	  }, [_vm._v("Esse campo é obrigatório")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', [_c('form-save-button', {
	    attrs: {
	      "event-click": _vm.onSend,
	      "is-disabled": _vm.isSubmitted || _vm.$v.$invalid,
	      "is-submitted": _vm.isSubmitted
	    }
	  }), _vm._v(" "), _c('form-cancel-button', {
	    attrs: {
	      "route-name": "country.index"
	    }
	  })], 1)], 1)], 1)], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 721 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (!_vm.isLoadingData) ? _c('div', [_c('ListHeader', {
	    attrs: {
	      "title": "Tipo de Avaliação"
	    }
	  }), _vm._v(" "), _c('el-card', {
	    staticClass: "el-card__save_form box-card"
	  }, [_c('div', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('span', [_vm._v("Dados do Tipo de Avaliação")])]), _vm._v(" "), _c('el-form', {
	    ref: "form",
	    attrs: {
	      "model": _vm.form,
	      "label-width": "20%"
	    },
	    nativeOn: {
	      "submit": function($event) {
	        $event.preventDefault();
	      }
	    }
	  }, [_c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.form.name.$error
	    },
	    attrs: {
	      "label": "Nome"
	    }
	  }, [_c('el-input', {
	    on: {
	      "input": function($event) {
	        _vm.$v.form.name.$touch()
	      }
	    },
	    model: {
	      value: (_vm.form.name),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "name", $$v)
	      },
	      expression: "form.name"
	    }
	  }), _vm._v(" "), (_vm.$v.form.name.$error) ? _c('div', {
	    staticClass: "el-form-item__error"
	  }, [_vm._v("Esse campo é obrigatório")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.form.description.$error
	    },
	    attrs: {
	      "label": "Descrição"
	    }
	  }, [_c('el-input', {
	    on: {
	      "input": function($event) {
	        _vm.$v.form.description.$touch()
	      }
	    },
	    model: {
	      value: (_vm.form.description),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "description", $$v)
	      },
	      expression: "form.description"
	    }
	  }), _vm._v(" "), (_vm.$v.form.description.$error) ? _c('div', {
	    staticClass: "el-form-item__error"
	  }, [_vm._v("Esse campo é obrigatório")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', [_c('form-save-button', {
	    attrs: {
	      "event-click": _vm.onSend,
	      "is-disabled": _vm.isSubmitted || _vm.$v.$invalid,
	      "is-submitted": _vm.isSubmitted
	    }
	  }), _vm._v(" "), _c('form-cancel-button', {
	    attrs: {
	      "route-name": "evaluation_type.index"
	    }
	  })], 1)], 1)], 1)], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 722 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (!_vm.isLoadingData) ? _c('div', [_c('ListHeader', {
	    attrs: {
	      "title": _vm.form.event.title + ' / ' + _vm.form.title,
	      "back-route": "event.index",
	      "edit-route-name": "event.update.basic-data",
	      "item": _vm.form
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "show-box"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "content"
	  }, [_c('table', {
	    attrs: {
	      "width": "100%"
	    }
	  }, [_c('tbody', [_c('tr', [_c('td', {
	    attrs: {
	      "width": "33%"
	    }
	  }, [_c('div', [_vm._v("Local: "), _c('strong', [_vm._v(_vm._s(_vm.form.place.description))])]), _vm._v(" "), _c('div', [_vm._v("Email Contato: "), _c('strong', [_vm._v(_vm._s(_vm.form.contact_email))])])]), _vm._v(" "), _c('td', {
	    attrs: {
	      "width": "33%"
	    }
	  }, [_c('div', [_vm._v("Data de Início: "), _c('strong', [_vm._v(_vm._s(_vm._f("dateTimeEnToBr")(_vm.form.start_datetime)))])]), _vm._v(" "), _c('div', [_vm._v("Data de Término: "), _c('strong', [_vm._v(_vm._s(_vm._f("dateTimeEnToBr")(_vm.form.end_datetime)))])])]), _vm._v(" "), _c('td', {
	    attrs: {
	      "width": "33%"
	    }
	  }, [_c('div', [_vm._v("Data de Início das Inscrições: "), _c('strong', [_vm._v(_vm._s(_vm._f("dateTimeEnToBr")(_vm.form.start_registration_datetime)))])]), _vm._v(" "), _c('div', [_vm._v("Data de Término das Inscrições: "), _c('strong', [_vm._v(_vm._s(_vm._f("dateTimeEnToBr")(_vm.form.end_registration_datetime)))])])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "event-actions"
	  }, [_c('router-link', {
	    staticClass: "-button1",
	    class: {
	      '-current': _vm.currentView === 'home'
	    },
	    attrs: {
	      "to": {
	        name: 'event.show.home',
	        params: {
	          id: _vm.form.id,
	          mainEventId: _vm.form.event_id
	        }
	      },
	      "title": "Início"
	    }
	  }, [_c('div', {
	    staticClass: "event-link-box"
	  }, [_c('div', {
	    staticClass: "event-box"
	  }, [_c('i', {
	    staticClass: "fa fa-home"
	  }), _vm._v(" "), _c('span', [_vm._v("Início")])])])]), _vm._v(" "), _c('router-link', {
	    staticClass: "-button2",
	    class: {
	      '-current': _vm.currentView === 'registration'
	    },
	    attrs: {
	      "to": {
	        name: 'event.index.registrations',
	        params: {
	          id: _vm.form.id,
	          mainEventId: _vm.form.event_id
	        }
	      },
	      "title": "Inscrições"
	    }
	  }, [_c('div', {
	    staticClass: "event-link-box"
	  }, [_c('div', {
	    staticClass: "event-box"
	  }, [_c('i', {
	    staticClass: "fa fa-user"
	  }), _vm._v(" "), _c('span', [_vm._v("Inscrições")])])])]), _vm._v(" "), _c('router-link', {
	    staticClass: "-button3",
	    class: {
	      '-current': _vm.currentView === 'event.index.papers.nao_designado'
	    },
	    attrs: {
	      "to": {
	        name: 'event.index.papers',
	        params: {
	          id: _vm.form.id,
	          statusKey: 'nao_designado'
	        }
	      },
	      "title": "Submissões Recebidas"
	    }
	  }, [_c('div', {
	    staticClass: "event-link-box"
	  }, [_c('div', {
	    staticClass: "event-box"
	  }, [_c('i', {
	    staticClass: "fa fa-file-o"
	  }), _vm._v(" "), _c('span', [_vm._v("Submissões Recebidas")]), _vm._v(" "), _c('span', {
	    staticClass: "total"
	  }, [_vm._v("Total: "), _c('strong', [_vm._v(_vm._s(_vm.form.papers['nao_designado']))])])])])]), _vm._v(" "), _c('router-link', {
	    staticClass: "-button4",
	    class: {
	      '-current': _vm.currentView === 'event.index.papers.aprovado_pela_triagem'
	    },
	    attrs: {
	      "to": {
	        name: 'event.index.papers',
	        params: {
	          id: _vm.form.id,
	          statusKey: 'aprovado_pela_triagem'
	        }
	      },
	      "title": "Aprovadas pela Triagem"
	    }
	  }, [_c('div', {
	    staticClass: "event-link-box"
	  }, [_c('div', {
	    staticClass: "event-box"
	  }, [_c('i', {
	    staticClass: "fa fa-file-o"
	  }), _vm._v(" "), _c('span', [_vm._v("Aprovadas pela Triagem")]), _vm._v(" "), _c('span', {
	    staticClass: "total"
	  }, [_vm._v("Total: "), _c('strong', [_vm._v(_vm._s(_vm.form.papers['aprovado_pela_triagem']))])])])])]), _vm._v(" "), _c('router-link', {
	    staticClass: "-button5",
	    class: {
	      '-current': _vm.currentView === 'event.index.papers.em_avaliacao'
	    },
	    attrs: {
	      "to": {
	        name: 'event.index.papers',
	        params: {
	          id: _vm.form.id,
	          statusKey: 'em_avaliacao'
	        }
	      },
	      "title": "Submissões Atribuidas"
	    }
	  }, [_c('div', {
	    staticClass: "event-link-box"
	  }, [_c('div', {
	    staticClass: "event-box"
	  }, [_c('i', {
	    staticClass: "fa fa-file-text-o"
	  }), _vm._v(" "), _c('span', [_vm._v("Submissões Atribuidas")]), _vm._v(" "), _c('span', {
	    staticClass: "total"
	  }, [_vm._v("Total: "), _c('strong', [_vm._v(_vm._s(_vm.form.papers['em_avaliacao']))])])])])]), _vm._v(" "), _c('router-link', {
	    staticClass: "-button6",
	    class: {
	      '-current': _vm.currentView === 'event.index.papers.finalizado'
	    },
	    attrs: {
	      "to": {
	        name: 'event.index.papers',
	        params: {
	          id: _vm.form.id,
	          statusKey: 'finalizado'
	        }
	      },
	      "title": "Submissões Avaliadas"
	    }
	  }, [_c('div', {
	    staticClass: "event-link-box"
	  }, [_c('div', {
	    staticClass: "event-box"
	  }, [_c('i', {
	    staticClass: "fa fa-file"
	  }), _vm._v(" "), _c('span', [_vm._v("Submissões Finalizadas")])])])])], 1), _vm._v(" "), _c('router-view', {
	    attrs: {
	      "event": _vm.form
	    }
	  })], 1) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "header"
	  }, [_c('span', {
	    staticClass: "title"
	  }, [_vm._v("Dados da Evento")])])
	}]}

/***/ }),
/* 723 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (!_vm.isLoadingData) ? _c('div', [_vm._m(0), _vm._v(" "), _c('el-tabs', {
	    attrs: {
	      "type": "card"
	    },
	    model: {
	      value: (_vm.activePaperType),
	      callback: function($$v) {
	        _vm.activePaperType = $$v
	      },
	      expression: "activePaperType"
	    }
	  }, _vm._l((_vm.eventPaperTypes), function(paperType, paperTypeIndex) {
	    return _c('el-tab-pane', {
	      attrs: {
	        "label": paperType.paper_type.name,
	        "name": 'tab_' + paperType.id
	      }
	    }, [_c('el-form', {
	      ref: "formSelectPaperType",
	      refInFor: true,
	      attrs: {
	        "label-position": "top"
	      }
	    }, [_c('el-form-item', {
	      attrs: {
	        "label": "Adicionar Avaliação"
	      }
	    }, [_c('el-select', {
	      staticClass: "el-select-full",
	      attrs: {
	        "filterable": "",
	        "clearable": "",
	        "placeholder": "Selecione uma avaliação",
	        "empty-text": "Nenhum registro encontrado"
	      },
	      on: {
	        "change": function($event) {
	          _vm.selectEvaluation(_vm.evaluationSelect, paperTypeIndex)
	        }
	      },
	      model: {
	        value: (_vm.evaluationSelect),
	        callback: function($$v) {
	          _vm.evaluationSelect = $$v
	        },
	        expression: "evaluationSelect"
	      }
	    }, _vm._l((_vm.dependencies.evaluation_types), function(item) {
	      return _c('el-option', {
	        key: item.id,
	        attrs: {
	          "disabled": _vm.checkEvaluationSelected(item.id, paperTypeIndex),
	          "label": item.name,
	          "value": item.id
	        }
	      })
	    }))], 1)], 1), _vm._v(" "), _c('h3', [_vm._v("Tipos de Avaliação")]), _vm._v(" "), _c('table', {
	      staticClass: "custom-table-list paper-types-table"
	    }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Avaliação")]), _vm._v(" "), _c('th', [_vm._v("Período de Avaliação")]), _vm._v(" "), _c('th', [_vm._v("Critérios")]), _vm._v(" "), _c('th', {
	      attrs: {
	        "width": "130"
	      }
	    }, [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', _vm._l((paperType.evaluation_types), function(evaluation) {
	      return _c('tr', [_c('td', [_vm._v(_vm._s(evaluation.evaluation_type.name))]), _vm._v(" "), _c('td', [_c('div', [_c('strong', [_vm._v("Início:")]), _vm._v(" " + _vm._s(_vm._f("dateTimeEnToBr")(evaluation.start_datetime)))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Término:")]), _vm._v(" " + _vm._s(_vm._f("dateTimeEnToBr")(evaluation.end_datetime)))])]), _vm._v(" "), _c('td', [_c('ul', _vm._l((evaluation.criterias), function(evaluationCriteria) {
	        return _c('li', [_vm._v("\n                                " + _vm._s(evaluationCriteria.criteria.name) + "\n                            ")])
	      }))]), _vm._v(" "), _c('td', {
	        staticClass: "buttons"
	      }, [_c('el-button', {
	        staticClass: "edit-paper-type",
	        attrs: {
	          "type": "info",
	          "title": "Editar Tipo de Trabalho"
	        },
	        on: {
	          "click": function($event) {
	            _vm.editEvaluation(evaluation)
	          }
	        }
	      }, [_c('i', {
	        staticClass: "fa fa-edit"
	      })]), _vm._v(" "), _c('el-button', {
	        attrs: {
	          "type": "danger",
	          "title": "Remover Tipo de Trabalho"
	        },
	        on: {
	          "click": function($event) {
	            _vm.removeEvaluation(evaluation, paperTypeIndex)
	          }
	        }
	      }, [_c('i', {
	        staticClass: "fa fa-times"
	      })])], 1)])
	    }))])], 1)
	  })), _vm._v(" "), (_vm.modalEvaluationVisible) ? _c('el-dialog', {
	    attrs: {
	      "title": 'Dados da avaliação: ' + _vm.evaluation.evaluation_type.name,
	      "top": "5vh",
	      "visible": _vm.modalEvaluationVisible
	    },
	    on: {
	      "update:visible": function($event) {
	        _vm.modalEvaluationVisible = $event
	      }
	    }
	  }, [_c('el-form', {
	    ref: "formEvaluation",
	    staticClass: "form-paper-type",
	    attrs: {
	      "label-position": "top"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.evaluation.start_datetime.$error
	    },
	    attrs: {
	      "label": "Data/Hora Início da Avaliação"
	    }
	  }, [_c('el-date-picker', {
	    attrs: {
	      "type": "datetime",
	      "format": "dd/MM/yyyy HH:mm",
	      "placeholder": "Data/Hora Início"
	    },
	    on: {
	      "input": function($event) {
	        _vm.$v.evaluation.start_datetime.$touch()
	      }
	    },
	    model: {
	      value: (_vm.evaluation.start_datetime),
	      callback: function($$v) {
	        _vm.$set(_vm.evaluation, "start_datetime", $$v)
	      },
	      expression: "evaluation.start_datetime"
	    }
	  }), _vm._v(" "), (!_vm.$v.evaluation.start_datetime.required && _vm.$v.evaluation.start_datetime.$dirty) ? _c('validation-message') : _vm._e()], 1)], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.evaluation.end_datetime.$error
	    },
	    attrs: {
	      "label": "Data/Hora Término da Avaliação"
	    }
	  }, [_c('el-date-picker', {
	    attrs: {
	      "type": "datetime",
	      "format": "dd/MM/yyyy HH:mm",
	      "placeholder": "Data/Hora Término"
	    },
	    on: {
	      "input": function($event) {
	        _vm.$v.evaluation.end_datetime.$touch()
	      }
	    },
	    model: {
	      value: (_vm.evaluation.end_datetime),
	      callback: function($$v) {
	        _vm.$set(_vm.evaluation, "end_datetime", $$v)
	      },
	      expression: "evaluation.end_datetime"
	    }
	  }), _vm._v(" "), (!_vm.$v.evaluation.end_datetime.required && _vm.$v.evaluation.end_datetime.$dirty) ? _c('validation-message') : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Nº Mínimo de avaliações"
	    }
	  }, [_c('el-input-number', {
	    attrs: {
	      "min": 0,
	      "step": 1,
	      "max": 100
	    },
	    model: {
	      value: (_vm.evaluation.min_evaluations_number),
	      callback: function($$v) {
	        _vm.$set(_vm.evaluation, "min_evaluations_number", $$v)
	      },
	      expression: "evaluation.min_evaluations_number"
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Nota Mínima para Aprovação"
	    }
	  }, [_c('el-input-number', {
	    attrs: {
	      "min": 0,
	      "step": 0.1,
	      "max": 10
	    },
	    model: {
	      value: (_vm.evaluation.min_evaluation_next_step),
	      callback: function($$v) {
	        _vm.$set(_vm.evaluation, "min_evaluation_next_step", $$v)
	      },
	      expression: "evaluation.min_evaluation_next_step"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('h3', [_vm._v("Critérios de Avaliação")]), _vm._v(" "), _c('div', {
	    staticClass: "fields-check"
	  }, _vm._l((_vm.evaluation.criterias), function(criteria) {
	    return _c('div', {
	      staticClass: "item",
	      class: {
	        '-checked': criteria.checked
	      },
	      on: {
	        "click": function($event) {
	          criteria.checked = !criteria.checked
	        }
	      }
	    }, [_c('div', {
	      staticClass: "name"
	    }, [_vm._v(_vm._s(criteria.name))]), _vm._v(" "), _c('div', {
	      staticClass: "description"
	    }, [_vm._v(_vm._s(criteria.description))]), _vm._v(" "), (criteria.type === 'number') ? _c('div', {
	      staticClass: "size"
	    }, [_vm._v("\n                        Nota Mínima: " + _vm._s(criteria.min_size) + " / Nota Máxima: " + _vm._s(criteria.max_size) + "\n                    ")]) : _vm._e()])
	  }))], 1), _vm._v(" "), _c('div', {
	    staticClass: "dialog-footer",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('el-button', {
	    staticClass: "submit",
	    attrs: {
	      "type": "primary",
	      "disabled": _vm.$v.evaluation.$invalid
	    },
	    on: {
	      "click": _vm.onSaveEvaluation
	    }
	  }, [_vm._v("\n                Salvar Alterações\n            ")]), _vm._v(" "), _c('el-button', {
	    on: {
	      "click": _vm.onHandleModalEvaluation
	    }
	  }, [_vm._v("Fechar")])], 1)], 1) : _vm._e()], 1) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "header-flex"
	  }, [_c('h2', [_vm._v("Tipos de Trabalhos")])])
	}]}

/***/ }),
/* 724 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (!_vm.isLoadingData) ? _c('div', [_c('ListHeader', {
	    attrs: {
	      "title": "Tipo de Trabalho"
	    }
	  }), _vm._v(" "), _c('el-card', {
	    staticClass: "el-card__save_form box-card"
	  }, [_c('div', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('span', [_vm._v("Dados do Tipo de Trabalho")])]), _vm._v(" "), _c('el-form', {
	    ref: "form",
	    attrs: {
	      "model": _vm.form,
	      "label-width": "20%"
	    },
	    nativeOn: {
	      "submit": function($event) {
	        $event.preventDefault();
	      }
	    }
	  }, [_c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.form.name.$error
	    },
	    attrs: {
	      "label": "Nome"
	    }
	  }, [_c('el-input', {
	    on: {
	      "input": function($event) {
	        _vm.$v.form.name.$touch()
	      }
	    },
	    model: {
	      value: (_vm.form.name),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "name", $$v)
	      },
	      expression: "form.name"
	    }
	  }), _vm._v(" "), (_vm.$v.form.name.$error) ? _c('div', {
	    staticClass: "el-form-item__error"
	  }, [_vm._v("Esse campo é obrigatório")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.form.description.$error
	    },
	    attrs: {
	      "label": "Descrição"
	    }
	  }, [_c('el-input', {
	    on: {
	      "input": function($event) {
	        _vm.$v.form.description.$touch()
	      }
	    },
	    model: {
	      value: (_vm.form.description),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "description", $$v)
	      },
	      expression: "form.description"
	    }
	  }), _vm._v(" "), (_vm.$v.form.description.$error) ? _c('div', {
	    staticClass: "el-form-item__error"
	  }, [_vm._v("Esse campo é obrigatório")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', [_c('form-save-button', {
	    attrs: {
	      "event-click": _vm.onSend,
	      "is-disabled": _vm.isSubmitted || _vm.$v.$invalid,
	      "is-submitted": _vm.isSubmitted
	    }
	  }), _vm._v(" "), _c('form-cancel-button', {
	    attrs: {
	      "route-name": "paper_type.index"
	    }
	  })], 1)], 1)], 1)], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 725 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "list-component"
	  }, [_vm._t("filters"), _vm._v(" "), _c('div', {
	    staticClass: "main-list"
	  }, [_vm._t("list")], 2), _vm._v(" "), _c('div', {
	    staticClass: "footer"
	  }, [_c('span'), _vm._v(" "), _c('span', [_vm._v("Total de Registros: "), _c('strong', [_vm._v(_vm._s(_vm.listStore.listTotal))])])]), _vm._v(" "), (_vm.isPaginationVisible) ? _c('el-pagination', {
	    staticClass: "list-pagination",
	    attrs: {
	      "page-sizes": _vm.pages,
	      "page-size": _vm.listStore.listPerPage,
	      "current-page": _vm.currentPage,
	      "layout": "sizes, prev, pager, next",
	      "total": _vm.listStore.listTotal
	    },
	    on: {
	      "size-change": _vm.onPaginatorChangeSize,
	      "current-change": _vm.onPaginatorChangePage,
	      "update:currentPage": function($event) {
	        _vm.currentPage = $event
	      }
	    }
	  }) : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 726 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('ListHeader', {
	    attrs: {
	      "title": "Usuários",
	      "store-route-name": "user.store"
	    }
	  }), _vm._v(" "), _c('ListMain', [_c('div', {
	    attrs: {
	      "slot": "filters"
	    },
	    slot: "filters"
	  }, [_c('el-card', {
	    staticClass: "el-card__search_list box-card"
	  }, [_c('div', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('span', [_vm._v("Filtrar Listagem")]), _vm._v(" "), _c('div', [_c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": _vm.onFilter
	    }
	  }, [_vm._v("Pesquisar")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "default"
	    },
	    on: {
	      "click": _vm.onFilterClean
	    }
	  }, [_vm._v("Limpar")])], 1)]), _vm._v(" "), _c('el-form', {
	    staticClass: "demo-form-inline",
	    attrs: {
	      "inline": true,
	      "model": _vm.filters
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Nome"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "placeholder": "Filtrar por nome"
	    },
	    nativeOn: {
	      "keydown": function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
	        $event.preventDefault();
	        _vm.onFilter($event)
	      }
	    },
	    model: {
	      value: (_vm.filters.nome),
	      callback: function($$v) {
	        _vm.$set(_vm.filters, "nome", $$v)
	      },
	      expression: "filters.nome"
	    }
	  })], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.isLoadingData) ? _c('div', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, [_c('h2', [_vm._v("Lista de Usuários")]), _vm._v(" "), _c('table', {
	    staticClass: "custom-table-list"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Matrícula")]), _vm._v(" "), _c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', {
	    staticClass: "btn-actions"
	  }, [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listStore.listData), function(item) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.ref_pessoa))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.pessoa.nome))]), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "btn-actions"
	    }, [_c('ListEditButton', {
	      attrs: {
	        "route-name": "user.update",
	        "item": item,
	        "domain": "user"
	      }
	    }), _vm._v(" "), _c('ListDeleteButton', {
	      attrs: {
	        "item": item,
	        "domain": "user"
	      }
	    })], 1)])])
	  }))])]) : _vm._e()])], 1)
	},staticRenderFns: []}

/***/ }),
/* 727 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (!_vm.isLoadingData) ? _c('div', [_c('ListHeader', {
	    attrs: {
	      "title": "Escolaridades"
	    }
	  }), _vm._v(" "), _c('el-card', {
	    staticClass: "el-card__save_form box-card"
	  }, [_c('div', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('span', [_vm._v("Dados das Escolaridades")])]), _vm._v(" "), _c('el-form', {
	    ref: "form",
	    attrs: {
	      "model": _vm.form,
	      "label-width": "20%"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.onSend($event)
	      }
	    }
	  }, [_c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.form.name.$error
	    },
	    attrs: {
	      "label": "Nome"
	    }
	  }, [_c('el-input', {
	    on: {
	      "input": function($event) {
	        _vm.$v.form.name.$touch()
	      }
	    },
	    model: {
	      value: (_vm.form.name),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "name", $$v)
	      },
	      expression: "form.name"
	    }
	  }), _vm._v(" "), (_vm.$v.form.name.$error) ? _c('div', {
	    staticClass: "el-form-item__error"
	  }, [_vm._v("Esse campo é obrigatório")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.form.description.$error
	    },
	    attrs: {
	      "label": "Descrição"
	    }
	  }, [_c('el-input', {
	    on: {
	      "input": function($event) {
	        _vm.$v.form.description.$touch()
	      }
	    },
	    model: {
	      value: (_vm.form.description),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "description", $$v)
	      },
	      expression: "form.description"
	    }
	  }), _vm._v(" "), (_vm.$v.form.description.$error) ? _c('div', {
	    staticClass: "el-form-item__error"
	  }, [_vm._v("Esse campo é obrigatório")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.form.order.$error
	    },
	    attrs: {
	      "label": "Ordem"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "type": "number",
	      "min": "0",
	      "max": "10000",
	      "step": "1",
	      "pattern": "[0-9]"
	    },
	    on: {
	      "input": function($event) {
	        _vm.$v.form.order.$touch()
	      }
	    },
	    model: {
	      value: (_vm.form.order),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "order", $$v)
	      },
	      expression: "form.order"
	    }
	  }), _vm._v(" "), (_vm.$v.form.order.$error) ? _c('div', {
	    staticClass: "el-form-item__error"
	  }, [_vm._v("Esse campo é obrigatório")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', [_c('form-save-button', {
	    attrs: {
	      "event-click": _vm.onSend,
	      "is-disabled": _vm.isSubmitted || _vm.$v.$invalid,
	      "is-submitted": _vm.isSubmitted
	    }
	  }), _vm._v(" "), _c('form-cancel-button', {
	    attrs: {
	      "route-name": "literacy.index"
	    }
	  })], 1)], 1)], 1)], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 728 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('ListHeader', {
	    attrs: {
	      "title": "Escolaridades",
	      "store-route-name": "literacy.store"
	    }
	  }), _vm._v(" "), _c('ListMain', [_c('div', {
	    attrs: {
	      "slot": "filters"
	    },
	    slot: "filters"
	  }, [_c('el-card', {
	    staticClass: "el-card__search_list box-card"
	  }, [_c('div', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('span', [_vm._v("Filtrar Listagem")]), _vm._v(" "), _c('div', [_c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": _vm.onFilter
	    }
	  }, [_vm._v("Pesquisar")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "default"
	    },
	    on: {
	      "click": _vm.onFilterClean
	    }
	  }, [_vm._v("Limpar")])], 1)]), _vm._v(" "), _c('el-form', {
	    staticClass: "demo-form-inline",
	    attrs: {
	      "inline": true,
	      "model": _vm.filters
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Nome"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "placeholder": "Filtrar por nome"
	    },
	    nativeOn: {
	      "keydown": function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
	        $event.preventDefault();
	        _vm.onFilter($event)
	      }
	    },
	    model: {
	      value: (_vm.filters.name),
	      callback: function($$v) {
	        _vm.$set(_vm.filters, "name", $$v)
	      },
	      expression: "filters.name"
	    }
	  })], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.isLoadingData) ? _c('div', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, [_c('h2', [_vm._v("Lista de Escolaridades")]), _vm._v(" "), _c('table', {
	    staticClass: "custom-table-list"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Descrição")]), _vm._v(" "), _c('th', {
	    staticClass: "btn-actions"
	  }, [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listStore.listData), function(item) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.description))]), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "btn-actions"
	    }, [_c('ListEditButton', {
	      attrs: {
	        "route-name": "literacy.update",
	        "item": item,
	        "domain": "literacy"
	      }
	    }), _vm._v(" "), _c('ListDeleteButton', {
	      attrs: {
	        "item": item,
	        "domain": "literacy"
	      }
	    })], 1)])])
	  }))])]) : _vm._e()])], 1)
	},staticRenderFns: []}

/***/ }),
/* 729 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('ListHeader', {
	    attrs: {
	      "title": _vm.pageTitle,
	      "back-route": "event.index"
	    }
	  }), _vm._v(" "), _c('el-card', {
	    staticClass: "el-card__search_list box-card",
	    staticStyle: {
	      "margin-bottom": "30px"
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('span', [_vm._v("Filtrar Listagem")]), _vm._v(" "), _c('div', [_c('el-button', {
	    attrs: {
	      "type": "default"
	    },
	    on: {
	      "click": _vm.onFilterClean
	    }
	  }, [_vm._v("Limpar todos filtros")])], 1)]), _vm._v(" "), _c('el-form', {
	    staticClass: "demo-form-inline",
	    attrs: {
	      "inline": true,
	      "model": _vm.filters
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Matrícula"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "placeholder": "Filtrar por Matrícula"
	    },
	    model: {
	      value: (_vm.filters.ref_pessoa),
	      callback: function($$v) {
	        _vm.$set(_vm.filters, "ref_pessoa", $$v)
	      },
	      expression: "filters.ref_pessoa"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "Nome"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "placeholder": "Filtrar por Nome"
	    },
	    model: {
	      value: (_vm.filters.name),
	      callback: function($$v) {
	        _vm.$set(_vm.filters, "name", $$v)
	      },
	      expression: "filters.name"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "Evento"
	    }
	  }, [_c('el-select', {
	    staticClass: "el-select-full",
	    attrs: {
	      "clearable": "",
	      "placeholder": "Filtrar por evento",
	      "empty-text": "Nenhum registro encontrado"
	    },
	    model: {
	      value: (_vm.filters.sub_event),
	      callback: function($$v) {
	        _vm.$set(_vm.filters, "sub_event", $$v)
	      },
	      expression: "filters.sub_event"
	    }
	  }, _vm._l((_vm.listEvents), function(item) {
	    return _c('el-option', {
	      key: item,
	      attrs: {
	        "label": item,
	        "value": item
	      }
	    })
	  }))], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "Campus"
	    }
	  }, [_c('el-select', {
	    staticClass: "el-select-full",
	    attrs: {
	      "clearable": "",
	      "placeholder": "Filtrar por campus",
	      "empty-text": "Nenhum registro encontrado"
	    },
	    model: {
	      value: (_vm.filters.campus),
	      callback: function($$v) {
	        _vm.$set(_vm.filters, "campus", $$v)
	      },
	      expression: "filters.campus"
	    }
	  }, _vm._l((_vm.listCampus), function(item) {
	    return _c('el-option', {
	      key: item,
	      attrs: {
	        "label": item,
	        "value": item
	      }
	    })
	  }))], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "Curso"
	    }
	  }, [_c('el-select', {
	    staticClass: "el-select-full",
	    attrs: {
	      "clearable": "",
	      "placeholder": "Filtrar por curso",
	      "empty-text": "Nenhum registro encontrado"
	    },
	    model: {
	      value: (_vm.filters.course),
	      callback: function($$v) {
	        _vm.$set(_vm.filters, "course", $$v)
	      },
	      expression: "filters.course"
	    }
	  }, _vm._l((_vm.listCourse), function(item) {
	    return _c('el-option', {
	      key: item,
	      attrs: {
	        "label": item,
	        "value": item
	      }
	    })
	  }))], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "Status"
	    }
	  }, [_c('el-select', {
	    staticClass: "el-select-full",
	    attrs: {
	      "clearable": "",
	      "placeholder": "Filtrar por status",
	      "empty-text": "Nenhum registro encontrado"
	    },
	    model: {
	      value: (_vm.filters.status),
	      callback: function($$v) {
	        _vm.$set(_vm.filters, "status", $$v)
	      },
	      expression: "filters.status"
	    }
	  }, _vm._l((_vm.listStatus), function(item) {
	    return _c('el-option', {
	      key: item,
	      attrs: {
	        "label": item,
	        "value": item
	      }
	    })
	  }))], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "Instituição"
	    }
	  }, [_c('el-select', {
	    staticClass: "el-select-full",
	    attrs: {
	      "clearable": "",
	      "placeholder": "Filtrar por Instituição",
	      "empty-text": "Nenhum registro encontrado"
	    },
	    model: {
	      value: (_vm.filters.institution),
	      callback: function($$v) {
	        _vm.$set(_vm.filters, "institution", $$v)
	      },
	      expression: "filters.institution"
	    }
	  }, _vm._l((_vm.listInstitution), function(item) {
	    return _c('el-option', {
	      key: item,
	      attrs: {
	        "label": item,
	        "value": item
	      }
	    })
	  }))], 1)], 1)], 1), _vm._v(" "), _c('el-tabs', {
	    attrs: {
	      "type": "card"
	    },
	    model: {
	      value: (_vm.activeTab),
	      callback: function($$v) {
	        _vm.activeTab = $$v
	      },
	      expression: "activeTab"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "name": "advisors-urcamp",
	      "label": "Orientadores da URCAMP"
	    }
	  }, [(_vm.activeTab === 'advisors-urcamp') ? _c('table', {
	    staticClass: "custom-table-list"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticStyle: {
	      "font-size": "18px"
	    },
	    attrs: {
	      "colspan": "10"
	    }
	  }, [_vm._v("Total: " + _vm._s(_vm.listFiltered.length))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Cód. Pessoa")]), _vm._v(" "), _c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Evento")]), _vm._v(" "), _c('th', [_vm._v("Título Trabalho")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listFiltered), function(item) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(item.ref_pessoa))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.subevento))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.titulo))])])
	  }))]) : _vm._e()]), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "name": "authors-students-urcamp",
	      "label": "Alunos Autores ou Coautores"
	    }
	  }, [(_vm.activeTab === 'authors-students-urcamp') ? _c('table', {
	    staticClass: "custom-table-list"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticStyle: {
	      "font-size": "18px"
	    },
	    attrs: {
	      "colspan": "10"
	    }
	  }, [_vm._v("Total: " + _vm._s(_vm.listFiltered.length))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Cód. Pessoa")]), _vm._v(" "), _c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Evento")]), _vm._v(" "), _c('th', [_vm._v("Título Trabalho")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listFiltered), function(item) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(item.ref_pessoa))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.subevento))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.titulo))])])
	  }))]) : _vm._e()]), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "name": "authors-professors-urcamp",
	      "label": "Professors Autores ou Coautores"
	    }
	  }, [(_vm.activeTab === 'authors-professors-urcamp') ? _c('table', {
	    staticClass: "custom-table-list"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticStyle: {
	      "font-size": "18px"
	    },
	    attrs: {
	      "colspan": "10"
	    }
	  }, [_vm._v("Total: " + _vm._s(_vm.listFiltered.length))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Cód. Pessoa")]), _vm._v(" "), _c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Evento")]), _vm._v(" "), _c('th', [_vm._v("Título Trabalho")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listFiltered), function(item) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(item.ref_pessoa))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.subevento))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.titulo))])])
	  }))]) : _vm._e()]), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "name": "registrations-fies",
	      "label": "Inscritos FIES"
	    }
	  }, [(_vm.activeTab === 'registrations-fies') ? _c('table', {
	    staticClass: "custom-table-list"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticStyle: {
	      "font-size": "18px"
	    },
	    attrs: {
	      "colspan": "10"
	    }
	  }, [_vm._v("Total: " + _vm._s(_vm.listFiltered.length))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Cód. Pessoa")]), _vm._v(" "), _c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Evento")]), _vm._v(" "), _c('th', [_vm._v("Título Trabalho")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listFiltered), function(item) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(item.ref_pessoa))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.subevento))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.titulo))])])
	  }))]) : _vm._e()]), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "name": "registrations-prouni",
	      "label": "Inscritos Prouni"
	    }
	  }, [(_vm.activeTab === 'registrations-prouni') ? _c('table', {
	    staticClass: "custom-table-list"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticStyle: {
	      "font-size": "18px"
	    },
	    attrs: {
	      "colspan": "10"
	    }
	  }, [_vm._v("Total: " + _vm._s(_vm.listFiltered.length))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Cód. Pessoa")]), _vm._v(" "), _c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Evento")]), _vm._v(" "), _c('th', [_vm._v("Título Trabalho")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listFiltered), function(item) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(item.ref_pessoa))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.subevento))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.titulo))])])
	  }))]) : _vm._e()]), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "name": "registrations-course-campus",
	      "label": "Inscritos por Curso e Campus"
	    }
	  }, [(_vm.activeTab === 'registrations-course-campus') ? _c('table', {
	    staticClass: "custom-table-list"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticStyle: {
	      "font-size": "18px"
	    },
	    attrs: {
	      "colspan": "10"
	    }
	  }, [_vm._v("Total: " + _vm._s(_vm.listFiltered.length))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Campus")]), _vm._v(" "), _c('th', [_vm._v("Curso")]), _vm._v(" "), _c('th', [_vm._v("Cód. Pessoa")]), _vm._v(" "), _c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Status Inscrição")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listFiltered), function(item) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(item.campus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.curso))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.ref_pessoa))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.status))])])
	  }))]) : _vm._e()]), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "name": "submissions",
	      "label": "Trabalhos"
	    }
	  }, [(_vm.activeTab === 'submissions') ? _c('div', [_c('table', {
	    staticClass: "custom-table-list"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticStyle: {
	      "font-size": "16px"
	    },
	    attrs: {
	      "colspan": "10"
	    }
	  }, [_vm._v("Estatísticas da Triagem")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Evento")]), _vm._v(" "), _c('th', [_vm._v("Não Atribuídos")]), _vm._v(" "), _c('th', [_vm._v("Aprovados")]), _vm._v(" "), _c('th', [_vm._v("Reprovados")]), _vm._v(" "), _c('th', [_vm._v("Total")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listFiltered), function(item) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(item.subevent))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nao_designado))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.aprovado_pela_triagem))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.reprovado_pela_triagem))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nao_designado + item.aprovado_pela_triagem + item.reprovado_pela_triagem))])])
	  })), _vm._v(" "), _c('thead', [_c('tr', [_c('th', {
	    staticStyle: {
	      "font-size": "16px"
	    },
	    attrs: {
	      "colspan": "10"
	    }
	  }, [_vm._v("Estatísticas da Avaliação")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Evento")]), _vm._v(" "), _c('th', [_vm._v("Em Avaliação")]), _vm._v(" "), _c('th', [_vm._v("Aprovados")]), _vm._v(" "), _c('th', [_vm._v("Reprovados")]), _vm._v(" "), _c('th', [_vm._v("Total")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listFiltered), function(item) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(item.subevent))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.em_avaliacao))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.avaliado))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.reprovado))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.em_avaliacao + item.avaliado + item.reprovado))])])
	  }))])]) : _vm._e()]), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "name": "submissions-event-area-city",
	      "label": "Trabalhos por Evento, Área, Cidade"
	    }
	  }, [(_vm.activeTab === 'submissions-event-area-city') ? _c('table', {
	    staticClass: "custom-table-list"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticStyle: {
	      "font-size": "18px"
	    },
	    attrs: {
	      "colspan": "10"
	    }
	  }, [_vm._v("Total: " + _vm._s(_vm.listFiltered.length))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Evento")]), _vm._v(" "), _c('th', [_vm._v("Área")]), _vm._v(" "), _c('th', [_vm._v("Cidade")]), _vm._v(" "), _c('th', [_vm._v("Título")]), _vm._v(" "), _c('th', [_vm._v("Autor")]), _vm._v(" "), _c('th', [_vm._v("E-mail")]), _vm._v(" "), _c('th', [_vm._v("Instituição")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listFiltered), function(item) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(item.subevento))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.area_conhecimento))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.cidade))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.titulo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.instituicao))])])
	  }))]) : _vm._e()]), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "name": "event-participants",
	      "label": "Participantes do Evento"
	    }
	  }, [(_vm.activeTab === 'event-participants') ? _c('table', {
	    staticClass: "custom-table-list"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticStyle: {
	      "font-size": "18px"
	    },
	    attrs: {
	      "colspan": "10"
	    }
	  }, [_vm._v("Total: " + _vm._s(_vm.listFiltered.length))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Inscrição Nº")]), _vm._v(" "), _c('th', [_vm._v("Id")]), _vm._v(" "), _c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("E-mail")]), _vm._v(" "), _c('th', [_vm._v("CPF")]), _vm._v(" "), _c('th', [_vm._v("Cidade/Estado")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listFiltered), function(item) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(item.registration))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.social_number))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.city) + "/" + _vm._s(item.state))])])
	  }))]) : _vm._e()])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 730 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.value) ? _c('el-tag', {
	    attrs: {
	      "type": "primary"
	    }
	  }, [_vm._v("SIM")]) : _vm._e(), _vm._v(" "), (!_vm.value) ? _c('el-tag', {
	    attrs: {
	      "type": "danger"
	    }
	  }, [_vm._v("NÃO")]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 731 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('ListHeader', {
	    attrs: {
	      "title": "Tipo de Trabalho",
	      "store-route-name": "paper_type.store"
	    }
	  }), _vm._v(" "), _c('ListMain', [_c('div', {
	    attrs: {
	      "slot": "filters"
	    },
	    slot: "filters"
	  }, [_c('el-card', {
	    staticClass: "el-card__search_list box-card"
	  }, [_c('div', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('span', [_vm._v("Filtrar Listagem")]), _vm._v(" "), _c('div', [_c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": _vm.onFilter
	    }
	  }, [_vm._v("Pesquisar")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "default"
	    },
	    on: {
	      "click": _vm.onFilterClean
	    }
	  }, [_vm._v("Limpar")])], 1)]), _vm._v(" "), _c('el-form', {
	    staticClass: "demo-form-inline",
	    attrs: {
	      "inline": true,
	      "model": _vm.filters
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Nome"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "placeholder": "Filtrar por nome"
	    },
	    nativeOn: {
	      "keydown": function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
	        $event.preventDefault();
	        _vm.onFilter($event)
	      }
	    },
	    model: {
	      value: (_vm.filters.name),
	      callback: function($$v) {
	        _vm.$set(_vm.filters, "name", $$v)
	      },
	      expression: "filters.name"
	    }
	  })], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.isLoadingData) ? _c('div', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, [_c('h2', [_vm._v("Lista de Tipos de Trabalhos")]), _vm._v(" "), _c('table', {
	    staticClass: "custom-table-list"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Descrição")]), _vm._v(" "), _c('th', {
	    staticClass: "btn-actions"
	  }, [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listStore.listData), function(item) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.description))]), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "btn-actions"
	    }, [_c('ListEditButton', {
	      attrs: {
	        "route-name": "paper_type.update",
	        "item": item,
	        "domain": "paper_type"
	      }
	    }), _vm._v(" "), _c('ListDeleteButton', {
	      attrs: {
	        "item": item,
	        "domain": "paper_type"
	      }
	    })], 1)])])
	  }))])]) : _vm._e()])], 1)
	},staticRenderFns: []}

/***/ }),
/* 732 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (!_vm.isLoadingData) ? _c('div', [_c('ListHeader', {
	    attrs: {
	      "title": "Campos"
	    }
	  }), _vm._v(" "), _c('el-card', {
	    staticClass: "el-card__save_form box-card"
	  }, [_c('div', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('span', [_vm._v("Dados dos Campos")])]), _vm._v(" "), _c('el-form', {
	    ref: "form",
	    attrs: {
	      "model": _vm.form,
	      "label-width": "20%"
	    },
	    nativeOn: {
	      "submit": function($event) {
	        $event.preventDefault();
	      }
	    }
	  }, [_c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.form.name.$error
	    },
	    attrs: {
	      "label": "Nome"
	    }
	  }, [_c('el-input', {
	    on: {
	      "input": function($event) {
	        _vm.$v.form.name.$touch()
	      }
	    },
	    model: {
	      value: (_vm.form.name),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "name", $$v)
	      },
	      expression: "form.name"
	    }
	  }), _vm._v(" "), (_vm.$v.form.name.$error) ? _c('div', {
	    staticClass: "el-form-item__error"
	  }, [_vm._v("Esse campo é obrigatório")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "Descrição"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "type": "textarea",
	      "rows": 4
	    },
	    model: {
	      value: (_vm.form.description),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "description", $$v)
	      },
	      expression: "form.description"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "Mostrar a descrição como observações?"
	    }
	  }, [_c('el-checkbox', {
	    model: {
	      value: (_vm.form.show_helper),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "show_helper", $$v)
	      },
	      expression: "form.show_helper"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.form.type.$error
	    },
	    attrs: {
	      "label": "Tipo"
	    }
	  }, [_c('el-select', {
	    staticClass: "el-select-full",
	    attrs: {
	      "placeholder": "Selecione..."
	    },
	    on: {
	      "input": function($event) {
	        _vm.$v.form.type.$touch()
	      }
	    },
	    model: {
	      value: (_vm.form.type),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "type", $$v)
	      },
	      expression: "form.type"
	    }
	  }, _vm._l((_vm.dependencies.type), function(item) {
	    return _c('el-option', {
	      key: item.value,
	      attrs: {
	        "label": item.label,
	        "value": item.value
	      }
	    })
	  })), _vm._v(" "), (_vm.$v.form.type.$error) ? _c('div', {
	    staticClass: "el-form-item__error"
	  }, [_vm._v("Esse campo é obrigatório")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
	    staticClass: "is-required",
	    attrs: {
	      "label": "Tamanho Mínimo"
	    }
	  }, [_c('el-input-number', {
	    attrs: {
	      "min": 0,
	      "step": 1,
	      "max": 1000000000000
	    },
	    model: {
	      value: (_vm.form.min_size),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "min_size", $$v)
	      },
	      expression: "form.min_size"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    staticClass: "is-required",
	    attrs: {
	      "label": "Tamanho Máximo"
	    }
	  }, [_c('el-input-number', {
	    attrs: {
	      "min": 0,
	      "step": 1,
	      "max": 1000000000000
	    },
	    model: {
	      value: (_vm.form.max_size),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "max_size", $$v)
	      },
	      expression: "form.max_size"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', [_c('form-save-button', {
	    attrs: {
	      "event-click": _vm.onSend,
	      "is-disabled": _vm.isSubmitted || _vm.$v.$invalid,
	      "is-submitted": _vm.isSubmitted
	    }
	  }), _vm._v(" "), _c('form-cancel-button', {
	    attrs: {
	      "route-name": "field.index"
	    }
	  })], 1)], 1)], 1)], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 733 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('ListHeader', {
	    attrs: {
	      "title": "Países",
	      "store-route-name": "country.store"
	    }
	  }), _vm._v(" "), _c('ListMain', [_c('div', {
	    attrs: {
	      "slot": "filters"
	    },
	    slot: "filters"
	  }, [_c('el-card', {
	    staticClass: "el-card__search_list box-card"
	  }, [_c('div', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('span', [_vm._v("Filtrar Listagem")]), _vm._v(" "), _c('div', [_c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": _vm.onFilter
	    }
	  }, [_vm._v("Pesquisar")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "default"
	    },
	    on: {
	      "click": _vm.onFilterClean
	    }
	  }, [_vm._v("Limpar")])], 1)]), _vm._v(" "), _c('el-form', {
	    staticClass: "demo-form-inline",
	    attrs: {
	      "inline": true,
	      "model": _vm.filters
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Nome"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "placeholder": "Filtrar por nome"
	    },
	    model: {
	      value: (_vm.filters.name),
	      callback: function($$v) {
	        _vm.$set(_vm.filters, "name", $$v)
	      },
	      expression: "filters.name"
	    }
	  })], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.isLoadingData) ? _c('div', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, [_c('h2', [_vm._v("Lista de Países")]), _vm._v(" "), _c('table', {
	    staticClass: "custom-table-list"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Nacionalidade")]), _vm._v(" "), _c('th', {
	    staticClass: "btn-actions"
	  }, [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listStore.listData), function(item) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nationality))]), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "btn-actions"
	    }, [_c('ListEditButton', {
	      attrs: {
	        "route-name": "country.update",
	        "item": item,
	        "domain": "country"
	      }
	    }), _vm._v(" "), _c('ListDeleteButton', {
	      attrs: {
	        "item": item,
	        "domain": "country"
	      }
	    })], 1)])])
	  }))])]) : _vm._e()])], 1)
	},staticRenderFns: []}

/***/ }),
/* 734 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('router-link', {
	    staticClass: "el-button el-button--default",
	    attrs: {
	      "to": {
	        name: _vm.routeName,
	        params: {
	          id: _vm.item.id
	        }
	      },
	      "title": "Visualizar Dados"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-eye"
	  })])
	},staticRenderFns: []}

/***/ }),
/* 735 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('ListHeader', {
	    attrs: {
	      "title": "Instituições",
	      "store-route-name": "institution.store"
	    }
	  }), _vm._v(" "), _c('ListMain', [_c('div', {
	    attrs: {
	      "slot": "filters"
	    },
	    slot: "filters"
	  }, [_c('el-card', {
	    staticClass: "el-card__search_list box-card"
	  }, [_c('div', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('span', [_vm._v("Filtrar Listagem")]), _vm._v(" "), _c('div', [_c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": _vm.onFilter
	    }
	  }, [_vm._v("Pesquisar")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "default"
	    },
	    on: {
	      "click": _vm.onFilterClean
	    }
	  }, [_vm._v("Limpar")])], 1)]), _vm._v(" "), _c('el-form', {
	    staticClass: "demo-form-inline",
	    attrs: {
	      "inline": true,
	      "model": _vm.filters
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Nome"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "placeholder": "Filtrar por nome"
	    },
	    model: {
	      value: (_vm.filters.name),
	      callback: function($$v) {
	        _vm.$set(_vm.filters, "name", $$v)
	      },
	      expression: "filters.name"
	    }
	  })], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.isLoadingData) ? _c('div', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, [_c('h2', [_vm._v("Lista de Instituições")]), _vm._v(" "), _c('table', {
	    staticClass: "custom-table-list"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Sigla")]), _vm._v(" "), _c('th', {
	    staticClass: "btn-actions"
	  }, [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listStore.listData), function(item) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.initials))]), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "btn-actions"
	    }, [_c('ListEditButton', {
	      attrs: {
	        "route-name": "institution.update",
	        "item": item,
	        "domain": "institution"
	      }
	    }), _vm._v(" "), _c('ListDeleteButton', {
	      attrs: {
	        "item": item,
	        "domain": "institution"
	      }
	    })], 1)])])
	  }))])]) : _vm._e()])], 1)
	},staticRenderFns: []}

/***/ }),
/* 736 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "login-box"
	  }, [_vm._m(0), _vm._v(" "), _c('el-card', {
	    staticClass: "el-card__save_form box-card"
	  }, [_c('el-form', {
	    ref: "form",
	    attrs: {
	      "model": _vm.form,
	      "label-position": "top"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.onLogin($event)
	      }
	    }
	  }, [_c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.form.login.$error
	    },
	    attrs: {
	      "label": "Matrícula"
	    }
	  }, [_c('el-input', {
	    ref: "formLogin",
	    attrs: {
	      "size": "large"
	    },
	    on: {
	      "input": function($event) {
	        _vm.$v.form.login.$touch()
	      }
	    },
	    nativeOn: {
	      "keydown": function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
	        $event.preventDefault();
	        _vm.onLogin($event)
	      }
	    },
	    model: {
	      value: (_vm.form.login),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "login", $$v)
	      },
	      expression: "form.login"
	    }
	  }), _vm._v(" "), (_vm.$v.form.login.$error) ? _c('div', {
	    staticClass: "el-form-item__error"
	  }, [_vm._v("Esse campo é obrigatório")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.form.password.$error
	    },
	    attrs: {
	      "label": "Senha"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "size": "large",
	      "type": "password"
	    },
	    on: {
	      "input": function($event) {
	        _vm.$v.form.password.$touch()
	      }
	    },
	    nativeOn: {
	      "keydown": function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
	        $event.preventDefault();
	        _vm.onLogin($event)
	      }
	    },
	    model: {
	      value: (_vm.form.password),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "password", $$v)
	      },
	      expression: "form.password"
	    }
	  }), _vm._v(" "), (_vm.$v.form.password.$error) ? _c('div', {
	    staticClass: "el-form-item__error"
	  }, [_vm._v("Esse campo é obrigatório")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
	    attrs: {
	      "type": "primary",
	      "size": "large",
	      "disabled": _vm.isSubmitted || _vm.$v.$invalid
	    },
	    on: {
	      "click": _vm.onLogin
	    }
	  }, [_vm._v("Acessar\n                ")])], 1), _vm._v(" "), _c('el-form-item', [_c('a', {
	    staticClass: "forget-password",
	    attrs: {
	      "href": "https://sou.urcamp.edu.br/recuperacao-de-acesso",
	      "target": "_blank"
	    }
	  }, [_vm._v("\n                    Esqueci minha senha\n                ")])])], 1)], 1)], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "app-header"
	  }, [_c('h2', [_vm._v("ÁREA RESTRITA")])])
	}]}

/***/ }),
/* 737 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.$can(_vm.domain + '.update')) ? _c('router-link', {
	    staticClass: "el-button el-button--info",
	    attrs: {
	      "to": {
	        name: _vm.routeName,
	        params: {
	          id: _vm.item.id
	        }
	      },
	      "title": "Editar Dados"
	    }
	  }, [_c('i', {
	    staticClass: "el-icon-edit"
	  })]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 738 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (!_vm.isLoadingData) ? _c('div', [_c('ListHeader', {
	    attrs: {
	      "title": "Layouts dos Certificados"
	    }
	  }), _vm._v(" "), _c('el-card', {
	    staticClass: "el-card__save_form box-card"
	  }, [_c('div', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('span', [_vm._v("Dados do Layout")])]), _vm._v(" "), _c('el-form', {
	    ref: "form",
	    attrs: {
	      "model": _vm.form,
	      "label-position": "top"
	    },
	    nativeOn: {
	      "submit": function($event) {
	        $event.preventDefault();
	      }
	    }
	  }, [_c('el-alert', {
	    staticClass: "submission-tips layout-alert",
	    attrs: {
	      "title": "Dicas para Layout",
	      "type": "warning",
	      "closable": false
	    }
	  }, [_c('ul', [_c('li', [_vm._v("O campo conteúdo deve conter o texto do certificado.")]), _vm._v(" "), _c('li', [_vm._v("A imagem deve obrigatóriamemte obedecer as medidas de 1122 pixes de largura e 794 pixels de altura")]), _vm._v(" "), _c('li', [_vm._v("Não se esquece de utilizar as variaveis para informações dinâmicas.")])])]), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.form.name.$error
	    },
	    attrs: {
	      "label": "Nome"
	    }
	  }, [_c('el-input', {
	    on: {
	      "input": function($event) {
	        _vm.$v.form.name.$touch()
	      }
	    },
	    model: {
	      value: (_vm.form.name),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "name", $$v)
	      },
	      expression: "form.name"
	    }
	  }), _vm._v(" "), (_vm.$v.form.name.$error) ? _c('div', {
	    staticClass: "el-form-item__error"
	  }, [_vm._v("Esse campo é obrigatório")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.form.description.$error
	    },
	    attrs: {
	      "label": "Descrição"
	    }
	  }, [_c('el-input', {
	    on: {
	      "input": function($event) {
	        _vm.$v.form.description.$touch()
	      }
	    },
	    model: {
	      value: (_vm.form.description),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "description", $$v)
	      },
	      expression: "form.description"
	    }
	  }), _vm._v(" "), (_vm.$v.form.description.$error) ? _c('div', {
	    staticClass: "el-form-item__error"
	  }, [_vm._v("Esse campo é obrigatório")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.form.content.$error
	    },
	    attrs: {
	      "label": "Conteúdo"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "type": "textarea",
	      "rows": 6
	    },
	    on: {
	      "input": function($event) {
	        _vm.$v.form.content.$touch()
	      }
	    },
	    model: {
	      value: (_vm.form.content),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "content", $$v)
	      },
	      expression: "form.content"
	    }
	  }), _vm._v(" "), (_vm.$v.form.content.$dirty && _vm.$v.form.content.$error) ? _c('div', {
	    staticClass: "el-form-item__error"
	  }, [_vm._v("Esse campo\n                    é obrigatório\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('el-row', {
	    staticClass: "layout-alert",
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('el-alert', {
	    attrs: {
	      "title": "Dicas para formatação do texto:",
	      "type": "info",
	      "closable": false,
	      "show-icon": ""
	    }
	  }, [_c('ul', [_c('li', [_vm._v("[ texto ] : entre colchetes ficará "), _c('b', [_vm._v("negrito")])]), _vm._v(" "), _c('li', [_vm._v("< texto > : entre setas ficará "), _c('i', [_vm._v("itálico")])]), _vm._v(" "), _c('li', [_vm._v("{ texto } : entre chaves ficará "), _c('u', [_vm._v("sublinado")])])])])], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('el-alert', {
	    attrs: {
	      "title": "Para informações dinâmicas utilize:",
	      "type": "warning",
	      "closable": false,
	      "show-icon": ""
	    }
	  }, [_c('ul', [_c('li', [_vm._v("$EVENTO_PRINCIPAL : nome do evento principal (Ex.: Congrega 2018) ")]), _vm._v(" "), _c('li', [_vm._v("$EVENTO : nome do evento (Ex.: MIC/Jornada) ")]), _vm._v(" "), _c('li', [_vm._v("$NOME : nome da pessoa (Autor/Participante) ")]), _vm._v(" "), _c('li', [_vm._v("$CARGA_HORARIA : carga horária do evento ")]), _vm._v(" "), _c('li', [_vm._v("$TITULO_TRABALHO: título do trabalho ")]), _vm._v(" "), _c('li', [_vm._v("$AUTORES : autores do trabalho ")]), _vm._v(" "), _c('li', [_vm._v("OBS¹ : Use apenas $TITULO_TRABALHO para certificados de submissão/apresentação de trabalho ou proposta de minicurso ")]), _vm._v(" "), _c('li', [_vm._v("OBS² : Use apenas $NOME ou $AUTORES para evitar duplicação")])])])], 1)], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('el-form-item', {
	    staticClass: "is-required",
	    attrs: {
	      "label": "Imagem Frente"
	    }
	  }, [_c('form-single-upload', {
	    attrs: {
	      "model": _vm.form.image,
	      "accepted-types": "image/*"
	    },
	    on: {
	      "update:model": function($event) {
	        _vm.$set(_vm.form, "image", $event)
	      }
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Imagem Verso"
	    }
	  }, [_c('form-single-upload', {
	    attrs: {
	      "model": _vm.form.image_back_page,
	      "accepted-types": "image/*"
	    },
	    on: {
	      "update:model": function($event) {
	        _vm.$set(_vm.form, "image_back_page", $event)
	      }
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Preview da Imagem Frente"
	    }
	  }, [(_vm.form.image.name && !_vm.form.image.base64) ? _c('div', {
	    staticClass: "preview-image",
	    style: ('background-image: url(' + _vm.getLayoutImage + ')')
	  }) : _vm._e()])], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Preview da Imagem Verso"
	    }
	  }, [(_vm.form.image_back_page.name && !_vm.form.image_back_page.base64) ? _c('div', {
	    staticClass: "preview-image",
	    style: ('background-image: url(' + _vm.getLayoutImageBackPage + ')')
	  }) : _vm._e()])], 1)], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "Assinaturas do Layout"
	    }
	  }, [_c('el-transfer', {
	    attrs: {
	      "data": _vm.dependencies.signature,
	      "titles": ['Disponíveis', 'Selecionados'],
	      "props": {
	        key: 'id',
	        label: 'name'
	      }
	    },
	    model: {
	      value: (_vm.selectedSignature),
	      callback: function($$v) {
	        _vm.selectedSignature = $$v
	      },
	      expression: "selectedSignature"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', [_c('form-save-button', {
	    attrs: {
	      "event-click": _vm.onSend,
	      "is-disabled": _vm.isSubmitted || _vm.$v.$invalid,
	      "is-submitted": _vm.isSubmitted
	    }
	  }), _vm._v(" "), _c('form-cancel-button', {
	    attrs: {
	      "route-name": "layout.index"
	    }
	  })], 1)], 1)], 1)], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 739 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "app-sidebar",
	    class: {
	      '-is-collapse-menu-active': _vm.collapseMenu
	    }
	  }, [_c('el-menu', {
	    attrs: {
	      "default-active": _vm.activeIndex,
	      "router": true,
	      "collapse": _vm.collapseMenu,
	      "background-color": "#222d32",
	      "text-color": "#fff"
	    }
	  }, [_vm._l((_vm.menu), function(item) {
	    return (item.children.length === 0 && item.permission) ? _c('el-menu-item', {
	      attrs: {
	        "route": {
	          name: item.domain + '.index'
	        },
	        "index": item.domain + '.index',
	        "title": item.name
	      }
	    }, [_c('i', {
	      class: item.icon
	    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.name))])]) : _vm._e()
	  }), _vm._v(" "), _vm._l((_vm.menu), function(item) {
	    return (item.children.length > 0 && item.permission) ? _c('el-submenu', {
	      attrs: {
	        "index": item.domain
	      }
	    }, [_c('template', {
	      slot: "title"
	    }, [_c('i', {
	      class: item.icon
	    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _vm._l((item.children), function(child) {
	      return (child.permission) ? _c('el-menu-item', {
	        attrs: {
	          "route": {
	            name: child.domain + '.index'
	          },
	          "index": child.domain + '.index',
	          "title": child.name
	        }
	      }, [_c('i', {
	        class: child.icon
	      }), _vm._v(" "), _c('span', [_vm._v(_vm._s(child.name))])]) : _vm._e()
	    })], 2) : _vm._e()
	  })], 2)], 1)
	},staticRenderFns: []}

/***/ }),
/* 740 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.canBeEvaluated) ? _c('div', _vm._l((_vm.paper.event_paper_type.evaluation_types), function(evaluationType) {
	    return (_vm.canBeApproved) ? _c('table', {
	      staticClass: "table-confirmation table-evaluations"
	    }, [_c('thead', [_c('tr', [_c('th', [_c('span', [_vm._v(_vm._s(evaluationType.evaluation_type.name) + " /")]), _vm._v(" "), _c('span', [_vm._v("De: " + _vm._s(_vm._f("dateTimeEnToBr")(evaluationType.start_datetime)))]), _vm._v(" "), _c('span', [_vm._v("a " + _vm._s(_vm._f("dateTimeEnToBr")(evaluationType.end_datetime)))]), _vm._v(" "), (evaluationType.evaluation_finished) ? _c('el-tag', {
	      attrs: {
	        "size": "small",
	        "type": "danger"
	      }
	    }, [_vm._v("\n                    Finalizada\n                ")]) : _vm._e(), _vm._v(" "), (evaluationType.evaluation_opened) ? _c('el-tag', {
	      attrs: {
	        "size": "small",
	        "type": "success"
	      }
	    }, [_vm._v("\n                    Em andamento\n                ")]) : _vm._e(), _vm._v(" "), (!evaluationType.evaluation_opened && !evaluationType.evaluation_finished) ? _c('el-tag', {
	      attrs: {
	        "size": "small",
	        "type": "info"
	      }
	    }, [_vm._v("\n                    Não disponível\n                ")]) : _vm._e()], 1)])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [(_vm.paper) ? _c('paper-show-evaluation-responses', {
	      attrs: {
	        "paper": _vm.paper,
	        "evaluation-type": evaluationType,
	        "reviews": _vm.reviews(evaluationType.id)
	      }
	    }) : _vm._e(), _vm._v(" "), (_vm.paper) ? _c('paper-show-evaluation-appraisers', {
	      attrs: {
	        "paper": _vm.paper,
	        "evaluation-type": evaluationType,
	        "reviews": _vm.reviews(evaluationType.id)
	      }
	    }) : _vm._e()], 1)])])]) : _vm._e()
	  })) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 741 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('el-tag', {
	    attrs: {
	      "type": _vm.labelType
	    }
	  }, [_vm._v(_vm._s(_vm.statusName))])], 1)
	},staticRenderFns: []}

/***/ }),
/* 742 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (!_vm.isLoadingData) ? _c('div', [_c('ListHeader', {
	    attrs: {
	      "title": "Critério"
	    }
	  }), _vm._v(" "), _c('el-card', {
	    staticClass: "el-card__save_form box-card"
	  }, [_c('div', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('span', [_vm._v("Dados dos Critérios")])]), _vm._v(" "), _c('el-form', {
	    ref: "form",
	    attrs: {
	      "model": _vm.form,
	      "label-width": "20%"
	    },
	    nativeOn: {
	      "submit": function($event) {
	        $event.preventDefault();
	      }
	    }
	  }, [_c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.form.name.$error
	    },
	    attrs: {
	      "label": "Nome"
	    }
	  }, [_c('el-input', {
	    on: {
	      "input": function($event) {
	        _vm.$v.form.name.$touch()
	      }
	    },
	    model: {
	      value: (_vm.form.name),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "name", $$v)
	      },
	      expression: "form.name"
	    }
	  }), _vm._v(" "), (_vm.$v.form.name.$error) ? _c('div', {
	    staticClass: "el-form-item__error"
	  }, [_vm._v("Esse campo é obrigatório")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.form.description.$error
	    },
	    attrs: {
	      "label": "Descrição"
	    }
	  }, [_c('el-input', {
	    on: {
	      "input": function($event) {
	        _vm.$v.form.description.$touch()
	      }
	    },
	    model: {
	      value: (_vm.form.description),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "description", $$v)
	      },
	      expression: "form.description"
	    }
	  }), _vm._v(" "), (_vm.$v.form.description.$error) ? _c('div', {
	    staticClass: "el-form-item__error"
	  }, [_vm._v("Esse campo é obrigatório")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.form.type.$error
	    },
	    attrs: {
	      "label": "Tipo"
	    }
	  }, [_c('el-select', {
	    staticClass: "el-select-full",
	    attrs: {
	      "placeholder": "Selecione..."
	    },
	    on: {
	      "input": function($event) {
	        _vm.$v.form.type.$touch()
	      }
	    },
	    model: {
	      value: (_vm.form.type),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "type", $$v)
	      },
	      expression: "form.type"
	    }
	  }, _vm._l((_vm.dependencies.type), function(item) {
	    return _c('el-option', {
	      key: item.value,
	      attrs: {
	        "label": item.label,
	        "value": item.value
	      }
	    })
	  })), _vm._v(" "), (_vm.$v.form.type.$error) ? _c('div', {
	    staticClass: "el-form-item__error"
	  }, [_vm._v("Esse campo é obrigatório")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
	    staticClass: "is-required",
	    attrs: {
	      "label": "Valor Mínimo"
	    }
	  }, [_c('el-input-number', {
	    attrs: {
	      "min": 0,
	      "step": 1,
	      "max": 100
	    },
	    model: {
	      value: (_vm.form.min_size),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "min_size", $$v)
	      },
	      expression: "form.min_size"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    staticClass: "is-required",
	    attrs: {
	      "label": "Valor Máximo"
	    }
	  }, [_c('el-input-number', {
	    attrs: {
	      "min": 0,
	      "step": 1,
	      "max": 100
	    },
	    model: {
	      value: (_vm.form.max_size),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "max_size", $$v)
	      },
	      expression: "form.max_size"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "Obrigatório?"
	    }
	  }, [_c('el-switch', {
	    attrs: {
	      "on-text": "SIM",
	      "off-text": "NÃO"
	    },
	    model: {
	      value: (_vm.form.required),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "required", $$v)
	      },
	      expression: "form.required"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', [_c('form-save-button', {
	    attrs: {
	      "event-click": _vm.onSend,
	      "is-disabled": _vm.isSubmitted || _vm.$v.$invalid,
	      "is-submitted": _vm.isSubmitted
	    }
	  }), _vm._v(" "), _c('form-cancel-button', {
	    attrs: {
	      "route-name": "criteria.index"
	    }
	  })], 1)], 1)], 1)], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 743 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (!_vm.isLoadingData) ? _c('div', [_c('ListHeader', {
	    attrs: {
	      "title": "Área de Conhecimento (CNPq)"
	    }
	  }), _vm._v(" "), _c('el-card', {
	    staticClass: "el-card__save_form box-card"
	  }, [_c('div', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('span', [_vm._v("Dados da Área de Conhecimento (CNPq)")])]), _vm._v(" "), _c('el-form', {
	    ref: "form",
	    attrs: {
	      "model": _vm.form,
	      "label-width": "20%"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.onSend($event)
	      }
	    }
	  }, [_c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.form.name.$error
	    },
	    attrs: {
	      "label": "Nome"
	    }
	  }, [_c('el-input', {
	    on: {
	      "input": function($event) {
	        _vm.$v.form.name.$touch()
	      }
	    },
	    model: {
	      value: (_vm.form.name),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "name", $$v)
	      },
	      expression: "form.name"
	    }
	  }), _vm._v(" "), (_vm.$v.form.name.$error) ? _c('div', {
	    staticClass: "el-form-item__error"
	  }, [_vm._v("Esse campo é obrigatório")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.form.nationality.$error
	    },
	    attrs: {
	      "label": "Nacionalidade"
	    }
	  }, [_c('el-input', {
	    on: {
	      "input": function($event) {
	        _vm.$v.form.nationality.$touch()
	      }
	    },
	    model: {
	      value: (_vm.form.nationality),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "nationality", $$v)
	      },
	      expression: "form.nationality"
	    }
	  }), _vm._v(" "), (_vm.$v.form.nationality.$error) ? _c('div', {
	    staticClass: "el-form-item__error"
	  }, [_vm._v("Esse campo é obrigatório")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', [_c('form-save-button', {
	    attrs: {
	      "event-click": _vm.onSend,
	      "is-disabled": _vm.isSubmitted || _vm.$v.$invalid,
	      "is-submitted": _vm.isSubmitted
	    }
	  }), _vm._v(" "), _c('form-cancel-button', {
	    attrs: {
	      "route-name": "knowledge_area.index"
	    }
	  })], 1)], 1)], 1)], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 744 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('ListHeader', {
	    attrs: {
	      "title": "Perfis de Usuário",
	      "store-route-name": "role.store"
	    }
	  }), _vm._v(" "), _c('ListMain', [_c('div', {
	    attrs: {
	      "slot": "filters"
	    },
	    slot: "filters"
	  }, [_c('el-card', {
	    staticClass: "el-card__search_list box-card"
	  }, [_c('div', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('span', [_vm._v("Filtrar Listagem")]), _vm._v(" "), _c('div', [_c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": _vm.onFilter
	    }
	  }, [_vm._v("Pesquisar")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "default"
	    },
	    on: {
	      "click": _vm.onFilterClean
	    }
	  }, [_vm._v("Limpar")])], 1)]), _vm._v(" "), _c('el-form', {
	    staticClass: "demo-form-inline",
	    attrs: {
	      "inline": true,
	      "model": _vm.filters
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Nome"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "placeholder": "Filtrar por nome"
	    },
	    nativeOn: {
	      "keydown": function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
	        $event.preventDefault();
	        _vm.onFilter($event)
	      }
	    },
	    model: {
	      value: (_vm.filters.nome),
	      callback: function($$v) {
	        _vm.$set(_vm.filters, "nome", $$v)
	      },
	      expression: "filters.nome"
	    }
	  })], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.isLoadingData) ? _c('div', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, [_c('h2', [_vm._v("Lista de Perfis")]), _vm._v(" "), _c('table', {
	    staticClass: "custom-table-list"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', {
	    staticClass: "btn-actions"
	  }, [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listStore.listData), function(item) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "btn-actions"
	    }, [_c('ListEditButton', {
	      attrs: {
	        "route-name": "role.update",
	        "item": item,
	        "domain": "role"
	      }
	    }), _vm._v(" "), _c('ListDeleteButton', {
	      attrs: {
	        "item": item,
	        "domain": "role"
	      }
	    })], 1)])])
	  }))])]) : _vm._e()])], 1)
	},staticRenderFns: []}

/***/ }),
/* 745 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (!_vm.isLoadingData) ? _c('div', [_c('ListHeader', {
	    attrs: {
	      "title": 'Evento: ' + _vm.event.title
	    }
	  }), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('el-card', {
	    staticClass: "el-card__save_form box-card"
	  }, [_c('div', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('span', [_vm._v("Dados do Evento")]), _vm._v(" "), (_vm.event.event_id) ? _c('router-link', {
	    staticClass: "el-button back-button",
	    attrs: {
	      "to": {
	        name: 'event.update.basic-data',
	        params: {
	          id: _vm.event.event_id
	        }
	      }
	    }
	  }, [_vm._v("\n                        Voltar para o evento pai\n                    ")]) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('div', {
	    staticClass: "event-tabs"
	  }, [_c('div', {
	    staticClass: "event-tabs-links"
	  }, [_c('router-link', {
	    staticClass: "el-tabs__item is-top",
	    attrs: {
	      "to": {
	        name: 'event.update.basic-data',
	        params: {
	          id: _vm.event.id
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-file"
	  }), _vm._v(" "), _c('span', [_vm._v("Dados Gerais")])]), _vm._v(" "), _c('router-link', {
	    staticClass: "el-tabs__item is-top",
	    attrs: {
	      "to": {
	        name: 'event.update.modalities',
	        params: {
	          id: _vm.event.id
	        }
	      },
	      "disabled": !_vm.event.id
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-users"
	  }), _vm._v(" "), _c('span', [_vm._v("Modalidades")])]), _vm._v(" "), (_vm.event.event_id) ? _c('router-link', {
	    staticClass: "el-tabs__item is-top",
	    attrs: {
	      "to": {
	        name: 'event.update.paper-types',
	        params: {
	          id: _vm.event.id
	        }
	      },
	      "disabled": !_vm.event.id
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-address-card-o"
	  }), _vm._v(" "), _c('span', [_vm._v("Trabalhos")])]) : _vm._e(), _vm._v(" "), (_vm.event.event_id) ? _c('router-link', {
	    staticClass: "el-tabs__item is-top",
	    attrs: {
	      "to": {
	        name: 'event.update.evaluations',
	        params: {
	          id: _vm.event.id
	        }
	      },
	      "disabled": !_vm.event.id
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-calculator"
	  }), _vm._v(" "), _c('span', [_vm._v("Avaliações")])]) : _vm._e()], 1), _vm._v(" "), _c('router-view')], 1)])])], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('el-card', {
	    staticClass: "el-card__save_form box-card"
	  }, [_c('div', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('span', [_vm._v("Subeventos")]), _vm._v(" "), (_vm.event.id) ? _c('el-button', {
	    staticClass: "back-button",
	    attrs: {
	      "type": "default"
	    },
	    on: {
	      "click": _vm.createSubevent
	    }
	  }, [_vm._v("\n                        Criar novo Subevento\n                    ")]) : _vm._e()], 1), _vm._v(" "), (_vm.event.events.length > 0) ? _c('div', [_c('table', {
	    staticClass: "custom-table-list"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Título")]), _vm._v(" "), _c('th', [_vm._v("Data de Início")]), _vm._v(" "), _c('th', [_vm._v("Data de Término")]), _vm._v(" "), _c('th', [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.event.events), function(item) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dateTimeEnToBr")(item.start_datetime)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dateTimeEnToBr")(item.end_datetime)))]), _vm._v(" "), _c('td', {
	      attrs: {
	        "width": "160"
	      }
	    }, [_c('el-button', {
	      attrs: {
	        "type": "warning",
	        "size": "small",
	        "title": "Duplicar Evento"
	      },
	      on: {
	        "click": function($event) {
	          _vm.cloneEvent(item)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-clone"
	    })]), _vm._v(" "), (false) ? _c('router-link', {
	      staticClass: "el-button el-button--primary el-button--small",
	      attrs: {
	        "to": {
	          name: 'event.show.home',
	          params: {
	            id: item.id
	          }
	        },
	        "title": "Gerenciar Evento"
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-cog"
	    })]) : _vm._e(), _vm._v(" "), _c('router-link', {
	      staticClass: "el-button el-button--info el-button--small",
	      attrs: {
	        "to": {
	          name: 'event.update.basic-data',
	          params: {
	            id: item.id
	          }
	        },
	        "title": "Editar Evento"
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-edit"
	    })]), _vm._v(" "), _c('el-button', {
	      attrs: {
	        "type": "danger",
	        "size": "small",
	        "title": "Remover Evento"
	      },
	      on: {
	        "click": function($event) {
	          _vm.deleteEvent(item)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-trash"
	    })])], 1)])
	  }))])]) : _c('p', [_vm._v("Nenhum sub-evento encontrado")])])], 1)], 1)], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 746 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('ListHeader', {
	    attrs: {
	      "title": "Tipo de Avaliação",
	      "store-route-name": "evaluation_type.store"
	    }
	  }), _vm._v(" "), _c('ListMain', [_c('div', {
	    attrs: {
	      "slot": "filters"
	    },
	    slot: "filters"
	  }, [_c('el-card', {
	    staticClass: "el-card__search_list box-card"
	  }, [_c('div', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('span', [_vm._v("Filtrar Listagem")]), _vm._v(" "), _c('div', [_c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": _vm.onFilter
	    }
	  }, [_vm._v("Pesquisar")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "default"
	    },
	    on: {
	      "click": _vm.onFilterClean
	    }
	  }, [_vm._v("Limpar")])], 1)]), _vm._v(" "), _c('el-form', {
	    staticClass: "demo-form-inline",
	    attrs: {
	      "inline": true,
	      "model": _vm.filters
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Nome"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "placeholder": "Filtrar por nome"
	    },
	    nativeOn: {
	      "keydown": function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
	        $event.preventDefault();
	        _vm.onFilter($event)
	      }
	    },
	    model: {
	      value: (_vm.filters.name),
	      callback: function($$v) {
	        _vm.$set(_vm.filters, "name", $$v)
	      },
	      expression: "filters.name"
	    }
	  })], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.isLoadingData) ? _c('div', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, [_c('h2', [_vm._v("Lista de Tipo de Avaliação")]), _vm._v(" "), _c('table', {
	    staticClass: "custom-table-list"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Descrição")]), _vm._v(" "), _c('th', {
	    staticClass: "btn-actions"
	  }, [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listStore.listData), function(item) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.description))]), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "btn-actions"
	    }, [_c('ListEditButton', {
	      attrs: {
	        "route-name": "evaluation_type.update",
	        "item": item,
	        "domain": "evaluation_type"
	      }
	    }), _vm._v(" "), _c('ListDeleteButton', {
	      attrs: {
	        "item": item,
	        "domain": "evaluation_type"
	      }
	    })], 1)])])
	  }))])]) : _vm._e()])], 1)
	},staticRenderFns: []}

/***/ }),
/* 747 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (!_vm.isLoadingData) ? _c('div', [_c('ListHeader', {
	    attrs: {
	      "title": "Assinatura dos Certificados"
	    }
	  }), _vm._v(" "), _c('el-card', {
	    staticClass: "el-card__save_form box-card"
	  }, [_c('div', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('span', [_vm._v("Dados da Assinatura")])]), _vm._v(" "), _c('el-form', {
	    ref: "form",
	    attrs: {
	      "model": _vm.form,
	      "label-width": "20%"
	    },
	    nativeOn: {
	      "submit": function($event) {
	        $event.preventDefault();
	      }
	    }
	  }, [_c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.form.name.$error
	    },
	    attrs: {
	      "label": "Nome"
	    }
	  }, [_c('el-input', {
	    on: {
	      "input": function($event) {
	        _vm.$v.form.name.$touch()
	      }
	    },
	    model: {
	      value: (_vm.form.name),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "name", $$v)
	      },
	      expression: "form.name"
	    }
	  }), _vm._v(" "), (_vm.$v.form.name.$error) ? _c('div', {
	    staticClass: "el-form-item__error"
	  }, [_vm._v("Esse campo é obrigatório")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.form.description.$error
	    },
	    attrs: {
	      "label": "Descrição"
	    }
	  }, [_c('el-input', {
	    on: {
	      "input": function($event) {
	        _vm.$v.form.description.$touch()
	      }
	    },
	    model: {
	      value: (_vm.form.description),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "description", $$v)
	      },
	      expression: "form.description"
	    }
	  }), _vm._v(" "), (_vm.$v.form.description.$error) ? _c('div', {
	    staticClass: "el-form-item__error"
	  }, [_vm._v("Esse campo é obrigatório")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
	    staticClass: "is-required",
	    attrs: {
	      "label": "Imagem"
	    }
	  }, [_c('form-single-upload', {
	    attrs: {
	      "model": _vm.form.image,
	      "accepted-types": "image/*"
	    },
	    on: {
	      "update:model": function($event) {
	        _vm.$set(_vm.form, "image", $event)
	      }
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', [_c('form-save-button', {
	    attrs: {
	      "event-click": _vm.onSend,
	      "is-disabled": _vm.isSubmitted || _vm.$v.$invalid,
	      "is-submitted": _vm.isSubmitted
	    }
	  }), _vm._v(" "), _c('form-cancel-button', {
	    attrs: {
	      "route-name": "signature.index"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', [_c('div', {
	    staticClass: "preview-image",
	    style: ('background-image: url(' + _vm.getSignatureImage + ')')
	  })])], 1)], 1)], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 748 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('el-form', {
	    ref: "formEvent",
	    attrs: {
	      "model": _vm.event,
	      "label-position": "top"
	    }
	  }, [_c('el-row', [_c('el-col', [_c('el-form-item', {
	    attrs: {
	      "label": "Evento Pai"
	    }
	  }, [_c('el-select', {
	    staticClass: "el-select-full",
	    attrs: {
	      "filterable": "",
	      "clearable": "",
	      "placeholder": "Selecione um evento",
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "change": _vm.changeEvent
	    },
	    model: {
	      value: (_vm.event.event_id),
	      callback: function($$v) {
	        _vm.$set(_vm.event, "event_id", $$v)
	      },
	      expression: "event.event_id"
	    }
	  }, _vm._l((_vm.dependencies.events), function(item) {
	    return _c('el-option', {
	      key: item.id,
	      attrs: {
	        "label": item.title,
	        "value": item.id
	      }
	    })
	  }))], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 24
	    }
	  }, [_c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.event.title.$error
	    },
	    attrs: {
	      "label": "Título"
	    }
	  }, [_c('el-input', {
	    on: {
	      "input": function($event) {
	        _vm.$v.event.title.$touch()
	      }
	    },
	    model: {
	      value: (_vm.event.title),
	      callback: function($$v) {
	        _vm.$set(_vm.event, "title", $$v)
	      },
	      expression: "event.title"
	    }
	  }), _vm._v(" "), (!_vm.$v.event.title.required && _vm.$v.event.title.$dirty) ? _c('validation-message') : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.event.type_id.$error
	    },
	    attrs: {
	      "label": "Tipo de Evento"
	    }
	  }, [_c('el-select', {
	    staticClass: "el-select-full",
	    attrs: {
	      "filterable": "",
	      "clearable": "",
	      "placeholder": "Selecione o tipo de evento",
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "input": function($event) {
	        _vm.$v.event.type_id.$touch()
	      }
	    },
	    model: {
	      value: (_vm.event.type_id),
	      callback: function($$v) {
	        _vm.$set(_vm.event, "type_id", $$v)
	      },
	      expression: "event.type_id"
	    }
	  }, [_vm._l((_vm.dependencies.event_types), function(item) {
	    return _c('el-option', {
	      key: item.id,
	      attrs: {
	        "label": item.description,
	        "value": item.id
	      }
	    })
	  }), _vm._v(" "), (_vm.$v.event.type_id.$error) ? _c('validation-message') : _vm._e()], 2), _vm._v(" "), (_vm.$v.event.type_id.$error) ? _c('div', {
	    staticClass: "el-form-item__error"
	  }, [_vm._v("\n              Esse campo é obrigatório\n          ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.event.place_id.$error
	    },
	    attrs: {
	      "label": "Local"
	    }
	  }, [_c('el-select', {
	    staticClass: "el-select-full",
	    attrs: {
	      "filterable": "",
	      "clearable": "",
	      "placeholder": "Selecione um local",
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "input": function($event) {
	        _vm.$v.event.place_id.$touch()
	      }
	    },
	    model: {
	      value: (_vm.event.place_id),
	      callback: function($$v) {
	        _vm.$set(_vm.event, "place_id", $$v)
	      },
	      expression: "event.place_id"
	    }
	  }, [_vm._l((_vm.dependencies.places), function(item) {
	    return _c('el-option', {
	      key: item.id,
	      attrs: {
	        "label": item.description,
	        "value": item.id
	      }
	    })
	  }), _vm._v(" "), (_vm.$v.event.place_id.$error) ? _c('validation-message') : _vm._e()], 2), _vm._v(" "), (_vm.$v.event.place_id.$error) ? _c('div', {
	    staticClass: "el-form-item__error"
	  }, [_vm._v("\n                  Esse campo é obrigatório\n              ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.event.start_datetime.$error
	    },
	    attrs: {
	      "label": "Data/Hora Início Evento"
	    }
	  }, [_c('el-date-picker', {
	    attrs: {
	      "type": "datetime",
	      "format": "dd/MM/yyyy HH:mm",
	      "placeholder": "Data/Hora Início"
	    },
	    on: {
	      "input": function($event) {
	        _vm.$v.event.start_datetime.$touch()
	      }
	    },
	    model: {
	      value: (_vm.event.start_datetime),
	      callback: function($$v) {
	        _vm.$set(_vm.event, "start_datetime", $$v)
	      },
	      expression: "event.start_datetime"
	    }
	  }), _vm._v(" "), (!_vm.$v.event.start_datetime.required && _vm.$v.event.start_datetime.$dirty) ? _c('validation-message') : _vm._e()], 1)], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.event.end_datetime.$error
	    },
	    attrs: {
	      "label": "Data/Hora Término Evento"
	    }
	  }, [_c('el-date-picker', {
	    attrs: {
	      "type": "datetime",
	      "format": "dd/MM/yyyy HH:mm",
	      "placeholder": "Data/Hora Término"
	    },
	    on: {
	      "input": function($event) {
	        _vm.$v.event.end_datetime.$touch()
	      }
	    },
	    model: {
	      value: (_vm.event.end_datetime),
	      callback: function($$v) {
	        _vm.$set(_vm.event, "end_datetime", $$v)
	      },
	      expression: "event.end_datetime"
	    }
	  }), _vm._v(" "), (!_vm.$v.event.end_datetime.required && _vm.$v.event.end_datetime.$dirty) ? _c('validation-message') : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.event.start_registration_datetime.$error
	    },
	    attrs: {
	      "label": "Data/Hora Início Inscrições"
	    }
	  }, [_c('el-date-picker', {
	    attrs: {
	      "type": "datetime",
	      "format": "dd/MM/yyyy HH:mm",
	      "placeholder": "Data/Hora Início Inscrições"
	    },
	    on: {
	      "input": function($event) {
	        _vm.$v.event.start_registration_datetime.$touch()
	      }
	    },
	    model: {
	      value: (_vm.event.start_registration_datetime),
	      callback: function($$v) {
	        _vm.$set(_vm.event, "start_registration_datetime", $$v)
	      },
	      expression: "event.start_registration_datetime"
	    }
	  }), _vm._v(" "), (!_vm.$v.event.start_registration_datetime.required && _vm.$v.event.start_registration_datetime.$dirty) ? _c('validation-message') : _vm._e()], 1)], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.event.end_registration_datetime.$error
	    },
	    attrs: {
	      "label": "Data/Hora Término Inscrições"
	    }
	  }, [_c('el-date-picker', {
	    attrs: {
	      "type": "datetime",
	      "format": "dd/MM/yyyy HH:mm",
	      "placeholder": "Data/Hora Término Inscrições"
	    },
	    on: {
	      "input": function($event) {
	        _vm.$v.event.end_registration_datetime.$touch()
	      }
	    },
	    model: {
	      value: (_vm.event.end_registration_datetime),
	      callback: function($$v) {
	        _vm.$set(_vm.event, "end_registration_datetime", $$v)
	      },
	      expression: "event.end_registration_datetime"
	    }
	  }), _vm._v(" "), (!_vm.isSubEvent && !_vm.$v.event.end_registration_datetime.required && _vm.$v.event.end_registration_datetime.$dirty) ? _c('validation-message') : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [(!_vm.isSubEvent) ? _c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.event.contact_email.$error && !_vm.isSubEvent
	    },
	    attrs: {
	      "label": "Email de Contato"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "type": "email"
	    },
	    on: {
	      "input": function($event) {
	        _vm.$v.event.contact_email.$touch()
	      }
	    },
	    model: {
	      value: (_vm.event.contact_email),
	      callback: function($$v) {
	        _vm.$set(_vm.event, "contact_email", $$v)
	      },
	      expression: "event.contact_email"
	    }
	  }), _vm._v(" "), (!_vm.$v.event.contact_email.email) ? _c('validation-message', {
	    attrs: {
	      "message": "O e-mail precisa ser válido."
	    }
	  }) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Material aos participantes?"
	    }
	  }, [_c('el-switch', {
	    attrs: {
	      "active-text": "SIM",
	      "inactive-text": "NÃO"
	    },
	    model: {
	      value: (_vm.event.has_material),
	      callback: function($$v) {
	        _vm.$set(_vm.event, "has_material", $$v)
	      },
	      expression: "event.has_material"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 8
	    }
	  }, [(!_vm.isSubEvent) ? _c('el-form-item', {
	    staticClass: "is-required",
	    attrs: {
	      "label": "Nº máximo de submissões por autor"
	    }
	  }, [_c('el-input-number', {
	    attrs: {
	      "min": 0,
	      "step": 1,
	      "max": 100
	    },
	    model: {
	      value: (_vm.event.max_submissions_per_author),
	      callback: function($$v) {
	        _vm.$set(_vm.event, "max_submissions_per_author", $$v)
	      },
	      expression: "event.max_submissions_per_author"
	    }
	  })], 1) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 8
	    }
	  }, [(_vm.isSubEvent) ? _c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.event.vacancies.$error
	    },
	    attrs: {
	      "label": "Nº máximo de vagas"
	    }
	  }, [_c('el-input-number', {
	    attrs: {
	      "min": 0,
	      "step": 1,
	      "max": 20000
	    },
	    model: {
	      value: (_vm.event.vacancies),
	      callback: function($$v) {
	        _vm.$set(_vm.event, "vacancies", $$v)
	      },
	      expression: "event.vacancies"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.$v.event.vacancies.$error) ? _c('validation-message') : _vm._e()], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 8
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Carga Horária"
	    }
	  }, [_c('el-input-number', {
	    attrs: {
	      "min": 0,
	      "step": 1,
	      "max": 1000
	    },
	    model: {
	      value: (_vm.event.workload),
	      callback: function($$v) {
	        _vm.$set(_vm.event, "workload", $$v)
	      },
	      expression: "event.workload"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.event.website.$error
	    },
	    attrs: {
	      "label": !_vm.isSubEvent ? 'Site do Evento' : 'Link do Regulamento'
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "type": "url"
	    },
	    on: {
	      "input": function($event) {
	        _vm.$v.event.website.$touch()
	      }
	    },
	    model: {
	      value: (_vm.event.website),
	      callback: function($$v) {
	        _vm.$set(_vm.event, "website", $$v)
	      },
	      expression: "event.website"
	    }
	  }), _vm._v(" "), (!_vm.$v.event.website.url) ? _c('validation-message', {
	    attrs: {
	      "message": "O link precisa ser válido."
	    }
	  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Layout do Certificado do Participante"
	    }
	  }, [_c('el-select', {
	    staticClass: "el-select-full",
	    attrs: {
	      "filterable": "",
	      "clearable": "",
	      "placeholder": "Selecione um Layout",
	      "empty-text": "Nenhum registro encontrado"
	    },
	    model: {
	      value: (_vm.event.layout_id),
	      callback: function($$v) {
	        _vm.$set(_vm.event, "layout_id", $$v)
	      },
	      expression: "event.layout_id"
	    }
	  }, _vm._l((_vm.dependencies.layouts), function(item) {
	    return _c('el-option', {
	      key: item.id,
	      attrs: {
	        "label": item.name,
	        "value": item.id
	      }
	    })
	  }))], 1)], 1)], 1), _vm._v(" "), (_vm.isSubEvent) ? _c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.event.coordinators.$error
	    },
	    attrs: {
	      "label": "Coordenadores"
	    }
	  }, [_c('el-select', {
	    staticClass: "el-select-full",
	    attrs: {
	      "filterable": "",
	      "multiple": "",
	      "clearable": "",
	      "placeholder": "Selecione os coordenadores",
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "input": function($event) {
	        _vm.$v.event.coordinators.$touch()
	      }
	    },
	    model: {
	      value: (_vm.event.coordinators),
	      callback: function($$v) {
	        _vm.$set(_vm.event, "coordinators", $$v)
	      },
	      expression: "event.coordinators"
	    }
	  }, _vm._l((_vm.dependencies.users), function(item) {
	    return _c('el-option', {
	      key: item.id,
	      attrs: {
	        "label": item.pessoa.nome + ' (' + item.ref_pessoa + ')',
	        "value": item.id
	      }
	    })
	  })), _vm._v(" "), (_vm.$v.event.coordinators.$error) ? _c('validation-message') : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.isSubEvent) ? _c('el-form-item', {
	    attrs: {
	      "label": "Comissão de Apoio"
	    }
	  }, [_c('el-select', {
	    staticClass: "el-select-full",
	    attrs: {
	      "filterable": "",
	      "multiple": "",
	      "clearable": "",
	      "placeholder": "Selecione os membros da comissão",
	      "empty-text": "Nenhum registro encontrado"
	    },
	    model: {
	      value: (_vm.event.support_committee),
	      callback: function($$v) {
	        _vm.$set(_vm.event, "support_committee", $$v)
	      },
	      expression: "event.support_committee"
	    }
	  }, _vm._l((_vm.dependencies.users), function(item) {
	    return _c('el-option', {
	      key: item.id,
	      attrs: {
	        "label": item.pessoa.nome + ' (' + item.ref_pessoa + ')',
	        "value": item.id
	      }
	    })
	  }))], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "Descrição"
	    }
	  }, [_c('form-tinymce', {
	    attrs: {
	      "id": "editorContent",
	      "configs": {
	        height: 300
	      }
	    },
	    model: {
	      value: (_vm.event.description),
	      callback: function($$v) {
	        _vm.$set(_vm.event, "description", $$v)
	      },
	      expression: "event.description"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
	    attrs: {
	      "type": "primary",
	      "disabled": _vm.isSubmitted || _vm.$v.event.$invalid
	    },
	    on: {
	      "click": _vm.onSaveBasicData
	    }
	  }, [_vm._v("\n            Salvar Alterações\n        ")]), _vm._v(" "), _c('form-cancel-button', {
	    attrs: {
	      "route-name": "event.index"
	    }
	  })], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 749 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('el-alert', {
	    staticClass: "empty-list",
	    attrs: {
	      "title": _vm.title,
	      "description": _vm.description,
	      "type": _vm.type,
	      "closable": _vm.showCloseButton,
	      "show-icon": _vm.showIcon
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 750 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (!_vm.isLoadingData) ? _c('div', [_c('ListHeader', {
	    attrs: {
	      "title": "Estados"
	    }
	  }), _vm._v(" "), _c('el-card', {
	    staticClass: "el-card__save_form box-card"
	  }, [_c('div', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('span', [_vm._v("Dados dos Estados")])]), _vm._v(" "), _c('el-form', {
	    ref: "form",
	    attrs: {
	      "model": _vm.form,
	      "label-width": "20%"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.onSend($event)
	      }
	    }
	  }, [_c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.form.country_id.$error
	    },
	    attrs: {
	      "label": "País"
	    }
	  }, [_c('el-select', {
	    staticClass: "el-select-full",
	    attrs: {
	      "filterable": "",
	      "placeholder": "Selecione um país",
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "input": function($event) {
	        _vm.$v.form.country_id.$touch()
	      }
	    },
	    model: {
	      value: (_vm.form.country_id),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "country_id", $$v)
	      },
	      expression: "form.country_id"
	    }
	  }, _vm._l((_vm.dependencies.countries), function(item) {
	    return _c('el-option', {
	      key: item.id,
	      attrs: {
	        "label": item.name,
	        "value": item.id
	      }
	    })
	  })), _vm._v(" "), (_vm.$v.form.country_id.$error) ? _c('div', {
	    staticClass: "el-form-item__error"
	  }, [_vm._v("\n                    Esse campo é obrigatório\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.form.name.$error
	    },
	    attrs: {
	      "label": "Nome"
	    }
	  }, [_c('el-input', {
	    on: {
	      "input": function($event) {
	        _vm.$v.form.name.$touch()
	      }
	    },
	    model: {
	      value: (_vm.form.name),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "name", $$v)
	      },
	      expression: "form.name"
	    }
	  }), _vm._v(" "), (_vm.$v.form.name.$error) ? _c('div', {
	    staticClass: "el-form-item__error"
	  }, [_vm._v("Esse campo é obrigatório")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.form.initials.$error
	    },
	    attrs: {
	      "label": "UF"
	    }
	  }, [_c('el-input', {
	    on: {
	      "input": function($event) {
	        _vm.$v.form.initials.$touch()
	      }
	    },
	    model: {
	      value: (_vm.form.initials),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "initials", $$v)
	      },
	      expression: "form.initials"
	    }
	  }), _vm._v(" "), (_vm.$v.form.initials.$error) ? _c('div', {
	    staticClass: "el-form-item__error"
	  }, [_vm._v("Esse campo é obrigatório")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', [_c('form-save-button', {
	    attrs: {
	      "event-click": _vm.onSend,
	      "is-disabled": _vm.isSubmitted || _vm.$v.$invalid,
	      "is-submitted": _vm.isSubmitted
	    }
	  }), _vm._v(" "), _c('form-cancel-button', {
	    attrs: {
	      "route-name": "registration.index"
	    }
	  })], 1)], 1)], 1)], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 751 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('el-button', {
	    attrs: {
	      "size": _vm.size
	    },
	    on: {
	      "click": function($event) {
	        _vm.goBack()
	      }
	    }
	  }, [_c('i', {
	    class: _vm.icon
	  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.text))])])
	},staticRenderFns: []}

/***/ }),
/* 752 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (!_vm.isLoadingData) ? _c('div', [_c('ListHeader', {
	    attrs: {
	      "title": "Cidades"
	    }
	  }), _vm._v(" "), _c('el-card', {
	    staticClass: "el-card__save_form box-card"
	  }, [_c('div', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('span', [_vm._v("Dados das Cidades")])]), _vm._v(" "), _c('el-form', {
	    ref: "form",
	    attrs: {
	      "model": _vm.form,
	      "label-width": "20%"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.onSend($event)
	      }
	    }
	  }, [_c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.form.state_id.$error
	    },
	    attrs: {
	      "label": "Estado"
	    }
	  }, [_c('el-select', {
	    staticClass: "el-select-full",
	    attrs: {
	      "filterable": "",
	      "placeholder": "Selecione um estado",
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "input": function($event) {
	        _vm.$v.form.state_id.$touch()
	      }
	    },
	    model: {
	      value: (_vm.form.state_id),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "state_id", $$v)
	      },
	      expression: "form.state_id"
	    }
	  }, _vm._l((_vm.dependencies.states), function(item) {
	    return _c('el-option', {
	      key: item.id,
	      attrs: {
	        "label": item.name,
	        "value": item.id
	      }
	    })
	  })), _vm._v(" "), (_vm.$v.form.state_id.$error) ? _c('div', {
	    staticClass: "el-form-item__error"
	  }, [_vm._v("\n                    Esse campo é obrigatório\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.form.name.$error
	    },
	    attrs: {
	      "label": "Nome"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "maxlength": 200
	    },
	    on: {
	      "input": function($event) {
	        _vm.$v.form.name.$touch()
	      }
	    },
	    model: {
	      value: (_vm.form.name),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "name", $$v)
	      },
	      expression: "form.name"
	    }
	  }), _vm._v(" "), (_vm.$v.form.name.$error) ? _c('div', {
	    staticClass: "el-form-item__error"
	  }, [_vm._v("Esse campo é obrigatório")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', [_c('form-save-button', {
	    attrs: {
	      "event-click": _vm.onSend,
	      "is-disabled": _vm.isSubmitted || _vm.$v.$invalid,
	      "is-submitted": _vm.isSubmitted
	    }
	  }), _vm._v(" "), _c('form-cancel-button', {
	    attrs: {
	      "route-name": "city.index"
	    }
	  })], 1)], 1)], 1)], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 753 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('ListHeader', {
	    attrs: {
	      "title": _vm.pageTitle,
	      "back-route": "event.index"
	    }
	  }), _vm._v(" "), _c('el-card', {
	    staticClass: "el-card__search_list box-card"
	  }, [_c('div', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('span', [_vm._v("Inserir presença")]), _vm._v(" "), _c('div', [_c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": _vm.onInsert
	    }
	  }, [_vm._v("Salvar")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "default"
	    },
	    on: {
	      "click": _vm.onInsertClean
	    }
	  }, [_vm._v("Limpar")])], 1)]), _vm._v(" "), _c('el-form', {
	    staticClass: "demo-form-inline",
	    attrs: {
	      "model": _vm.form
	    },
	    nativeOn: {
	      "submit": function($event) {
	        $event.preventDefault();
	      }
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Matrícula"
	    }
	  }, [_c('el-input', {
	    ref: "formMatricula",
	    attrs: {
	      "name": "formMatricula",
	      "placeholder": "Digite a matrícula ou leia com o leitor de códigos de barra"
	    },
	    nativeOn: {
	      "keyup": function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
	        _vm.onInsert($event)
	      }
	    },
	    model: {
	      value: (_vm.form.ref_pessoa),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "ref_pessoa", $$v)
	      },
	      expression: "form.ref_pessoa"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('ListMain', [_c('div', {
	    staticStyle: {
	      "margin-top": "15px"
	    },
	    attrs: {
	      "slot": "filters"
	    },
	    slot: "filters"
	  }, [_c('el-card', {
	    staticClass: "el-card__search_list box-card"
	  }, [_c('div', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('span', [_vm._v("Filtrar Listagem")]), _vm._v(" "), _c('div', [_c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": _vm.onFilter
	    }
	  }, [_vm._v("Pesquisar")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "default"
	    },
	    on: {
	      "click": _vm.onFilterClean
	    }
	  }, [_vm._v("Limpar")])], 1)]), _vm._v(" "), _c('el-form', {
	    staticClass: "demo-form-inline",
	    attrs: {
	      "inline": true,
	      "model": _vm.filters
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Matrícula"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "placeholder": "Filtrar por matrícula"
	    },
	    model: {
	      value: (_vm.filters.ref_pessoa),
	      callback: function($$v) {
	        _vm.$set(_vm.filters, "ref_pessoa", $$v)
	      },
	      expression: "filters.ref_pessoa"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "Data de Entrada"
	    }
	  }, [_c('el-date-picker', {
	    attrs: {
	      "type": "daterange",
	      "format": "dd/MM/yyyy",
	      "placeholder": "Filtrar por data"
	    },
	    model: {
	      value: (_vm.filters.dates),
	      callback: function($$v) {
	        _vm.$set(_vm.filters, "dates", $$v)
	      },
	      expression: "filters.dates"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "Status Financeiro"
	    }
	  }, [_c('el-select', {
	    attrs: {
	      "filterable": "",
	      "placeholder": "Filtrar Status",
	      "empty-text": "Nenhum registro encontrado"
	    },
	    model: {
	      value: (_vm.filters.status_id),
	      callback: function($$v) {
	        _vm.$set(_vm.filters, "status_id", $$v)
	      },
	      expression: "filters.status_id"
	    }
	  }, _vm._l((_vm.dependencies.status), function(item) {
	    return _c('el-option', {
	      key: item.id,
	      attrs: {
	        "label": item.name,
	        "value": item.id
	      }
	    })
	  }))], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.isLoadingData && _vm.event.id) ? _c('div', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, [_c('table', {
	    staticClass: "custom-table-list"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Cód. Inscrição")]), _vm._v(" "), _c('th', [_vm._v("Participante")]), _vm._v(" "), _c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Evento")]), _vm._v(" "), _c('th', [_vm._v("Entrada")]), _vm._v(" "), _c('th', [_vm._v("Saída")]), _vm._v(" "), _c('th', [_vm._v("Financeiro")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "100"
	    }
	  }, [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listStore.listData), function(item) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.registration.person.ref_pessoa))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.registration.person.pessoa.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.event_modality_registration.event_modality.event.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dateTimeEnToBr")(item.datetime_in)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dateTimeEnToBr")(item.datetime_out)))]), _vm._v(" "), _c('td', [_c('div', [_c('registration-status-label', {
	      attrs: {
	        "status-id": item.registration.status_id,
	        "status-name": item.registration.status.name
	      }
	    })], 1)]), _vm._v(" "), _c('td', [(!item.canceled_by) ? _c('el-button', {
	      attrs: {
	        "type": "danger",
	        "disabled": item.canceled_by,
	        "title": "Cancelar Inscrição"
	      },
	      on: {
	        "click": function($event) {
	          _vm.cancelRegistrationActivity(item)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-times"
	    })]) : _vm._e(), _vm._v(" "), (item.canceled_by) ? _c('div', [_c('el-tag', {
	      attrs: {
	        "type": _vm.labelType
	      }
	    }, [_vm._v("Cancelado")])], 1) : _vm._e()], 1)])
	  })), _vm._v(" "), _c('tfoot')])]) : _vm._e()])], 1)
	},staticRenderFns: []}

/***/ }),
/* 754 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (!_vm.isLoadingData) ? _c('div', [_c('ListHeader', {
	    attrs: {
	      "title": "Status do Trabalho"
	    }
	  }), _vm._v(" "), _c('el-card', {
	    staticClass: "el-card__save_form box-card"
	  }, [_c('div', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('span', [_vm._v("Dados do Status do Trabalho")])]), _vm._v(" "), _c('el-form', {
	    ref: "form",
	    attrs: {
	      "model": _vm.form,
	      "label-width": "20%"
	    },
	    nativeOn: {
	      "submit": function($event) {
	        $event.preventDefault();
	      }
	    }
	  }, [_c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.form.name.$error
	    },
	    attrs: {
	      "label": "Nome"
	    }
	  }, [_c('el-input', {
	    on: {
	      "input": function($event) {
	        _vm.$v.form.name.$touch()
	      }
	    },
	    model: {
	      value: (_vm.form.name),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "name", $$v)
	      },
	      expression: "form.name"
	    }
	  }), _vm._v(" "), (_vm.$v.form.name.$error) ? _c('div', {
	    staticClass: "el-form-item__error"
	  }, [_vm._v("Esse campo é obrigatório")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.form.public_name.$error
	    },
	    attrs: {
	      "label": "Nome Publico"
	    }
	  }, [_c('el-input', {
	    on: {
	      "input": function($event) {
	        _vm.$v.form.public_name.$touch()
	      }
	    },
	    model: {
	      value: (_vm.form.public_name),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "public_name", $$v)
	      },
	      expression: "form.public_name"
	    }
	  }), _vm._v(" "), (_vm.$v.form.public_name.$error) ? _c('div', {
	    staticClass: "el-form-item__error"
	  }, [_vm._v("Esse campo é obrigatório")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.form.description.$error
	    },
	    attrs: {
	      "label": "Descrição"
	    }
	  }, [_c('el-input', {
	    on: {
	      "input": function($event) {
	        _vm.$v.form.description.$touch()
	      }
	    },
	    model: {
	      value: (_vm.form.description),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "description", $$v)
	      },
	      expression: "form.description"
	    }
	  }), _vm._v(" "), (_vm.$v.form.description.$error) ? _c('div', {
	    staticClass: "el-form-item__error"
	  }, [_vm._v("Esse campo é obrigatório")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', [_c('form-save-button', {
	    attrs: {
	      "event-click": _vm.onSend,
	      "is-disabled": _vm.isSubmitted || _vm.$v.$invalid,
	      "is-submitted": _vm.isSubmitted
	    }
	  }), _vm._v(" "), _c('form-cancel-button', {
	    attrs: {
	      "route-name": "paper_status.index"
	    }
	  })], 1)], 1)], 1)], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 755 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('ListHeader', {
	    attrs: {
	      "title": "Campo de Formulário",
	      "store-route-name": "field.store"
	    }
	  }), _vm._v(" "), _c('ListMain', [_c('div', {
	    attrs: {
	      "slot": "filters"
	    },
	    slot: "filters"
	  }, [_c('el-card', {
	    staticClass: "el-card__search_list box-card"
	  }, [_c('div', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('span', [_vm._v("Filtrar")]), _vm._v(" "), _c('div', [_c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": _vm.onFilter
	    }
	  }, [_vm._v("Pesquisar")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "default"
	    },
	    on: {
	      "click": _vm.onFilterClean
	    }
	  }, [_vm._v("Limpar")])], 1)]), _vm._v(" "), _c('el-form', {
	    staticClass: "demo-form-inline",
	    attrs: {
	      "inline": true,
	      "model": _vm.filters
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Nome"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "placeholder": "Filtrar por nome"
	    },
	    nativeOn: {
	      "keydown": function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
	        $event.preventDefault();
	        _vm.onFilter($event)
	      }
	    },
	    model: {
	      value: (_vm.filters.name),
	      callback: function($$v) {
	        _vm.$set(_vm.filters, "name", $$v)
	      },
	      expression: "filters.name"
	    }
	  })], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.isLoadingData) ? _c('div', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, [_c('h2', [_vm._v("Lista de Campos")]), _vm._v(" "), _c('table', {
	    staticClass: "custom-table-list"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Descrição")]), _vm._v(" "), _c('th', [_vm._v("Tipo")]), _vm._v(" "), _c('th', [_vm._v("Mínimo")]), _vm._v(" "), _c('th', [_vm._v("Maxímo")]), _vm._v(" "), _c('th', {
	    staticClass: "btn-actions"
	  }, [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listStore.listData), function(item) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.description))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.type))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.min_size))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.max_size))]), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "btn-actions"
	    }, [_c('ListEditButton', {
	      attrs: {
	        "route-name": "field.update",
	        "item": item,
	        "domain": "field"
	      }
	    }), _vm._v(" "), _c('ListDeleteButton', {
	      attrs: {
	        "item": item,
	        "domain": "field"
	      }
	    })], 1)])])
	  }))])]) : _vm._e()])], 1)
	},staticRenderFns: []}

/***/ }),
/* 756 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (!_vm.isLoadingData) ? _c('div', [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('h3', [_vm._v("Últimas Inscrições")]), _vm._v(" "), _c('table', {
	    staticClass: "custom-table-list"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Pessoa")]), _vm._v(" "), _c('th', [_vm._v("Data da Inscrição")]), _vm._v(" "), _c('th', [_vm._v("Instituição")]), _vm._v(" "), _c('th', [_vm._v("Status da Inscrição")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.registrations), function(item) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(item.person.pessoa.id) + " - " + _vm._s(item.person.pessoa.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dateTimeEnToBr")(item.created_at)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.institution.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.status.name))])])
	  }))])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('h3', [_vm._v("Últimas Submissões")]), _vm._v(" "), _c('table', {
	    staticClass: "custom-table-list"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Autor")]), _vm._v(" "), _c('th', [_vm._v("Data da Submissão")]), _vm._v(" "), _c('th', [_vm._v("Status")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.papers), function(item) {
	    return _c('tr', [_c('td', [_vm._v("\n                        " + _vm._s(item.registration.person.ref_pessoa) + " - " + _vm._s(item.registration.person.pessoa.nome) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dateTimeEnToBr")(item.date_submitted)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.status.name))])])
	  }))])])], 1)], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 757 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "single-file-upload-box"
	  }, [(!_vm.isAvailable) ? _c('span', [_vm._v(_vm._s(_vm.file.name))]) : _vm._e(), _vm._v(" "), (!_vm.isAvailable) ? _c('el-button', {
	    staticClass: "file-exists",
	    attrs: {
	      "type": "danger"
	    },
	    on: {
	      "click": function($event) {
	        _vm.onDelete(_vm.file)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times"
	  })]) : _vm._e(), _vm._v(" "), (_vm.isAvailable) ? _c('vue-base64-file-upload', {
	    attrs: {
	      "input-class": "uploader",
	      "accept": _vm.acceptedTypes,
	      "disable-preview": true,
	      "placeholder": "Clique aqui para selecionar um arquivo",
	      "max-size": _vm.maxFileSize
	    },
	    on: {
	      "size-exceeded": _vm.onSizeExceeded,
	      "file": _vm.onFile,
	      "load": _vm.onLoad
	    }
	  }) : _vm._e()], 1)])
	},staticRenderFns: []}

/***/ }),
/* 758 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (!_vm.isLoadingData) ? _c('div', [_c('ListHeader', {
	    attrs: {
	      "title": "Modalidades"
	    }
	  }), _vm._v(" "), _c('el-card', {
	    staticClass: "el-card__save_form box-card"
	  }, [_c('div', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('span', [_vm._v("Dados das Modalidades")])]), _vm._v(" "), _c('el-form', {
	    ref: "form",
	    attrs: {
	      "model": _vm.form,
	      "label-width": "20%"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.onSend($event)
	      }
	    }
	  }, [_c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.form.name.$error
	    },
	    attrs: {
	      "label": "Nome"
	    }
	  }, [_c('el-input', {
	    on: {
	      "input": function($event) {
	        _vm.$v.form.name.$touch()
	      }
	    },
	    model: {
	      value: (_vm.form.name),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "name", $$v)
	      },
	      expression: "form.name"
	    }
	  }), _vm._v(" "), (_vm.$v.form.name.$error) ? _c('div', {
	    staticClass: "el-form-item__error"
	  }, [_vm._v("Esse campo é obrigatório")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.form.description.$error
	    },
	    attrs: {
	      "label": "Descrição"
	    }
	  }, [_c('el-input', {
	    on: {
	      "input": function($event) {
	        _vm.$v.form.description.$touch()
	      }
	    },
	    model: {
	      value: (_vm.form.description),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "description", $$v)
	      },
	      expression: "form.description"
	    }
	  }), _vm._v(" "), (_vm.$v.form.description.$error) ? _c('div', {
	    staticClass: "el-form-item__error"
	  }, [_vm._v("Esse campo é obrigatório")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', [_c('form-save-button', {
	    attrs: {
	      "event-click": _vm.onSend,
	      "is-disabled": _vm.isSubmitted || _vm.$v.$invalid,
	      "is-submitted": _vm.isSubmitted
	    }
	  }), _vm._v(" "), _c('form-cancel-button', {
	    attrs: {
	      "route-name": "modality.index"
	    }
	  })], 1)], 1)], 1)], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 759 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('ListHeader', {
	    attrs: {
	      "title": _vm.pageTitle,
	      "back-route": "event.index"
	    }
	  }), _vm._v(" "), _c('el-tabs', {
	    attrs: {
	      "type": "card"
	    },
	    model: {
	      value: (_vm.activeTab),
	      callback: function($$v) {
	        _vm.activeTab = $$v
	      },
	      expression: "activeTab"
	    }
	  }, [_c('el-tab-pane', {
	    attrs: {
	      "name": "registration_list",
	      "label": "Lista de Inscrições"
	    }
	  }, [_c('table', {
	    staticClass: "custom-table-list"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Cód. Inscrição")]), _vm._v(" "), _c('th', [_vm._v("Ref. Pessoa")]), _vm._v(" "), _c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Email")]), _vm._v(" "), _c('th', [_vm._v("Telefone")]), _vm._v(" "), _c('th', [_vm._v("Instituição")]), _vm._v(" "), _c('th', [_vm._v("Modalidades")]), _vm._v(" "), _c('th', [_vm._v("Valor")]), _vm._v(" "), _c('th', [_vm._v("Vencimento")]), _vm._v(" "), _c('th', [_vm._v("Pago")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.reports.registrations_list.list), function(item) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.ref_pessoa))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.phone))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.institution))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.modalities))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.amount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.due_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.pago ? 'Sim' : 'Não'))])])
	  }))])]), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "name": "registrations",
	      "label": "Inscrições por Situação de Pagamento"
	    }
	  }, [_c('table', {
	    staticClass: "custom-table-list reports-table-status"
	  }, [_c('tbody', [_c('tr', [_c('td', [_c('div', [_vm._v("Total")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.totalRegistrations))])]), _vm._v(" "), _vm._l((_vm.reports.registrations), function(item) {
	    return _c('td', [_c('div', [_vm._v(_vm._s(item.status_name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.total))])])
	  })], 2), _vm._v(" "), _c('tr', [_c('td', [_c('div', [_vm._v("R$ " + _vm._s(_vm._f("currencyEnToBr")(_vm.totalAmountRegistrations)))])]), _vm._v(" "), _vm._l((_vm.reports.registrations), function(item) {
	    return _c('td', [_c('div', [_vm._v("R$ " + _vm._s(_vm._f("currencyEnToBr")(item.total_amount)))])])
	  })], 2)])])]), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "name": "events",
	      "label": "Inscrições por Evento"
	    }
	  }, [_c('div', {
	    staticClass: "modalities-list"
	  }, [_c('div', {
	    staticClass: "modality-items"
	  }, _vm._l((_vm.reports.events), function(item, index) {
	    return _c('div', {
	      staticClass: "modality-item --small"
	    }, [_c('h4', [_vm._v(_vm._s(item.event_title))]), _vm._v(" "), _c('div', [_c('highcharts', {
	      key: index,
	      attrs: {
	        "options": _vm.mountChartSemiCircleOptions(item.registrations)
	      }
	    })], 1)])
	  }))])]), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "name": "modalities",
	      "label": "Participantes por Modalidade"
	    }
	  }, [_c('div', {
	    staticClass: "modalities-list"
	  }, [_c('div', {
	    staticClass: "modality-items"
	  }, _vm._l((_vm.reports.modalities), function(items, index) {
	    return _c('div', {
	      staticClass: "modality-item"
	    }, [_c('h4', [_vm._v(_vm._s(items[0].modality_name))]), _vm._v(" "), _c('div', [_c('highcharts', {
	      key: index,
	      attrs: {
	        "options": _vm.mountChartPieOptions(items)
	      }
	    })], 1)])
	  }))])]), _vm._v(" "), _c('el-tab-pane', {
	    attrs: {
	      "name": "papers_review",
	      "label": "Trabalhos por Avaliador"
	    }
	  }, [_c('table', {
	    staticClass: "custom-table-list"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Avaliador")]), _vm._v(" "), _c('th', [_vm._v("Graduação")]), _vm._v(" "), _c('th', [_vm._v("Instituição")]), _vm._v(" "), _c('th', [_vm._v("Total de Avaliações")])])]), _c('thead', [_c('tr', [_c('th', {
	    attrs: {
	      "colspan": "4"
	    }
	  }, [_vm._v("\n                        Pesquisar Avaliador:\n                        "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.searchAppraiser),
	      expression: "searchAppraiser"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.searchAppraiser)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.searchAppraiser = $event.target.value
	      }
	    }
	  })])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.papersReviewList), function(item) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.grade))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.institution))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.total))])])
	  }))])])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 760 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('ListHeader', {
	    attrs: {
	      "title": "Layouts dos Certificados",
	      "store-route-name": "layout.store"
	    }
	  }), _vm._v(" "), _c('ListMain', [_c('div', {
	    attrs: {
	      "slot": "filters"
	    },
	    slot: "filters"
	  }, [_c('el-card', {
	    staticClass: "el-card__search_list box-card"
	  }, [_c('div', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('span', [_vm._v("Filtrar")]), _vm._v(" "), _c('div', [_c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": _vm.onFilter
	    }
	  }, [_vm._v("Pesquisar")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "default"
	    },
	    on: {
	      "click": _vm.onFilterClean
	    }
	  }, [_vm._v("Limpar")])], 1)]), _vm._v(" "), _c('el-form', {
	    staticClass: "demo-form-inline",
	    attrs: {
	      "inline": true,
	      "model": _vm.filters
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Nome"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "placeholder": "Filtrar por nome"
	    },
	    nativeOn: {
	      "keydown": function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
	        $event.preventDefault();
	        _vm.onFilter($event)
	      }
	    },
	    model: {
	      value: (_vm.filters.name),
	      callback: function($$v) {
	        _vm.$set(_vm.filters, "name", $$v)
	      },
	      expression: "filters.name"
	    }
	  })], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.isLoadingData) ? _c('div', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, [_c('h2', [_vm._v("Lista de Campos")]), _vm._v(" "), _c('table', {
	    staticClass: "custom-table-list"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Descrição")]), _vm._v(" "), _c('th', {
	    staticClass: "btn-actions"
	  }, [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listStore.listData), function(item) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.description))]), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "btn-actions"
	    }, [_c('ListEditButton', {
	      attrs: {
	        "route-name": "layout.update",
	        "item": item,
	        "domain": "layout"
	      }
	    }), _vm._v(" "), _c('ListDeleteButton', {
	      attrs: {
	        "item": item,
	        "domain": "layout"
	      }
	    })], 1)])])
	  }))])]) : _vm._e()])], 1)
	},staticRenderFns: []}

/***/ }),
/* 761 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "el-form-item__error"
	  }, [_vm._v(_vm._s(_vm.message))])
	},staticRenderFns: []}

/***/ }),
/* 762 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading.fullscreen.lock",
	      value: (_vm.isLoading),
	      expression: "isLoading",
	      modifiers: {
	        "fullscreen": true,
	        "lock": true
	      }
	    }],
	    attrs: {
	      "id": "app",
	      "element-loading-text": "Carregando Dados...",
	      "element-loading-background": "rgba(0, 0, 0, .8)"
	    }
	  }, [(_vm.isLogged) ? _c('AppHeader') : _vm._e(), _vm._v(" "), (_vm.isLogged) ? _c('AppSidebar') : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "app-content"
	  }, [_c('div', {
	    class: {
	      'container': _vm.isLogged
	    }
	  }, [_c('router-view')], 1)])], 1)
	},staticRenderFns: []}

/***/ }),
/* 763 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (!_vm.isLoadingData) ? _c('div', [_c('ListHeader', {
	    attrs: {
	      "title": "Estados"
	    }
	  }), _vm._v(" "), _c('el-card', {
	    staticClass: "el-card__save_form box-card"
	  }, [_c('div', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('span', [_vm._v("Dados dos Estados")])]), _vm._v(" "), _c('el-form', {
	    ref: "form",
	    attrs: {
	      "model": _vm.form,
	      "label-width": "20%"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.onSend($event)
	      }
	    }
	  }, [_c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.form.country_id.$error
	    },
	    attrs: {
	      "label": "País"
	    }
	  }, [_c('el-select', {
	    staticClass: "el-select-full",
	    attrs: {
	      "filterable": "",
	      "placeholder": "Selecione um país",
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "input": function($event) {
	        _vm.$v.form.country_id.$touch()
	      }
	    },
	    model: {
	      value: (_vm.form.country_id),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "country_id", $$v)
	      },
	      expression: "form.country_id"
	    }
	  }, _vm._l((_vm.dependencies.countries), function(item) {
	    return _c('el-option', {
	      key: item.id,
	      attrs: {
	        "label": item.name,
	        "value": item.id
	      }
	    })
	  })), _vm._v(" "), (_vm.$v.form.country_id.$error) ? _c('div', {
	    staticClass: "el-form-item__error"
	  }, [_vm._v("\n                    Esse campo é obrigatório\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.form.name.$error
	    },
	    attrs: {
	      "label": "Nome"
	    }
	  }, [_c('el-input', {
	    on: {
	      "input": function($event) {
	        _vm.$v.form.name.$touch()
	      }
	    },
	    model: {
	      value: (_vm.form.name),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "name", $$v)
	      },
	      expression: "form.name"
	    }
	  }), _vm._v(" "), (_vm.$v.form.name.$error) ? _c('div', {
	    staticClass: "el-form-item__error"
	  }, [_vm._v("Esse campo é obrigatório")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.form.initials.$error
	    },
	    attrs: {
	      "label": "UF"
	    }
	  }, [_c('el-input', {
	    on: {
	      "input": function($event) {
	        _vm.$v.form.initials.$touch()
	      }
	    },
	    model: {
	      value: (_vm.form.initials),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "initials", $$v)
	      },
	      expression: "form.initials"
	    }
	  }), _vm._v(" "), (_vm.$v.form.initials.$error) ? _c('div', {
	    staticClass: "el-form-item__error"
	  }, [_vm._v("Esse campo é obrigatório")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', [_c('form-save-button', {
	    attrs: {
	      "event-click": _vm.onSend,
	      "is-disabled": _vm.isSubmitted || _vm.$v.$invalid,
	      "is-submitted": _vm.isSubmitted
	    }
	  }), _vm._v(" "), _c('form-cancel-button', {
	    attrs: {
	      "route-name": "state.index"
	    }
	  })], 1)], 1)], 1)], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 764 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('el-button', {
	    attrs: {
	      "type": "primary",
	      "disabled": _vm.isDisabled,
	      "loading": _vm.isSubmitted
	    },
	    on: {
	      "click": _vm.onSend
	    }
	  }, [_vm._v("\n    " + _vm._s(_vm.isSubmitted ? 'Salvando' : 'Salvar') + " Alterações\n")])
	},staticRenderFns: []}

/***/ }),
/* 765 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (!_vm.isLoadingData) ? _c('div', [_c('ListHeader', {
	    attrs: {
	      "title": "Locais"
	    }
	  }), _vm._v(" "), _c('el-card', {
	    staticClass: "el-card__save_form box-card"
	  }, [_c('div', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('span', [_vm._v("Dados do Local")])]), _vm._v(" "), _c('el-form', {
	    ref: "form",
	    attrs: {
	      "model": _vm.form,
	      "label-width": "20%"
	    },
	    nativeOn: {
	      "submit": function($event) {
	        $event.preventDefault();
	      }
	    }
	  }, [_c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.form.city_id.$error
	    },
	    attrs: {
	      "label": "Cidade"
	    }
	  }, [_c('el-select', {
	    staticClass: "el-select-full",
	    attrs: {
	      "clearable": "",
	      "filterable": "",
	      "remote": "",
	      "remote-method": _vm.onSearchCity,
	      "loading": _vm.isSearchingCity,
	      "placeholder": "Digite o nome da cidade",
	      "empty-text": "Nenhum registro encontrado"
	    },
	    model: {
	      value: (_vm.form.city_id),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "city_id", $$v)
	      },
	      expression: "form.city_id"
	    }
	  }, _vm._l((_vm.dependencies.cities), function(item) {
	    return _c('el-option', {
	      key: item.id,
	      attrs: {
	        "label": item.name + ' / ' + item.state.uf,
	        "value": item.id
	      }
	    })
	  })), _vm._v(" "), (_vm.$v.form.city_id.$error) ? _c('div', {
	    staticClass: "el-form-item__error"
	  }, [_vm._v("\n                    Esse campo é obrigatório\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.form.address.$error
	    },
	    attrs: {
	      "label": "Endereço"
	    }
	  }, [_c('el-input', {
	    on: {
	      "input": function($event) {
	        _vm.$v.form.address.$touch()
	      }
	    },
	    model: {
	      value: (_vm.form.address),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "address", $$v)
	      },
	      expression: "form.address"
	    }
	  }), _vm._v(" "), (_vm.$v.form.address.$error) ? _c('div', {
	    staticClass: "el-form-item__error"
	  }, [_vm._v("Esse campo é obrigatório")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.form.description.$error
	    },
	    attrs: {
	      "label": "Descrição"
	    }
	  }, [_c('el-input', {
	    on: {
	      "input": function($event) {
	        _vm.$v.form.description.$touch()
	      }
	    },
	    model: {
	      value: (_vm.form.description),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "description", $$v)
	      },
	      expression: "form.description"
	    }
	  }), _vm._v(" "), (_vm.$v.form.description.$error) ? _c('div', {
	    staticClass: "el-form-item__error"
	  }, [_vm._v("Esse campo é obrigatório")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', [_c('form-save-button', {
	    attrs: {
	      "event-click": _vm.onSend,
	      "is-disabled": _vm.isSubmitted || _vm.$v.$invalid,
	      "is-submitted": _vm.isSubmitted
	    }
	  }), _vm._v(" "), _c('form-cancel-button', {
	    attrs: {
	      "route-name": "place.index"
	    }
	  })], 1)], 1)], 1)], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 766 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "app-bar"
	  }, [_c('div', {
	    staticClass: "app-bar-content"
	  }, [_c('div', {
	    staticClass: "app-bar-logo"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "toggle-menu",
	    on: {
	      "click": _vm.toggleCollapseMenu
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-bars"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "app-bar-user"
	  }, [_c('el-dropdown', {
	    on: {
	      "command": _vm.handleDropdownCommand
	    }
	  }, [_c('span', {
	    staticClass: "el-dropdown-link"
	  }, [_vm._v("\n                    " + _vm._s(_vm.currentUser.name) + " "), _c('i', {
	    staticClass: "el-icon-caret-bottom el-icon--right"
	  })]), _vm._v(" "), _c('el-dropdown-menu', {
	    attrs: {
	      "slot": "dropdown"
	    },
	    slot: "dropdown"
	  }, [_c('el-dropdown-item', {
	    attrs: {
	      "command": "changePassword"
	    }
	  }, [_c('span', [_vm._v("Alterar Senha")])]), _vm._v(" "), _c('el-dropdown-item', {
	    attrs: {
	      "command": "logout"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-sign-out"
	  }), _vm._v(" "), _c('span', [_vm._v("Sair")])])], 1)], 1)], 1)])]), _vm._v(" "), (_vm.showChangePasswordModal) ? _c('el-dialog', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading.body",
	      value: (_vm.isSubmitted),
	      expression: "isSubmitted",
	      modifiers: {
	        "body": true
	      }
	    }],
	    attrs: {
	      "title": "Alteração de senha",
	      "size": "tiny",
	      "element-loading-text": "Gravando dados...",
	      "visible": _vm.showChangePasswordModal
	    },
	    on: {
	      "update:visible": function($event) {
	        _vm.showChangePasswordModal = $event
	      }
	    }
	  }, [_c('el-form', {
	    ref: "form",
	    attrs: {
	      "model": _vm.changePassword,
	      "label-width": "120px"
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Senha atual"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "type": "password"
	    },
	    model: {
	      value: (_vm.changePassword.current_password),
	      callback: function($$v) {
	        _vm.$set(_vm.changePassword, "current_password", $$v)
	      },
	      expression: "changePassword.current_password"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "Senha"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "type": "password"
	    },
	    model: {
	      value: (_vm.changePassword.password),
	      callback: function($$v) {
	        _vm.$set(_vm.changePassword, "password", $$v)
	      },
	      expression: "changePassword.password"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "Confirmação"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "type": "password"
	    },
	    model: {
	      value: (_vm.changePassword.password_confirmation),
	      callback: function($$v) {
	        _vm.$set(_vm.changePassword, "password_confirmation", $$v)
	      },
	      expression: "changePassword.password_confirmation"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
	    attrs: {
	      "type": "primary",
	      "disabled": _vm.isSubmitted
	    },
	    on: {
	      "click": _vm.onChangePassword
	    }
	  }, [_vm._v("Salvar nova senha\n                ")])], 1)], 1)], 1) : _vm._e()], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": ""
	    }
	  }, [_c('span', {
	    staticClass: "text-full"
	  }, [_c('strong', [_vm._v("Sistema")]), _vm._v(" Eventos")]), _vm._v(" "), _c('span', {
	    staticClass: "text-mobile"
	  }, [_c('strong', [_vm._v("SE")])])])
	}]}

/***/ }),
/* 767 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('ListHeader', {
	    attrs: {
	      "title": "Critérios",
	      "store-route-name": "criteria.store"
	    }
	  }), _vm._v(" "), _c('ListMain', [_c('div', {
	    attrs: {
	      "slot": "filters"
	    },
	    slot: "filters"
	  }, [_c('el-card', {
	    staticClass: "el-card__search_list box-card"
	  }, [_c('div', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('span', [_vm._v("Filtrar")]), _vm._v(" "), _c('div', [_c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": _vm.onFilter
	    }
	  }, [_vm._v("Pesquisar")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "default"
	    },
	    on: {
	      "click": _vm.onFilterClean
	    }
	  }, [_vm._v("Limpar")])], 1)]), _vm._v(" "), _c('el-form', {
	    staticClass: "demo-form-inline",
	    attrs: {
	      "inline": true,
	      "model": _vm.filters
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Nome"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "placeholder": "Filtrar por nome"
	    },
	    nativeOn: {
	      "keydown": function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
	        $event.preventDefault();
	        _vm.onFilter($event)
	      }
	    },
	    model: {
	      value: (_vm.filters.name),
	      callback: function($$v) {
	        _vm.$set(_vm.filters, "name", $$v)
	      },
	      expression: "filters.name"
	    }
	  })], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.isLoadingData) ? _c('div', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, [_c('h2', [_vm._v("Lista de Critérios")]), _vm._v(" "), _c('table', {
	    staticClass: "custom-table-list"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Descrição")]), _vm._v(" "), _c('th', [_vm._v("Tipo")]), _vm._v(" "), _c('th', [_vm._v("Tamanho Mínimo")]), _vm._v(" "), _c('th', [_vm._v("Tamanho Máximo")]), _vm._v(" "), _c('th', [_vm._v("Obrigatório?")]), _vm._v(" "), _c('th', {
	    staticClass: "btn-actions"
	  }, [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listStore.listData), function(item) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.description))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.type))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.min_size))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.max_size))]), _vm._v(" "), _c('td', [_c('list-yes-no', {
	      attrs: {
	        "value": item.required
	      }
	    })], 1), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "btn-actions"
	    }, [_c('ListEditButton', {
	      attrs: {
	        "route-name": "criteria.update",
	        "item": item,
	        "domain": "criteria"
	      }
	    }), _vm._v(" "), _c('ListDeleteButton', {
	      attrs: {
	        "item": item,
	        "domain": "criteria"
	      }
	    })], 1)])])
	  }))])]) : _vm._e()])], 1)
	},staticRenderFns: []}

/***/ }),
/* 768 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (!_vm.isLoadingData) ? _c('div', [_c('ListHeader', {
	    attrs: {
	      "title": "Status de Inscrição"
	    }
	  }), _vm._v(" "), _c('el-card', {
	    staticClass: "el-card__save_form box-card"
	  }, [_c('div', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('span', [_vm._v("Dados do Status de Inscrição")])]), _vm._v(" "), _c('el-form', {
	    ref: "form",
	    attrs: {
	      "model": _vm.form,
	      "label-width": "20%"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.onSend($event)
	      }
	    }
	  }, [_c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.form.name.$error
	    },
	    attrs: {
	      "label": "Nome"
	    }
	  }, [_c('el-input', {
	    on: {
	      "input": function($event) {
	        _vm.$v.form.name.$touch()
	      }
	    },
	    model: {
	      value: (_vm.form.name),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "name", $$v)
	      },
	      expression: "form.name"
	    }
	  }), _vm._v(" "), (_vm.$v.form.name.$error) ? _c('div', {
	    staticClass: "el-form-item__error"
	  }, [_vm._v("Esse campo é obrigatório")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.form.description.$error
	    },
	    attrs: {
	      "label": "Descrição"
	    }
	  }, [_c('el-input', {
	    on: {
	      "input": function($event) {
	        _vm.$v.form.description.$touch()
	      }
	    },
	    model: {
	      value: (_vm.form.description),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "description", $$v)
	      },
	      expression: "form.description"
	    }
	  }), _vm._v(" "), (_vm.$v.form.description.$error) ? _c('div', {
	    staticClass: "el-form-item__error"
	  }, [_vm._v("Esse campo é obrigatório")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', [_c('form-save-button', {
	    attrs: {
	      "event-click": _vm.onSend,
	      "is-disabled": _vm.isSubmitted || _vm.$v.$invalid,
	      "is-submitted": _vm.isSubmitted
	    }
	  }), _vm._v(" "), _c('form-cancel-button', {
	    attrs: {
	      "route-name": "registration_status.index"
	    }
	  })], 1)], 1)], 1)], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 769 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('ListHeader', {
	    attrs: {
	      "title": "Áreas de Conhecimento (CNPq)",
	      "store-route-name": "knowledge_area.store"
	    }
	  }), _vm._v(" "), _c('ListMain', [_c('div', {
	    attrs: {
	      "slot": "filters"
	    },
	    slot: "filters"
	  }, [_c('el-card', {
	    staticClass: "el-card__search_list box-card"
	  }, [_c('div', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('span', [_vm._v("Filtrar Listagem")]), _vm._v(" "), _c('div', [_c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": _vm.onFilter
	    }
	  }, [_vm._v("Pesquisar")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "default"
	    },
	    on: {
	      "click": _vm.onFilterClean
	    }
	  }, [_vm._v("Limpar")])], 1)]), _vm._v(" "), _c('el-form', {
	    staticClass: "demo-form-inline",
	    attrs: {
	      "inline": true,
	      "model": _vm.filters
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.onFilter($event)
	      }
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Nome"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "placeholder": "Filtrar por nome"
	    },
	    nativeOn: {
	      "keydown": function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
	        $event.preventDefault();
	        _vm.onFilter($event)
	      }
	    },
	    model: {
	      value: (_vm.filters.name),
	      callback: function($$v) {
	        _vm.$set(_vm.filters, "name", $$v)
	      },
	      expression: "filters.name"
	    }
	  })], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.isLoadingData) ? _c('div', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, [_c('h2', [_vm._v("Lista de Áreas de Conhecimento (CNPq)")]), _vm._v(" "), _c('table', {
	    staticClass: "custom-table-list"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Código CNPq")]), _vm._v(" "), _c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', {
	    staticClass: "btn-actions"
	  }, [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listStore.listData), function(item) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(item.cnpq_code))]), _vm._v(" "), _c('td', [_c('span', {
	      staticClass: "knowledge_area_name",
	      domProps: {
	        "innerHTML": _vm._s(item.full_name_span)
	      }
	    })]), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "btn-actions"
	    }, [_c('ListEditButton', {
	      attrs: {
	        "route-name": "knowledge_area.update",
	        "item": item,
	        "domain": "knowledge_area"
	      }
	    }), _vm._v(" "), _c('ListDeleteButton', {
	      attrs: {
	        "item": item,
	        "domain": "knowledge_area"
	      }
	    })], 1)])])
	  }))])]) : _vm._e()])], 1)
	},staticRenderFns: []}

/***/ }),
/* 770 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_vm._m(0), _vm._v(" "), _c('ListMain', [_c('div', {
	    attrs: {
	      "slot": "filters"
	    },
	    slot: "filters"
	  }, [_c('el-card', {
	    staticClass: "el-card__search_list box-card"
	  }, [_c('div', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('span', [_vm._v("Filtrar Listagem")]), _vm._v(" "), _c('div', [_c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": _vm.onFilter
	    }
	  }, [_vm._v("Pesquisar")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "default"
	    },
	    on: {
	      "click": _vm.onFilterClean
	    }
	  }, [_vm._v("Limpar")])], 1)]), _vm._v(" "), _c('el-form', {
	    staticClass: "demo-form-inline",
	    attrs: {
	      "inline": true,
	      "model": _vm.filters
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Matrícula"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "placeholder": "Filtrar por matrícula"
	    },
	    model: {
	      value: (_vm.filters.ref_pessoa),
	      callback: function($$v) {
	        _vm.$set(_vm.filters, "ref_pessoa", $$v)
	      },
	      expression: "filters.ref_pessoa"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "Data da Inscrição"
	    }
	  }, [_c('el-date-picker', {
	    attrs: {
	      "type": "daterange",
	      "format": "dd/MM/yyyy",
	      "placeholder": "Filtrar por data"
	    },
	    model: {
	      value: (_vm.filters.dates),
	      callback: function($$v) {
	        _vm.$set(_vm.filters, "dates", $$v)
	      },
	      expression: "filters.dates"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "Status"
	    }
	  }, [_c('el-select', {
	    attrs: {
	      "filterable": "",
	      "placeholder": "Filtrar Status",
	      "empty-text": "Nenhum registro encontrado"
	    },
	    model: {
	      value: (_vm.filters.status_id),
	      callback: function($$v) {
	        _vm.$set(_vm.filters, "status_id", $$v)
	      },
	      expression: "filters.status_id"
	    }
	  }, _vm._l((_vm.dependencies.status), function(item) {
	    return _c('el-option', {
	      key: item.id,
	      attrs: {
	        "label": item.name,
	        "value": item.id
	      }
	    })
	  }))], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "Modalidade"
	    }
	  }, [_c('el-select', {
	    attrs: {
	      "filterable": "",
	      "placeholder": "Filtrar Modalidade",
	      "empty-text": "Nenhum registro encontrado"
	    },
	    model: {
	      value: (_vm.filters.modality_id),
	      callback: function($$v) {
	        _vm.$set(_vm.filters, "modality_id", $$v)
	      },
	      expression: "filters.modality_id"
	    }
	  }, _vm._l((_vm.dependencies.modalities), function(item) {
	    return _c('el-option', {
	      key: item.id,
	      attrs: {
	        "label": item.name,
	        "value": item.id
	      }
	    })
	  }))], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "Filtrar pelo evento atual"
	    }
	  }, [_c('el-switch', {
	    attrs: {
	      "active-text": "Sim",
	      "inactive-text": "Não"
	    },
	    model: {
	      value: (_vm.filters.filter_by_current_event),
	      callback: function($$v) {
	        _vm.$set(_vm.filters, "filter_by_current_event", $$v)
	      },
	      expression: "filters.filter_by_current_event"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "Mostrar modalidades"
	    }
	  }, [_c('el-switch', {
	    attrs: {
	      "active-text": "Sim",
	      "inactive-text": "Não"
	    },
	    model: {
	      value: (_vm.filters.show_modalities),
	      callback: function($$v) {
	        _vm.$set(_vm.filters, "show_modalities", $$v)
	      },
	      expression: "filters.show_modalities"
	    }
	  })], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.isLoadingData) ? _c('div', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, [_c('table', {
	    staticClass: "custom-table-list"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Código")]), _vm._v(" "), _c('th', [_vm._v("Pessoa")]), _vm._v(" "), _c('th', [_vm._v("E-mail")]), _vm._v(" "), _c('th', [_vm._v("Instituição")]), _vm._v(" "), _c('th', [_vm._v("Data")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "60"
	    }
	  }, [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listStore.listData), function(item) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v("\n                      " + _vm._s(item.person.pessoa ? item.person.pessoa.nome : 'Cadastro não encontrado no Segue') + " (" + _vm._s(item.person.ref_pessoa) + ")\n\n                      "), (_vm.filters.show_modalities) ? _c('div', {
	      staticStyle: {
	        "margin-top": "8px"
	      }
	    }, [_c('table', {
	      staticClass: "custom-table-list"
	    }, [_c('tr', [_c('th', [_vm._v("Modalidades")]), _vm._v(" "), _c('th', [_vm._v("Ações")])]), _vm._v(" "), _vm._l((item.modalities), function(modality) {
	      return _c('tr', [_c('td', [_vm._v(_vm._s(modality.event_modality.event.title))]), _vm._v(" "), _c('td', [(!modality.activities.length) ? _c('el-button', {
	        attrs: {
	          "type": "primary",
	          "plain": "",
	          "size": "mini"
	        },
	        on: {
	          "click": function($event) {
	            _vm.addActivity(item.id, modality.id)
	          }
	        }
	      }, [_vm._v("Inserir presença")]) : _vm._e()], 1)])
	    })], 2)]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.person.pessoa ? item.person.pessoa.email : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.institution.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dateTimeEnToBr")(item.created_at)))]), _vm._v(" "), _c('td', [_c('div', [_c('registration-status-label', {
	      attrs: {
	        "status-id": item.status_id,
	        "status-name": item.status.name
	      }
	    })], 1), _vm._v(" "), _c('div', {
	      staticClass: "small"
	    }, [_vm._v("Última Atualização: " + _vm._s(_vm._f("dateTimeEnToBr")(item.status_updated_at)))])]), _vm._v(" "), _c('td', [_c('el-button', {
	      attrs: {
	        "type": "danger",
	        "size": "mini",
	        "disabled": item.papers.length > 0 || item.status.key === 'cancelado',
	        "title": "Cancelar Inscrição"
	      },
	      on: {
	        "click": function($event) {
	          _vm.cancelRegistration(item)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-times"
	    })])], 1)])
	  })), _vm._v(" "), _c('tfoot', [_c('tr', [_c('th', {
	    attrs: {
	      "colspan": "5",
	      "align": "right"
	    }
	  }, [_vm._v("Total:")]), _vm._v(" "), _c('th', [_vm._v("R$ " + _vm._s(_vm.totalAmount))]), _vm._v(" "), _c('th')]), _vm._v(" "), _c('tr', [_c('th', {
	    attrs: {
	      "colspan": "5",
	      "align": "right"
	    }
	  }, [_vm._v("Total Recebido:")]), _vm._v(" "), _c('th', [_vm._v("R$ " + _vm._s(_vm.totalAmountPaid))]), _vm._v(" "), _c('th')])])])]) : _vm._e()])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "header"
	  }, [_c('h2', [_vm._v("Lista de Inscrições")])])
	}]}

/***/ }),
/* 771 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.reviews.length > 0) ? _c('table', {
	    staticClass: "table-confirmation"
	  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('table', {
	    staticClass: "table-confirmation"
	  }, [_c('tbody', [_vm._l((_vm.reviews), function(item) {
	    return _c('tr', {
	      class: {
	        'danger-row': !item.evaluation_action && (item.last_action.status.key === 'rejeitado' || item.last_action.status.key === 'cancelado')
	      }
	    }, [_c('td', [_vm._v("\n                        " + _vm._s(item.registration.person.pessoa.nome) + "\n                        "), (item.last_action.notes) ? _c('div', {
	      staticStyle: {
	        "padding-top": "5px"
	      }
	    }, [_c('strong', [_vm._v("Observações do Avaliador:")]), _vm._v(" " + _vm._s(item.last_action.notes) + "\n                        ")]) : _vm._e()]), _vm._v(" "), (item.evaluation_action) ? _c('td', [_vm._v("\n                        " + _vm._s(_vm.averageResponsesEvaluation(item)) + "\n                    ")]) : _vm._e(), _vm._v(" "), (item.evaluation_action) ? _c('td', [_vm._v("\n                        " + _vm._s(_vm._f("dateTimeEnToBr")(item.last_action.created_at)) + "\n                    ")]) : _vm._e(), _vm._v(" "), (!item.evaluation_action) ? _c('td', {
	      attrs: {
	        "colspan": "2"
	      }
	    }, [(item.last_action.status.key === 'rejeitado') ? _c('span', [_vm._v("Rejeitado pelo avaliador")]) : _vm._e(), _vm._v(" "), (item.last_action.status.key === 'cancelado') ? _c('span', [_vm._v("Avaliação cancelada")]) : _vm._e(), _vm._v(" "), (item.last_action.status.key === 'atribuido' || item.last_action.status.key === 'aceito') ? _c('span', [_vm._v("\n                            Aguardando avaliação\n                        ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('td', {
	      attrs: {
	        "width": "50"
	      }
	    }, [(item.last_action.status.key === 'avaliado' && !_vm.evaluationType.evaluation_finished && (_vm.paperStatusKey !== 'finalizado' && _vm.paperStatusKey !== 'aguardando_publicacao')) ? _c('el-button', {
	      attrs: {
	        "type": "warning",
	        "size": "small",
	        "title": "Remover notas da avaliação"
	      },
	      on: {
	        "click": function($event) {
	          _vm.resetEvaluation(item)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-minus-circle"
	    })]) : _vm._e(), _vm._v(" "), ((item.last_action.status.key === 'atribuido' || item.last_action.status.key === 'aceito') && !_vm.evaluationType.evaluation_finished) ? _c('el-button', {
	      attrs: {
	        "type": "danger",
	        "size": "small",
	        "title": "Cancelar essa avaliação"
	      },
	      on: {
	        "click": function($event) {
	          _vm.cancelEvaluation(item)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-trash"
	    })]) : _vm._e()], 1)])
	  }), _vm._v(" "), _c('tr', [_vm._m(1), _vm._v(" "), _c('td', {
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v(_vm._s(_vm.averageEvaluations))]), _vm._v(" "), _c('td')])], 2)])])])])]) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', [_vm._v("Avaliações")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', {
	    attrs: {
	      "align": "right"
	    }
	  }, [_c('strong', [_vm._v("Média")])])
	}]}

/***/ }),
/* 772 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('ListHeader', {
	    attrs: {
	      "title": "Eventos",
	      "store-route-name": "event.store"
	    }
	  }), _vm._v(" "), _c('ListMain', [_c('div', {
	    attrs: {
	      "slot": "filters"
	    },
	    slot: "filters"
	  }, [_c('el-card', {
	    staticClass: "el-card__search_list box-card"
	  }, [_c('div', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('span', [_vm._v("Filtrar Listagem")]), _vm._v(" "), _c('div', [_c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": _vm.onFilter
	    }
	  }, [_vm._v("Pesquisar")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "default"
	    },
	    on: {
	      "click": _vm.onFilterClean
	    }
	  }, [_vm._v("Limpar")])], 1)]), _vm._v(" "), _c('el-form', {
	    staticClass: "demo-form-inline",
	    attrs: {
	      "inline": true,
	      "model": _vm.filters
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Nome"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "placeholder": "Filtrar por Nome"
	    },
	    nativeOn: {
	      "keydown": function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
	        $event.preventDefault();
	        _vm.onFilter($event)
	      }
	    },
	    model: {
	      value: (_vm.filters.title),
	      callback: function($$v) {
	        _vm.$set(_vm.filters, "title", $$v)
	      },
	      expression: "filters.title"
	    }
	  })], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.isLoadingData) ? _c('div', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, [_c('h2', [_vm._v("Lista de Eventos")]), _vm._v(" "), _c('table', {
	    staticClass: "custom-table-list"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Nome do Evento")]), _vm._v(" "), _c('th', [_vm._v("Data")]), _vm._v(" "), _c('th', {
	    staticClass: "btn-actions"
	  }, [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listStore.listData), function(item) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v("De " + _vm._s(_vm._f("dateTimeEnToBr")(item.start_datetime)) + " até " + _vm._s(_vm._f("dateTimeEnToBr")(item.end_datetime)) + "\n                    ")]), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "btn-actions"
	    }, [(_vm.$can('event.show')) ? _c('router-link', {
	      staticClass: "el-button el-button--primary",
	      attrs: {
	        "to": {
	          name: 'event.events.index',
	          params: {
	            id: item.id
	          }
	        },
	        "title": "Gerenciar Eventos"
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-cog"
	    })]) : _vm._e(), _vm._v(" "), _c('ListEditButton', {
	      attrs: {
	        "route-name": "event.update.basic-data",
	        "item": item,
	        "domain": "event"
	      }
	    }), _vm._v(" "), _c('ListDeleteButton', {
	      attrs: {
	        "item": item,
	        "domain": "event"
	      }
	    })], 1)])])
	  }))])]) : _vm._e()])], 1)
	},staticRenderFns: []}

/***/ }),
/* 773 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (!_vm.isLoadingData) ? _c('div', [_c('ListHeader', {
	    attrs: {
	      "title": "Campus"
	    }
	  }), _vm._v(" "), _c('el-card', {
	    staticClass: "el-card__save_form box-card"
	  }, [_c('div', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('span', [_vm._v("Dados dos Campus")])]), _vm._v(" "), _c('el-form', {
	    ref: "form",
	    attrs: {
	      "model": _vm.form,
	      "label-width": "20%"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.onSend($event)
	      }
	    }
	  }, [_c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.form.institution_id.$error
	    },
	    attrs: {
	      "label": "Instituição"
	    }
	  }, [_c('el-select', {
	    staticClass: "el-select-full",
	    attrs: {
	      "filterable": "",
	      "placeholder": "Selecione uma instituição",
	      "empty-text": "Nenhum registro encontrado"
	    },
	    on: {
	      "input": function($event) {
	        _vm.$v.form.institution_id.$touch()
	      }
	    },
	    model: {
	      value: (_vm.form.institution_id),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "institution_id", $$v)
	      },
	      expression: "form.institution_id"
	    }
	  }, _vm._l((_vm.dependencies.institutions), function(item) {
	    return _c('el-option', {
	      key: item.id,
	      attrs: {
	        "label": item.name,
	        "value": item.id
	      }
	    })
	  })), _vm._v(" "), (_vm.$v.form.institution_id.$error) ? _c('div', {
	    staticClass: "el-form-item__error"
	  }, [_vm._v("\n                    Esse campo é obrigatório\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.form.name.$error
	    },
	    attrs: {
	      "label": "Nome"
	    }
	  }, [_c('el-input', {
	    on: {
	      "input": function($event) {
	        _vm.$v.form.name.$touch()
	      }
	    },
	    model: {
	      value: (_vm.form.name),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "name", $$v)
	      },
	      expression: "form.name"
	    }
	  }), _vm._v(" "), (_vm.$v.form.name.$error) ? _c('div', {
	    staticClass: "el-form-item__error"
	  }, [_vm._v("Esse campo é obrigatório")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "Descrição"
	    }
	  }, [_c('el-input', {
	    model: {
	      value: (_vm.form.description),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "description", $$v)
	      },
	      expression: "form.description"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', [_c('form-save-button', {
	    attrs: {
	      "event-click": _vm.onSend,
	      "is-disabled": _vm.isSubmitted || _vm.$v.$invalid,
	      "is-submitted": _vm.isSubmitted
	    }
	  }), _vm._v(" "), _c('form-cancel-button', {
	    attrs: {
	      "route-name": "institution_unit.index"
	    }
	  })], 1)], 1)], 1)], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 774 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('router-link', {
	    staticClass: "el-button el-button--default",
	    attrs: {
	      "to": {
	        name: _vm.routeName
	      }
	    }
	  }, [_vm._v("Cancelar\n")])
	},staticRenderFns: []}

/***/ }),
/* 775 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('textarea', {
	    attrs: {
	      "id": _vm.id
	    }
	  }, [_vm._v(_vm._s(_vm.content))])])
	},staticRenderFns: []}

/***/ }),
/* 776 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (!_vm.isLoadingData) ? _c('div', [_c('ListHeader', {
	    attrs: {
	      "title": "Usuários"
	    }
	  }), _vm._v(" "), _c('el-card', {
	    staticClass: "el-card__save_form box-card"
	  }, [_c('div', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('span', [_vm._v("Dados do Usuário")])]), _vm._v(" "), _c('el-form', {
	    ref: "form",
	    attrs: {
	      "model": _vm.form,
	      "label-width": "20%"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.onSend($event)
	      }
	    }
	  }, [_c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.form.ref_pessoa.$error
	    },
	    attrs: {
	      "label": "Matrícula"
	    }
	  }, [_c('el-input', {
	    on: {
	      "input": function($event) {
	        _vm.$v.form.ref_pessoa.$touch()
	      }
	    },
	    model: {
	      value: (_vm.form.ref_pessoa),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "ref_pessoa", $$v)
	      },
	      expression: "form.ref_pessoa"
	    }
	  }), _vm._v(" "), (_vm.$v.form.ref_pessoa.$error) ? _c('div', {
	    staticClass: "el-form-item__error"
	  }, [_vm._v("Esse campo é obrigatório")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "Nome"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "disabled": true
	    },
	    model: {
	      value: (_vm.form.pessoa.nome),
	      callback: function($$v) {
	        _vm.$set(_vm.form.pessoa, "nome", $$v)
	      },
	      expression: "form.pessoa.nome"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "Perfis do Usuário"
	    }
	  }, [_c('el-transfer', {
	    attrs: {
	      "data": _vm.dependencies.roles,
	      "titles": ['Disponíveis', 'Selecionados'],
	      "props": {
	        key: 'id',
	        label: 'name'
	      }
	    },
	    model: {
	      value: (_vm.selectedRoles),
	      callback: function($$v) {
	        _vm.selectedRoles = $$v
	      },
	      expression: "selectedRoles"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', [_c('form-save-button', {
	    attrs: {
	      "event-click": _vm.onSend,
	      "is-disabled": _vm.isSubmitted || _vm.$v.$invalid,
	      "is-submitted": _vm.isSubmitted
	    }
	  }), _vm._v(" "), _c('form-cancel-button', {
	    attrs: {
	      "route-name": "user.index"
	    }
	  })], 1)], 1)], 1)], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 777 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.evaluationType.evaluation_opened || _vm.evaluationType.evaluation_finished) ? _c('table', {
	    staticClass: "table-confirmation",
	    staticStyle: {
	      "margin-top": "15px"
	    }
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Atribuir Avaliadores")]), _vm._v(" "), _c('th', [(!_vm.evaluationType.evaluation_finished) ? _c('el-button', {
	    attrs: {
	      "type": "success",
	      "size": "mini"
	    },
	    on: {
	      "click": _vm.addSingleAppraiser
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus"
	  }), _vm._v(" "), _c('span', [_vm._v("Adicionar Avaliador")])]) : _vm._e()], 1)])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_c('el-form', {
	    ref: "formPaper",
	    attrs: {
	      "model": _vm.paper,
	      "label-width": "20%"
	    }
	  }, [_vm._l((_vm.appraisers), function(item, index) {
	    return _c('el-form-item', {
	      staticClass: "is-required",
	      class: {
	        'el-form-item--error': _vm.$v.appraisers.$each[index].appraiser_id.$error
	      },
	      attrs: {
	        "label": "Avaliador"
	      }
	    }, [_c('el-row', {
	      attrs: {
	        "gutter": 10
	      }
	    }, [_c('el-col', {
	      attrs: {
	        "span": 20
	      }
	    }, [_c('el-select', {
	      staticClass: "el-select-full",
	      attrs: {
	        "clearable": "",
	        "filterable": "",
	        "placeholder": "Digite o nome do avaliador",
	        "no-data-text": "Nenhum registro encontrado",
	        "no-match-text": "Nenhum registro encontrado"
	      },
	      on: {
	        "change": _vm.selectAppraiser,
	        "input": function($event) {
	          _vm.$v.appraisers.$each[index].appraiser_id.$touch()
	        }
	      },
	      model: {
	        value: (item.appraiser_id),
	        callback: function($$v) {
	          _vm.$set(item, "appraiser_id", $$v)
	        },
	        expression: "item.appraiser_id"
	      }
	    }, _vm._l((_vm.dependencies.filteredAppraisers), function(item) {
	      return _c('el-option', {
	        directives: [{
	          name: "show",
	          rawName: "v-show",
	          value: (item.show && item.evaluation_types.some(function (obj) { return obj.evaluation_type_id === _vm.evaluationType.evaluation_type_id; })),
	          expression: "item.show && item.evaluation_types.some(obj => obj.evaluation_type_id === evaluationType.evaluation_type_id)"
	        }],
	        key: item.id,
	        staticClass: "el-select-appraisers",
	        attrs: {
	          "label": item.name,
	          "value": item.id
	        }
	      }, [_c('div', {
	        staticClass: "item-name"
	      }, [_vm._v(_vm._s(item.name) + " (" + _vm._s(item.ref_pessoa) + ")\n                                    ")]), _vm._v(" "), (item.knowledge_areas.length > 0) ? _c('div', {
	        staticClass: "item-description"
	      }, [_vm._v("\n                                         Graduação: " + _vm._s(item.grade)), _c('br'), _vm._v("\n                                         Áreas de Conhecimento: " + _vm._s(item.knowledge_areas.map(function (obj) { return obj.knowledge_area.name; }).join(', ')) + "\n                                    ")]) : _vm._e()])
	    })), _vm._v(" "), (!_vm.$v.appraisers.$each[index].appraiser_id.required && _vm.$v.appraisers.$each[index].appraiser_id.$dirty) ? _c('validation-message') : _vm._e()], 1), _vm._v(" "), _c('el-col', {
	      attrs: {
	        "span": 3
	      }
	    }, [(!_vm.evaluationType.evaluation_finished) ? _c('el-button', {
	      attrs: {
	        "type": "danger",
	        "size": "mini",
	        "title": "Remover Avaliador"
	      },
	      on: {
	        "click": function($event) {
	          _vm.removeAppraiser(index)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-times"
	    })]) : _vm._e()], 1)], 1)], 1)
	  }), _vm._v(" "), _c('el-form-item', [_c('el-button', {
	    attrs: {
	      "type": "success",
	      "disabled": _vm.isSubmitted || _vm.$v.appraisers.$invalid
	    },
	    on: {
	      "click": _vm.onAssignAppraisers
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check"
	  }), _vm._v(" "), _c('span', [_vm._v("Atribuir Avaliadores")])])], 1)], 2)], 1)])])]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 778 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.showScreeningOption) ? _c('table', {
	    staticClass: "table-confirmation"
	  }, [_vm._m(0), _vm._v(" "), _c('tbody', [(_vm.hasScreening && _vm.showScreeningOption && _vm.canBeApproved) ? _c('tr', [_c('td', [_c('el-form', {
	    ref: "formPaper",
	    attrs: {
	      "model": _vm.paper,
	      "label-width": "20%"
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Observações"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "type": "textarea",
	      "rows": 5
	    },
	    model: {
	      value: (_vm.paper.notes),
	      callback: function($$v) {
	        _vm.$set(_vm.paper, "notes", $$v)
	      },
	      expression: "paper.notes"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
	    attrs: {
	      "type": "success",
	      "disabled": _vm.isSubmitted
	    },
	    on: {
	      "click": _vm.onAcceptPaper
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check"
	  }), _vm._v(" "), _c('span', [_vm._v("Aprovado")])]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "danger",
	      "disabled": _vm.isSubmitted || _vm.$v.paper.$invalid
	    },
	    on: {
	      "click": _vm.onRejectPaper
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-times"
	  }), _vm._v(" "), _c('span', [_vm._v("Reprovado")])]), _vm._v(" "), _c('span', {
	    staticClass: "helper-text"
	  }, [_vm._v("Para reprovar o trabalho você precisa fornecer uma resposta ao autor")])], 1)], 1)], 1)]) : _vm._e(), _vm._v(" "), (!_vm.showScreeningOption) ? _c('tr', [_c('td', [(_vm.isInvoiceOpened) ? _c('el-alert', {
	    attrs: {
	      "title": "Trabalho aguardando liberação",
	      "type": "error",
	      "description": "Pagamento da inscrição do autor não confirmado.",
	      "closable": false,
	      "show-icon": ""
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isInvoicePaid && _vm.isEditDaysAvailable) ? _c('el-alert', {
	    attrs: {
	      "title": "Trabalho aguardando liberação",
	      "type": "error",
	      "description": "O trabalho ainda está no período de edição.",
	      "closable": false,
	      "show-icon": ""
	    }
	  }) : _vm._e()], 1)]) : _vm._e()])]) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', {
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Liberação do Trabalho")])])])
	}]}

/***/ }),
/* 779 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('ListHeader', {
	    attrs: {
	      "title": "Campus",
	      "store-route-name": "institution_unit.store"
	    }
	  }), _vm._v(" "), _c('ListMain', [_c('div', {
	    attrs: {
	      "slot": "filters"
	    },
	    slot: "filters"
	  }, [_c('el-card', {
	    staticClass: "el-card__search_list box-card"
	  }, [_c('div', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('span', [_vm._v("Filtrar Listagem")]), _vm._v(" "), _c('div', [_c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": _vm.onFilter
	    }
	  }, [_vm._v("Pesquisar")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "default"
	    },
	    on: {
	      "click": _vm.onFilterClean
	    }
	  }, [_vm._v("Limpar")])], 1)]), _vm._v(" "), _c('el-form', {
	    staticClass: "demo-form-inline",
	    attrs: {
	      "inline": true,
	      "model": _vm.filters
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Nome"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "placeholder": "Filtrar por nome"
	    },
	    model: {
	      value: (_vm.filters.name),
	      callback: function($$v) {
	        _vm.$set(_vm.filters, "name", $$v)
	      },
	      expression: "filters.name"
	    }
	  })], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.isLoadingData) ? _c('div', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, [_c('h2', [_vm._v("Lista de Campus")]), _vm._v(" "), _c('table', {
	    staticClass: "custom-table-list"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Instituição")]), _vm._v(" "), _c('th', [_vm._v("Campus")]), _vm._v(" "), _c('th', {
	    staticClass: "btn-actions"
	  }, [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listStore.listData), function(item) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.institution.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "btn-actions"
	    }, [_c('ListEditButton', {
	      attrs: {
	        "route-name": "institution_unit.update",
	        "item": item,
	        "domain": "institution_unit"
	      }
	    }), _vm._v(" "), _c('ListDeleteButton', {
	      attrs: {
	        "item": item,
	        "domain": "institution_unit"
	      }
	    })], 1)])])
	  }))])]) : _vm._e()])], 1)
	},staticRenderFns: []}

/***/ }),
/* 780 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (!_vm.isLoadingData) ? _c('div', [_c('ListHeader', {
	    attrs: {
	      "title": "Perfis de Usuário"
	    }
	  }), _vm._v(" "), _c('el-card', {
	    staticClass: "el-card__save_form box-card"
	  }, [_c('div', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('span', [_vm._v("Dados do Perfil")])]), _vm._v(" "), _c('el-form', {
	    ref: "form",
	    attrs: {
	      "model": _vm.form,
	      "label-width": "20%"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.onSend($event)
	      }
	    }
	  }, [_c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.form.name.$error
	    },
	    attrs: {
	      "label": "Nome"
	    }
	  }, [_c('el-input', {
	    on: {
	      "input": function($event) {
	        _vm.$v.form.name.$touch()
	      }
	    },
	    model: {
	      value: (_vm.form.name),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "name", $$v)
	      },
	      expression: "form.name"
	    }
	  }), _vm._v(" "), (_vm.$v.form.name.$error) ? _c('div', {
	    staticClass: "el-form-item__error"
	  }, [_vm._v("Esse campo é obrigatório")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', [_c('h3', [_vm._v("Permissões")]), _vm._v(" "), _c('div', {
	    staticClass: "permissions-box"
	  }, _vm._l((_vm.domains), function(domain) {
	    return _c('el-card', {
	      staticClass: "box-card"
	    }, [_c('div', {
	      staticClass: "clearfix",
	      attrs: {
	        "slot": "header"
	      },
	      slot: "header"
	    }, [_c('el-checkbox', {
	      on: {
	        "change": function($event) {
	          _vm.onSelectAll(domain)
	        }
	      },
	      model: {
	        value: (domain.checked),
	        callback: function($$v) {
	          _vm.$set(domain, "checked", $$v)
	        },
	        expression: "domain.checked"
	      }
	    }, [_vm._v("\n                                " + _vm._s(domain.name) + "\n                            ")])], 1), _vm._v(" "), _c('div', _vm._l((domain.permissions), function(permission) {
	      return _c('div', [_c('el-checkbox', {
	        model: {
	          value: (permission.checked),
	          callback: function($$v) {
	            _vm.$set(permission, "checked", $$v)
	          },
	          expression: "permission.checked"
	        }
	      }, [_vm._v("\n                                    " + _vm._s(permission.readable_name) + "\n                                ")])], 1)
	    }))])
	  }))]), _vm._v(" "), _c('el-form-item', [_c('form-save-button', {
	    attrs: {
	      "event-click": _vm.onSend,
	      "is-disabled": _vm.isSubmitted || _vm.$v.$invalid,
	      "is-submitted": _vm.isSubmitted
	    }
	  }), _vm._v(" "), _c('form-cancel-button', {
	    attrs: {
	      "route-name": "role.index"
	    }
	  })], 1)], 1)], 1)], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 781 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "header-flex"
	  }, [_c('h2', [_vm._v("Modalidades")]), _vm._v(" "), (_vm.event.event_id) ? _c('el-button', {
	    attrs: {
	      "type": "primary",
	      "size": "small"
	    },
	    on: {
	      "click": _vm.onAddNewModality
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus"
	  }), _vm._v("\n            Nova Modalidade\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('table', {
	    staticClass: "custom-table-list"
	  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.event.modalities), function(item) {
	    return _c('tr', [_c('td', {
	      attrs: {
	        "align": "center"
	      }
	    }, [_c('div', [_vm._v(_vm._s(item.modality.name))]), _vm._v(" "), (item.current_price) ? _c('div', {
	      staticStyle: {
	        "padding-top": "10px"
	      }
	    }, [_c('strong', [_vm._v("Valor Atual:")])]) : _vm._e(), _vm._v(" "), (item.current_price) ? _c('div', [_vm._v(_vm._s('R$ ' + (item.current_price.amount | _vm.currencyEnToBr)))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('div', [_c('strong', [_vm._v("Incluir: ")]), _vm._v(" "), (item.institutions_in.length > 0) ? _c('span', [_vm._v("\n                        " + _vm._s(item.institutions_in.map(function (institution) { return institution.institution.name; }).join(', ')) + "\n                    ")]) : _vm._e(), _vm._v(" "), (item.institutions_in.length === 0) ? _c('span', [_vm._v("Todas")]) : _vm._e()]), _vm._v(" "), (item.institutions_not_in.length > 0) ? _c('div', [_c('strong', [_vm._v("Excluir: ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.institutions_not_in.map(function (institution) { return institution.institution.name; }).join(', ')))])]) : _vm._e()]), _vm._v(" "), _c('td', [(!_vm.event.event_id) ? _c('span', [_vm._v("Todas")]) : _c('span', [_vm._v(_vm._s(item.literacies.map(function (modalityLiteracy) { return modalityLiteracy.literacy.name; }).join(', ')))])]), _vm._v(" "), _c('td', {
	      attrs: {
	        "width": "150",
	        "align": "center"
	      }
	    }, [_c('el-button', {
	      attrs: {
	        "type": "default",
	        "size": "mini",
	        "title": "Editar Modalidade"
	      },
	      on: {
	        "click": function($event) {
	          _vm.onEditModality(item)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-edit"
	    })]), _vm._v(" "), (_vm.event.event_id) ? _c('el-button', {
	      attrs: {
	        "type": "info",
	        "size": "mini",
	        "disabled": item.not_charged,
	        "title": "Gerencias Valores"
	      },
	      on: {
	        "click": function($event) {
	          _vm.onHandleModalPrice(item)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-money"
	    })]) : _vm._e(), _vm._v(" "), (_vm.event.event_id) ? _c('el-button', {
	      attrs: {
	        "type": "danger",
	        "size": "mini",
	        "title": "Remover Modalidade"
	      },
	      on: {
	        "click": function($event) {
	          _vm.onDeleteModality(item)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-times"
	    })]) : _vm._e()], 1)])
	  }))]), _vm._v(" "), _c('el-dialog', {
	    attrs: {
	      "title": "Editando modalidade",
	      "top": "2vh",
	      "visible": _vm.modalModalityVisible
	    },
	    on: {
	      "update:visible": function($event) {
	        _vm.modalModalityVisible = $event
	      }
	    }
	  }, [_c('el-form', {
	    ref: "formModality",
	    attrs: {
	      "model": _vm.modality,
	      "label-position": "top"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 6
	    }
	  }, [_c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.modality.modality_id.$error
	    },
	    attrs: {
	      "label": "Modalidade"
	    }
	  }, [_c('el-select', {
	    staticClass: "el-select-full",
	    attrs: {
	      "filterable": "",
	      "clearable": "",
	      "placeholder": "Selecione uma modalidade",
	      "empty-text": "Nenhum registro encontrado",
	      "disabled": !!_vm.modality.id
	    },
	    on: {
	      "input": function($event) {
	        _vm.$v.modality.modality_id.$touch()
	      }
	    },
	    model: {
	      value: (_vm.modality.modality_id),
	      callback: function($$v) {
	        _vm.$set(_vm.modality, "modality_id", $$v)
	      },
	      expression: "modality.modality_id"
	    }
	  }, _vm._l((_vm.dependencies.modalities), function(item) {
	    return _c('el-option', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: ((!_vm.event.event_id && item.disabled) || (_vm.event.event_id && !item.disabled)),
	        expression: "(!event.event_id && item.disabled) || (event.event_id && !item.disabled)"
	      }],
	      key: item.id,
	      attrs: {
	        "label": item.name,
	        "value": item.id
	      }
	    })
	  })), _vm._v(" "), (_vm.$v.modality.modality_id.$error) ? _c('validation-message') : _vm._e()], 1)], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 6
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Layout"
	    }
	  }, [_c('el-select', {
	    staticClass: "el-select-full",
	    attrs: {
	      "filterable": "",
	      "clearable": "",
	      "placeholder": "Selecione um layout",
	      "empty-text": "Nenhum registro encontrado"
	    },
	    model: {
	      value: (_vm.modality.layout_id),
	      callback: function($$v) {
	        _vm.$set(_vm.modality, "layout_id", $$v)
	      },
	      expression: "modality.layout_id"
	    }
	  }, _vm._l((_vm.dependencies.layouts), function(item) {
	    return _c('el-option', {
	      key: item.id,
	      attrs: {
	        "label": item.name,
	        "value": item.id
	      }
	    })
	  }))], 1)], 1), _vm._v(" "), _c('el-col', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.event.event_id),
	      expression: "event.event_id"
	    }],
	    attrs: {
	      "span": 6
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Isento"
	    }
	  }, [_c('el-switch', {
	    attrs: {
	      "active-text": "SIM",
	      "inactive-text": "NÃO"
	    },
	    model: {
	      value: (_vm.modality.not_charged),
	      callback: function($$v) {
	        _vm.$set(_vm.modality, "not_charged", $$v)
	      },
	      expression: "modality.not_charged"
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 6
	    }
	  }, [_c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.modality.release_date_certificate.$error
	    },
	    attrs: {
	      "label": "Data liberação do certificado"
	    }
	  }, [_c('el-date-picker', {
	    attrs: {
	      "type": "datetime",
	      "format": "dd/MM/yyyy HH:mm",
	      "placeholder": "Data"
	    },
	    on: {
	      "input": function($event) {
	        _vm.$v.modality.release_date_certificate.$touch()
	      }
	    },
	    model: {
	      value: (_vm.modality.release_date_certificate),
	      callback: function($$v) {
	        _vm.$set(_vm.modality, "release_date_certificate", $$v)
	      },
	      expression: "modality.release_date_certificate"
	    }
	  }), _vm._v(" "), (!_vm.$v.modality.release_date_certificate.required && _vm.$v.modality.release_date_certificate.$dirty) ? _c('validation-message') : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.event.event_id),
	      expression: "event.event_id"
	    }],
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 24
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Incluir Instituições"
	    }
	  }, [_c('el-select', {
	    staticClass: "el-select-full",
	    attrs: {
	      "filterable": "",
	      "multiple": "",
	      "remote": "",
	      "remote-method": _vm.onSearchInstitution,
	      "loading": _vm.isSearchingInstitution,
	      "placeholder": "Digite o nome da instituição",
	      "empty-text": "Nenhum registro encontrado"
	    },
	    model: {
	      value: (_vm.modality.institutions_in),
	      callback: function($$v) {
	        _vm.$set(_vm.modality, "institutions_in", $$v)
	      },
	      expression: "modality.institutions_in"
	    }
	  }, _vm._l((_vm.dependencies.institutions), function(item) {
	    return _c('el-option', {
	      key: item.id,
	      attrs: {
	        "label": item.name,
	        "value": item.id
	      }
	    })
	  }))], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.event.event_id),
	      expression: "event.event_id"
	    }],
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 24
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Excluir Instituições"
	    }
	  }, [_c('el-select', {
	    staticClass: "el-select-full",
	    attrs: {
	      "filterable": "",
	      "multiple": "",
	      "remote": "",
	      "remote-method": _vm.onSearchInstitution,
	      "loading": _vm.isSearchingInstitution,
	      "placeholder": "Digite o nome da instituição",
	      "empty-text": "Nenhum registro encontrado"
	    },
	    model: {
	      value: (_vm.modality.institutions_not_in),
	      callback: function($$v) {
	        _vm.$set(_vm.modality, "institutions_not_in", $$v)
	      },
	      expression: "modality.institutions_not_in"
	    }
	  }, _vm._l((_vm.dependencies.institutions), function(item) {
	    return _c('el-option', {
	      key: item.id,
	      attrs: {
	        "label": item.name,
	        "value": item.id
	      }
	    })
	  }))], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.event.event_id),
	      expression: "event.event_id"
	    }],
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 24
	    }
	  }, [_c('el-form-item', {
	    staticClass: "is-required",
	    class: {
	      'el-form-item--error': _vm.$v.modality.literacies.$error
	    },
	    attrs: {
	      "label": "Escolaridades"
	    }
	  }, [_c('el-transfer', {
	    staticClass: "el-transfer-full",
	    attrs: {
	      "data": _vm.dependencies.literacies,
	      "titles": ['Disponíveis', 'Selecionadas'],
	      "props": {
	        key: 'id',
	        label: 'name'
	      }
	    },
	    model: {
	      value: (_vm.modality.literacies),
	      callback: function($$v) {
	        _vm.$set(_vm.modality, "literacies", $$v)
	      },
	      expression: "modality.literacies"
	    }
	  }), _vm._v(" "), (_vm.$v.modality.literacies.$error) ? _c('validation-message') : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "dialog-footer",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('el-button', {
	    staticClass: "submit",
	    attrs: {
	      "disabled": _vm.isSubmitted || _vm.$v.modality.$invalid,
	      "type": "primary"
	    },
	    on: {
	      "click": _vm.onSaveModality
	    }
	  }, [_vm._v("\n                Salvar Modalidade\n            ")]), _vm._v(" "), _c('el-button', {
	    on: {
	      "click": _vm.onHandleModalModality
	    }
	  }, [_vm._v("Fechar")])], 1)], 1), _vm._v(" "), (_vm.modalPriceVisible) ? _c('el-dialog', {
	    attrs: {
	      "title": "Períodos de valores",
	      "visible": _vm.modalPriceVisible
	    },
	    on: {
	      "update:visible": function($event) {
	        _vm.modalPriceVisible = $event
	      }
	    }
	  }, [_c('el-form', {
	    ref: "formModalityPrice",
	    attrs: {
	      "model": _vm.price,
	      "inline": true,
	      "label-position": "top"
	    }
	  }, [_c('el-form-item', {
	    staticClass: "is-required",
	    attrs: {
	      "label": "Data Início"
	    }
	  }, [_c('el-date-picker', {
	    attrs: {
	      "type": "datetime",
	      "format": "dd/MM/yyyy HH:mm",
	      "placeholder": "Data"
	    },
	    on: {
	      "input": function($event) {
	        _vm.$v.price.start_datetime.$touch()
	      }
	    },
	    model: {
	      value: (_vm.price.start_datetime),
	      callback: function($$v) {
	        _vm.$set(_vm.price, "start_datetime", $$v)
	      },
	      expression: "price.start_datetime"
	    }
	  }), _vm._v(" "), (!_vm.$v.price.start_datetime.required && _vm.$v.price.start_datetime.$dirty) ? _c('validation-message') : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
	    staticClass: "is-required",
	    attrs: {
	      "label": "Data Término"
	    }
	  }, [_c('el-date-picker', {
	    attrs: {
	      "type": "datetime",
	      "format": "dd/MM/yyyy HH:mm",
	      "placeholder": "Data"
	    },
	    on: {
	      "input": function($event) {
	        _vm.$v.price.end_datetime.$touch()
	      }
	    },
	    model: {
	      value: (_vm.price.end_datetime),
	      callback: function($$v) {
	        _vm.$set(_vm.price, "end_datetime", $$v)
	      },
	      expression: "price.end_datetime"
	    }
	  }), _vm._v(" "), (!_vm.$v.price.end_datetime.required && _vm.$v.price.end_datetime.$dirty) ? _c('validation-message') : _vm._e()], 1), _vm._v(" "), (!_vm.isResetPrice) ? _c('el-form-item', {
	    staticClass: "is-required",
	    attrs: {
	      "label": "Valor"
	    }
	  }, [_c('el-input', {
	    directives: [{
	      name: "money",
	      rawName: "v-money",
	      value: (_vm.moneyMask),
	      expression: "moneyMask"
	    }],
	    on: {
	      "input": function($event) {
	        _vm.$v.price.amount.$touch()
	      }
	    },
	    model: {
	      value: (_vm.price.amount),
	      callback: function($$v) {
	        _vm.$set(_vm.price, "amount", $$v)
	      },
	      expression: "price.amount"
	    }
	  }), _vm._v(" "), (!_vm.$v.price.amount.required) ? _c('validation-message') : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-button', {
	    staticClass: "submit",
	    staticStyle: {
	      "margin-top": "24px"
	    },
	    attrs: {
	      "type": "primary",
	      "disabled": _vm.isSubmitted || _vm.$v.price.$invalid
	    },
	    on: {
	      "click": _vm.onSavePrice
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus"
	  }), _vm._v("\n                    Gravar Valor\n                ")])], 1)], 1), _vm._v(" "), _c('table', {
	    staticClass: "custom-table-list"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Data Início")]), _vm._v(" "), _c('th', [_vm._v("Data Término")]), _vm._v(" "), _c('th', [_vm._v("Valor")]), _vm._v(" "), _c('th', [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.modality.prices), function(priceItem) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm._f("dateTimeEnToBr")(priceItem.start_datetime)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dateTimeEnToBr")(priceItem.end_datetime)))]), _vm._v(" "), _c('td', [_vm._v("R$ " + _vm._s(priceItem.amount ? (priceItem.amount | _vm.currencyEnToBr) : '0,00'))]), _vm._v(" "), _c('td', {
	      attrs: {
	        "align": "center"
	      }
	    }, [_c('el-button', {
	      attrs: {
	        "type": "danger",
	        "title": "Remover Valor",
	        "size": "mini"
	      },
	      on: {
	        "click": function($event) {
	          _vm.onDeletePrice(priceItem)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-times"
	    })])], 1)])
	  }))]), _vm._v(" "), _c('div', {
	    staticClass: "dialog-footer",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('el-button', {
	    on: {
	      "click": _vm.onHandleModalPrice
	    }
	  }, [_vm._v("Fechar")])], 1)], 1) : _vm._e()], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', [_vm._v("Modalidade")]), _vm._v(" "), _c('th', [_vm._v("Instituições")]), _vm._v(" "), _c('th', [_vm._v("Escolaridades")]), _vm._v(" "), _c('th', [_vm._v("Ações")])])])
	}]}

/***/ }),
/* 782 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "app-header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', [_vm._t("default"), _vm._v(" "), (_vm.storeRouteName && _vm.canStore) ? _c('router-link', {
	    staticClass: "el-button el-button--success",
	    attrs: {
	      "to": {
	        name: _vm.storeRouteName
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus"
	  }), _vm._v(" "), _c('span', [_vm._v("Criar " + _vm._s(_vm.title))])]) : _vm._e(), _vm._v(" "), (_vm.editRouteName && _vm.item && _vm.canUpdate) ? _c('router-link', {
	    staticClass: "el-button el-button--info",
	    attrs: {
	      "to": {
	        name: _vm.editRouteName,
	        params: {
	          id: _vm.item.id
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "el-icon-edit"
	  }), _vm._v(" "), _c('span', [_vm._v("Editar")])]) : _vm._e(), _vm._v(" "), (_vm.backRoute) ? _c('back-button') : _vm._e()], 2)])
	},staticRenderFns: []}

/***/ }),
/* 783 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('ListHeader', {
	    attrs: {
	      "title": "Endereços",
	      "store-route-name": "place.store"
	    }
	  }), _vm._v(" "), _c('ListMain', [_c('div', {
	    attrs: {
	      "slot": "filters"
	    },
	    slot: "filters"
	  }, [_c('el-card', {
	    staticClass: "el-card__search_list box-card"
	  }, [_c('div', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('span', [_vm._v("Filtrar Listagem")]), _vm._v(" "), _c('div', [_c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": _vm.onFilter
	    }
	  }, [_vm._v("Pesquisar")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "default"
	    },
	    on: {
	      "click": _vm.onFilterClean
	    }
	  }, [_vm._v("Limpar")])], 1)]), _vm._v(" "), _c('el-form', {
	    staticClass: "demo-form-inline",
	    attrs: {
	      "inline": true,
	      "model": _vm.filters
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Endereço"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "placeholder": "Filtrar por Endereço"
	    },
	    nativeOn: {
	      "keydown": function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
	        $event.preventDefault();
	        _vm.onFilter($event)
	      }
	    },
	    model: {
	      value: (_vm.filters.address),
	      callback: function($$v) {
	        _vm.$set(_vm.filters, "address", $$v)
	      },
	      expression: "filters.address"
	    }
	  })], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.isLoadingData) ? _c('div', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, [_c('h2', [_vm._v("Lista de Endereços")]), _vm._v(" "), _c('table', {
	    staticClass: "custom-table-list"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Cidade")]), _vm._v(" "), _c('th', [_vm._v("Endereço")]), _vm._v(" "), _c('th', [_vm._v("Descrição")]), _vm._v(" "), _c('th', {
	    staticClass: "btn-actions"
	  }, [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listStore.listData), function(item) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.city.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.address))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.description))]), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "btn-actions"
	    }, [_c('ListEditButton', {
	      attrs: {
	        "route-name": "place.update",
	        "item": item,
	        "domain": "place"
	      }
	    }), _vm._v(" "), _c('ListDeleteButton', {
	      attrs: {
	        "item": item,
	        "domain": "place"
	      }
	    })], 1)])])
	  }))])]) : _vm._e()])], 1)
	},staticRenderFns: []}

/***/ }),
/* 784 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('ListHeader', {
	    attrs: {
	      "title": "Eventos"
	    }
	  }), _vm._v(" "), _c('el-card', {
	    staticClass: "el-card__save_form box-card"
	  }, [_c('div', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('span', [_vm._v("Dados do Evento")])]), _vm._v(" "), _c('event-basic-data', {
	    attrs: {
	      "event-id": _vm.eventId
	    }
	  })], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 785 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "header header-flex"
	  }, [_c('h2', [_vm._v("Lista de Submissões")]), _vm._v(" "), (_vm.statusKey === 'em_avaliacao' && this.listStore.listData.length) ? _c('el-button', {
	    attrs: {
	      "type": "success",
	      "disabled": !_vm.allPapersEvaluated && true
	    },
	    on: {
	      "click": _vm.onFinishPapersWeb
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check"
	  }), _vm._v(" "), _c('span', [_vm._v("Finalizar Todas Avaliações")])]) : _vm._e()], 1), _vm._v(" "), _c('ListMain', [_c('div', {
	    attrs: {
	      "slot": "filters"
	    },
	    slot: "filters"
	  }, [_c('el-card', {
	    staticClass: "el-card__search_list box-card"
	  }, [_c('div', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('span', [_vm._v("Filtrar Listagem")]), _vm._v(" "), _c('div', [_c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": _vm.onFilter
	    }
	  }, [_vm._v("Pesquisar")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "default"
	    },
	    on: {
	      "click": _vm.onFilterClean
	    }
	  }, [_vm._v("Limpar")])], 1)]), _vm._v(" "), _c('el-form', {
	    staticClass: "demo-form-inline",
	    attrs: {
	      "inline": true,
	      "model": _vm.filters
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Código"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "placeholder": "Filtrar por Código"
	    },
	    model: {
	      value: (_vm.filters.id),
	      callback: function($$v) {
	        _vm.$set(_vm.filters, "id", $$v)
	      },
	      expression: "filters.id"
	    }
	  })], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.isLoadingData) ? _c('div', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, [_c('table', {
	    staticClass: "custom-table-list"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Código")]), _vm._v(" "), _c('th', [_vm._v("Autor")]), _vm._v(" "), _c('th', [_vm._v("Data da Submissão")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Avaliadores In Loco")]), _vm._v(" "), (_vm.isOnEvaluation) ? _c('th', {
	    attrs: {
	      "width": "140"
	    }
	  }, [_vm._v("Avaliações")]) : _vm._e(), _vm._v(" "), _c('th', {
	    staticClass: "btn-actions"
	  }, [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listFiltered), function(item) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.registration.person.pessoa ? item.registration.person.pessoa.nome : 'Cadastro não encontrado no Segue') + " (" + _vm._s(item.registration.person.ref_pessoa) + ")")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dateTimeEnToBr")(item.date_submitted)))]), _vm._v(" "), _c('td', [_c('div', [_c('paper-status-label', {
	      attrs: {
	        "status-id": item.paper_status_id,
	        "status-key": item.status.key,
	        "status-name": item.status.name
	      }
	    })], 1), _vm._v(" "), _c('div', {
	      staticClass: "small"
	    }, [_vm._v("Última Atualização: " + _vm._s(_vm._f("dateTimeEnToBr")(item.last_modified)))])]), _vm._v(" "), _c('td', [_c('paper-evaluations-label', {
	      attrs: {
	        "evaluations": _vm.getTotalAvaliacoesInloco(item.reviews)
	      }
	    })], 1), _vm._v(" "), (_vm.isOnEvaluation && item.event_paper_type.evaluation_type) ? _c('td', [_c('el-progress', {
	      attrs: {
	        "percentage": _vm.getEvaluationProgress(item),
	        "stroke-width": 18,
	        "text-inside": true
	      }
	    })], 1) : _vm._e(), _vm._v(" "), (_vm.isOnEvaluation && !item.event_paper_type.evaluation_type) ? _c('td', [_vm._v("\n                        Avaliações fora do período\n                    ")]) : _vm._e(), _vm._v(" "), _c('td', {
	      attrs: {
	        "align": "center"
	      }
	    }, [_c('el-button', {
	      attrs: {
	        "type": "default",
	        "disabled": !_vm.canBeApproved(item),
	        "size": "mini",
	        "title": _vm.canBeApproved(item) ? 'Visualizar Trabalho' : 'Trabalho indisponível'
	      },
	      on: {
	        "click": function($event) {
	          _vm.showPaper(item)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-eye"
	    })]), _vm._v(" "), (item.file) ? _c('a', {
	      staticClass: "el-button el-button--info el-button--mini",
	      attrs: {
	        "href": item.file.download_file_path,
	        "target": "_blank",
	        "title": "Baixar arquivo"
	      }
	    }, [_c('i', {
	      staticClass: "fa fa-download"
	    })]) : _vm._e()], 1)])
	  }))])]) : _vm._e()]), _vm._v(" "), (_vm.isPaperVisible) ? _c('div', {
	    attrs: {
	      "id": "paper-content"
	    }
	  }, [_c('paper-show', {
	    attrs: {
	      "model": _vm.paper,
	      "load-list": _vm.loadList
	    }
	  })], 1) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 786 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('ListHeader', {
	    attrs: {
	      "title": "Modalidades",
	      "store-route-name": "modality.store"
	    }
	  }), _vm._v(" "), _c('ListMain', [_c('div', {
	    attrs: {
	      "slot": "filters"
	    },
	    slot: "filters"
	  }, [_c('el-card', {
	    staticClass: "el-card__search_list box-card"
	  }, [_c('div', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('span', [_vm._v("Filtrar Listagem")]), _vm._v(" "), _c('div', [_c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": _vm.onFilter
	    }
	  }, [_vm._v("Pesquisar")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "default"
	    },
	    on: {
	      "click": _vm.onFilterClean
	    }
	  }, [_vm._v("Limpar")])], 1)]), _vm._v(" "), _c('el-form', {
	    staticClass: "demo-form-inline",
	    attrs: {
	      "inline": true,
	      "model": _vm.filters
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Nome"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "placeholder": "Filtrar por nome"
	    },
	    nativeOn: {
	      "keydown": function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
	        $event.preventDefault();
	        _vm.onFilter($event)
	      }
	    },
	    model: {
	      value: (_vm.filters.name),
	      callback: function($$v) {
	        _vm.$set(_vm.filters, "name", $$v)
	      },
	      expression: "filters.name"
	    }
	  })], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.isLoadingData) ? _c('div', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, [_c('h2', [_vm._v("Lista de Modalidades")]), _vm._v(" "), _c('table', {
	    staticClass: "custom-table-list"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Descrição")]), _vm._v(" "), _c('th', {
	    staticClass: "btn-actions"
	  }, [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listStore.listData), function(item) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.description))]), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "btn-actions"
	    }, [_c('ListEditButton', {
	      attrs: {
	        "route-name": "modality.update",
	        "item": item,
	        "domain": "modality"
	      }
	    }), _vm._v(" "), _c('ListDeleteButton', {
	      attrs: {
	        "item": item,
	        "domain": "modality"
	      }
	    })], 1)])])
	  }))])]) : _vm._e()])], 1)
	},staticRenderFns: []}

/***/ }),
/* 787 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('ListHeader', {
	    attrs: {
	      "title": "Status de Trabalho",
	      "store-route-name": "paper_status.store"
	    }
	  }), _vm._v(" "), _c('ListMain', [_c('div', {
	    attrs: {
	      "slot": "filters"
	    },
	    slot: "filters"
	  }, [_c('el-card', {
	    staticClass: "el-card__search_list box-card"
	  }, [_c('div', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('span', [_vm._v("Filtrar Listagem")]), _vm._v(" "), _c('div', [_c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": _vm.onFilter
	    }
	  }, [_vm._v("Pesquisar")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "default"
	    },
	    on: {
	      "click": _vm.onFilterClean
	    }
	  }, [_vm._v("Limpar")])], 1)]), _vm._v(" "), _c('el-form', {
	    staticClass: "demo-form-inline",
	    attrs: {
	      "inline": true,
	      "model": _vm.filters
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Nome"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "placeholder": "Filtrar por nome"
	    },
	    nativeOn: {
	      "keydown": function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
	        $event.preventDefault();
	        _vm.onFilter($event)
	      }
	    },
	    model: {
	      value: (_vm.filters.name),
	      callback: function($$v) {
	        _vm.$set(_vm.filters, "name", $$v)
	      },
	      expression: "filters.name"
	    }
	  })], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.isLoadingData) ? _c('div', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, [_c('h2', [_vm._v("Lista de Status de Trabalhos")]), _vm._v(" "), _c('table', {
	    staticClass: "custom-table-list"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Nome Público")]), _vm._v(" "), _c('th', [_vm._v("Descrição")]), _vm._v(" "), _c('th', {
	    staticClass: "btn-actions"
	  }, [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listStore.listData), function(item) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.public_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.description))]), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "btn-actions"
	    }, [_c('ListEditButton', {
	      attrs: {
	        "route-name": "paper_status.update",
	        "item": item,
	        "domain": "paper_status"
	      }
	    }), _vm._v(" "), _c('ListDeleteButton', {
	      attrs: {
	        "item": item,
	        "domain": "paper_status"
	      }
	    })], 1)])])
	  }))])]) : _vm._e()])], 1)
	},staticRenderFns: []}

/***/ }),
/* 788 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.$can(_vm.domain + '.destroy')) ? _c('el-button', {
	    attrs: {
	      "type": "danger",
	      "title": "Remover"
	    },
	    on: {
	      "click": function($event) {
	        _vm.onDestroy(_vm.item)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-trash"
	  })]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 789 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('ListHeader', {
	    attrs: {
	      "title": "Cidades",
	      "store-route-name": "city.store"
	    }
	  }), _vm._v(" "), _c('ListMain', [_c('div', {
	    attrs: {
	      "slot": "filters"
	    },
	    slot: "filters"
	  }, [_c('el-card', {
	    staticClass: "el-card__search_list box-card"
	  }, [_c('div', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('span', [_vm._v("Filtrar Listagem")]), _vm._v(" "), _c('div', [_c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": _vm.onFilter
	    }
	  }, [_vm._v("Pesquisar")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "default"
	    },
	    on: {
	      "click": _vm.onFilterClean
	    }
	  }, [_vm._v("Limpar")])], 1)]), _vm._v(" "), _c('el-form', {
	    staticClass: "demo-form-inline",
	    attrs: {
	      "inline": true,
	      "model": _vm.filters
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Nome"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "placeholder": "Filtrar por nome"
	    },
	    model: {
	      value: (_vm.filters.name),
	      callback: function($$v) {
	        _vm.$set(_vm.filters, "name", $$v)
	      },
	      expression: "filters.name"
	    }
	  })], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.isLoadingData) ? _c('div', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, [_c('h2', [_vm._v("Lista de Cidades")]), _vm._v(" "), _c('table', {
	    staticClass: "custom-table-list"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Estado")]), _vm._v(" "), _c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', {
	    staticClass: "btn-actions"
	  }, [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listStore.listData), function(item) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.state.initials))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "btn-actions"
	    }, [_c('ListEditButton', {
	      attrs: {
	        "route-name": "city.update",
	        "item": item,
	        "domain": "city"
	      }
	    }), _vm._v(" "), _c('ListDeleteButton', {
	      attrs: {
	        "item": item,
	        "domain": "city"
	      }
	    })], 1)])])
	  }))])]) : _vm._e()])], 1)
	},staticRenderFns: []}

/***/ }),
/* 790 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('el-tag', {
	    attrs: {
	      "type": _vm.labelType
	    }
	  }, [_vm._v(_vm._s(_vm.statusName))])], 1)
	},staticRenderFns: []}

/***/ }),
/* 791 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('el-tag', {
	    class: 'label_' + _vm.statusKey,
	    attrs: {
	      "type": "default"
	    }
	  }, [_vm._v(_vm._s(_vm.statusName))])], 1)
	},staticRenderFns: []}

/***/ }),
/* 792 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('ListHeader', {
	    attrs: {
	      "title": "Inscrições"
	    }
	  }), _vm._v(" "), _c('ListMain', [(true) ? _c('div', {
	    attrs: {
	      "slot": "filters"
	    },
	    slot: "filters"
	  }, [_c('el-card', {
	    staticClass: "el-card__search_list box-card"
	  }, [_c('div', {
	    attrs: {
	      "slot": "header"
	    },
	    slot: "header"
	  }, [_c('span', [_vm._v("Pesquisar")]), _vm._v(" "), _c('div', [_c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": _vm.onFilter
	    }
	  }, [_vm._v("Pesquisar")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "default"
	    },
	    on: {
	      "click": _vm.onFilterClean
	    }
	  }, [_vm._v("Limpar")])], 1)]), _vm._v(" "), _c('el-form', {
	    staticClass: "demo-form-inline",
	    attrs: {
	      "inline": true,
	      "model": _vm.filters
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Matrícula"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "placeholder": "Filtrar por matrícula"
	    },
	    model: {
	      value: (_vm.filters.ref_pessoa),
	      callback: function($$v) {
	        _vm.$set(_vm.filters, "ref_pessoa", $$v)
	      },
	      expression: "filters.ref_pessoa"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "Data da Inscrição"
	    }
	  }, [_c('el-date-picker', {
	    attrs: {
	      "type": "daterange",
	      "format": "dd/MM/yyyy",
	      "placeholder": "Filtrar por data"
	    },
	    model: {
	      value: (_vm.filters.dates),
	      callback: function($$v) {
	        _vm.$set(_vm.filters, "dates", $$v)
	      },
	      expression: "filters.dates"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "Status"
	    }
	  }, [_c('el-select', {
	    attrs: {
	      "filterable": "",
	      "placeholder": "Filtrar Status",
	      "empty-text": "Nenhum registro encontrado"
	    },
	    model: {
	      value: (_vm.filters.status_id),
	      callback: function($$v) {
	        _vm.$set(_vm.filters, "status_id", $$v)
	      },
	      expression: "filters.status_id"
	    }
	  }, _vm._l((_vm.dependencies.status), function(item) {
	    return _c('el-option', {
	      key: item.id,
	      attrs: {
	        "label": item.name,
	        "value": item.id
	      }
	    })
	  }))], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "Modalidade"
	    }
	  }, [_c('el-select', {
	    attrs: {
	      "filterable": "",
	      "placeholder": "Filtrar Modalidade",
	      "empty-text": "Nenhum registro encontrado"
	    },
	    model: {
	      value: (_vm.filters.modality_id),
	      callback: function($$v) {
	        _vm.$set(_vm.filters, "modality_id", $$v)
	      },
	      expression: "filters.modality_id"
	    }
	  }, _vm._l((_vm.dependencies.modalities), function(item) {
	    return _c('el-option', {
	      key: item.id,
	      attrs: {
	        "label": item.name,
	        "value": item.id
	      }
	    })
	  }))], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoadingData) ? _c('div', {
	    attrs: {
	      "slot": "list"
	    },
	    slot: "list"
	  }, [_c('div', {
	    staticClass: "header"
	  }, [_c('h2', [_vm._v("Lista de Inscrições")])]), _vm._v(" "), _c('table', {
	    staticClass: "custom-table-list"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Evento")]), _vm._v(" "), _c('th', [_vm._v("Pessoa")]), _vm._v(" "), _c('th', [_vm._v("Instituição")]), _vm._v(" "), _c('th', [_vm._v("Data")]), _vm._v(" "), _c('th', [_vm._v("Modalidades")]), _vm._v(" "), _c('th', [_vm._v("Status")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listStore.listData), function(item) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.main_event.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.person.ref_pessoa) + " - " + _vm._s(item.person.pessoa.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.institution.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dateTimeEnToBr")(item.created_at)))]), _vm._v(" "), _c('td', _vm._l((item.modalities), function(modality) {
	      return _c('div', [_vm._v(_vm._s(modality.event_modality.modality.name))])
	    })), _vm._v(" "), _c('td', [_c('div', [_c('registration-status-label', {
	      attrs: {
	        "status-id": item.status_id,
	        "status-name": item.status.name
	      }
	    })], 1), _vm._v(" "), _c('div', {
	      staticClass: "small"
	    }, [_vm._v("Última Atualização: " + _vm._s(_vm._f("dateTimeEnToBr")(item.status_updated_at)))])])])
	  }))])]) : _vm._e()])], 1)
	},staticRenderFns: []}

/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.99d105dfce9e96580889.js